export const gender_data = [
    {
        id: 1,
        name: "Male",
        nameamh: "ወንድ",
    },
    {
        id: 2,
        name: "Female",
        nameamh: "ሴት",
    },
];
export const address_documentType_data = [
    {
        id: 1,
        name: "Kebele ID",
        updateType: "Address proof"
    },
    {
        id: 2,
        name: "Taxpayer Identification Number/ID (ID card with photo)",
        updateType: "Address proof"
    },
    {
        id: 3,
        name: "Consent",
        updateType: "Address proof"
    },
    {
        id: 4,
        name: "Court Decision",
        updateType: "Address proof"
    },
    {
        id: 5,
        name: "Confirmation Paper given by Kebele Head",
        updateType: "Address proof"
    },
    {
        id: 6,
        name: "Trade registration and trade license",
        updateType: "Address proof"
    },
    {
        id: 7,
        name: "Community membership card",
        updateType: "Address proof"
    },
    {
        id: 8,
        name: "Official Letter with photo from Orphanage",
        updateType: "Address proof"
    },
    {
        id: 9,
        name: "Passport",
        updateType: "Address proof"
    },
    {
        id: 10,
        name: "License of Arms",
        updateType: "Address proof"
    },
    {
        id: 11,
        name: "Officially authenticated rental contract",
        updateType: "Address proof"
    },
    {
        id: 12,
        name: "Account statement",
        updateType: "Address proof"
    },
    {
        id: 13,
        name: "Utility bill (previous three months)",
        updateType: "Address proof"
    },
    {
        id: 14,
        name: "Driving License",
        updateType: "Address proof"
    },
    {
        id: 15,
        name: "Diplomat ID (Indicating that he is a resident in Ethiopia)",
        updateType: "Address proof"
    },
    {
        id: 16,
        name: "Election ID",
        updateType: "Address proof"
    },
    {
        id: 17,
        name: "Job seeker ID",
        updateType: "Address proof"
    },
];
export const identity_documentType_data = [
    {
        id: 1,
        name: "Kebele ID",
        updateType: "Identity proof"
    },
    {
        id: 2,
        name: "Taxpayer Identification Number/ID (ID card with photo)",
        updateType: "Identity proof"
    },
    {
        id: 3,
        name: "Birth Certificate",
        updateType: "Identity proof"
    },
    {
        id: 4,
        name: "Title Deed",
        updateType: "Identity proof"
    },
    {
        id: 5,
        name: "Confirmation Paper given by Kebele Head",
        updateType: "Identity proof"
    },
    {
        id: 6,
        name: "Witness",
        updateType: "Identity proof"
    },
    {
        id: 7,
        name: "Idir Card",
        updateType: "Identity proof"
    },
    {
        id: 8,
        name: "Pension ID",
        updateType: "Identity proof"
    },
    {
        id: 9,
        name: "Official Letter with photo from Orphanage",
        updateType: "Identity proof"
    },
    {
        id: 10,
        name: "Work permit (foreigners only)",
        updateType: "Identity proof"
    },
    {
        id: 11,
        name: "Car Ownership Certificate",
        updateType: "Identity proof"
    },
    {
        id: 12,
        name: "Education Certificate",
        updateType: "Identity proof"
    },
    {
        id: 13,
        name: "Officially authenticated rental contract",
        updateType: "Identity proof"
    },
    {
        id: 14,
        name: "Residence permit (foreigners only)",
        updateType: "Identity proof"
    },
    {
        id: 15,
        name: "Diplomat ID (Indicating that he/she is a resident in Ethiopia)",
        updateType: "Identity proof"
    },
    {
        id: 16,
        name: "Resident verification/Yellow card",
        updateType: "Identity proof"
    },
    {
        id: 17,
        name: "Licensed ID issued by legal financial entites",
        updateType: "Identity proof"
    },
    {
        id: 18,
        name: "Job seeker ID",
        updateType: "Identity proof"
    },
    {
        id: 19,
        name: "Student ID",
        updateType: "Identity proof"
    },
    {
        id: 20,
        name: "Bank Book",
        updateType: "Identity proof"
    },
    {
        id: 21,
        name: "Refugee Card or Evidence of Refugee and Refugee return services",
        updateType: "Identity proof"
    },
    {
        id: 22,
        name: "Employment ID",
        updateType: "Identity proof"
    },
    {
        id: 23,
        name: "Professional Licence issued by Government",
        updateType: "Identity proof"
    },
    {
        id: 24,
        name: "Court Decision",
        updateType: "Identity proof"
    },
    {
        id: 25,
        name: "Proof of Marital Status",
        updateType: "Identity proof"
    },
    {
        id: 26,
        name: "International Organization Employment ID",
        updateType: "Identity proof"
    },
    {
        id: 27,
        name: "Trade registration and trade license",
        updateType: "Identity proof"
    },
    {
        id: 28,
        name: "Any identity legal document provided from the court",
        updateType: "Identity proof"
    },
    {
        id: 29,
        name: "Certificate of Birth",
        updateType: "Identity proof"
    },
    {
        id: 30,
        name: "Passport",
        updateType: "Identity proof"
    },
    {
        id: 31,
        name: "Licence of Arms",
        updateType: "Identity proof"
    },
    {
        id: 32,
        name: "Canteen card of the Army",
        updateType: "Identity proof"
    },
    {
        id: 33,
        name: "Account statement",
        updateType: "Identity proof"
    },
    {
        id: 34,
        name: "Ration card",
        updateType: "Identity proof"
    },
    {
        id: 35,
        name: "Driving licence",
        updateType: "Identity proof"
    },
    {
        id: 36,
        name: "Health Insurance Card",
        updateType: "Identity proof"
    }
];

export const nationality_data = [
    {
        "id": 1,
        "name": "Afghanistan",
        "nameamh": "አፍጋኒስታን"
    },
    {
        "id": 2,
        "name": "Albania",
        "nameamh": "አልቤኒያ"
    },
    {
        "id": 3,
        "name": "Algeria",
        "nameamh": "አልጄሪያ"
    },
    {
        "id": 4,
        "name": "Andorra",
        "nameamh": "አንዶራ"
    },
    {
        "id": 5,
        "name": "Angola",
        "nameamh": "አንጎላ"
    },
    {
        "id": 6,
        "name": "Antigua and Barbuda",
        "nameamh": "አንቲጉአ እና ባርቡዳ"
    },
    {
        "id": 7,
        "name": "Argentina",
        "nameamh": "አርጀንቲና"
    },
    {
        "id": 8,
        "name": "Armenia",
        "nameamh": "አርሜኒያ"
    },
    {
        "id": 9,
        "name": "Australia",
        "nameamh": "አውስትራሊያ"
    },
    {
        "id": 10,
        "name": "Austria",
        "nameamh": "ኦስትሪያ"
    },
    {
        "id": 11,
        "name": "Azerbaijan",
        "nameamh": "አዘርባጃን"
    },
    {
        "id": 12,
        "name": "Bahamas",
        "nameamh": "ባሐማስ"
    },
    {
        "id": 13,
        "name": "Bahrain",
        "nameamh": "ባህሬን"
    },
    {
        "id": 14,
        "name": "Bangladesh",
        "nameamh": "ባንግላዲሽ"
    },
    {
        "id": 15,
        "name": "Barbados",
        "nameamh": "ባርቤዶስ"
    },
    {
        "id": 16,
        "name": "Belarus",
        "nameamh": "ቤላሩስ"
    },
    {
        "id": 17,
        "name": "Belgium",
        "nameamh": "ቤልጂየም"
    },
    {
        "id": 18,
        "name": "Belize",
        "nameamh": "ቤሊዝ"
    },
    {
        "id": 19,
        "name": "Benin",
        "nameamh": "ቤኒን"
    },
    {
        "id": 20,
        "name": "Bhutan",
        "nameamh": "ቡታን"
    },
    {
        "id": 21,
        "name": "Bolivia, Plurinational State of",
        "nameamh": "የቦሊቪያ ፕሉሪ ናሽናል ግዛት "
    },
    {
        "id": 22,
        "name": "Bosnia and Herzegovina",
        "nameamh": "ቦስኒያ እና ሔርዚጎቬኒያ"
    },
    {
        "id": 23,
        "name": "Botswana",
        "nameamh": "ቦትስዋና"
    },
    {
        "id": 24,
        "name": "Brazil",
        "nameamh": "ብራዚል"
    },
    {
        "id": 25,
        "name": "Brunei Darussalam",
        "nameamh": "ብሩኔይ ዳሩሳላም"
    },
    {
        "id": 26,
        "name": "Bulgaria",
        "nameamh": "ቡልጋሪያ"
    },
    {
        "id": 27,
        "name": "Burkina Faso",
        "nameamh": "ቡርኪናፋሶ"
    },
    {
        "id": 28,
        "name": "Burundi",
        "nameamh": "ቡሩንዲ"
    },
    {
        "id": 29,
        "name": "Cabo Verde",
        "nameamh": "ኬፕ ቨርዴ"
    },
    {
        "id": 30,
        "name": "Cambodia",
        "nameamh": "ካምቦዲያ"
    },
    {
        "id": 31,
        "name": "Cameroon",
        "nameamh": "ካሜሩን"
    },
    {
        "id": 32,
        "name": "Canada",
        "nameamh": "ካናዳ"
    },
    {
        "id": 33,
        "name": "Central African Republic",
        "nameamh": "ሴንትራል አፍሪካን ሪፐብሊክ"
    },
    {
        "id": 34,
        "name": "Chad",
        "nameamh": "ቻድ"
    },
    {
        "id": 35,
        "name": "Chile",
        "nameamh": "ቺሊ"
    },
    {
        "id": 36,
        "name": "China",
        "nameamh": "ቻይና"
    },
    {
        "id": 37,
        "name": "Colombia",
        "nameamh": "ኮሎምቢያ"
    },
    {
        "id": 38,
        "name": "Comoros",
        "nameamh": "ኮሞሮስ"
    },
    {
        "id": 39,
        "name": "Congo",
        "nameamh": "ኮንጎ"
    },
    {
        "id": 40,
        "name": "Congo, the Democratic Republic of the",
        "nameamh": "የኮንጎ ዲሞክራቲክ  ሪፐብሊክ ኮንጎ"
    },
    {
        "id": 41,
        "name": "Costa Rica",
        "nameamh": "ኮስታሪካ"
    },
    {
        "id": 42,
        "name": "Côte d'Ivoire",
        "nameamh": "ኮትዲቫር"
    },
    {
        "id": 43,
        "name": "Croatia",
        "nameamh": "ክሮዌሽያ"
    },
    {
        "id": 44,
        "name": "Cuba",
        "nameamh": "ኩባ"
    },
    {
        "id": 45,
        "name": "Cyprus",
        "nameamh": "ቆጵሮስ"
    },
    {
        "id": 46,
        "name": "Czechia",
        "nameamh": "ቼክ ሪፐብሊክ "
    },
    {
        "id": 47,
        "name": "Denmark",
        "nameamh": "ዴንማርክ"
    },
    {
        "id": 48,
        "name": "Djibouti",
        "nameamh": "ጅቡቲ"
    },
    {
        "id": 49,
        "name": "Dominica",
        "nameamh": "ዶሚኒካ"
    },
    {
        "id": 50,
        "name": "Dominican Republic",
        "nameamh": "ዶሚኒካን ሪፑብሊክ"
    },
    {
        "id": 51,
        "name": "Ecuador",
        "nameamh": "ኢኳዶር"
    },
    {
        "id": 52,
        "name": "Egypt",
        "nameamh": "ግብጽ"
    },
    {
        "id": 53,
        "name": "El Salvador",
        "nameamh": "ኤልሳቫዶር"
    },
    {
        "id": 54,
        "name": "Equatorial Guinea",
        "nameamh": "ኢኳቶሪያል ጊኒ"
    },
    {
        "id": 55,
        "name": "Eritrea",
        "nameamh": "ኤርትራ"
    },
    {
        "id": 56,
        "name": "Estonia",
        "nameamh": "ኢስቶኒያ"
    },
    {
        "id": 57,
        "name": "Ethiopian",
        "nameamh": "ኢትዮጵያዊ"
    },
    {
        "id": 58,
        "name": "Fiji",
        "nameamh": "ፊጂ"
    },
    {
        "id": 59,
        "name": "Finland",
        "nameamh": "ፊንላንድ"
    },
    {
        "id": 60,
        "name": "France",
        "nameamh": "ፈረንሳይ"
    },
    {
        "id": 61,
        "name": "Gabon",
        "nameamh": "ጋቦን"
    },
    {
        "id": 62,
        "name": "Gambia",
        "nameamh": "ጋምቢያ"
    },
    {
        "id": 63,
        "name": "Georgia",
        "nameamh": "ጆርጂያ"
    },
    {
        "id": 64,
        "name": "Germany",
        "nameamh": "ጀርመን"
    },
    {
        "id": 65,
        "name": "Ghana",
        "nameamh": "ጋና"
    },
    {
        "id": 66,
        "name": "Greece",
        "nameamh": "ግሪክ"
    },
    {
        "id": 67,
        "name": "Grenada",
        "nameamh": "ገርናዳ"
    },
    {
        "id": 68,
        "name": "Guatemala",
        "nameamh": "ጓቲማላ"
    },
    {
        "id": 69,
        "name": "Guinea",
        "nameamh": "ጊኒ"
    },
    {
        "id": 70,
        "name": "Guinea-Bissau",
        "nameamh": "ጊኒ-ቢሳው"
    },
    {
        "id": 71,
        "name": "Guyana",
        "nameamh": "ጉያና"
    },
    {
        "id": 72,
        "name": "Haiti",
        "nameamh": "ሄይቲ"
    },
    {
        "id": 73,
        "name": "Holy See (Vatican City State)",
        "nameamh": "ቫቲካን "
    },
    {
        "id": 74,
        "name": "Honduras",
        "nameamh": "ሆንዱራስ"
    },
    {
        "id": 75,
        "name": "Hungary",
        "nameamh": "ሃንጋሪ"
    },
    {
        "id": 76,
        "name": "Iceland",
        "nameamh": "አይስላንድ"
    },
    {
        "id": 77,
        "name": "India",
        "nameamh": "ሕንድ"
    },
    {
        "id": 78,
        "name": "Indonesia",
        "nameamh": "ኢንዶኔዥያ"
    },
    {
        "id": 79,
        "name": "Iran, Islamic Republic of",
        "nameamh": "ኢራን"
    },
    {
        "id": 80,
        "name": "Iraq",
        "nameamh": "ኢራቅ"
    },
    {
        "id": 81,
        "name": "Ireland",
        "nameamh": "አየርላንድ"
    },
    {
        "id": 82,
        "name": "Israel",
        "nameamh": "እስራኤል"
    },
    {
        "id": 83,
        "name": "Italy",
        "nameamh": "ጣሊያን"
    },
    {
        "id": 84,
        "name": "Jamaica",
        "nameamh": "ጃማይካ"
    },
    {
        "id": 85,
        "name": "Japan",
        "nameamh": "ጃፓን"
    },
    {
        "id": 86,
        "name": "Jordan",
        "nameamh": "ጆርዳን"
    },
    {
        "id": 87,
        "name": "Kazakhstan",
        "nameamh": "ካዛክስታን"
    },
    {
        "id": 88,
        "name": "Kenya",
        "nameamh": "ኬንያ"
    },
    {
        "id": 89,
        "name": "Kiribati",
        "nameamh": "ኪሪባቲ"
    },
    {
        "id": 90,
        "name": "Korea, Republic of",
        "nameamh": "ኮሪያ "
    },
    {
        "id": 91,
        "name": "Kuwait",
        "nameamh": "ኵዌት"
    },
    {
        "id": 92,
        "name": "Kyrgyzstan",
        "nameamh": "ከርጊስታን"
    },
    {
        "id": 93,
        "name": "Lao People's Democratic Republic",
        "nameamh": "ላኦስ"
    },
    {
        "id": 94,
        "name": "Latvia",
        "nameamh": "ላቲቪያ"
    },
    {
        "id": 95,
        "name": "Lebanon",
        "nameamh": "ሊባኖስ"
    },
    {
        "id": 96,
        "name": "Lesotho",
        "nameamh": "ሌሴቶ"
    },
    {
        "id": 97,
        "name": "Liberia",
        "nameamh": "ላይቤሪያ"
    },
    {
        "id": 98,
        "name": "Libya",
        "nameamh": "ሊቢያ"
    },
    {
        "id": 99,
        "name": "Liechtenstein",
        "nameamh": "ሊክተንጊስታይን"
    },
    {
        "id": 100,
        "name": "Lithuania",
        "nameamh": "ሊቱዌኒያ"
    },
    {
        "id": 101,
        "name": "Luxembourg",
        "nameamh": "ሉክሰምበርግ"
    },
    {
        "id": 102,
        "name": "Madagascar",
        "nameamh": "ማዳጋስካር"
    },
    {
        "id": 103,
        "name": "Malawi",
        "nameamh": "ማላዊ"
    },
    {
        "id": 104,
        "name": "Malaysia",
        "nameamh": "ማሌዥያ"
    },
    {
        "id": 105,
        "name": "Maldives",
        "nameamh": "ማልዲቬስ"
    },
    {
        "id": 106,
        "name": "Mali",
        "nameamh": "ማሊ"
    },
    {
        "id": 107,
        "name": "Malta",
        "nameamh": "ማልታ"
    },
    {
        "id": 108,
        "name": "Marshall Islands",
        "nameamh": "የማርሻል ደሴት"
    },
    {
        "id": 109,
        "name": "Mauritania",
        "nameamh": "ሞሪታኒያ"
    },
    {
        "id": 110,
        "name": "Mauritius",
        "nameamh": "ሞሪሺየስ"
    },
    {
        "id": 111,
        "name": "Mexico",
        "nameamh": "ሜክስኮ"
    },
    {
        "id": 112,
        "name": "Micronesia, Federated States of",
        "nameamh": "የማክሮኔዥያ ፌዴራል ግዛቶች"
    },
    {
        "id": 113,
        "name": "Moldova, Republic of",
        "nameamh": "የሞንዲቫ ረፐብሊክ"
    },
    {
        "id": 114,
        "name": "Monaco",
        "nameamh": "ሞናኮ"
    },
    {
        "id": 115,
        "name": "Mongolia",
        "nameamh": "ሞንጎሊያ"
    },
    {
        "id": 116,
        "name": "Montenegro",
        "nameamh": "ሞንቴኔግሮ"
    },
    {
        "id": 117,
        "name": "Morocco",
        "nameamh": "ሞሮኮ"
    },
    {
        "id": 118,
        "name": "Mozambique",
        "nameamh": "ሞዛምቢክ"
    },
    {
        "id": 119,
        "name": "Myanmar",
        "nameamh": "ሚየንማር"
    },
    {
        "id": 120,
        "name": "Namibia",
        "nameamh": "ናሚቢያ"
    },
    {
        "id": 121,
        "name": "Nauru",
        "nameamh": "ናኡሩ"
    },
    {
        "id": 122,
        "name": "Nepal",
        "nameamh": "ኔፓል"
    },
    {
        "id": 123,
        "name": "Netherlands",
        "nameamh": "ኔዘርላንድ"
    },
    {
        "id": 124,
        "name": "New Zealand",
        "nameamh": "ኒውዚላንድ"
    },
    {
        "id": 125,
        "name": "Nicaragua",
        "nameamh": "ኒካራጉአ"
    },
    {
        "id": 126,
        "name": "Niger",
        "nameamh": "ኒጀር"
    },
    {
        "id": 127,
        "name": "Nigeria",
        "nameamh": "ናይጄሪያ"
    },
    {
        "id": 128,
        "name": "North Macedonia, The Republic of",
        "nameamh": "የሰሜን ማሲዶኒያ ሪፐብሊክ"
    },
    {
        "id": 129,
        "name": "Norway",
        "nameamh": "ኖርዌይ"
    },
    {
        "id": 130,
        "name": "Oman",
        "nameamh": "ኦማን"
    },
    {
        "id": 131,
        "name": "Pakistan",
        "nameamh": "ፓኪስታን"
    },
    {
        "id": 132,
        "name": "Palau",
        "nameamh": "ፓላው"
    },
    {
        "id": 133,
        "name": "Palestine, State of",
        "nameamh": "የፍልስጤም ግዛት"
    },
    {
        "id": 134,
        "name": "Panama",
        "nameamh": "ፓናማ"
    },
    {
        "id": 135,
        "name": "Papua New Guinea",
        "nameamh": "ጊኒ"
    },
    {
        "id": 136,
        "name": "Paraguay",
        "nameamh": "ፓራጓይ"
    },
    {
        "id": 137,
        "name": "Peru",
        "nameamh": "ፔሩ"
    },
    {
        "id": 138,
        "name": "Philippines",
        "nameamh": "ፊሊፒንስ"
    },
    {
        "id": 139,
        "name": "Poland",
        "nameamh": "ፖላንድ"
    },
    {
        "id": 140,
        "name": "Portugal",
        "nameamh": "ፖርቹጋል"
    },
    {
        "id": 141,
        "name": "Qatar",
        "nameamh": "ኳታር"
    },
    {
        "id": 142,
        "name": "Romania",
        "nameamh": "ሮማኒያ"
    },
    {
        "id": 143,
        "name": "Russian Federation",
        "nameamh": "የሩሲያ ፌዴሬሽን"
    },
    {
        "id": 144,
        "name": "Rwanda",
        "nameamh": "ሩዋንዳ"
    },
    {
        "id": 145,
        "name": "Saint Kitts and Nevis",
        "nameamh": "ሴይንት ኪትስ እና ኔቪስ"
    },
    {
        "id": 146,
        "name": "Saint Lucia",
        "nameamh": "ሴይንት ሉካስ"
    },
    {
        "id": 147,
        "name": "Saint Vincent and the Grenadines",
        "nameamh": "ሴይንት ቪንሴንት እና ጀሬናዲኔስ"
    },
    {
        "id": 148,
        "name": "Samoa",
        "nameamh": "ሳሞአ"
    },
    {
        "id": 149,
        "name": "San Marino",
        "nameamh": "ሳን ማሪኖ"
    },
    {
        "id": 150,
        "name": "Sao Tome and Principe",
        "nameamh": "ሳኦ ቶሜ እና ፕሪንስፔ"
    },
    {
        "id": 151,
        "name": "Saudi Arabia",
        "nameamh": "ሳውዲ ዓረቢያ"
    },
    {
        "id": 152,
        "name": "Senegal",
        "nameamh": "ሴኔጋል"
    },
    {
        "id": 153,
        "name": "Serbia",
        "nameamh": "ሴርቢያ"
    },
    {
        "id": 154,
        "name": "Seychelles",
        "nameamh": "ሲሼልስ"
    },
    {
        "id": 155,
        "name": "Sierra Leone",
        "nameamh": "ሴራሊዮን"
    },
    {
        "id": 156,
        "name": "Singapore",
        "nameamh": "ሲንጋፖር"
    },
    {
        "id": 157,
        "name": "Slovakia",
        "nameamh": "ስሎቫኪያ"
    },
    {
        "id": 158,
        "name": "Slovenia",
        "nameamh": "ስሎቫኒያ"
    },
    {
        "id": 159,
        "name": "Solomon Islands",
        "nameamh": "የሰሎሞን ደሴቶች"
    },
    {
        "id": 160,
        "name": "Somalia",
        "nameamh": "ሶማሊያ"
    },
    {
        "id": 161,
        "name": "South Africa",
        "nameamh": "ደቡብ አፍሪካ"
    },
    {
        "id": 162,
        "name": "South Sudan",
        "nameamh": "ደቡብ ሱዳን"
    },
    {
        "id": 163,
        "name": "Spain",
        "nameamh": "እስፔን"
    },
    {
        "id": 164,
        "name": "Sri Lanka",
        "nameamh": "ሲሪላንካ"
    },
    {
        "id": 165,
        "name": "Sudan",
        "nameamh": "ሱዳን"
    },
    {
        "id": 166,
        "name": "Suriname",
        "nameamh": "ሱሪናሜ"
    },
    {
        "id": 167,
        "name": "Swaziland",
        "nameamh": "ስዋዚላንድ"
    },
    {
        "id": 168,
        "name": "Sweden",
        "nameamh": "ስዊዲን"
    },
    {
        "id": 169,
        "name": "Switzerland",
        "nameamh": "ስዊዘርላንድ"
    },
    {
        "id": 170,
        "name": "Syrian Arab Republic",
        "nameamh": "የሶሪያ አረብ ሪፐብሊክ"
    },
    {
        "id": 171,
        "name": "Taiwan, Province of China",
        "nameamh": "ታይዋን"
    },
    {
        "id": 172,
        "name": "Tajikistan",
        "nameamh": "ታጂኪስታን"
    },
    {
        "id": 173,
        "name": "Tanzania, United Republic of",
        "nameamh": "ታንዛኒያ"
    },
    {
        "id": 174,
        "name": "Thailand",
        "nameamh": "ታይላንድ"
    },
    {
        "id": 175,
        "name": "Timor-Leste",
        "nameamh": "ቲሞር-ሌስቴ"
    },
    {
        "id": 176,
        "name": "Togo",
        "nameamh": "ቶጎ"
    },
    {
        "id": 177,
        "name": "Tonga",
        "nameamh": "ቶንጋ"
    },
    {
        "id": 178,
        "name": "Trinidad and Tobago",
        "nameamh": "ትሪኒዳድ እና ቶባጎ"
    },
    {
        "id": 179,
        "name": "Tunisia",
        "nameamh": "ቱንዚያ"
    },
    {
        "id": 180,
        "name": "Turkey",
        "nameamh": "ቱርክ"
    },
    {
        "id": 181,
        "name": "Turkmenistan",
        "nameamh": "ቱርክሜኒስታን"
    },
    {
        "id": 182,
        "name": "Tuvalu",
        "nameamh": "ቱቫሉ"
    },
    {
        "id": 183,
        "name": "Uganda",
        "nameamh": "ኡጋንዳ"
    },
    {
        "id": 184,
        "name": "Ukraine",
        "nameamh": "ዩክሬን"
    },
    {
        "id": 185,
        "name": "Undetermined",
        "nameamh": "ያልታወቀ"
    },
    {
        "id": 186,
        "name": "United Arab Emirates",
        "nameamh": "ዩናይትድ ዓረብ ኤምሬት"
    },
    {
        "id": 187,
        "name": "United Kingdom",
        "nameamh": "እንግሊዝ"
    },
    {
        "id": 188,
        "name": "United States",
        "nameamh": "አሜሪካ"
    },
    {
        "id": 189,
        "name": "Uruguay",
        "nameamh": "ኡራጓይ"
    },
    {
        "id": 190,
        "name": "Uzbekistan",
        "nameamh": "ኡዝቤክስታን"
    },
    {
        "id": 191,
        "name": "Vanuatu",
        "nameamh": "ቫኑአቱ"
    },
    {
        "id": 192,
        "name": "Venezuela, Bolivarian Republic of",
        "nameamh": "ቬንዙዌላ"
    },
    {
        "id": 193,
        "name": "Viet Nam",
        "nameamh": "ቬየትናም"
    },
    {
        "id": 194,
        "name": "Western Sahara",
        "nameamh": "ምዕራባዊ ሳሃራ"
    },
    {
        "id": 195,
        "name": "Yemen",
        "nameamh": "የመን"
    },
    {
        "id": 196,
        "name": "Zambia",
        "nameamh": "ዛምቢያ"
    },
    {
        "id": 197,
        "name": "Zimbabwe",
        "nameamh": "ዝምባቡዌ"
    }
]
export const localLocationData = [
    {
        "regionCode": "ZZ00000000",
        "regionEng": "-",
        "regionAmh": "-",
        "zones": [
            {
                "zoneCode": "ZZUNK80000",
                "zoneEng": "-",
                "zoneAmh": "-",
                "woredas": [
                    {
                        "woredaCode": "ZZUNK8ALM1",
                        "woredaEng": "Alamata City Administration",
                        "woredaAmh": "አላማጣ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "ZZUNK8AWR0",
                        "woredaEng": "Awura",
                        "woredaAmh": "ኣዉራ"
                    },
                    {
                        "woredaCode": "ZZUNK8BEM1",
                        "woredaEng": "Bet Molo City Administration",
                        "woredaAmh": "ቤት ሞሎ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "ZZUNK8DNS1",
                        "woredaEng": "Dansha City Administration",
                        "woredaAmh": "ዳንሻ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "ZZUNK8KAH0",
                        "woredaEng": "Kabtia Humera",
                        "woredaAmh": "ቃብቲያ ሁመራ"
                    },
                    {
                        "woredaCode": "ZZUNK8KAB0",
                        "woredaEng": "Kafta Humera",
                        "woredaAmh": "ቃፍታ ሑመራ"
                    },
                    {
                        "woredaCode": "ZZUNK8KRR1",
                        "woredaEng": "Korarit City Administration",
                        "woredaAmh": "ቆራሪት ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "ZZUNK8KRM1",
                        "woredaEng": "Korem City Administration",
                        "woredaAmh": "ኮረም ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "ZZUNK8MKD1",
                        "woredaEng": "Maikadra City Administration",
                        "woredaAmh": "ማይካድራ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "ZZUNK8MYG2",
                        "woredaEng": "Maygaba Town",
                        "woredaAmh": "ማይጋባ ከተማ"
                    },
                    {
                        "woredaCode": "ZZUNK8MYB2",
                        "woredaEng": "Maytebri Town",
                        "woredaAmh": "ማይጠብሪ ከተማ"
                    },
                    {
                        "woredaCode": "ZZUNK8MYT2",
                        "woredaEng": "Maytsebri Town",
                        "woredaAmh": "ማይፀብሪ ከተማ"
                    },
                    {
                        "woredaCode": "ZZUNK8OFL0",
                        "woredaEng": "Ofla",
                        "woredaAmh": "ኦፍላ"
                    },
                    {
                        "woredaCode": "ZZUNK8RAA0",
                        "woredaEng": "Raya Alamata",
                        "woredaAmh": "ራያ አላማጣ"
                    },
                    {
                        "woredaCode": "ZZUNK8RAB0",
                        "woredaEng": "Raya Bala",
                        "woredaAmh": "ራያ ባላ"
                    },
                    {
                        "woredaCode": "ZZUNK8SEH1",
                        "woredaEng": "Setit Humera City Administration",
                        "woredaAmh": "ሰቲት ሁመራ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "ZZUNK8TGD0",
                        "woredaEng": "Tegede",
                        "woredaAmh": "ጠገዴ"
                    },
                    {
                        "woredaCode": "ZZUNK8TSG0",
                        "woredaEng": "Tsegede",
                        "woredaAmh": "ፀገዴ"
                    },
                    {
                        "woredaCode": "ZZUNK8WLK0",
                        "woredaEng": "Welkayit",
                        "woredaAmh": "ወልቃይት"
                    },
                    {
                        "woredaCode": "ZZUNK8ZAT0",
                        "woredaEng": "Zata",
                        "woredaAmh": "ዛታ"
                    }
                ]
            }
        ]
    },
    {
        "regionCode": "AA00000000",
        "regionEng": "Addis Ababa",
        "regionAmh": "አዲስ አበባ",
        "zones": [
            {
                "zoneCode": "AAADK30000",
                "zoneEng": "Addis Ketema",
                "zoneAmh": "አዲስ ከተማ",
                "woredas": [
                    {
                        "woredaCode": "AAADK3W016",
                        "woredaEng": "Woreda 1",
                        "woredaAmh": "ወረዳ 1"
                    },
                    {
                        "woredaCode": "AAADK3W106",
                        "woredaEng": "Woreda 10",
                        "woredaAmh": "ወረዳ 10"
                    },
                    {
                        "woredaCode": "AAADK3W116",
                        "woredaEng": "Woreda 11",
                        "woredaAmh": "ወረዳ 11"
                    },
                    {
                        "woredaCode": "AAADK3W126",
                        "woredaEng": "Woreda 12",
                        "woredaAmh": "ወረዳ 12"
                    },
                    {
                        "woredaCode": "AAADK3W136",
                        "woredaEng": "Woreda 13",
                        "woredaAmh": "ወረዳ 13"
                    },
                    {
                        "woredaCode": "AAADK3W146",
                        "woredaEng": "Woreda 14",
                        "woredaAmh": "ወረዳ 14"
                    },
                    {
                        "woredaCode": "AAADK3W036",
                        "woredaEng": "Woreda 3",
                        "woredaAmh": "ወረዳ 3"
                    },
                    {
                        "woredaCode": "AAADK3W046",
                        "woredaEng": "Woreda 4",
                        "woredaAmh": "ወረዳ 4"
                    },
                    {
                        "woredaCode": "AAADK3W056",
                        "woredaEng": "Woreda 5",
                        "woredaAmh": "ወረዳ 5"
                    },
                    {
                        "woredaCode": "AAADK3W066",
                        "woredaEng": "Woreda 6",
                        "woredaAmh": "ወረዳ 6"
                    },
                    {
                        "woredaCode": "AAADK3W086",
                        "woredaEng": "Woreda 8",
                        "woredaAmh": "ወረዳ 8"
                    },
                    {
                        "woredaCode": "AAADK3W096",
                        "woredaEng": "Woreda 9",
                        "woredaAmh": "ወረዳ 9"
                    }
                ]
            },
            {
                "zoneCode": "AAAKK30000",
                "zoneEng": "Akaki Kality",
                "zoneAmh": "አቃቂ ቃሊቲ",
                "woredas": [
                    {
                        "woredaCode": "AAAKK3W016",
                        "woredaEng": "Woreda 1",
                        "woredaAmh": "ወረዳ 1"
                    },
                    {
                        "woredaCode": "AAAKK3W106",
                        "woredaEng": "Woreda 10",
                        "woredaAmh": "ወረዳ 10"
                    },
                    {
                        "woredaCode": "AAAKK3W126",
                        "woredaEng": "Woreda 12",
                        "woredaAmh": "ወረዳ 12"
                    },
                    {
                        "woredaCode": "AAAKK3W136",
                        "woredaEng": "Woreda 13",
                        "woredaAmh": "ወረዳ 13"
                    },
                    {
                        "woredaCode": "AAAKK3W026",
                        "woredaEng": "Woreda 2",
                        "woredaAmh": "ወረዳ 2"
                    },
                    {
                        "woredaCode": "AAAKK3W036",
                        "woredaEng": "Woreda 3",
                        "woredaAmh": "ወረዳ 3"
                    },
                    {
                        "woredaCode": "AAAKK3W046",
                        "woredaEng": "Woreda 4",
                        "woredaAmh": "ወረዳ 4"
                    },
                    {
                        "woredaCode": "AAAKK3W056",
                        "woredaEng": "Woreda 5",
                        "woredaAmh": "ወረዳ 5"
                    },
                    {
                        "woredaCode": "AAAKK3W066",
                        "woredaEng": "Woreda 6",
                        "woredaAmh": "ወረዳ 6"
                    },
                    {
                        "woredaCode": "AAAKK3W076",
                        "woredaEng": "Woreda 7",
                        "woredaAmh": "ወረዳ 7"
                    },
                    {
                        "woredaCode": "AAAKK3W086",
                        "woredaEng": "Woreda 8",
                        "woredaAmh": "ወረዳ 8"
                    },
                    {
                        "woredaCode": "AAAKK3W096",
                        "woredaEng": "Woreda 9",
                        "woredaAmh": "ወረዳ 9"
                    }
                ]
            },
            {
                "zoneCode": "AAARD30000",
                "zoneEng": "Arada",
                "zoneAmh": "አራዳ",
                "woredas": [
                    {
                        "woredaCode": "AAARD3W016",
                        "woredaEng": "Woreda 1",
                        "woredaAmh": "ወረዳ 1"
                    },
                    {
                        "woredaCode": "AAARD3W026",
                        "woredaEng": "Woreda 2",
                        "woredaAmh": "ወረዳ 2"
                    },
                    {
                        "woredaCode": "AAARD3W046",
                        "woredaEng": "Woreda 4",
                        "woredaAmh": "ወረዳ 4"
                    },
                    {
                        "woredaCode": "AAARD3W056",
                        "woredaEng": "Woreda 5",
                        "woredaAmh": "ወረዳ 5"
                    },
                    {
                        "woredaCode": "AAARD3W066",
                        "woredaEng": "Woreda 6",
                        "woredaAmh": "ወረዳ 6"
                    },
                    {
                        "woredaCode": "AAARD3W076",
                        "woredaEng": "Woreda 7",
                        "woredaAmh": "ወረዳ 7"
                    },
                    {
                        "woredaCode": "AAARD3W086",
                        "woredaEng": "Woreda 8",
                        "woredaAmh": "ወረዳ 8"
                    },
                    {
                        "woredaCode": "AAARD3W096",
                        "woredaEng": "Woreda 9",
                        "woredaAmh": "ወረዳ 9"
                    }
                ]
            },
            {
                "zoneCode": "AABOL30000",
                "zoneEng": "Bole",
                "zoneAmh": "ቦሌ",
                "woredas": [
                    {
                        "woredaCode": "AABOL3W016",
                        "woredaEng": "Woreda 1",
                        "woredaAmh": "ወረዳ 1"
                    },
                    {
                        "woredaCode": "AABOL3W116",
                        "woredaEng": "Woreda 11",
                        "woredaAmh": "ወረዳ 11"
                    },
                    {
                        "woredaCode": "AABOL3W126",
                        "woredaEng": "Woreda 12",
                        "woredaAmh": "ወረዳ 12"
                    },
                    {
                        "woredaCode": "AABOL3W136",
                        "woredaEng": "Woreda 13",
                        "woredaAmh": "ወረዳ 13"
                    },
                    {
                        "woredaCode": "AABOL3W146",
                        "woredaEng": "Woreda 14",
                        "woredaAmh": "ወረዳ 14"
                    },
                    {
                        "woredaCode": "AABOL3W026",
                        "woredaEng": "Woreda 2",
                        "woredaAmh": "ወረዳ 2"
                    },
                    {
                        "woredaCode": "AABOL3W036",
                        "woredaEng": "Woreda 3",
                        "woredaAmh": "ወረዳ 3"
                    },
                    {
                        "woredaCode": "AABOL3W046",
                        "woredaEng": "Woreda 4",
                        "woredaAmh": "ወረዳ 4"
                    },
                    {
                        "woredaCode": "AABOL3W056",
                        "woredaEng": "Woreda 5",
                        "woredaAmh": "ወረዳ 5"
                    },
                    {
                        "woredaCode": "AABOL3W066",
                        "woredaEng": "Woreda 6",
                        "woredaAmh": "ወረዳ 6"
                    },
                    {
                        "woredaCode": "AABOL3W076",
                        "woredaEng": "Woreda 7",
                        "woredaAmh": "ወረዳ 7"
                    }
                ]
            },
            {
                "zoneCode": "AAGLL30000",
                "zoneEng": "Gullele",
                "zoneAmh": "ጉለሌ",
                "woredas": [
                    {
                        "woredaCode": "AAGLL3W016",
                        "woredaEng": "Woreda 1",
                        "woredaAmh": "ወረዳ 1"
                    },
                    {
                        "woredaCode": "AAGLL3W106",
                        "woredaEng": "Woreda 10",
                        "woredaAmh": "ወረዳ 10"
                    },
                    {
                        "woredaCode": "AAGLL3W026",
                        "woredaEng": "Woreda 2",
                        "woredaAmh": "ወረዳ 2"
                    },
                    {
                        "woredaCode": "AAGLL3W036",
                        "woredaEng": "Woreda 3",
                        "woredaAmh": "ወረዳ 3"
                    },
                    {
                        "woredaCode": "AAGLL3W046",
                        "woredaEng": "Woreda 4",
                        "woredaAmh": "ወረዳ 4"
                    },
                    {
                        "woredaCode": "AAGLL3W056",
                        "woredaEng": "Woreda 5",
                        "woredaAmh": "ወረዳ 5"
                    },
                    {
                        "woredaCode": "AAGLL3W066",
                        "woredaEng": "Woreda 6",
                        "woredaAmh": "ወረዳ 6"
                    },
                    {
                        "woredaCode": "AAGLL3W076",
                        "woredaEng": "Woreda 7",
                        "woredaAmh": "ወረዳ 7"
                    },
                    {
                        "woredaCode": "AAGLL3W086",
                        "woredaEng": "Woreda 8",
                        "woredaAmh": "ወረዳ 8"
                    },
                    {
                        "woredaCode": "AAGLL3W096",
                        "woredaEng": "Woreda 9",
                        "woredaAmh": "ወረዳ 9"
                    }
                ]
            },
            {
                "zoneCode": "AAKRK30000",
                "zoneEng": "Kirkos",
                "zoneAmh": "ቂርቆስ",
                "woredas": [
                    {
                        "woredaCode": "AAKRK3W016",
                        "woredaEng": "Woreda 1",
                        "woredaAmh": "ወረዳ 1"
                    },
                    {
                        "woredaCode": "AAKRK3W106",
                        "woredaEng": "Woreda 10",
                        "woredaAmh": "ወረዳ 10"
                    },
                    {
                        "woredaCode": "AAKRK3W116",
                        "woredaEng": "Woreda 11",
                        "woredaAmh": "ወረዳ 11"
                    },
                    {
                        "woredaCode": "AAKRK3W026",
                        "woredaEng": "Woreda 2",
                        "woredaAmh": "ወረዳ 2"
                    },
                    {
                        "woredaCode": "AAKRK3W036",
                        "woredaEng": "Woreda 3",
                        "woredaAmh": "ወረዳ 3"
                    },
                    {
                        "woredaCode": "AAKRK3W046",
                        "woredaEng": "Woreda 4",
                        "woredaAmh": "ወረዳ 4"
                    },
                    {
                        "woredaCode": "AAKRK3W056",
                        "woredaEng": "Woreda 5",
                        "woredaAmh": "ወረዳ 5"
                    },
                    {
                        "woredaCode": "AAKRK3W076",
                        "woredaEng": "Woreda 7",
                        "woredaAmh": "ወረዳ 7"
                    },
                    {
                        "woredaCode": "AAKRK3W086",
                        "woredaEng": "Woreda 8",
                        "woredaAmh": "ወረዳ 8"
                    },
                    {
                        "woredaCode": "AAKRK3W096",
                        "woredaEng": "Woreda 9",
                        "woredaAmh": "ወረዳ 9"
                    }
                ]
            },
            {
                "zoneCode": "AAKOK30000",
                "zoneEng": "Kolfe Keranio",
                "zoneAmh": "ኮልፌ ቀራኒዮ",
                "woredas": [
                    {
                        "woredaCode": "AAKOK3W016",
                        "woredaEng": "Woreda 1",
                        "woredaAmh": "ወረዳ 1"
                    },
                    {
                        "woredaCode": "AAKOK3W106",
                        "woredaEng": "Woreda 10",
                        "woredaAmh": "ወረዳ 10"
                    },
                    {
                        "woredaCode": "AAKOK3W116",
                        "woredaEng": "Woreda 11",
                        "woredaAmh": "ወረዳ 11"
                    },
                    {
                        "woredaCode": "AAKOK3W026",
                        "woredaEng": "Woreda 2",
                        "woredaAmh": "ወረዳ 2"
                    },
                    {
                        "woredaCode": "AAKOK3W036",
                        "woredaEng": "Woreda 3",
                        "woredaAmh": "ወረዳ 3"
                    },
                    {
                        "woredaCode": "AAKOK3W046",
                        "woredaEng": "Woreda 4",
                        "woredaAmh": "ወረዳ 4"
                    },
                    {
                        "woredaCode": "AAKOK3W056",
                        "woredaEng": "Woreda 5",
                        "woredaAmh": "ወረዳ 5"
                    },
                    {
                        "woredaCode": "AAKOK3W066",
                        "woredaEng": "Woreda 6",
                        "woredaAmh": "ወረዳ 6"
                    },
                    {
                        "woredaCode": "AAKOK3W076",
                        "woredaEng": "Woreda 7",
                        "woredaAmh": "ወረዳ 7"
                    },
                    {
                        "woredaCode": "AAKOK3W086",
                        "woredaEng": "Woreda 8",
                        "woredaAmh": "ወረዳ 8"
                    },
                    {
                        "woredaCode": "AAKOK3W096",
                        "woredaEng": "Woreda 9",
                        "woredaAmh": "ወረዳ 9"
                    }
                ]
            },
            {
                "zoneCode": "AALEK30000",
                "zoneEng": "Lemi Kura",
                "zoneAmh": "ለሚ ኩራ",
                "woredas": [
                    {
                        "woredaCode": "AALEK3W106",
                        "woredaEng": "Woreda 10",
                        "woredaAmh": "ወረዳ 10"
                    },
                    {
                        "woredaCode": "AALEK3W136",
                        "woredaEng": "Woreda 13",
                        "woredaAmh": "ወረዳ 13"
                    },
                    {
                        "woredaCode": "AALEK3W146",
                        "woredaEng": "Woreda 14",
                        "woredaAmh": "ወረዳ 14"
                    },
                    {
                        "woredaCode": "AALEK3W026",
                        "woredaEng": "Woreda 2",
                        "woredaAmh": "ወረዳ 2"
                    },
                    {
                        "woredaCode": "AALEK3W036",
                        "woredaEng": "Woreda 3",
                        "woredaAmh": "ወረዳ 3"
                    },
                    {
                        "woredaCode": "AALEK3W046",
                        "woredaEng": "Woreda 4",
                        "woredaAmh": "ወረዳ 4"
                    },
                    {
                        "woredaCode": "AALEK3W056",
                        "woredaEng": "Woreda 5",
                        "woredaAmh": "ወረዳ 5"
                    },
                    {
                        "woredaCode": "AALEK3W066",
                        "woredaEng": "Woreda 6",
                        "woredaAmh": "ወረዳ 6"
                    },
                    {
                        "woredaCode": "AALEK3W086",
                        "woredaEng": "Woreda 8",
                        "woredaAmh": "ወረዳ 8"
                    },
                    {
                        "woredaCode": "AALEK3W096",
                        "woredaEng": "Woreda 9",
                        "woredaAmh": "ወረዳ 9"
                    }
                ]
            },
            {
                "zoneCode": "AALDT30000",
                "zoneEng": "Lideta",
                "zoneAmh": "ልደታ",
                "woredas": [
                    {
                        "woredaCode": "AALDT3W016",
                        "woredaEng": "Woreda 1",
                        "woredaAmh": "ወረዳ 1"
                    },
                    {
                        "woredaCode": "AALDT3W106",
                        "woredaEng": "Woreda 10",
                        "woredaAmh": "ወረዳ 10"
                    },
                    {
                        "woredaCode": "AALDT3W026",
                        "woredaEng": "Woreda 2",
                        "woredaAmh": "ወረዳ 2"
                    },
                    {
                        "woredaCode": "AALDT3W036",
                        "woredaEng": "Woreda 3",
                        "woredaAmh": "ወረዳ 3"
                    },
                    {
                        "woredaCode": "AALDT3W046",
                        "woredaEng": "Woreda 4",
                        "woredaAmh": "ወረዳ 4"
                    },
                    {
                        "woredaCode": "AALDT3W056",
                        "woredaEng": "Woreda 5",
                        "woredaAmh": "ወረዳ 5"
                    },
                    {
                        "woredaCode": "AALDT3W066",
                        "woredaEng": "Woreda 6",
                        "woredaAmh": "ወረዳ 6"
                    },
                    {
                        "woredaCode": "AALDT3W076",
                        "woredaEng": "Woreda 7",
                        "woredaAmh": "ወረዳ 7"
                    },
                    {
                        "woredaCode": "AALDT3W086",
                        "woredaEng": "Woreda 8",
                        "woredaAmh": "ወረዳ 8"
                    },
                    {
                        "woredaCode": "AALDT3W096",
                        "woredaEng": "Woreda 9",
                        "woredaAmh": "ወረዳ 9"
                    }
                ]
            },
            {
                "zoneCode": "AANSL30000",
                "zoneEng": "Nifas Silk-Lafto",
                "zoneAmh": "ንፋስ ስልክ ላፍቶ",
                "woredas": [
                    {
                        "woredaCode": "AANSL3W016",
                        "woredaEng": "Woreda 1",
                        "woredaAmh": "ወረዳ 1"
                    },
                    {
                        "woredaCode": "AANSL3W106",
                        "woredaEng": "Woreda 10",
                        "woredaAmh": "ወረዳ 10"
                    },
                    {
                        "woredaCode": "AANSL3W116",
                        "woredaEng": "Woreda 11",
                        "woredaAmh": "ወረዳ 11"
                    },
                    {
                        "woredaCode": "AANSL3W126",
                        "woredaEng": "Woreda 12",
                        "woredaAmh": "ወረዳ 12"
                    },
                    {
                        "woredaCode": "AANSL3W136",
                        "woredaEng": "Woreda 13",
                        "woredaAmh": "ወረዳ 13"
                    },
                    {
                        "woredaCode": "AANSL3W146",
                        "woredaEng": "Woreda 14",
                        "woredaAmh": "ወረዳ 14"
                    },
                    {
                        "woredaCode": "AANSL3W156",
                        "woredaEng": "Woreda 15",
                        "woredaAmh": "ወረዳ 15"
                    },
                    {
                        "woredaCode": "AANSL3W026",
                        "woredaEng": "Woreda 2",
                        "woredaAmh": "ወረዳ 2"
                    },
                    {
                        "woredaCode": "AANSL3W056",
                        "woredaEng": "Woreda 5",
                        "woredaAmh": "ወረዳ 5"
                    },
                    {
                        "woredaCode": "AANSL3W066",
                        "woredaEng": "Woreda 6",
                        "woredaAmh": "ወረዳ 6"
                    },
                    {
                        "woredaCode": "AANSL3W076",
                        "woredaEng": "Woreda 7",
                        "woredaAmh": "ወረዳ 7"
                    },
                    {
                        "woredaCode": "AANSL3W086",
                        "woredaEng": "Woreda 8",
                        "woredaAmh": "ወረዳ 8"
                    },
                    {
                        "woredaCode": "AANSL3W096",
                        "woredaEng": "Woreda 9",
                        "woredaAmh": "ወረዳ 9"
                    }
                ]
            },
            {
                "zoneCode": "AAYEK30000",
                "zoneEng": "Yeka",
                "zoneAmh": "የካ",
                "woredas": [
                    {
                        "woredaCode": "AAYEK3W016",
                        "woredaEng": "Woreda 1",
                        "woredaAmh": "ወረዳ 1"
                    },
                    {
                        "woredaCode": "AAYEK3W106",
                        "woredaEng": "Woreda 10",
                        "woredaAmh": "ወረዳ 10"
                    },
                    {
                        "woredaCode": "AAYEK3W116",
                        "woredaEng": "Woreda 11",
                        "woredaAmh": "ወረዳ 11"
                    },
                    {
                        "woredaCode": "AAYEK3W126",
                        "woredaEng": "Woreda 12",
                        "woredaAmh": "ወረዳ 12"
                    },
                    {
                        "woredaCode": "AAYEK3W026",
                        "woredaEng": "Woreda 2",
                        "woredaAmh": "ወረዳ 2"
                    },
                    {
                        "woredaCode": "AAYEK3W036",
                        "woredaEng": "Woreda 3",
                        "woredaAmh": "ወረዳ 3"
                    },
                    {
                        "woredaCode": "AAYEK3W046",
                        "woredaEng": "Woreda 4",
                        "woredaAmh": "ወረዳ 4"
                    },
                    {
                        "woredaCode": "AAYEK3W056",
                        "woredaEng": "Woreda 5",
                        "woredaAmh": "ወረዳ 5"
                    },
                    {
                        "woredaCode": "AAYEK3W066",
                        "woredaEng": "Woreda 6",
                        "woredaAmh": "ወረዳ 6"
                    },
                    {
                        "woredaCode": "AAYEK3W076",
                        "woredaEng": "Woreda 7",
                        "woredaAmh": "ወረዳ 7"
                    },
                    {
                        "woredaCode": "AAYEK3W086",
                        "woredaEng": "Woreda 8",
                        "woredaAmh": "ወረዳ 8"
                    },
                    {
                        "woredaCode": "AAYEK3W096",
                        "woredaEng": "Woreda 9",
                        "woredaAmh": "ወረዳ 9"
                    }
                ]
            }
        ]
    },
    {
        "regionCode": "AF00000000",
        "regionEng": "Afar",
        "regionAmh": "አፋር",
        "zones": [
            {
                "zoneCode": "AFAWR00000",
                "zoneEng": "Awsi Rasu",
                "zoneAmh": "አውሲ ራሱ",
                "woredas": [
                    {
                        "woredaCode": "AFAWR0ADA0",
                        "woredaEng": "Ada'Ar",
                        "woredaAmh": "አዳአር"
                    },
                    {
                        "woredaCode": "AFAWR0AFM0",
                        "woredaEng": "Afambo",
                        "woredaAmh": "አፋምቦ"
                    },
                    {
                        "woredaCode": "AFAWR0ASY0",
                        "woredaEng": "Asayita",
                        "woredaAmh": "አይሳኢታ"
                    },
                    {
                        "woredaCode": "AFAWR0ASY1",
                        "woredaEng": "Asayita City Administration",
                        "woredaAmh": "አይሳኢታ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "AFAWR0CHF0",
                        "woredaEng": "Chifra",
                        "woredaAmh": "ጭፍራ"
                    },
                    {
                        "woredaCode": "AFAWR0CHF1",
                        "woredaEng": "Chifra City Administration",
                        "woredaAmh": "ጭፍራ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "AFAWR0DBT0",
                        "woredaEng": "Dubti",
                        "woredaAmh": "ዱብቲ"
                    },
                    {
                        "woredaCode": "AFAWR0DBT1",
                        "woredaEng": "Dubti City Administration",
                        "woredaAmh": "ዱብቲ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "AFAWR0ELD0",
                        "woredaEng": "Elidar",
                        "woredaAmh": "ኤሊዳአር"
                    },
                    {
                        "woredaCode": "AFAWR0KOR0",
                        "woredaEng": "Kori",
                        "woredaAmh": "ኮሪ"
                    },
                    {
                        "woredaCode": "AFAWR0MLL0",
                        "woredaEng": "Mille",
                        "woredaAmh": "ሚሌ"
                    },
                    {
                        "woredaCode": "AFAWR0MLL1",
                        "woredaEng": "Mille City Administration",
                        "woredaAmh": "ሚሌ ከተማ አስተዳደር"
                    }
                ]
            },
            {
                "zoneCode": "AFFAR00000",
                "zoneEng": "Fanti Rasu",
                "zoneAmh": "ፋንቲ ራሱ",
                "woredas": [
                    {
                        "woredaCode": "AFFAR0AUR0",
                        "woredaEng": "Aura",
                        "woredaAmh": "አዉራ"
                    },
                    {
                        "woredaCode": "AFFAR0EWA0",
                        "woredaEng": "Ewa",
                        "woredaAmh": "ኡዋ"
                    },
                    {
                        "woredaCode": "AFFAR0GLN0",
                        "woredaEng": "Golina",
                        "woredaAmh": "ጎሊና"
                    },
                    {
                        "woredaCode": "AFFAR0MBY0",
                        "woredaEng": "Mebay",
                        "woredaAmh": "መባይ"
                    },
                    {
                        "woredaCode": "AFFAR0TER0",
                        "woredaEng": "Teru",
                        "woredaAmh": "ቴሩ"
                    },
                    {
                        "woredaCode": "AFFAR0YAL0",
                        "woredaEng": "Yalo",
                        "woredaAmh": "ያሎ"
                    }
                ]
            },
            {
                "zoneCode": "AFGAR00000",
                "zoneEng": "Gabi Rasu",
                "zoneAmh": "ጋቢ ራሱ",
                "woredas": [
                    {
                        "woredaCode": "AFGAR0ABD0",
                        "woredaEng": "Abida",
                        "woredaAmh": "ዓቢዳ"
                    },
                    {
                        "woredaCode": "AFGAR0AMB0",
                        "woredaEng": "Amibara",
                        "woredaAmh": "አሚባራ"
                    },
                    {
                        "woredaCode": "AFGAR0ARG0",
                        "woredaEng": "Argoba",
                        "woredaAmh": "አርጎባ"
                    },
                    {
                        "woredaCode": "AFGAR0AWS1",
                        "woredaEng": "Awash City Administration",
                        "woredaAmh": "አዋሽ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "AFGAR0AWF0",
                        "woredaEng": "Awash Fentale",
                        "woredaAmh": "አዋሽ ፈንቲአሌ"
                    },
                    {
                        "woredaCode": "AFGAR0BRM0",
                        "woredaEng": "Burimodayto",
                        "woredaAmh": "ቡሪሞዳይቶ"
                    },
                    {
                        "woredaCode": "AFGAR0DLL0",
                        "woredaEng": "Dulilasa",
                        "woredaAmh": "ዱልላሳ"
                    },
                    {
                        "woredaCode": "AFGAR0GLL0",
                        "woredaEng": "Gelalo",
                        "woredaAmh": "ገላእሎ"
                    },
                    {
                        "woredaCode": "AFGAR0GWN0",
                        "woredaEng": "Gewane",
                        "woredaAmh": "ገዋኔ"
                    },
                    {
                        "woredaCode": "AFGAR0HNR0",
                        "woredaEng": "Hanruka",
                        "woredaAmh": "ሀንሩካ"
                    },
                    {
                        "woredaCode": "AFGAR0WRR1",
                        "woredaEng": "Werer City Administration",
                        "woredaAmh": "ወረር ከተማ አስተዳደር"
                    }
                ]
            },
            {
                "zoneCode": "AFHAR00000",
                "zoneEng": "Hari Rasu",
                "zoneAmh": "ሀሪ ራሱ",
                "woredas": [
                    {
                        "woredaCode": "AFHAR0DLF0",
                        "woredaEng": "Dalifage",
                        "woredaAmh": "ዳሊፋጌ"
                    },
                    {
                        "woredaCode": "AFHAR0DEW0",
                        "woredaEng": "Dewe",
                        "woredaAmh": "ደዌ"
                    },
                    {
                        "woredaCode": "AFHAR0HAE0",
                        "woredaEng": "Hadale Ela",
                        "woredaAmh": "ሀዳሌ ኤላ"
                    },
                    {
                        "woredaCode": "AFHAR0SGA0",
                        "woredaEng": "Semurobi Ena Gela'Alu",
                        "woredaAmh": "ሰሙሮቢ እና ገላእሉ"
                    },
                    {
                        "woredaCode": "AFHAR0TLL0",
                        "woredaEng": "Telalak",
                        "woredaAmh": "ተላላክ"
                    }
                ]
            },
            {
                "zoneCode": "AFKIR00000",
                "zoneEng": "Kilbati Rasu",
                "zoneAmh": "ኪልባቲ ራሱ",
                "woredas": [
                    {
                        "woredaCode": "AFKIR0ABL0",
                        "woredaEng": "Abala",
                        "woredaAmh": "አብኣላ"
                    },
                    {
                        "woredaCode": "AFKIR0ABL1",
                        "woredaEng": "Abala City Administration",
                        "woredaAmh": "አብኣላ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "AFKIR0AFD0",
                        "woredaEng": "Afdera",
                        "woredaAmh": "አፍዴራ"
                    },
                    {
                        "woredaCode": "AFKIR0BRH0",
                        "woredaEng": "Barahle",
                        "woredaAmh": "ባራህሌ"
                    },
                    {
                        "woredaCode": "AFKIR0BID0",
                        "woredaEng": "Bidu",
                        "woredaAmh": "ቢዱ"
                    },
                    {
                        "woredaCode": "AFKIR0DLL0",
                        "woredaEng": "Dallol",
                        "woredaAmh": "ዳሎል"
                    },
                    {
                        "woredaCode": "AFKIR0ERB0",
                        "woredaEng": "Erebti",
                        "woredaAmh": "ኢረብቲ"
                    },
                    {
                        "woredaCode": "AFKIR0KNB0",
                        "woredaEng": "Koneba",
                        "woredaAmh": "ኮነባ"
                    },
                    {
                        "woredaCode": "AFKIR0MGL0",
                        "woredaEng": "Megale",
                        "woredaAmh": "መጋሌ"
                    },
                    {
                        "woredaCode": "AFKIR0WSM0",
                        "woredaEng": "Wasama",
                        "woredaAmh": "ዋሳማ"
                    }
                ]
            },
            {
                "zoneCode": "AFMAR00000",
                "zoneEng": "Mahi Rasu",
                "zoneAmh": "ማሂ ራሱ",
                "woredas": [
                    {
                        "woredaCode": "AFMAR0ADD0",
                        "woredaEng": "Adado",
                        "woredaAmh": "አዳዓዶ"
                    },
                    {
                        "woredaCode": "AFMAR0GRN0",
                        "woredaEng": "Gereni",
                        "woredaAmh": "ገረኒ"
                    },
                    {
                        "woredaCode": "AFMAR0KLL0",
                        "woredaEng": "Kilalu",
                        "woredaAmh": "ኪላሉ"
                    },
                    {
                        "woredaCode": "AFMAR0SBY0",
                        "woredaEng": "Sibaybi",
                        "woredaAmh": "ሲባይቢ"
                    },
                    {
                        "woredaCode": "AFMAR0YNG0",
                        "woredaEng": "Yangudi",
                        "woredaAmh": "ያንጉዲ"
                    }
                ]
            },
            {
                "zoneCode": "AFSEL10000",
                "zoneEng": "Semera Logia City Administration",
                "zoneAmh": "ሰመራ ሎጊያ ከተማ አስተዳደር",
                "woredas": [
                    {
                        "woredaCode": "AFSEL1LOG3",
                        "woredaEng": "Logia Sub-City",
                        "woredaAmh": "ሎጊያ ክፍለ-ከተማ"
                    },
                    {
                        "woredaCode": "AFSEL1SMR3",
                        "woredaEng": "Semera Sub-City",
                        "woredaAmh": "ሰመራ ክፍለ-ከተማ"
                    }
                ]
            }
        ]
    },
    {
        "regionCode": "AM00000000",
        "regionEng": "Amhara",
        "regionAmh": "አማራ",
        "zones": [
            {
                "zoneCode": "AMAWN00000",
                "zoneEng": "Awi Nation",
                "zoneAmh": "አዊ ብሔረሰብ",
                "woredas": [
                    {
                        "woredaCode": "AMAWN0ADK1",
                        "woredaEng": "Addis Kidam City Administration",
                        "woredaAmh": "አዲስ ቅዳም ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "AMAWN0AGB1",
                        "woredaEng": "Agew Gimja Bet City Administration",
                        "woredaAmh": "አገው ግምጃ ቤት ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "AMAWN0ANG0",
                        "woredaEng": "Ankesha Guagusa",
                        "woredaAmh": "አንከሻ ጓጉሳ"
                    },
                    {
                        "woredaCode": "AMAWN0AYG0",
                        "woredaEng": "Ayehu Guagusa",
                        "woredaAmh": "አየሁ ጓጉሳ"
                    },
                    {
                        "woredaCode": "AMAWN0BNJ0",
                        "woredaEng": "Banja",
                        "woredaAmh": "ባንጃ"
                    },
                    {
                        "woredaCode": "AMAWN0CHG1",
                        "woredaEng": "Chagni City Administration",
                        "woredaAmh": "ቻግኒ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "AMAWN0DNG1",
                        "woredaEng": "Dangila City Administration",
                        "woredaAmh": "ዳንግላ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "AMAWN0DAZ0",
                        "woredaEng": "Dangila Zuriya",
                        "woredaAmh": "ዳንግላ ዙሪያ"
                    },
                    {
                        "woredaCode": "AMAWN0ENJ1",
                        "woredaEng": "Enjibara City Administration",
                        "woredaAmh": "እንጅባራ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "AMAWN0FAL0",
                        "woredaEng": "Fagita Lekoma",
                        "woredaAmh": "ፋግታ ለኮማ"
                    },
                    {
                        "woredaCode": "AMAWN0FND1",
                        "woredaEng": "Fendika City Administration",
                        "woredaAmh": "ፈንድቃ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "AMAWN0GUS0",
                        "woredaEng": "Guagusa Shikudad",
                        "woredaAmh": "ጓጉሳ ሽኩዳድ"
                    },
                    {
                        "woredaCode": "AMAWN0GNG0",
                        "woredaEng": "Guangua",
                        "woredaAmh": "ጓንጓ"
                    },
                    {
                        "woredaCode": "AMAWN0JAW0",
                        "woredaEng": "Jawi",
                        "woredaAmh": "ጃዊ"
                    },
                    {
                        "woredaCode": "AMAWN0TLL1",
                        "woredaEng": "Tilili City Administration",
                        "woredaAmh": "ቲሊሊ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "AMAWN0ZGM0",
                        "woredaEng": "Zigem",
                        "woredaAmh": "ዚገም"
                    }
                ]
            },
            {
                "zoneCode": "AMBDR10000",
                "zoneEng": "Bahir Dar Regiopolis City Administration",
                "zoneAmh": "ባህር ዳር ሪጂዮፖሊስ ከተማ አስተዳደር",
                "woredas": [
                    {
                        "woredaCode": "AMBDR1ATT3",
                        "woredaEng": "Atse Tewedros Sub City",
                        "woredaAmh": "አፄ ቴዎድሮስ ክፍለ ከተማ"
                    },
                    {
                        "woredaCode": "AMBDR1BEZ3",
                        "woredaEng": "Belay Zeleke Sub City",
                        "woredaAmh": "በላይ ዘለቀ ክፍለ ከተማ"
                    },
                    {
                        "woredaCode": "AMBDR1DAM3",
                        "woredaEng": "Dagmawi Minilik Sub City",
                        "woredaAmh": "ዳግማዊ ሚኒሊክ ክፍለ ከተማ"
                    },
                    {
                        "woredaCode": "AMBDR1FSL3",
                        "woredaEng": "Fasilo Sub City",
                        "woredaAmh": "ፋሲሎ ክፍለ ከተማ"
                    },
                    {
                        "woredaCode": "AMBDR1GIA3",
                        "woredaEng": "Gish Abay Sub City",
                        "woredaAmh": "ግሽ አባይ ክፍለ ከተማ"
                    },
                    {
                        "woredaCode": "AMBDR1TAN3",
                        "woredaEng": "Tana Sub City",
                        "woredaAmh": "ጣና ክፍለ ከተማ"
                    }
                ]
            },
            {
                "zoneCode": "AMCEG00000",
                "zoneEng": "Central Gondar",
                "zoneAmh": "ማዕከላዊ ጎንደር",
                "woredas": [
                    {
                        "woredaCode": "AMCEG0ALF0",
                        "woredaEng": "Alefa",
                        "woredaAmh": "አለፋ"
                    },
                    {
                        "woredaCode": "AMCEG0AMG1",
                        "woredaEng": "Amiba Giworgis City Administration",
                        "woredaAmh": "አምባ ጊዮርጊስ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "AMCEG0AYK1",
                        "woredaEng": "Ayikel City Administration",
                        "woredaAmh": "አይከል ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "AMCEG0CEA0",
                        "woredaEng": "Central Armachiho",
                        "woredaAmh": "ማዕከላዊ አርማጭሆ"
                    },
                    {
                        "woredaCode": "AMCEG0CHL0",
                        "woredaEng": "Chilga",
                        "woredaAmh": "ጭልጋ"
                    },
                    {
                        "woredaCode": "AMCEG0EAB0",
                        "woredaEng": "East Belesa",
                        "woredaAmh": "ምስራቅ በለሳ"
                    },
                    {
                        "woredaCode": "AMCEG0EAD0",
                        "woredaEng": "East Dembiya",
                        "woredaAmh": "ምስራቅ ደምቢያ"
                    },
                    {
                        "woredaCode": "AMCEG0GOZ0",
                        "woredaEng": "Gonder Zuriya",
                        "woredaAmh": "ጎንደር ዙሪያ"
                    },
                    {
                        "woredaCode": "AMCEG0KIB0",
                        "woredaEng": "Kinfaz Begela",
                        "woredaAmh": "ኪንፋዝ በገላ"
                    },
                    {
                        "woredaCode": "AMCEG0KLD1",
                        "woredaEng": "Koladiba City Administration",
                        "woredaAmh": "ቆላድባ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "AMCEG0LAA0",
                        "woredaEng": "Lay Armachiho",
                        "woredaAmh": "ላይ አርማጭሆ"
                    },
                    {
                        "woredaCode": "AMCEG0NEC0",
                        "woredaEng": "Nebaru Chilga",
                        "woredaAmh": "ነባሩ ጭልጋ"
                    },
                    {
                        "woredaCode": "AMCEG0SHW1",
                        "woredaEng": "Shawra City Administration",
                        "woredaAmh": "ሻሁራ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "AMCEG0TAA0",
                        "woredaEng": "Tach Armachiho",
                        "woredaAmh": "ታች አርማጭሆ"
                    },
                    {
                        "woredaCode": "AMCEG0TKS0",
                        "woredaEng": "Takusa",
                        "woredaAmh": "ጣቁሳ"
                    },
                    {
                        "woredaCode": "AMCEG0WGR0",
                        "woredaEng": "Wegera",
                        "woredaAmh": "ወገራ"
                    },
                    {
                        "woredaCode": "AMCEG0WEB0",
                        "woredaEng": "West Belesa",
                        "woredaAmh": "ምዕራብ በለሳ"
                    },
                    {
                        "woredaCode": "AMCEG0WED0",
                        "woredaEng": "West Dembiya",
                        "woredaAmh": "ምዕራብ ደምቢያ"
                    }
                ]
            },
            {
                "zoneCode": "AMDTR10000",
                "zoneEng": "Debere Tabor Regiopolis City Administration",
                "zoneAmh": "ደብረ ታቦር ሪጂዮፖሊስ ከተማ አስተዳደር",
                "woredas": [
                    {
                        "woredaCode": "AMDTR1ATT3",
                        "woredaEng": "Atse Tewedros Sub City",
                        "woredaAmh": "አፄ ቴዎድሮስ ክፍለ ከተማ"
                    },
                    {
                        "woredaCode": "AMDTR1ETT3",
                        "woredaEng": "Etege Tayitu Sub City",
                        "woredaAmh": "እቴጌ ጣይቱ ክፍለ ከተማ"
                    },
                    {
                        "woredaCode": "AMDTR1FIG3",
                        "woredaEng": "Fitawurary Gebirye Sub City",
                        "woredaAmh": "ፊታውራሪ ገብርዬ ክፍለ ከተማ"
                    }
                ]
            },
            {
                "zoneCode": "AMDMR10000",
                "zoneEng": "Debire Markos Regiopolis City Administration",
                "zoneAmh": "ደብረ ማርቆስ ሪጂዮፖሊስ ከተማ አስተዳደር",
                "woredas": [
                    {
                        "woredaCode": "AMDMR1ABM3",
                        "woredaEng": "Abima Sub City",
                        "woredaAmh": "አብማ ክፍለ ከተማ"
                    },
                    {
                        "woredaCode": "AMDMR1DAT3",
                        "woredaEng": "Dej Azmach Tedila Gualu Sub City",
                        "woredaAmh": "ደጅ አዝማች ተድላ ጓሉ ክፍለ ከተማ"
                    },
                    {
                        "woredaCode": "AMDMR1MNK3",
                        "woredaEng": "Menkorer Sub City",
                        "woredaAmh": "መንቆረር ክፍለ ከተማ"
                    },
                    {
                        "woredaCode": "AMDMR1NTH3",
                        "woredaEng": "Nigus Tekeile Haimanot Sub City",
                        "woredaAmh": "ንጉስ ተክለ ሃይማኖት ክፍለ ከተማ"
                    }
                ]
            },
            {
                "zoneCode": "AMDBR10000",
                "zoneEng": "Debre Birhan Regiopolis City Administration",
                "zoneAmh": "ደብረ ብርሃን ሪጂዮፖሊስ ከተማ አስተዳደር",
                "woredas": [
                    {
                        "woredaCode": "AMDBR1ATZ3",
                        "woredaEng": "Atse Zerayikob Sub City",
                        "woredaAmh": "አፄ ዘርዓያቆብ ክፍለ ከተማ"
                    },
                    {
                        "woredaCode": "AMDBR1CHC3",
                        "woredaEng": "Chacha Sub City",
                        "woredaAmh": "ጫጫ ክፍለ ከተማ"
                    },
                    {
                        "woredaCode": "AMDBR1EMM3",
                        "woredaEng": "Emye Minilik Sub City",
                        "woredaAmh": "እምዬ ሚኒሊክ ክፍለ ከተማ"
                    },
                    {
                        "woredaCode": "AMDBR1ETT3",
                        "woredaEng": "Etege Tayitu Sub City",
                        "woredaAmh": "እቴጌ ጣይቱ ክፍለ ከተማ"
                    },
                    {
                        "woredaCode": "AMDBR1TBS3",
                        "woredaEng": "Tebase Sub City",
                        "woredaAmh": "ጠባሴ ክፍለ ከተማ"
                    }
                ]
            },
            {
                "zoneCode": "AMDER10000",
                "zoneEng": "Dessie Regiopolis City Administration",
                "zoneAmh": "ደሴ ሪጂዮፖሊስ ከተማ አስተዳደር",
                "woredas": [
                    {
                        "woredaCode": "AMDER1ARD3",
                        "woredaEng": "Arada Sub City",
                        "woredaAmh": "አራዳ ክፍለ ከተማ"
                    },
                    {
                        "woredaCode": "AMDER1BUW3",
                        "woredaEng": "Buanbua Wuha Sub City",
                        "woredaAmh": "ቧንቧ ውሀ ክፍለ ከተማ"
                    },
                    {
                        "woredaCode": "AMDER1HOT3",
                        "woredaEng": "Hote Sub City",
                        "woredaAmh": "ሆጤ ክፍለ ከተማ"
                    },
                    {
                        "woredaCode": "AMDER1MNF3",
                        "woredaEng": "Menafesha Sub City",
                        "woredaAmh": "መናፈሻ ክፍለ ከተማ"
                    },
                    {
                        "woredaCode": "AMDER1SEG3",
                        "woredaEng": "Segno Gebeya Sub City",
                        "woredaAmh": "ሰኞ ገበያ ክፍለ ከተማ"
                    }
                ]
            },
            {
                "zoneCode": "AMEAG00000",
                "zoneEng": "East Gojjam",
                "zoneAmh": "ምስራቅ ጎጃም",
                "woredas": [
                    {
                        "woredaCode": "AMEAG0AMN1",
                        "woredaEng": "Amanuel City Administration",
                        "woredaAmh": "አማኑኤል ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "AMEAG0AND0",
                        "woredaEng": "Aneded",
                        "woredaAmh": "አነደድ"
                    },
                    {
                        "woredaCode": "AMEAG0AWB0",
                        "woredaEng": "Awabel",
                        "woredaAmh": "አዋበል"
                    },
                    {
                        "woredaCode": "AMEAG0BSL0",
                        "woredaEng": "Basoliben",
                        "woredaAmh": "ባሶሊበን"
                    },
                    {
                        "woredaCode": "AMEAG0BBG0",
                        "woredaEng": "Bibugn",
                        "woredaAmh": "ቢቡኝ"
                    },
                    {
                        "woredaCode": "AMEAG0BCH1",
                        "woredaEng": "Bichena City Administration",
                        "woredaAmh": "ብቸና ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "AMEAG0DTG0",
                        "woredaEng": "Debay Tilat Gin",
                        "woredaAmh": "ደባይ ጥላት ግን"
                    },
                    {
                        "woredaCode": "AMEAG0DEE0",
                        "woredaEng": "Debere Eliyas",
                        "woredaAmh": "ደብረ ኤልያስ"
                    },
                    {
                        "woredaCode": "AMEAG0DBR1",
                        "woredaEng": "Debrework City Administration",
                        "woredaAmh": "ደብረወርቅ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "AMEAG0DJN0",
                        "woredaEng": "Dejen",
                        "woredaAmh": "ደጀን"
                    },
                    {
                        "woredaCode": "AMEAG0DJN1",
                        "woredaEng": "Dejen City Administration",
                        "woredaAmh": "ደጀን ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "AMEAG0ENE0",
                        "woredaEng": "Enarj Enawga",
                        "woredaAmh": "እናርጅ እናውጋ"
                    },
                    {
                        "woredaCode": "AMEAG0ESM0",
                        "woredaEng": "Enebise Sar Midr",
                        "woredaAmh": "እነብሴ ሳር ምድር"
                    },
                    {
                        "woredaCode": "AMEAG0ENM0",
                        "woredaEng": "Enemay",
                        "woredaAmh": "እነማይ"
                    },
                    {
                        "woredaCode": "AMEAG0GND1",
                        "woredaEng": "Gindewoyin City Administration",
                        "woredaAmh": "ግንደወይን ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "AMEAG0GSE0",
                        "woredaEng": "Goncha Siso Enese",
                        "woredaAmh": "ጎንቻ ሲሶ እነሴ"
                    },
                    {
                        "woredaCode": "AMEAG0GZM0",
                        "woredaEng": "Gozamen",
                        "woredaAmh": "ጎዛምን"
                    },
                    {
                        "woredaCode": "AMEAG0HEE0",
                        "woredaEng": "Hulet Eju Enese",
                        "woredaAmh": "ሁለት እጁ እነሴ"
                    },
                    {
                        "woredaCode": "AMEAG0LMM1",
                        "woredaEng": "Lumame City Administration",
                        "woredaAmh": "ሉማሜ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "AMEAG0MCH0",
                        "woredaEng": "Machakel",
                        "woredaAmh": "ማቻከል"
                    },
                    {
                        "woredaCode": "AMEAG0MEL1",
                        "woredaEng": "Merto Lemariyam City Administration",
                        "woredaAmh": "መርጦ ለማሪያም ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "AMEAG0MOT1",
                        "woredaEng": "Mota City Administration",
                        "woredaAmh": "ሞጣ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "AMEAG0SED0",
                        "woredaEng": "Sede",
                        "woredaAmh": "ሰዴ"
                    },
                    {
                        "woredaCode": "AMEAG0SHB0",
                        "woredaEng": "Shebel Berenta",
                        "woredaAmh": "ሸበል በረንታ"
                    },
                    {
                        "woredaCode": "AMEAG0SNN0",
                        "woredaEng": "Sinan",
                        "woredaAmh": "ስናን"
                    }
                ]
            },
            {
                "zoneCode": "AMGOR10000",
                "zoneEng": "Gondar Regiopolis City Administration",
                "zoneAmh": "ጎንደር ሪጂዮፖሊስ ከተማ አስተዳደር",
                "woredas": [
                    {
                        "woredaCode": "AMGOR1ARD3",
                        "woredaEng": "Arada Sub City",
                        "woredaAmh": "አራዳ ክፍለ ከተማ"
                    },
                    {
                        "woredaCode": "AMGOR1AZT3",
                        "woredaEng": "Azezo Teda Sub City",
                        "woredaAmh": "አዘዞ ጠዳ ክፍለ ከተማ"
                    },
                    {
                        "woredaCode": "AMGOR1FSL3",
                        "woredaEng": "Fasil Sub City",
                        "woredaAmh": "ፋሲል ክፍለ ከተማ"
                    },
                    {
                        "woredaCode": "AMGOR1JNT3",
                        "woredaEng": "Jantekel Sub City",
                        "woredaAmh": "ጃንተከል ክፍለ ከተማ"
                    },
                    {
                        "woredaCode": "AMGOR1MRK3",
                        "woredaEng": "Maraki Sub City",
                        "woredaAmh": "ማራኪ ክፍለ ከተማ"
                    },
                    {
                        "woredaCode": "AMGOR1ZBL3",
                        "woredaEng": "Zobil Sub City",
                        "woredaAmh": "ዞብል ክፍለ ከተማ"
                    }
                ]
            },
            {
                "zoneCode": "AMKOR10000",
                "zoneEng": "Kombolcha Regiopolis City Administration",
                "zoneAmh": "ኮምቦልቻ ሪጂዮፖሊስ ከተማ አስተዳደር",
                "woredas": [
                    {
                        "woredaCode": "AMKOR1ABA3",
                        "woredaEng": "Abisha Ager Sub City",
                        "woredaAmh": "አቢሻ አገር ክፍለ ከተማ"
                    },
                    {
                        "woredaCode": "AMKOR1BRR3",
                        "woredaEng": "Biraro Sub City",
                        "woredaAmh": "ቢራሮ ክፍለ ከተማ"
                    },
                    {
                        "woredaCode": "AMKOR1BRK3",
                        "woredaEng": "Borkena Sub City",
                        "woredaAmh": "ቦርከና ክፍለ ከተማ"
                    },
                    {
                        "woredaCode": "AMKOR1HAA3",
                        "woredaEng": "Hasena Ager Sub City",
                        "woredaAmh": "ሀሰና አገር ክፍለ ከተማ"
                    }
                ]
            },
            {
                "zoneCode": "AMNOG00000",
                "zoneEng": "North Gojjam",
                "zoneAmh": "ሰሜን ጎጃም",
                "woredas": [
                    {
                        "woredaCode": "AMNOG0ADT1",
                        "woredaEng": "Adet City Administration",
                        "woredaAmh": "አዴት ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "AMNOG0BDZ0",
                        "woredaEng": "Bahir Dar Zuriya",
                        "woredaAmh": "ባህር ዳር ዙሪያ"
                    },
                    {
                        "woredaCode": "AMNOG0DRB1",
                        "woredaEng": "Durbete City Administration",
                        "woredaAmh": "ዱርቤቴ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "AMNOG0GOK0",
                        "woredaEng": "Gonj Kolela",
                        "woredaAmh": "ጐንጅ ቆለላ"
                    },
                    {
                        "woredaCode": "AMNOG0MRW1",
                        "woredaEng": "Merawi City Administration",
                        "woredaAmh": "መርዓዊ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "AMNOG0NOA0",
                        "woredaEng": "North Achefer",
                        "woredaAmh": "ሰሜን አቸፈር"
                    },
                    {
                        "woredaCode": "AMNOG0NOM0",
                        "woredaEng": "North Mecha",
                        "woredaAmh": "ሰሜን ሜጫ"
                    },
                    {
                        "woredaCode": "AMNOG0SOA0",
                        "woredaEng": "South Achefer",
                        "woredaAmh": "ደቡብ አቸፈር"
                    },
                    {
                        "woredaCode": "AMNOG0SOM0",
                        "woredaEng": "South Mecha",
                        "woredaAmh": "ደቡብ ሜጫ"
                    },
                    {
                        "woredaCode": "AMNOG0YID0",
                        "woredaEng": "Yilmana Densa",
                        "woredaAmh": "ይልማና ዴንሳ"
                    }
                ]
            },
            {
                "zoneCode": "AMNOB00000",
                "zoneEng": "North Gondar",
                "zoneAmh": "ሰሜን ጎንደር",
                "woredas": [
                    {
                        "woredaCode": "AMNOB0ADA0",
                        "woredaEng": "Adi Arkay",
                        "woredaAmh": "አዲ አርቃይ"
                    },
                    {
                        "woredaCode": "AMNOB0BYD0",
                        "woredaEng": "Beyeda",
                        "woredaAmh": "በየዳ"
                    },
                    {
                        "woredaCode": "AMNOB0DBT0",
                        "woredaEng": "Dabat",
                        "woredaAmh": "ዳባት"
                    },
                    {
                        "woredaCode": "AMNOB0DBT1",
                        "woredaEng": "Dabat City Administration",
                        "woredaAmh": "ዳባት ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "AMNOB0DBR0",
                        "woredaEng": "Debark",
                        "woredaAmh": "ደባርቅ"
                    },
                    {
                        "woredaCode": "AMNOB0DBR1",
                        "woredaEng": "Debark City Administration",
                        "woredaAmh": "ደባርቅ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "AMNOB0EAT0",
                        "woredaEng": "East Telemit",
                        "woredaAmh": "ምስራቅ ጠለምት"
                    },
                    {
                        "woredaCode": "AMNOB0JNM0",
                        "woredaEng": "Janamora",
                        "woredaAmh": "ጃናሞራ"
                    },
                    {
                        "woredaCode": "AMNOB0TLM0",
                        "woredaEng": "Telemit",
                        "woredaAmh": "ጠለምት"
                    },
                    {
                        "woredaCode": "AMNOB0WET0",
                        "woredaEng": "West Telemit",
                        "woredaAmh": "ምዕራብ ጠለምት"
                    }
                ]
            },
            {
                "zoneCode": "AMNOS00000",
                "zoneEng": "North Shewa",
                "zoneAmh": "ሰሜን ሸዋ",
                "woredas": [
                    {
                        "woredaCode": "AMNOS0ALK1",
                        "woredaEng": "Alem Ketema City Administration",
                        "woredaAmh": "ዓለም ከተማ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "AMNOS0ANT0",
                        "woredaEng": "Angolalana Tera",
                        "woredaAmh": "አንጎላላና ጠራ"
                    },
                    {
                        "woredaCode": "AMNOS0ANK0",
                        "woredaEng": "Ankober",
                        "woredaAmh": "አንኮበር"
                    },
                    {
                        "woredaCode": "AMNOS0ANG0",
                        "woredaEng": "Antsokiya Gemza",
                        "woredaAmh": "አንፆኪያ ገምዛ"
                    },
                    {
                        "woredaCode": "AMNOS0ARR1",
                        "woredaEng": "Arerti City Administration",
                        "woredaAmh": "አረርቲ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "AMNOS0ASG0",
                        "woredaEng": "Asagirt",
                        "woredaAmh": "አሳግርት"
                    },
                    {
                        "woredaCode": "AMNOS0ATY1",
                        "woredaEng": "Ataye City Administration",
                        "woredaAmh": "አጣዬ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "AMNOS0BSN0",
                        "woredaEng": "Basonawerena",
                        "woredaAmh": "ባሶናወረና"
                    },
                    {
                        "woredaCode": "AMNOS0BRH0",
                        "woredaEng": "Berehet",
                        "woredaAmh": "በረኸት"
                    },
                    {
                        "woredaCode": "AMNOS0BLG1",
                        "woredaEng": "Bulga City Administration",
                        "woredaAmh": "ቡልጋ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "AMNOS0DBR1",
                        "woredaEng": "Deberesina City Administration",
                        "woredaAmh": "ደብረሲና ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "AMNOS0EFG0",
                        "woredaEng": "Efiratana Gidim",
                        "woredaAmh": "ኤፍራታና ግድም"
                    },
                    {
                        "woredaCode": "AMNOS0ENW1",
                        "woredaEng": "Enewari City Administration",
                        "woredaAmh": "እነዋሪ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "AMNOS0ENS0",
                        "woredaEng": "Ensaro",
                        "woredaAmh": "እንሳሮ"
                    },
                    {
                        "woredaCode": "AMNOS0GIR0",
                        "woredaEng": "Gishe Rabel",
                        "woredaAmh": "ግሼ ራቤል"
                    },
                    {
                        "woredaCode": "AMNOS0HMK0",
                        "woredaEng": "Hagere Mariyam Kesem",
                        "woredaAmh": "ሀገረ ማርያም ከሰም"
                    },
                    {
                        "woredaCode": "AMNOS0KWT0",
                        "woredaEng": "Kewet",
                        "woredaAmh": "ቀወት"
                    },
                    {
                        "woredaCode": "AMNOS0MEM1",
                        "woredaEng": "Mehal Meda City Administration",
                        "woredaAmh": "መሐል ሜዳ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "AMNOS0MEG0",
                        "woredaEng": "Menz Gera",
                        "woredaAmh": "መንዝ ጌራ"
                    },
                    {
                        "woredaCode": "AMNOS0MEK0",
                        "woredaEng": "Menz Keya",
                        "woredaAmh": "መንዝ ቀያ"
                    },
                    {
                        "woredaCode": "AMNOS0MEL0",
                        "woredaEng": "Menz Lalo",
                        "woredaAmh": "መንዝ ላሎ"
                    },
                    {
                        "woredaCode": "AMNOS0MEM0",
                        "woredaEng": "Menz Mama",
                        "woredaAmh": "መንዝ ማማ"
                    },
                    {
                        "woredaCode": "AMNOS0MRH0",
                        "woredaEng": "Merhabete",
                        "woredaAmh": "መርሀቤቴ"
                    },
                    {
                        "woredaCode": "AMNOS0MDW0",
                        "woredaEng": "Midaworemo",
                        "woredaAmh": "ሚዳወረሞ"
                    },
                    {
                        "woredaCode": "AMNOS0MIS0",
                        "woredaEng": "Minjar Shenkora",
                        "woredaAmh": "ምንጃር ሸንኮራ"
                    },
                    {
                        "woredaCode": "AMNOS0MOW0",
                        "woredaEng": "Mojana Wedera",
                        "woredaAmh": "ሞጃና ወደራ"
                    },
                    {
                        "woredaCode": "AMNOS0MLL1",
                        "woredaEng": "Molale City Administration",
                        "woredaAmh": "ሞላሌ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "AMNOS0MOJ0",
                        "woredaEng": "Moretina Jiru",
                        "woredaAmh": "ሞረትና ጅሩ"
                    },
                    {
                        "woredaCode": "AMNOS0SHW1",
                        "woredaEng": "Shewarobit City Administration",
                        "woredaAmh": "ሸዋሮቢት ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "AMNOS0SIW0",
                        "woredaEng": "Siyadebirna Wayu",
                        "woredaAmh": "ሲያደብርና ዋዩ"
                    },
                    {
                        "woredaCode": "AMNOS0TAB0",
                        "woredaEng": "Tarma Ber",
                        "woredaAmh": "ጣርማ በር"
                    }
                ]
            },
            {
                "zoneCode": "AMNOW00000",
                "zoneEng": "North Wollo",
                "zoneAmh": "ሰሜን ወሎ",
                "woredas": [
                    {
                        "woredaCode": "AMNOW0ANG0",
                        "woredaEng": "Anigot",
                        "woredaAmh": "አንጎት"
                    },
                    {
                        "woredaCode": "AMNOW0BGN0",
                        "woredaEng": "Bugina",
                        "woredaAmh": "ቡግና"
                    },
                    {
                        "woredaCode": "AMNOW0DWN0",
                        "woredaEng": "Dawnt",
                        "woredaAmh": "ዳውንት"
                    },
                    {
                        "woredaCode": "AMNOW0FIG1",
                        "woredaEng": "Filakit Geregera City Administration",
                        "woredaAmh": "ፍላቂት ገረገራ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "AMNOW0GSH1",
                        "woredaEng": "Gashena City Administration",
                        "woredaAmh": "ጋሸና ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "AMNOW0GAZ0",
                        "woredaEng": "Gazo",
                        "woredaAmh": "ጋዞ"
                    },
                    {
                        "woredaCode": "AMNOW0GDN0",
                        "woredaEng": "Gidan",
                        "woredaAmh": "ግዳን"
                    },
                    {
                        "woredaCode": "AMNOW0GBL0",
                        "woredaEng": "Gubalafito",
                        "woredaAmh": "ጉባላፍቶ"
                    },
                    {
                        "woredaCode": "AMNOW0HBR0",
                        "woredaEng": "Habiru",
                        "woredaAmh": "ሀብሩ"
                    },
                    {
                        "woredaCode": "AMNOW0HAR1",
                        "woredaEng": "Hara City Administration",
                        "woredaAmh": "ሀራ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "AMNOW0KOB1",
                        "woredaEng": "Kobo City Administration",
                        "woredaAmh": "ቆቦ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "AMNOW0LLB1",
                        "woredaEng": "Lalibela City Administration",
                        "woredaAmh": "ላሊበላ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "AMNOW0LST0",
                        "woredaEng": "Lasta",
                        "woredaAmh": "ላስታ"
                    },
                    {
                        "woredaCode": "AMNOW0MKT0",
                        "woredaEng": "Meket",
                        "woredaAmh": "መቄት"
                    },
                    {
                        "woredaCode": "AMNOW0MRS1",
                        "woredaEng": "Mersa City Administration",
                        "woredaAmh": "መርሳ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "AMNOW0RAK0",
                        "woredaEng": "Raya Kobo",
                        "woredaAmh": "ራያ ቆቦ"
                    },
                    {
                        "woredaCode": "AMNOW0WDL0",
                        "woredaEng": "Wadila",
                        "woredaAmh": "ዋድላ"
                    }
                ]
            },
            {
                "zoneCode": "AMORN00000",
                "zoneEng": "Oromo Nation",
                "zoneAmh": "ኦሮሞ ብሔረሰብ",
                "woredas": [
                    {
                        "woredaCode": "AMORN0ARF0",
                        "woredaEng": "Artuma Fursy",
                        "woredaAmh": "አርጡማ ፉርሲ"
                    },
                    {
                        "woredaCode": "AMORN0BAT1",
                        "woredaEng": "Bati City Administration",
                        "woredaAmh": "ባቲ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "AMORN0BAZ0",
                        "woredaEng": "Bati Zuriya",
                        "woredaAmh": "ባቲ ዙሪያ"
                    },
                    {
                        "woredaCode": "AMORN0CHR1",
                        "woredaEng": "Chefa Robit City Administration",
                        "woredaAmh": "ጨፋ ሮቢት ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "AMORN0DAC0",
                        "woredaEng": "Dawa Chefa",
                        "woredaAmh": "ዳዋ ጨፋ"
                    },
                    {
                        "woredaCode": "AMORN0DEH0",
                        "woredaEng": "Dewe Harewa",
                        "woredaAmh": "ደዌ ሐረዋ"
                    },
                    {
                        "woredaCode": "AMORN0JIT0",
                        "woredaEng": "Jile Timuga",
                        "woredaAmh": "ጂሌ ጥሙጋ"
                    },
                    {
                        "woredaCode": "AMORN0KMS1",
                        "woredaEng": "Kemise City Administration",
                        "woredaAmh": "ከሚሴ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "AMORN0SNB1",
                        "woredaEng": "Senbete City Administration",
                        "woredaAmh": "ሰንበቴ ከተማ አስተዳደር"
                    }
                ]
            },
            {
                "zoneCode": "AMSOG00000",
                "zoneEng": "South Gondar",
                "zoneAmh": "ደቡብ ጎንደር",
                "woredas": [
                    {
                        "woredaCode": "AMSOG0ADZ1",
                        "woredaEng": "Addis Zemen City Administration",
                        "woredaAmh": "አዲስ ዘመን ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "AMSOG0AND0",
                        "woredaEng": "Andabet",
                        "woredaAmh": "አንዳቤት"
                    },
                    {
                        "woredaCode": "AMSOG0DER0",
                        "woredaEng": "Dera",
                        "woredaAmh": "ደራ"
                    },
                    {
                        "woredaCode": "AMSOG0EAE0",
                        "woredaEng": "East Este",
                        "woredaAmh": "ምስራቅ እስቴ"
                    },
                    {
                        "woredaCode": "AMSOG0EBN0",
                        "woredaEng": "Ebinat",
                        "woredaAmh": "እብናት"
                    },
                    {
                        "woredaCode": "AMSOG0EBN1",
                        "woredaEng": "Ebinat City Administration",
                        "woredaAmh": "እብናት ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "AMSOG0FRT0",
                        "woredaEng": "Farta",
                        "woredaAmh": "ፋርጣ"
                    },
                    {
                        "woredaCode": "AMSOG0FGR0",
                        "woredaEng": "Fogera",
                        "woredaAmh": "ፎገራ"
                    },
                    {
                        "woredaCode": "AMSOG0GUB0",
                        "woredaEng": "Guna Begemidir",
                        "woredaAmh": "ጉና በጌምድር"
                    },
                    {
                        "woredaCode": "AMSOG0HMS1",
                        "woredaEng": "Hamusit City Administration",
                        "woredaAmh": "ሀሙሲት ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "AMSOG0LAG0",
                        "woredaEng": "Lay Gayint",
                        "woredaAmh": "ላይ ጋይንት"
                    },
                    {
                        "woredaCode": "AMSOG0LIK0",
                        "woredaEng": "Libo Kemikem",
                        "woredaAmh": "ሊቦ ከምከም"
                    },
                    {
                        "woredaCode": "AMSOG0MEE1",
                        "woredaEng": "Mekane Eyesus City Administration",
                        "woredaAmh": "መካነ ኢየሱስ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "AMSOG0MKT0",
                        "woredaEng": "Meketewa",
                        "woredaAmh": "መቀጠዋ"
                    },
                    {
                        "woredaCode": "AMSOG0NEM1",
                        "woredaEng": "Nefas Mewcha City Administration",
                        "woredaAmh": "ነፋስ መውጫ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "AMSOG0SEM0",
                        "woredaEng": "Sede Muja",
                        "woredaAmh": "ሰዴ ሙጃ"
                    },
                    {
                        "woredaCode": "AMSOG0SMD0",
                        "woredaEng": "Simada",
                        "woredaAmh": "ስማዳ"
                    },
                    {
                        "woredaCode": "AMSOG0TAG0",
                        "woredaEng": "Tach Gayint",
                        "woredaAmh": "ታች ጋይንት"
                    },
                    {
                        "woredaCode": "AMSOG0WGD1",
                        "woredaEng": "Wegeda City Administration",
                        "woredaAmh": "ወገዳ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "AMSOG0WRT1",
                        "woredaEng": "Wereta City Administration",
                        "woredaAmh": "ወረታ ከተማ አስተዳደር"
                    }
                ]
            },
            {
                "zoneCode": "AMSOW00000",
                "zoneEng": "South Wollo",
                "zoneAmh": "ደቡብ ወሎ",
                "woredas": [
                    {
                        "woredaCode": "AMSOW0AKS1",
                        "woredaEng": "Akesita City Administration",
                        "woredaAmh": "አቀስታ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "AMSOW0ALB0",
                        "woredaEng": "Albko",
                        "woredaAmh": "አልብኮ"
                    },
                    {
                        "woredaCode": "AMSOW0AMB0",
                        "woredaEng": "Ambasel",
                        "woredaAmh": "አምባሰል"
                    },
                    {
                        "woredaCode": "AMSOW0AMS0",
                        "woredaEng": "Amhara Sayint",
                        "woredaAmh": "አማራ ሣይንት"
                    },
                    {
                        "woredaCode": "AMSOW0ARN5",
                        "woredaEng": "Argoba Nation Special Woreda",
                        "woredaAmh": "አርጎባ ብሔረሰብ ልዩ ወረዳ"
                    },
                    {
                        "woredaCode": "AMSOW0BRN0",
                        "woredaEng": "Borena",
                        "woredaAmh": "ቦረና"
                    },
                    {
                        "woredaCode": "AMSOW0DGL1",
                        "woredaEng": "Degolo City Administration",
                        "woredaAmh": "ደጎሎ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "AMSOW0DLN0",
                        "woredaEng": "Delaneta",
                        "woredaAmh": "ደላንታ"
                    },
                    {
                        "woredaCode": "AMSOW0DEZ0",
                        "woredaEng": "Dessie Zuriya",
                        "woredaAmh": "ደሴ ዙሪያ"
                    },
                    {
                        "woredaCode": "AMSOW0GMB1",
                        "woredaEng": "Gimba City Administration",
                        "woredaAmh": "ጊምባ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "AMSOW0HAI1",
                        "woredaEng": "Haik City Administration",
                        "woredaAmh": "ሐይቅ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "AMSOW0HRB1",
                        "woredaEng": "Harbu City Administration",
                        "woredaAmh": "ሀርቡ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "AMSOW0JMM0",
                        "woredaEng": "Jamma",
                        "woredaAmh": "ጃማ"
                    },
                    {
                        "woredaCode": "AMSOW0KAL0",
                        "woredaEng": "Kalu",
                        "woredaAmh": "ቃሉ"
                    },
                    {
                        "woredaCode": "AMSOW0KLL0",
                        "woredaEng": "Kelela",
                        "woredaAmh": "ከለላ"
                    },
                    {
                        "woredaCode": "AMSOW0KLL1",
                        "woredaEng": "Kelela City Administration",
                        "woredaAmh": "ከለላ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "AMSOW0KTB0",
                        "woredaEng": "Kutaber",
                        "woredaAmh": "ኩታበር"
                    },
                    {
                        "woredaCode": "AMSOW0LGM0",
                        "woredaEng": "Legambo",
                        "woredaAmh": "ለጋምቦ"
                    },
                    {
                        "woredaCode": "AMSOW0LGH0",
                        "woredaEng": "Legehida",
                        "woredaAmh": "ለገሂዳ"
                    },
                    {
                        "woredaCode": "AMSOW0MES0",
                        "woredaEng": "Mehal Sayint",
                        "woredaAmh": "መሀል ሣይንት"
                    },
                    {
                        "woredaCode": "AMSOW0MES1",
                        "woredaEng": "Mekane Selam City Administration",
                        "woredaAmh": "መካነ ሰላም ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "AMSOW0MKD0",
                        "woredaEng": "Mekidela",
                        "woredaAmh": "መቅደላ"
                    },
                    {
                        "woredaCode": "AMSOW0THL0",
                        "woredaEng": "Tehuledere",
                        "woredaAmh": "ተሁለደሬ"
                    },
                    {
                        "woredaCode": "AMSOW0TNT0",
                        "woredaEng": "Tenta",
                        "woredaAmh": "ተንታ"
                    },
                    {
                        "woredaCode": "AMSOW0WGL1",
                        "woredaEng": "Wegeltena City Administration",
                        "woredaAmh": "ወገልጤና ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "AMSOW0WGD0",
                        "woredaEng": "Wegidie",
                        "woredaAmh": "ወግዲ"
                    },
                    {
                        "woredaCode": "AMSOW0WRB0",
                        "woredaEng": "Werebabo",
                        "woredaAmh": "ወረባቦ"
                    },
                    {
                        "woredaCode": "AMSOW0WRL0",
                        "woredaEng": "Woreilu",
                        "woredaAmh": "ወረኢሉ"
                    },
                    {
                        "woredaCode": "AMSOW0WRL1",
                        "woredaEng": "Woreilu City Administration",
                        "woredaAmh": "ወረኢሉ ከተማ አስተዳደር"
                    }
                ]
            },
            {
                "zoneCode": "AMWAN00000",
                "zoneEng": "Waghimira Nation",
                "zoneAmh": "ዋግኽምራ ብሔረሰብ",
                "woredas": [
                    {
                        "woredaCode": "AMWAN0ABR0",
                        "woredaEng": "Abergele",
                        "woredaAmh": "አበርገሌ"
                    },
                    {
                        "woredaCode": "AMWAN0AMD1",
                        "woredaEng": "Amdework City Administration",
                        "woredaAmh": "አምደወርቅ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "AMWAN0DHN0",
                        "woredaEng": "Dahna",
                        "woredaAmh": "ዳህና"
                    },
                    {
                        "woredaCode": "AMWAN0GZG0",
                        "woredaEng": "Gazgibla",
                        "woredaAmh": "ጋዝጊብላ"
                    },
                    {
                        "woredaCode": "AMWAN0SES0",
                        "woredaEng": "Sehala Seyemit",
                        "woredaAmh": "ሰሃላ ሰየምት"
                    },
                    {
                        "woredaCode": "AMWAN0SKT1",
                        "woredaEng": "Sekota City Administration",
                        "woredaAmh": "ሰቆጣ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "AMWAN0SEZ0",
                        "woredaEng": "Sekota Zuriya",
                        "woredaAmh": "ሰቆጣ ዙሪያ"
                    },
                    {
                        "woredaCode": "AMWAN0TSG0",
                        "woredaEng": "Tsagibj",
                        "woredaAmh": "ጻግብጅ"
                    },
                    {
                        "woredaCode": "AMWAN0ZQL0",
                        "woredaEng": "Ziquala",
                        "woredaAmh": "ዝቋላ"
                    }
                ]
            },
            {
                "zoneCode": "AMWEB00000",
                "zoneEng": "West Gojjam",
                "zoneAmh": "ምዕራብ ጎጃም",
                "woredas": [
                    {
                        "woredaCode": "AMWEB0BUR1",
                        "woredaEng": "Bure City Administration",
                        "woredaAmh": "ቡሬ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "AMWEB0BUZ0",
                        "woredaEng": "Bure Zuriya",
                        "woredaAmh": "ቡሬ ዙሪያ"
                    },
                    {
                        "woredaCode": "AMWEB0DED0",
                        "woredaEng": "Dega Damot",
                        "woredaAmh": "ደጋ ዳሞት"
                    },
                    {
                        "woredaCode": "AMWEB0DMB1",
                        "woredaEng": "Demebecha City Administration",
                        "woredaAmh": "ደምበጫ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "AMWEB0DEZ0",
                        "woredaEng": "Demebecha Zuriya",
                        "woredaAmh": "ደምበጫ ዙሪያ"
                    },
                    {
                        "woredaCode": "AMWEB0FIS1",
                        "woredaEng": "Finote Selam City Administration",
                        "woredaAmh": "ፍኖተ ሠላም ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "AMWEB0JAT0",
                        "woredaEng": "Jabi Tehinan",
                        "woredaAmh": "ጃቢ ጠህናን"
                    },
                    {
                        "woredaCode": "AMWEB0JIG1",
                        "woredaEng": "Jiga City Administration",
                        "woredaAmh": "ጅጋ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "AMWEB0QRT0",
                        "woredaEng": "Quarit",
                        "woredaAmh": "ቋሪት"
                    },
                    {
                        "woredaCode": "AMWEB0SKL0",
                        "woredaEng": "Sekela",
                        "woredaAmh": "ሰከላ"
                    },
                    {
                        "woredaCode": "AMWEB0SHN1",
                        "woredaEng": "Shindi City Administration",
                        "woredaAmh": "ሽንዲ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "AMWEB0WMB0",
                        "woredaEng": "Wemeberma",
                        "woredaAmh": "ወምበርማ"
                    }
                ]
            },
            {
                "zoneCode": "AMWEG00000",
                "zoneEng": "West Gondar",
                "zoneAmh": "ምዕራብ ጎንደር",
                "woredas": [
                    {
                        "woredaCode": "AMWEG0ADA0",
                        "woredaEng": "Adagn Agerchaqo",
                        "woredaAmh": "አዳኝ አገርጫቆ"
                    },
                    {
                        "woredaCode": "AMWEG0GEW1",
                        "woredaEng": "Gende Wuha City Administration",
                        "woredaAmh": "ገንደ ውሀ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "AMWEG0MTM0",
                        "woredaEng": "Metema",
                        "woredaAmh": "መተማ"
                    },
                    {
                        "woredaCode": "AMWEG0MEY1",
                        "woredaEng": "Metema Yohanes City Administration",
                        "woredaAmh": "መተማ ዮሐንስ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "AMWEG0MIG1",
                        "woredaEng": "Midre Genet City Administration",
                        "woredaAmh": "ምድረ ገነት ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "AMWEG0QUA0",
                        "woredaEng": "Quara",
                        "woredaAmh": "ቋራ"
                    },
                    {
                        "woredaCode": "AMWEG0WEA0",
                        "woredaEng": "West Armachiho",
                        "woredaAmh": "ምዕራብ አርማጭሆ"
                    }
                ]
            },
            {
                "zoneCode": "AMWOR10000",
                "zoneEng": "Woldiya Regiopolis City Administration",
                "zoneAmh": "ወልድያ ሪጂዮፖሊስ ከተማ አስተዳደር",
                "woredas": [
                    {
                        "woredaCode": "AMWOR1ETT3",
                        "woredaEng": "Etege Taytu Sub City",
                        "woredaAmh": "እቴጌ ጣይቱ ክፍለ ከተማ"
                    },
                    {
                        "woredaCode": "AMWOR1TRA3",
                        "woredaEng": "Talaku Ras Ali Sub City",
                        "woredaAmh": "ታላቁ ራስ አሊ ክፍለ ከተማ"
                    },
                    {
                        "woredaCode": "AMWOR1YEJ3",
                        "woredaEng": "Yeju Sub City",
                        "woredaAmh": "የጁ ክፍለ ከተማ"
                    }
                ]
            }
        ]
    },
    {
        "regionCode": "BG00000000",
        "regionEng": "Benishangul Gumuz",
        "regionAmh": "ቤኒሻንጉል ጉሙዝ",
        "zones": [
            {
                "zoneCode": "BGASS00000",
                "zoneEng": "Assosa",
                "zoneAmh": "አሶሳ",
                "woredas": [
                    {
                        "woredaCode": "BGASS0ABR0",
                        "woredaEng": "Abrehamo",
                        "woredaAmh": "አብርሀሞ"
                    },
                    {
                        "woredaCode": "BGASS0BMB0",
                        "woredaEng": "Bambasi",
                        "woredaAmh": "ባምባሲ"
                    },
                    {
                        "woredaCode": "BGASS0BLD0",
                        "woredaEng": "Bildiglu",
                        "woredaAmh": "ቢልዲግሉ"
                    },
                    {
                        "woredaCode": "BGASS0HMS0",
                        "woredaEng": "Homosha",
                        "woredaAmh": "ሆሞሻ"
                    },
                    {
                        "woredaCode": "BGASS0KRM0",
                        "woredaEng": "Kurmuk",
                        "woredaAmh": "ኩርሙክ"
                    },
                    {
                        "woredaCode": "BGASS0MNG0",
                        "woredaEng": "Menge",
                        "woredaAmh": "መንጌ"
                    },
                    {
                        "woredaCode": "BGASS0SHR0",
                        "woredaEng": "Sherkole",
                        "woredaAmh": "ሸርቆሌ"
                    },
                    {
                        "woredaCode": "BGASS0UND0",
                        "woredaEng": "Undulu",
                        "woredaAmh": "ኡንዱሉ"
                    },
                    {
                        "woredaCode": "BGASS0URA0",
                        "woredaEng": "Ura",
                        "woredaAmh": "ኡራ"
                    }
                ]
            },
            {
                "zoneCode": "BGASS10000",
                "zoneEng": "Assosa City Administration",
                "zoneAmh": "አሶሳ ከተማ አስተዳደር",
                "woredas": [
                    {
                        "woredaCode": "BGASS1AS10",
                        "woredaEng": "Assosa Woreda 1",
                        "woredaAmh": "አሶሳ ወረዳ 1"
                    },
                    {
                        "woredaCode": "BGASS1AS20",
                        "woredaEng": "Assosa Woreda 2",
                        "woredaAmh": "አሶሳ ወረዳ 2"
                    }
                ]
            },
            {
                "zoneCode": "BGGIB10000",
                "zoneEng": "Gilgel Beles City Administration",
                "zoneAmh": "ግልገል በለስ ከተማ አስተዳደር",
                "woredas": [
                    {
                        "woredaCode": "BGGIB1GIB1",
                        "woredaEng": "Gilgel Beles City Administration",
                        "woredaAmh": "ግልገል በለስ ከተማ አስተዳደር"
                    }
                ]
            },
            {
                "zoneCode": "BGKMS00000",
                "zoneEng": "Kamashi",
                "zoneAmh": "ካማሺ",
                "woredas": [
                    {
                        "woredaCode": "BGKMS0DMB0",
                        "woredaEng": "Dembe",
                        "woredaAmh": "ደምቤ"
                    },
                    {
                        "woredaCode": "BGKMS0KMS0",
                        "woredaEng": "Kamashi",
                        "woredaAmh": "ካማሺ"
                    },
                    {
                        "woredaCode": "BGKMS0MZG0",
                        "woredaEng": "Mizga",
                        "woredaAmh": "ምዥጋ"
                    },
                    {
                        "woredaCode": "BGKMS0SDL0",
                        "woredaEng": "Sedal",
                        "woredaAmh": "ሰዳል"
                    },
                    {
                        "woredaCode": "BGKMS0ZAY0",
                        "woredaEng": "Zay",
                        "woredaAmh": "ዛይ"
                    }
                ]
            },
            {
                "zoneCode": "BGKMS10000",
                "zoneEng": "Kamashi City Administration",
                "zoneAmh": "ካማሺ ከተማ አስተዳደር",
                "woredas": [
                    {
                        "woredaCode": "BGKMS1KMS1",
                        "woredaEng": "Kamashi City Administration",
                        "woredaAmh": "ካማሺ ከተማ አስተዳደር"
                    }
                ]
            },
            {
                "zoneCode": "BGMAK50000",
                "zoneEng": "Mao Ena Komo Liyu Woreda",
                "zoneAmh": "ማኦ እና ኮሞ ልዩ ወረዳ",
                "woredas": [
                    {
                        "woredaCode": "BGMAK5MAK5",
                        "woredaEng": "Mao Ena Komo Liyu Woreda",
                        "woredaAmh": "ማኦ እና ኮሞ ልዩ ወረዳ"
                    }
                ]
            },
            {
                "zoneCode": "BGMTK00000",
                "zoneEng": "Metekel",
                "zoneAmh": "መተከል",
                "woredas": [
                    {
                        "woredaCode": "BGMTK0BLN0",
                        "woredaEng": "Bulen",
                        "woredaAmh": "ቡለን"
                    },
                    {
                        "woredaCode": "BGMTK0DNG0",
                        "woredaEng": "Dangur",
                        "woredaAmh": "ዳንጉር"
                    },
                    {
                        "woredaCode": "BGMTK0DBT0",
                        "woredaEng": "Debatie",
                        "woredaAmh": "ድባጤ"
                    },
                    {
                        "woredaCode": "BGMTK0GUB0",
                        "woredaEng": "Guba",
                        "woredaAmh": "ጉባ"
                    },
                    {
                        "woredaCode": "BGMTK0MND0",
                        "woredaEng": "Mandura",
                        "woredaAmh": "ማንዱራ"
                    },
                    {
                        "woredaCode": "BGMTK0PAW0",
                        "woredaEng": "Pawe",
                        "woredaAmh": "ፓዌ"
                    },
                    {
                        "woredaCode": "BGMTK0WMB0",
                        "woredaEng": "Wembera",
                        "woredaAmh": "ወምበራ"
                    }
                ]
            }
        ]
    },
    {
        "regionCode": "CE00000000",
        "regionEng": "Central Ethiopia",
        "regionAmh": "ማዕከላዊ ኢትዮጵያ",
        "zones": [
            {
                "zoneCode": "CEGRG00000",
                "zoneEng": "Gurage",
                "zoneAmh": "ጉራጌ",
                "woredas": [
                    {
                        "woredaCode": "CEGRG0ABS0",
                        "woredaEng": "Abeshege",
                        "woredaAmh": "አበሽጌ"
                    },
                    {
                        "woredaCode": "CEGRG0AGN1",
                        "woredaEng": "Agena City Administration",
                        "woredaAmh": "አገና ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "CEGRG0ARA1",
                        "woredaEng": "Arekit City Administartion",
                        "woredaAmh": "አረቅጥ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "CEGRG0CHH0",
                        "woredaEng": "Cheha",
                        "woredaAmh": "ቸሃ"
                    },
                    {
                        "woredaCode": "CEGRG0EMD1",
                        "woredaEng": "Emdebir City Administration",
                        "woredaAmh": "እምድብር ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "CEGRG0END0",
                        "woredaEng": "Endegagn",
                        "woredaAmh": "እንደጋኝ"
                    },
                    {
                        "woredaCode": "CEGRG0ENR0",
                        "woredaEng": "Enor",
                        "woredaAmh": "እኖር"
                    },
                    {
                        "woredaCode": "CEGRG0EEM0",
                        "woredaEng": "Enor Ener Meger",
                        "woredaAmh": "እኖር ኤነር መገር"
                    },
                    {
                        "woredaCode": "CEGRG0EZH0",
                        "woredaEng": "Ezha",
                        "woredaAmh": "እዣ"
                    },
                    {
                        "woredaCode": "CEGRG0GGW0",
                        "woredaEng": "Gedebano Gutazer Welene",
                        "woredaAmh": "ገደባኖ ጉታዘር ወለኔ"
                    },
                    {
                        "woredaCode": "CEGRG0GET0",
                        "woredaEng": "Geta",
                        "woredaAmh": "ጌታ"
                    },
                    {
                        "woredaCode": "CEGRG0GMR0",
                        "woredaEng": "Gumer",
                        "woredaAmh": "ጉመር"
                    },
                    {
                        "woredaCode": "CEGRG0GNC1",
                        "woredaEng": "Gunchere City Administration",
                        "woredaAmh": "ጉንችሬ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "CEGRG0MUA0",
                        "woredaEng": "Muhr Aklil",
                        "woredaAmh": "ሙህር አክሊል"
                    },
                    {
                        "woredaCode": "CEGRG0WLK1",
                        "woredaEng": "Welkite City Administration",
                        "woredaAmh": "ወልቂጤ ከተማ አስተዳደር"
                    }
                ]
            },
            {
                "zoneCode": "CEHDY00000",
                "zoneEng": "Hadiya",
                "zoneAmh": "ሃዲያ",
                "woredas": [
                    {
                        "woredaCode": "CEHDY0AMK0",
                        "woredaEng": "Ameka",
                        "woredaAmh": "አመካ"
                    },
                    {
                        "woredaCode": "CEHDY0ANL0",
                        "woredaEng": "Anlemo",
                        "woredaAmh": "አንሌሞ"
                    },
                    {
                        "woredaCode": "CEHDY0BNN2",
                        "woredaEng": "Bonnosha Town Administration",
                        "woredaAmh": "ቦኖሻ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "CEHDY0DUN0",
                        "woredaEng": "Duna",
                        "woredaAmh": "ዱና"
                    },
                    {
                        "woredaCode": "CEHDY0FNK2",
                        "woredaEng": "Fonko Town Administration",
                        "woredaAmh": "ፎንቆ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "CEHDY0GIB0",
                        "woredaEng": "Gibe",
                        "woredaAmh": "ጊቤ"
                    },
                    {
                        "woredaCode": "CEHDY0GNB2",
                        "woredaEng": "Ginbichu Town Administration",
                        "woredaAmh": "ጊንቢቹ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "CEHDY0GMB0",
                        "woredaEng": "Gombora",
                        "woredaAmh": "ጎምቦራ"
                    },
                    {
                        "woredaCode": "CEHDY0HMC2",
                        "woredaEng": "Homecho Town Administration",
                        "woredaAmh": "ሆመቾ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "CEHDY0HSS2",
                        "woredaEng": "Hossana Town Administration",
                        "woredaAmh": "ሆሳዕና ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "CEHDY0JJR2",
                        "woredaEng": "Jajura Town Administration",
                        "woredaAmh": "ጃጁራ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "CEHDY0LEM0",
                        "woredaEng": "Lemo",
                        "woredaAmh": "ሌሞ"
                    },
                    {
                        "woredaCode": "CEHDY0MIB0",
                        "woredaEng": "Mierab Badewacho",
                        "woredaAmh": "ምዕራብ ባደዋቾ"
                    },
                    {
                        "woredaCode": "CEHDY0MIS0",
                        "woredaEng": "Mierab Soro",
                        "woredaAmh": "ምዕራብ ሶሮ"
                    },
                    {
                        "woredaCode": "CEHDY0MSH0",
                        "woredaEng": "Misha",
                        "woredaAmh": "ሚሻ"
                    },
                    {
                        "woredaCode": "CEHDY0MIC0",
                        "woredaEng": "Misrak Badewacho",
                        "woredaAmh": "ምስራቅ ባደዋቾ"
                    },
                    {
                        "woredaCode": "CEHDY0SHS0",
                        "woredaEng": "Shashogo",
                        "woredaAmh": "ሻሾጎ"
                    },
                    {
                        "woredaCode": "CEHDY0SHN2",
                        "woredaEng": "Shone Town Administration",
                        "woredaAmh": "ሾኔ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "CEHDY0SIB0",
                        "woredaEng": "Siraro Badewacho",
                        "woredaAmh": "ሲራሮ ባደዋቾ"
                    },
                    {
                        "woredaCode": "CEHDY0SOR0",
                        "woredaEng": "Soro",
                        "woredaAmh": "ሶሮ"
                    }
                ]
            },
            {
                "zoneCode": "CEHLB00000",
                "zoneEng": "Halaba",
                "zoneAmh": "ሃላባ",
                "woredas": [
                    {
                        "woredaCode": "CEHLB0ATU0",
                        "woredaEng": "Atoti Ulo",
                        "woredaAmh": "አቶቲ ኡሎ"
                    },
                    {
                        "woredaCode": "CEHLB0HAQ1",
                        "woredaEng": "Halaba Qulito City Administration",
                        "woredaAmh": "ሀላባ ቁሊቶ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "CEHLB0WER0",
                        "woredaEng": "Wera",
                        "woredaAmh": "ዌራ"
                    },
                    {
                        "woredaCode": "CEHLB0WED0",
                        "woredaEng": "Wera Dijo",
                        "woredaAmh": "ዌራ ዲጆ"
                    }
                ]
            },
            {
                "zoneCode": "CEKMB00000",
                "zoneEng": "Kembata",
                "zoneAmh": "ከምባታ",
                "woredas": [
                    {
                        "woredaCode": "CEKMB0ADZ0",
                        "woredaEng": "Adilo Zuriya",
                        "woredaAmh": "አዲሎ ዙሪያ"
                    },
                    {
                        "woredaCode": "CEKMB0ANG0",
                        "woredaEng": "Angecha",
                        "woredaAmh": "አንገጫ"
                    },
                    {
                        "woredaCode": "CEKMB0ANG1",
                        "woredaEng": "Angecha City Administration",
                        "woredaAmh": "አንገጫ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "CEKMB0DMB0",
                        "woredaEng": "Damboya",
                        "woredaAmh": "ዳምቦያ"
                    },
                    {
                        "woredaCode": "CEKMB0DMB1",
                        "woredaEng": "Damboya City Administration",
                        "woredaAmh": "ዳምቦያ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "CEKMB0DYG0",
                        "woredaEng": "Doyogena",
                        "woredaAmh": "ዶዮገና"
                    },
                    {
                        "woredaCode": "CEKMB0DYG1",
                        "woredaEng": "Doyogena City Administration",
                        "woredaAmh": "ዶዮገና ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "CEKMB0DRM1",
                        "woredaEng": "Durame City Administration",
                        "woredaAmh": "ዱራሜ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "CEKMB0HDR1",
                        "woredaEng": "Hadero City Administration",
                        "woredaAmh": "ሀደሮ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "CEKMB0HAT0",
                        "woredaEng": "Hadero Tunto",
                        "woredaAmh": "ሀደሮ ጡንጦ"
                    },
                    {
                        "woredaCode": "CEKMB0QCH0",
                        "woredaEng": "Qachabira",
                        "woredaAmh": "ቃጫቢራ"
                    },
                    {
                        "woredaCode": "CEKMB0QEG0",
                        "woredaEng": "Qedida Gamela",
                        "woredaAmh": "ቀዲዳ ጋሜላ"
                    },
                    {
                        "woredaCode": "CEKMB0SHA1",
                        "woredaEng": "Shinshicho City Administartion",
                        "woredaAmh": "ሺንሺቾ ከተማ አስተዳደር"
                    }
                ]
            },
            {
                "zoneCode": "CEMRQ50000",
                "zoneEng": "Mareqo Special Woreda",
                "zoneAmh": "ማረቆ ልዩ ወረዳ",
                "woredas": [
                    {
                        "woredaCode": "CEMRQ5MRQ5",
                        "woredaEng": "Mareqo Special Woreda",
                        "woredaAmh": "ማረቆ ልዩ ወረዳ"
                    }
                ]
            },
            {
                "zoneCode": "CEMIG00000",
                "zoneEng": "Misraq Gurage",
                "zoneAmh": "ምስራቅ ጉራጌ",
                "woredas": [
                    {
                        "woredaCode": "CEMIG0BUE2",
                        "woredaEng": "Buee Town Administration",
                        "woredaAmh": "ቡኢ ከተማ አስተደደር"
                    },
                    {
                        "woredaCode": "CEMIG0BTJ2",
                        "woredaEng": "Butajira Town Administration",
                        "woredaAmh": "ቡታጅራ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "CEMIG0ENS2",
                        "woredaEng": "Enseno Town Administration",
                        "woredaAmh": "ኢንሴኖ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "CEMIG0MSK0",
                        "woredaEng": "Meskan",
                        "woredaAmh": "መስቃን"
                    },
                    {
                        "woredaCode": "CEMIG0MIM0",
                        "woredaEng": "Misrak Meskan",
                        "woredaAmh": "ምስራቅ መስቃን"
                    },
                    {
                        "woredaCode": "CEMIG0SOD0",
                        "woredaEng": "Sodo",
                        "woredaAmh": "ሶዶ"
                    },
                    {
                        "woredaCode": "CEMIG0SOS0",
                        "woredaEng": "South Sodo",
                        "woredaAmh": "ደቡብ ሶዶ"
                    }
                ]
            },
            {
                "zoneCode": "CEQBN50000",
                "zoneEng": "Qebena Special Woreda",
                "zoneAmh": "ቀቤና ልዩ ወረዳ",
                "woredas": [
                    {
                        "woredaCode": "CEQBN5QBN5",
                        "woredaEng": "Qebena Special Woreda",
                        "woredaAmh": "ቀቤና ልዩ ወረዳ"
                    }
                ]
            },
            {
                "zoneCode": "CESLT00000",
                "zoneEng": "Silte",
                "zoneAmh": "ስልጤ",
                "woredas": [
                    {
                        "woredaCode": "CESLT0ALG1",
                        "woredaEng": "Alem Gebeya City Administration",
                        "woredaAmh": "አለም ገበያ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "CESLT0ALW0",
                        "woredaEng": "Alicho weriro",
                        "woredaAmh": "አሊቾ ውሪሮ"
                    },
                    {
                        "woredaCode": "CESLT0DLC0",
                        "woredaEng": "Dalocha",
                        "woredaAmh": "ዳሎቻ"
                    },
                    {
                        "woredaCode": "CESLT0DLC1",
                        "woredaEng": "Dalocha City Administration",
                        "woredaAmh": "ዳሎቻ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "CESLT0HLB0",
                        "woredaEng": "Hulbareg",
                        "woredaAmh": "ሁልባረግ"
                    },
                    {
                        "woredaCode": "CESLT0KBT1",
                        "woredaEng": "Kibet City Administration",
                        "woredaAmh": "ቅበት ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "CESLT0LNF0",
                        "woredaEng": "Lanfro",
                        "woredaAmh": "ላንፍሮ"
                    },
                    {
                        "woredaCode": "CESLT0MAB0",
                        "woredaEng": "Mierab Azernet Berbere",
                        "woredaAmh": "ምእራብ አዘርነት በርበሬ"
                    },
                    {
                        "woredaCode": "CESLT0MAC0",
                        "woredaEng": "Misrak Azernet Berbere",
                        "woredaAmh": "ምስራቅ አዘርነት በርበሬ"
                    },
                    {
                        "woredaCode": "CESLT0MIS0",
                        "woredaEng": "Misrak Silti",
                        "woredaAmh": "ምስራቅ ስልጢ"
                    },
                    {
                        "woredaCode": "CESLT0MIT0",
                        "woredaEng": "Mito",
                        "woredaAmh": "ሚቶ"
                    },
                    {
                        "woredaCode": "CESLT0SNK0",
                        "woredaEng": "Sankura",
                        "woredaAmh": "ሳንኩራ"
                    },
                    {
                        "woredaCode": "CESLT0SLT0",
                        "woredaEng": "Silti",
                        "woredaAmh": "ስልጢ"
                    },
                    {
                        "woredaCode": "CESLT0TOR1",
                        "woredaEng": "Tora City Administration",
                        "woredaAmh": "ጦራ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "CESLT0WRB1",
                        "woredaEng": "Werabe City Administration",
                        "woredaAmh": "ወራቤ ከተማ አስተዳደር"
                    }
                ]
            },
            {
                "zoneCode": "CETMB50000",
                "zoneEng": "Tembaro Special Woreda",
                "zoneAmh": "ጠምባሮ ልዩ ወረዳ",
                "woredas": [
                    {
                        "woredaCode": "CETMB5MDL2",
                        "woredaEng": "Mudula Town Administration",
                        "woredaAmh": "ሙዱላ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "CETMB5TMB0",
                        "woredaEng": "Tembaro",
                        "woredaAmh": "ጠምባሮ"
                    }
                ]
            },
            {
                "zoneCode": "CEYEM00000",
                "zoneEng": "Yem",
                "zoneAmh": "የም",
                "woredas": [
                    {
                        "woredaCode": "CEYEM0DSZ0",
                        "woredaEng": "Deri Saja Zuriya",
                        "woredaAmh": "ደሪ ሳጃ ዙሪያ"
                    },
                    {
                        "woredaCode": "CEYEM0FOF0",
                        "woredaEng": "Fofa",
                        "woredaAmh": "ፎፋ"
                    },
                    {
                        "woredaCode": "CEYEM0SAJ1",
                        "woredaEng": "Saja City Administration",
                        "woredaAmh": "ሳጃ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "CEYEM0TOB0",
                        "woredaEng": "Toba",
                        "woredaAmh": "ቶባ"
                    }
                ]
            }
        ]
    },
    {
        "regionCode": "DD00000000",
        "regionEng": "Dire Dawa",
        "regionAmh": "ድሬዳዋ",
        "zones": [
            {
                "zoneCode": "DDDID80000",
                "zoneEng": "Dire Dawa",
                "zoneAmh": "ድሬዳዋ",
                "woredas": [
                    {
                        "woredaCode": "DDDID8DID0",
                        "woredaEng": "Dire Dawa Administration",
                        "woredaAmh": "ድሬዳዋ አስተዳደር"
                    }
                ]
            }
        ]
    },
    {
        "regionCode": "GM00000000",
        "regionEng": "Gambela",
        "regionAmh": "ጋምቤላ",
        "zones": [
            {
                "zoneCode": "GMAGN00000",
                "zoneEng": "Agnua",
                "zoneAmh": "አኟ",
                "woredas": [
                    {
                        "woredaCode": "GMAGN0ABB0",
                        "woredaEng": "Abobo",
                        "woredaAmh": "አቦቦ"
                    },
                    {
                        "woredaCode": "GMAGN0DIM0",
                        "woredaEng": "Dima",
                        "woredaAmh": "ዲማ"
                    },
                    {
                        "woredaCode": "GMAGN0GMB0",
                        "woredaEng": "Gambela",
                        "woredaAmh": "ጋምቤላ"
                    },
                    {
                        "woredaCode": "GMAGN0GOG0",
                        "woredaEng": "Gog",
                        "woredaAmh": "ጎግ"
                    },
                    {
                        "woredaCode": "GMAGN0JOR0",
                        "woredaEng": "Jor",
                        "woredaAmh": "ጆር"
                    }
                ]
            },
            {
                "zoneCode": "GMETN50000",
                "zoneEng": "Etang Special Woreda",
                "zoneAmh": "ኢታንግ ልዩ ወረዳ",
                "woredas": [
                    {
                        "woredaCode": "GMETN5ETN5",
                        "woredaEng": "Etang Special Woreda",
                        "woredaAmh": "ኢታንግ ልዩ ወረዳ"
                    }
                ]
            },
            {
                "zoneCode": "GMGMB10000",
                "zoneEng": "Gambella City Administration",
                "zoneAmh": "ጋምቤላ ከተማ አስተዳደር",
                "woredas": [
                    {
                        "woredaCode": "GMGMB1GMB1",
                        "woredaEng": "Gambella City Administration",
                        "woredaAmh": "ጋምቤላ ከተማ አስተዳደር"
                    }
                ]
            },
            {
                "zoneCode": "GMMJN00000",
                "zoneEng": "Majang",
                "zoneAmh": "ማጃንግ",
                "woredas": [
                    {
                        "woredaCode": "GMMJN0GDR0",
                        "woredaEng": "Godere",
                        "woredaAmh": "ጎደሬ"
                    },
                    {
                        "woredaCode": "GMMJN0MNG0",
                        "woredaEng": "Mengeshi",
                        "woredaAmh": "መንገሺ"
                    }
                ]
            },
            {
                "zoneCode": "GMMET10000",
                "zoneEng": "Meti City Administration",
                "zoneAmh": "ሜጢ ከተማ አስተዳደር",
                "woredas": [
                    {
                        "woredaCode": "GMMET1MET1",
                        "woredaEng": "Meti City Administration",
                        "woredaAmh": "ሜጢ ከተማ አስተዳደር"
                    }
                ]
            },
            {
                "zoneCode": "GMNUE00000",
                "zoneEng": "Nuer",
                "zoneAmh": "ኑዌር",
                "woredas": [
                    {
                        "woredaCode": "GMNUE0AKB0",
                        "woredaEng": "Akobo",
                        "woredaAmh": "አኮቦ"
                    },
                    {
                        "woredaCode": "GMNUE0JKW0",
                        "woredaEng": "Jikawo",
                        "woredaAmh": "ጂካዎ"
                    },
                    {
                        "woredaCode": "GMNUE0LAR0",
                        "woredaEng": "Lare",
                        "woredaAmh": "ላሬ"
                    },
                    {
                        "woredaCode": "GMNUE0MKW0",
                        "woredaEng": "Makuwey",
                        "woredaAmh": "ማኩዌይ"
                    },
                    {
                        "woredaCode": "GMNUE0WNT0",
                        "woredaEng": "Wantuwa",
                        "woredaAmh": "ዋንቱዋ"
                    }
                ]
            }
        ]
    },
    {
        "regionCode": "HR00000000",
        "regionEng": "Harari",
        "regionAmh": "ሃረሪ",
        "zones": [
            {
                "zoneCode": "HRHRR80000",
                "zoneEng": "Harari",
                "zoneAmh": "ሃረሪ",
                "woredas": [
                    {
                        "woredaCode": "HRHRR8ABD0",
                        "woredaEng": "Abadir",
                        "woredaAmh": "አባዲር"
                    },
                    {
                        "woredaCode": "HRHRR8ABK0",
                        "woredaEng": "Aboker",
                        "woredaAmh": "አቦከር"
                    },
                    {
                        "woredaCode": "HRHRR8AMN0",
                        "woredaEng": "Amir Nur",
                        "woredaAmh": "አሚር ኑር"
                    },
                    {
                        "woredaCode": "HRHRR8DRT0",
                        "woredaEng": "Direteyara",
                        "woredaAmh": "ድሬጠያራ"
                    },
                    {
                        "woredaCode": "HRHRR8ERR0",
                        "woredaEng": "Erer",
                        "woredaAmh": "ኤረር"
                    },
                    {
                        "woredaCode": "HRHRR8HKM0",
                        "woredaEng": "Hakim",
                        "woredaAmh": "ሀኪም"
                    },
                    {
                        "woredaCode": "HRHRR8JIE0",
                        "woredaEng": "Jin Ella",
                        "woredaAmh": "ጂን ኤላ"
                    },
                    {
                        "woredaCode": "HRHRR8SHN0",
                        "woredaEng": "Shenkor",
                        "woredaAmh": "ሸንኮር"
                    },
                    {
                        "woredaCode": "HRHRR8SOF0",
                        "woredaEng": "Sofi",
                        "woredaAmh": "ሶፊ"
                    }
                ]
            }
        ]
    },
    {
        "regionCode": "OR00000000",
        "regionEng": "Oromia",
        "regionAmh": "ኦሮሚያ",
        "zones": [
            {
                "zoneCode": "ORADA10000",
                "zoneEng": "Adama City Administration - Aba Gada",
                "zoneAmh": "አዳማ ከተማ አስተዳደር - አባ ገዳ",
                "woredas": [
                    {
                        "woredaCode": "ORADA1BDT0",
                        "woredaEng": "Badatu",
                        "woredaAmh": "ቤዳቱ"
                    },
                    {
                        "woredaCode": "ORADA1DGG0",
                        "woredaEng": "Degaga",
                        "woredaAmh": "ደጋጋ"
                    },
                    {
                        "woredaCode": "ORADA1ODA0",
                        "woredaEng": "Oda",
                        "woredaAmh": "ኦዳ"
                    }
                ]
            },
            {
                "zoneCode": "ORADB10000",
                "zoneEng": "Adama City Administration - Boku Shanan",
                "zoneAmh": "አዳማ ከተማ አስተዳደር - ቦኩ ሻናን",
                "woredas": [
                    {
                        "woredaCode": "ORADB1ARR0",
                        "woredaEng": "Aroreti",
                        "woredaAmh": "አሮሬቲ"
                    },
                    {
                        "woredaCode": "ORADB1AWM0",
                        "woredaEng": "Awash Melkasa",
                        "woredaAmh": "አዋሽ መልካሳ"
                    },
                    {
                        "woredaCode": "ORADB1TOO0",
                        "woredaEng": "Torban Obo",
                        "woredaAmh": "ቶርባን ኦቦ"
                    }
                ]
            },
            {
                "zoneCode": "ORADO10000",
                "zoneEng": "Adama City Administration - Bole",
                "zoneAmh": "አዳማ ከተማ አስተዳደር - ቦሌ",
                "woredas": [
                    {
                        "woredaCode": "ORADO1AND0",
                        "woredaEng": "Andode",
                        "woredaAmh": "አንዶዴ"
                    },
                    {
                        "woredaCode": "ORADO1DAA0",
                        "woredaEng": "Dadacha Arara",
                        "woredaAmh": "ዳዴቻ አራራ"
                    },
                    {
                        "woredaCode": "ORADO1DAB0",
                        "woredaEng": "Daka Adi",
                        "woredaAmh": "ደቃ አዲ"
                    },
                    {
                        "woredaCode": "ORADO1GOR0",
                        "woredaEng": "Goro",
                        "woredaAmh": "ጎሮ"
                    }
                ]
            },
            {
                "zoneCode": "ORADD10000",
                "zoneEng": "Adama City Administration - Dabe",
                "zoneAmh": "አዳማ ከተማ አስተዳደር - ዳቤ",
                "woredas": [
                    {
                        "woredaCode": "ORADD1CHF0",
                        "woredaEng": "Chafe",
                        "woredaAmh": "ጨፌ"
                    },
                    {
                        "woredaCode": "ORADD1HNG0",
                        "woredaEng": "Hengatu",
                        "woredaAmh": "ሄንጋቱ"
                    },
                    {
                        "woredaCode": "ORADD1SOD0",
                        "woredaEng": "Soloke Dongore",
                        "woredaAmh": "ሶሎክ ዶንጎሬ"
                    }
                ]
            },
            {
                "zoneCode": "ORADN10000",
                "zoneEng": "Adama City Administration - Danbala",
                "zoneAmh": "አዳማ ከተማ አስተዳደር - ደንበላ",
                "woredas": [
                    {
                        "woredaCode": "ORADN1ERC0",
                        "woredaEng": "Erecha",
                        "woredaAmh": "ኢሬቻ"
                    },
                    {
                        "woredaCode": "ORADN1MAA0",
                        "woredaEng": "Malka Adama",
                        "woredaAmh": "መልካ አዳማ"
                    },
                    {
                        "woredaCode": "ORADN1WNJ0",
                        "woredaEng": "Wanji",
                        "woredaAmh": "ወንጂ"
                    }
                ]
            },
            {
                "zoneCode": "ORADL10000",
                "zoneEng": "Adama City Administration - Logo",
                "zoneAmh": "አዳማ ከተማ አስተዳደር - ሎጎ",
                "woredas": [
                    {
                        "woredaCode": "ORADL1BRC0",
                        "woredaEng": "Barecha",
                        "woredaAmh": "በሬቻ"
                    },
                    {
                        "woredaCode": "ORADL1DIN0",
                        "woredaEng": "Dire Naga",
                        "woredaAmh": "ድሬ ነጋ"
                    },
                    {
                        "woredaCode": "ORADL1MGR0",
                        "woredaEng": "Migira",
                        "woredaAmh": "ሚግራ"
                    }
                ]
            },
            {
                "zoneCode": "ORAGR10000",
                "zoneEng": "Agaro City Administration",
                "zoneAmh": "አጋሮ ከተማ አስተዳደር",
                "woredas": [
                    {
                        "woredaCode": "ORAGR1BAK7",
                        "woredaEng": "Beke Agelo Kebele",
                        "woredaAmh": "በኬ አገሎ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORAGR1BBK7",
                        "woredaEng": "Biftu Baleto Kebele",
                        "woredaAmh": "ቢፍቱ ባለቶ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORAGR1BUK7",
                        "woredaEng": "Bulebulo Kebele",
                        "woredaAmh": "ቡለቡሎ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORAGR1MAK7",
                        "woredaEng": "Mesera Ababoka Kebele",
                        "woredaAmh": "መሰራ አባቦቃ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORAGR1TJK7",
                        "woredaEng": "Temsa Jida Kebele",
                        "woredaAmh": "ተምሳ ጂዳ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORAGR1TKK7",
                        "woredaEng": "Tije Koye Kebele",
                        "woredaAmh": "ትጄ ኮዬ ቀበሌ"
                    }
                ]
            },
            {
                "zoneCode": "ORAMB10000",
                "zoneEng": "Ambo City Administration",
                "zoneAmh": "አምቦ ከተማ አስተዳደር",
                "woredas": [
                    {
                        "woredaCode": "ORAMB1AKK7",
                        "woredaEng": "Awaro Kora Kebele",
                        "woredaAmh": "አዋሮ ቆራ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORAMB1HAK7",
                        "woredaEng": "Hora Ayetu Kebele",
                        "woredaAmh": "ሆራ አዬቱ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORAMB1KOL7",
                        "woredaEng": "Kisose Odo Liben Kebele",
                        "woredaAmh": "ኪሶሴ ኦዶ ሊባን ቀበሌ"
                    },
                    {
                        "woredaCode": "ORAMB1SFK7",
                        "woredaEng": "Senkele Farisi Kebele",
                        "woredaAmh": "ሰንቃሌ ፋርሲ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORAMB1TKK7",
                        "woredaEng": "Torben Kutaye Kebele",
                        "woredaAmh": "ቶርበን ኩታዬ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORAMB1YGK7",
                        "woredaEng": "Yahi Geda Kebele",
                        "woredaAmh": "ያኢ ገዳ ቀበሌ"
                    }
                ]
            },
            {
                "zoneCode": "ORARS00000",
                "zoneEng": "Arsi",
                "zoneAmh": "አርሲ",
                "woredas": [
                    {
                        "woredaCode": "ORARS0AMG0",
                        "woredaEng": "Amigna",
                        "woredaAmh": "አሚኛ"
                    },
                    {
                        "woredaCode": "ORARS0ASK0",
                        "woredaEng": "Aseko",
                        "woredaAmh": "አሰኮ"
                    },
                    {
                        "woredaCode": "ORARS0BEG0",
                        "woredaEng": "Bele Gesgar",
                        "woredaAmh": "በሌ ገሰጋር"
                    },
                    {
                        "woredaCode": "ORARS0BKJ2",
                        "woredaEng": "Bokoji Town",
                        "woredaAmh": "ቦቆጂ ከተማ"
                    },
                    {
                        "woredaCode": "ORARS0CHL0",
                        "woredaEng": "Chole",
                        "woredaAmh": "ጮሌ"
                    },
                    {
                        "woredaCode": "ORARS0DHR2",
                        "woredaEng": "Dhera Town",
                        "woredaAmh": "ዴራ ከተማ"
                    },
                    {
                        "woredaCode": "ORARS0DIT0",
                        "woredaEng": "Digeluna Tijo",
                        "woredaAmh": "ዲገሉና ጢጆ"
                    },
                    {
                        "woredaCode": "ORARS0DKS0",
                        "woredaEng": "Diksis",
                        "woredaAmh": "ዲክሲስ"
                    },
                    {
                        "woredaCode": "ORARS0DDT0",
                        "woredaEng": "Dodota",
                        "woredaAmh": "ዶዶታ"
                    },
                    {
                        "woredaCode": "ORARS0GLL0",
                        "woredaEng": "Gololcha",
                        "woredaAmh": "ጎሎልቻ"
                    },
                    {
                        "woredaCode": "ORARS0GUN0",
                        "woredaEng": "Guna",
                        "woredaAmh": "ጉና"
                    },
                    {
                        "woredaCode": "ORARS0HTS0",
                        "woredaEng": "Hetosa",
                        "woredaAmh": "ሄጦሳ"
                    },
                    {
                        "woredaCode": "ORARS0HOW0",
                        "woredaEng": "Honkolo Wabe",
                        "woredaAmh": "ሆንቆሎ ዋቤ"
                    },
                    {
                        "woredaCode": "ORARS0HRT2",
                        "woredaEng": "Huruta Town",
                        "woredaAmh": "ሁሩታ ከተማ"
                    },
                    {
                        "woredaCode": "ORARS0JEJ0",
                        "woredaEng": "Jeju",
                        "woredaAmh": "ጀጁ"
                    },
                    {
                        "woredaCode": "ORARS0LEB0",
                        "woredaEng": "Lemuna Bilbilo",
                        "woredaAmh": "ሌሙና ቢልቢሎ"
                    },
                    {
                        "woredaCode": "ORARS0LOH0",
                        "woredaEng": "Lode Hetosa",
                        "woredaAmh": "ሎዴ ሄጦሳ"
                    },
                    {
                        "woredaCode": "ORARS0MRT0",
                        "woredaEng": "Merti",
                        "woredaAmh": "መርቲ"
                    },
                    {
                        "woredaCode": "ORARS0MNS0",
                        "woredaEng": "Munesa",
                        "woredaAmh": "ሙኔሳ"
                    },
                    {
                        "woredaCode": "ORARS0ROB0",
                        "woredaEng": "Robe",
                        "woredaAmh": "ሮቤ"
                    },
                    {
                        "woredaCode": "ORARS0SER0",
                        "woredaEng": "Seru",
                        "woredaAmh": "ሴሩ"
                    },
                    {
                        "woredaCode": "ORARS0SHK0",
                        "woredaEng": "Shenen Kolu",
                        "woredaAmh": "ሸነን ኮሉ"
                    },
                    {
                        "woredaCode": "ORARS0SHR0",
                        "woredaEng": "Shirka",
                        "woredaAmh": "ሽርካ"
                    },
                    {
                        "woredaCode": "ORARS0SIR0",
                        "woredaEng": "Sire",
                        "woredaAmh": "ስሬ"
                    },
                    {
                        "woredaCode": "ORARS0SUD0",
                        "woredaEng": "Sude",
                        "woredaAmh": "ሱዴ"
                    },
                    {
                        "woredaCode": "ORARS0TCH0",
                        "woredaEng": "Ticho",
                        "woredaAmh": "ጢቾ"
                    },
                    {
                        "woredaCode": "ORARS0TIY0",
                        "woredaEng": "Tiyo",
                        "woredaAmh": "ጢዮ"
                    },
                    {
                        "woredaCode": "ORARS0ZED0",
                        "woredaEng": "Zeway Dugda",
                        "woredaAmh": "ዙዋይ ዱግዳ"
                    }
                ]
            },
            {
                "zoneCode": "ORASL10000",
                "zoneEng": "Asella City Administration",
                "zoneAmh": "አሰላ ከተማ አስተዳደር",
                "woredas": [
                    {
                        "woredaCode": "ORASL1BUK7",
                        "woredaEng": "Burkitu Kebele",
                        "woredaAmh": "ቡርቂቱ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORASL1BUB7",
                        "woredaEng": "Buseta Kebele",
                        "woredaAmh": "ቡሰታ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORASL1CHK7",
                        "woredaEng": "Chilalo Kebele",
                        "woredaAmh": "ጭላሎ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORASL1HAK7",
                        "woredaEng": "Hanku Kebele",
                        "woredaAmh": "ሃንቁ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORASL1HEK7",
                        "woredaEng": "Helila Kebele",
                        "woredaAmh": "ሀሊላ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORASL1HGK7",
                        "woredaEng": "Hunde Gudina Kebele",
                        "woredaAmh": "ሁንዴ ጉዲና ቀበሌ"
                    },
                    {
                        "woredaCode": "ORASL1KOK7",
                        "woredaEng": "Kombolcha Kebele",
                        "woredaAmh": "ኮምቦልቻ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORASL1WEK7",
                        "woredaEng": "Welkesa Kebele",
                        "woredaAmh": "ወልኬሳ ቀበሌ"
                    }
                ]
            },
            {
                "zoneCode": "ORBAL00000",
                "zoneEng": "Bale",
                "zoneAmh": "ባሌ",
                "woredas": [
                    {
                        "woredaCode": "ORBAL0AGR0",
                        "woredaEng": "Agarfa",
                        "woredaAmh": "አጋርፋ"
                    },
                    {
                        "woredaCode": "ORBAL0BRB0",
                        "woredaEng": "Berbere",
                        "woredaAmh": "በርበሬ"
                    },
                    {
                        "woredaCode": "ORBAL0DEM0",
                        "woredaEng": "Delo Mena",
                        "woredaAmh": "ደሎ መና"
                    },
                    {
                        "woredaCode": "ORBAL0DNS0",
                        "woredaEng": "Dinsho",
                        "woredaAmh": "ዲንሾ"
                    },
                    {
                        "woredaCode": "ORBAL0GSR0",
                        "woredaEng": "Gasera",
                        "woredaAmh": "ጋሳራ"
                    },
                    {
                        "woredaCode": "ORBAL0GOB0",
                        "woredaEng": "Goba",
                        "woredaAmh": "ጎባ"
                    },
                    {
                        "woredaCode": "ORBAL0GOR0",
                        "woredaEng": "Goro",
                        "woredaAmh": "ጎሮ"
                    },
                    {
                        "woredaCode": "ORBAL0GUD0",
                        "woredaEng": "Gura Damole",
                        "woredaAmh": "ጉራ ዳሞሌ"
                    },
                    {
                        "woredaCode": "ORBAL0HAB0",
                        "woredaEng": "Harena Buluk",
                        "woredaAmh": "ሀረና ቡሉቅ"
                    },
                    {
                        "woredaCode": "ORBAL0SNN0",
                        "woredaEng": "Sinana",
                        "woredaAmh": "ሲናና"
                    }
                ]
            },
            {
                "zoneCode": "ORBAT10000",
                "zoneEng": "Batu City Administration",
                "zoneAmh": "ባቱ ከተማ አስተዳደር",
                "woredas": [
                    {
                        "woredaCode": "ORBAT1AGK7",
                        "woredaEng": "Abine Germama Kebele",
                        "woredaAmh": "አቢኔ ገርማማ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORBAT1ABK7",
                        "woredaEng": "Abosa Kebele",
                        "woredaAmh": "አቦሳ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORBAT1ATK7",
                        "woredaEng": "Adami Tulu Kebele",
                        "woredaAmh": "አዳሚ ቱሉ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORBAT1BAK7",
                        "woredaEng": "Batale Kebele",
                        "woredaAmh": "በተሌ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORBAT1BDK7",
                        "woredaEng": "Bochesa Dodicha Kebele",
                        "woredaAmh": "ቦጬሳ ዶዲቻ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORBAT1DAK7",
                        "woredaEng": "Dambal Kebele",
                        "woredaAmh": "ደምበል ቀበሌ"
                    },
                    {
                        "woredaCode": "ORBAT1EEK7",
                        "woredaEng": "Elka Edo Kebele",
                        "woredaAmh": "ኢልካ ኤዶ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORBAT1MSK7",
                        "woredaEng": "Malka Shalo Kebele",
                        "woredaAmh": "መልካ ሻሎ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORBAT1MWK7",
                        "woredaEng": "Malka Wafiko Kebele",
                        "woredaAmh": "መልካ ዋፊቆ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORBAT1WWK7",
                        "woredaEng": "Warja Washgula Kebele",
                        "woredaAmh": "ወርጃ ወሽጉላ ቀበሌ"
                    }
                ]
            },
            {
                "zoneCode": "ORBIC10000",
                "zoneEng": "Bishoftu City Administration - Chalalaka",
                "zoneAmh": "ቢሾፍቱ ከተማ አስተዳደር - ጨለለቃ",
                "woredas": [
                    {
                        "woredaCode": "ORBIC1ARS0",
                        "woredaEng": "Arsade",
                        "woredaAmh": "አርሰዴ"
                    },
                    {
                        "woredaCode": "ORBIC1ERR0",
                        "woredaEng": "Erar",
                        "woredaAmh": "ኤረር"
                    },
                    {
                        "woredaCode": "ORBIC1KLL0",
                        "woredaEng": "Kilolie",
                        "woredaAmh": "ኪሎሌ"
                    }
                ]
            },
            {
                "zoneCode": "ORBID10000",
                "zoneEng": "Bishoftu City Administration - Dibayu",
                "zoneAmh": "ቢሾፍቱ ከተማ አስተዳደር - ዲባዩ",
                "woredas": [
                    {
                        "woredaCode": "ORBID1BFT0",
                        "woredaEng": "Biftu",
                        "woredaAmh": "ቢፍቱ"
                    },
                    {
                        "woredaCode": "ORBID1DEB0",
                        "woredaEng": "Deke Bora",
                        "woredaAmh": "ደካ ቦራ"
                    },
                    {
                        "woredaCode": "ORBID1DIR0",
                        "woredaEng": "Dire",
                        "woredaAmh": "ድሬ"
                    },
                    {
                        "woredaCode": "ORBID1HOR0",
                        "woredaEng": "Hora",
                        "woredaAmh": "ሆራ"
                    }
                ]
            },
            {
                "zoneCode": "ORBIU10000",
                "zoneEng": "Bishoftu City Administration - Dukam",
                "zoneAmh": "ቢሾፍቱ ከተማ አስተዳደር - ዱካም",
                "woredas": [
                    {
                        "woredaCode": "ORBIU1ABS0",
                        "woredaEng": "Abu sera",
                        "woredaAmh": "አቡ ሴራ"
                    },
                    {
                        "woredaCode": "ORBIU1MLK0",
                        "woredaEng": "Melka",
                        "woredaAmh": "መልካ"
                    },
                    {
                        "woredaCode": "ORBIU1ODN0",
                        "woredaEng": "Oda Nabe",
                        "woredaAmh": "ኦዳ ነቤ"
                    },
                    {
                        "woredaCode": "ORBIU1TDC0",
                        "woredaEng": "Tedecha",
                        "woredaAmh": "ጠደቻ"
                    }
                ]
            },
            {
                "zoneCode": "ORBRN00000",
                "zoneEng": "Borena",
                "zoneAmh": "ቦረና",
                "woredas": [
                    {
                        "woredaCode": "ORBRN0DIL0",
                        "woredaEng": "Dilo",
                        "woredaAmh": "ዲሎ"
                    },
                    {
                        "woredaCode": "ORBRN0DIR0",
                        "woredaEng": "Dire",
                        "woredaAmh": "ድሬ"
                    },
                    {
                        "woredaCode": "ORBRN0DBL0",
                        "woredaEng": "Dubluk",
                        "woredaAmh": "ዱቡሉቅ"
                    },
                    {
                        "woredaCode": "ORBRN0ELW0",
                        "woredaEng": "Elweye",
                        "woredaAmh": "ኤልወዬ"
                    },
                    {
                        "woredaCode": "ORBRN0GML0",
                        "woredaEng": "Gomole",
                        "woredaAmh": "ጎሞሌ"
                    },
                    {
                        "woredaCode": "ORBRN0GCH0",
                        "woredaEng": "Guchi",
                        "woredaAmh": "ጉቺ"
                    },
                    {
                        "woredaCode": "ORBRN0MIY0",
                        "woredaEng": "Miyo",
                        "woredaAmh": "ሚዮ"
                    },
                    {
                        "woredaCode": "ORBRN0MYL0",
                        "woredaEng": "Moyale",
                        "woredaAmh": "ሞያሌ"
                    },
                    {
                        "woredaCode": "ORBRN0TLT0",
                        "woredaEng": "Teltele",
                        "woredaAmh": "ተልተሌ"
                    },
                    {
                        "woredaCode": "ORBRN0YBL0",
                        "woredaEng": "Yabalo",
                        "woredaAmh": "ያቤሎ"
                    },
                    {
                        "woredaCode": "ORBRN0YBL2",
                        "woredaEng": "Yabelo Town",
                        "woredaAmh": "ያቤሎ ከተማ"
                    }
                ]
            },
            {
                "zoneCode": "ORBUH10000",
                "zoneEng": "Bule Hora City Administration",
                "zoneAmh": "ቡሌ ሆራ ከተማ አስተዳደር",
                "woredas": [
                    {
                        "woredaCode": "ORBUH1ABK7",
                        "woredaEng": "Arda Biya Kebele",
                        "woredaAmh": "አርዳ ቢያ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORBUH1BKK7",
                        "woredaEng": "Bule Kagna Kebele",
                        "woredaAmh": "ቡሌ ቃኛ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORBUH1BKB7",
                        "woredaEng": "Bule Kilta Kebele",
                        "woredaAmh": "ቡሌ ቂልጣ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORBUH1EFK7",
                        "woredaEng": "Ejersa Fora Kebele",
                        "woredaAmh": "ኤጄርሰ ፎራ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORBUH1GAK7",
                        "woredaEng": "Goro Abayi Kebele",
                        "woredaAmh": "ጎሮ አባይ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORBUH1GGK7",
                        "woredaEng": "Goro Gudina Kebele",
                        "woredaAmh": "ጎሮ ጉዲና ቀበሌ"
                    },
                    {
                        "woredaCode": "ORBUH1KYA7",
                        "woredaEng": "Kacha Ya'a Kebele",
                        "woredaAmh": "ቃቻ ያአ ቀበሌ"
                    }
                ]
            },
            {
                "zoneCode": "ORBUB00000",
                "zoneEng": "Buno Bedele",
                "zoneAmh": "ቡኖ በደሌ",
                "woredas": [
                    {
                        "woredaCode": "ORBUB0BDL0",
                        "woredaEng": "Bedele",
                        "woredaAmh": "በደሌ"
                    },
                    {
                        "woredaCode": "ORBUB0BDL2",
                        "woredaEng": "Bedele Town",
                        "woredaAmh": "በደሌ ከተማ"
                    },
                    {
                        "woredaCode": "ORBUB0BRC0",
                        "woredaEng": "Borecha",
                        "woredaAmh": "ቦረቻ"
                    },
                    {
                        "woredaCode": "ORBUB0CHW0",
                        "woredaEng": "Chewaka",
                        "woredaAmh": "ጨዋቃ"
                    },
                    {
                        "woredaCode": "ORBUB0CHR0",
                        "woredaEng": "Chora",
                        "woredaAmh": "ጮራ"
                    },
                    {
                        "woredaCode": "ORBUB0DAH0",
                        "woredaEng": "Dabo Hana",
                        "woredaAmh": "ዳቦ ሃና"
                    },
                    {
                        "woredaCode": "ORBUB0DDS0",
                        "woredaEng": "Dedessa",
                        "woredaAmh": "ደዴሳ"
                    },
                    {
                        "woredaCode": "ORBUB0DEG0",
                        "woredaEng": "Dega",
                        "woredaAmh": "ዴጋ"
                    },
                    {
                        "woredaCode": "ORBUB0GCH0",
                        "woredaEng": "Gechi",
                        "woredaAmh": "ገቺ"
                    },
                    {
                        "woredaCode": "ORBUB0MAK0",
                        "woredaEng": "Mako",
                        "woredaAmh": "መኮ"
                    }
                ]
            },
            {
                "zoneCode": "ORDDL10000",
                "zoneEng": "Dodola City Administration",
                "zoneAmh": "ዶዶላ ከተማ አስተዳደር",
                "woredas": [
                    {
                        "woredaCode": "ORDDL1ANK7",
                        "woredaEng": "Anole Kebele",
                        "woredaAmh": "አኖሌ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORDDL1MWK7",
                        "woredaEng": "Made Wabe Kebele",
                        "woredaAmh": "መደ ዋቤ ቀበሌ"
                    }
                ]
            },
            {
                "zoneCode": "OREAC00000",
                "zoneEng": "East Bale",
                "zoneAmh": "ምስራቅ ባሌ",
                "woredas": [
                    {
                        "woredaCode": "OREAC0DAK0",
                        "woredaEng": "Dawe Kachen",
                        "woredaAmh": "ዳዋ ቃጫን"
                    },
                    {
                        "woredaCode": "OREAC0DAS0",
                        "woredaEng": "Dawe Serer",
                        "woredaAmh": "ዳዌ ሰረር"
                    },
                    {
                        "woredaCode": "OREAC0GNR0",
                        "woredaEng": "Ginir",
                        "woredaAmh": "ጊኒር"
                    },
                    {
                        "woredaCode": "OREAC0GNR2",
                        "woredaEng": "Ginir Town",
                        "woredaAmh": "ጊኒር ከተማ"
                    },
                    {
                        "woredaCode": "OREAC0GLL0",
                        "woredaEng": "Gololcha",
                        "woredaAmh": "ጎሎልቻ"
                    },
                    {
                        "woredaCode": "OREAC0LGH0",
                        "woredaEng": "Legehida",
                        "woredaAmh": "ለገሂዳ"
                    },
                    {
                        "woredaCode": "OREAC0RYT0",
                        "woredaEng": "Rayitu",
                        "woredaAmh": "ራይቱ"
                    },
                    {
                        "woredaCode": "OREAC0SWY0",
                        "woredaEng": "Seweyna",
                        "woredaAmh": "ሰዌና"
                    }
                ]
            },
            {
                "zoneCode": "OREAB00000",
                "zoneEng": "East Borena",
                "zoneAmh": "ምስራቅ ቦረና",
                "woredas": [
                    {
                        "woredaCode": "OREAB0ARR0",
                        "woredaEng": "Arero",
                        "woredaAmh": "አሬሮ"
                    },
                    {
                        "woredaCode": "OREAB0DHS0",
                        "woredaEng": "Dhas",
                        "woredaAmh": "ደሀስ"
                    },
                    {
                        "woredaCode": "OREAB0GOD0",
                        "woredaEng": "Goro Dola",
                        "woredaAmh": "ጎሮ ዶላ"
                    },
                    {
                        "woredaCode": "OREAB0GUE0",
                        "woredaEng": "Gumi Eldalo",
                        "woredaAmh": "ጉሚ ኤልደሎ"
                    },
                    {
                        "woredaCode": "OREAB0LBN0",
                        "woredaEng": "Liben",
                        "woredaAmh": "ሊበን"
                    },
                    {
                        "woredaCode": "OREAB0MEW0",
                        "woredaEng": "Meda Welabu",
                        "woredaAmh": "መደ ወላቡ"
                    },
                    {
                        "woredaCode": "OREAB0NEB2",
                        "woredaEng": "Negele Borena Town",
                        "woredaAmh": "ነገሌ ቦረና ከተማ"
                    },
                    {
                        "woredaCode": "OREAB0WCH0",
                        "woredaEng": "Wachile",
                        "woredaAmh": "ዋጭሌ"
                    },
                    {
                        "woredaCode": "OREAB0WEW0",
                        "woredaEng": "West Welabu",
                        "woredaAmh": "ወላቡ ሊጣ"
                    }
                ]
            },
            {
                "zoneCode": "OREAH00000",
                "zoneEng": "East Harerge",
                "zoneAmh": "ምስራቅ ሐረርጌ",
                "woredas": [
                    {
                        "woredaCode": "OREAH0BBL0",
                        "woredaEng": "Babile",
                        "woredaAmh": "ባቢሌ"
                    },
                    {
                        "woredaCode": "OREAH0BBL2",
                        "woredaEng": "Babile Town",
                        "woredaAmh": "ባቢሌ ከተማ"
                    },
                    {
                        "woredaCode": "OREAH0BDN0",
                        "woredaEng": "Bedeno",
                        "woredaAmh": "በደኖ"
                    },
                    {
                        "woredaCode": "OREAH0CHN0",
                        "woredaEng": "Chinaksen",
                        "woredaAmh": "ጭናክሰን"
                    },
                    {
                        "woredaCode": "OREAH0DDR0",
                        "woredaEng": "Deder",
                        "woredaAmh": "ደደር"
                    },
                    {
                        "woredaCode": "OREAH0DDR2",
                        "woredaEng": "Deder Town",
                        "woredaAmh": "ደደር ከተማ"
                    },
                    {
                        "woredaCode": "OREAH0FDS0",
                        "woredaEng": "Fedis",
                        "woredaAmh": "ፈዲስ"
                    },
                    {
                        "woredaCode": "OREAH0GOO0",
                        "woredaEng": "Gola Oda",
                        "woredaAmh": "ጎለ ኦዳ"
                    },
                    {
                        "woredaCode": "OREAH0GOG0",
                        "woredaEng": "Goro Gutu",
                        "woredaAmh": "ጎሮ ጉቱ"
                    },
                    {
                        "woredaCode": "OREAH0GOM0",
                        "woredaEng": "Goro Muti",
                        "woredaAmh": "ጎሮ ሙጢ"
                    },
                    {
                        "woredaCode": "OREAH0GRW0",
                        "woredaEng": "Gurawa",
                        "woredaAmh": "ጉራዋ"
                    },
                    {
                        "woredaCode": "OREAH0GRS0",
                        "woredaEng": "Gursum",
                        "woredaAmh": "ጉርሱም"
                    },
                    {
                        "woredaCode": "OREAH0HRM0",
                        "woredaEng": "Haramaya",
                        "woredaAmh": "ሀሮማያ"
                    },
                    {
                        "woredaCode": "OREAH0JRS0",
                        "woredaEng": "Jarso",
                        "woredaAmh": "ጃርሶ"
                    },
                    {
                        "woredaCode": "OREAH0KRS0",
                        "woredaEng": "Kersa",
                        "woredaAmh": "ቀርሳ"
                    },
                    {
                        "woredaCode": "OREAH0KMB0",
                        "woredaEng": "Kombolcha",
                        "woredaAmh": "ኮምቦልቻ"
                    },
                    {
                        "woredaCode": "OREAH0KMC0",
                        "woredaEng": "Kumbi",
                        "woredaAmh": "ቁምቢ"
                    },
                    {
                        "woredaCode": "OREAH0KUC0",
                        "woredaEng": "Kurfa Chele",
                        "woredaAmh": "ኩርፋ ጨሌ"
                    },
                    {
                        "woredaCode": "OREAH0MEO0",
                        "woredaEng": "Mekanisa Oromo",
                        "woredaAmh": "መከኒሳ ኦሮሞ"
                    },
                    {
                        "woredaCode": "OREAH0MEB0",
                        "woredaEng": "Melka Belo",
                        "woredaAmh": "መልካ በልኦ"
                    },
                    {
                        "woredaCode": "OREAH0MET0",
                        "woredaEng": "Meta",
                        "woredaAmh": "ሜታ"
                    },
                    {
                        "woredaCode": "OREAH0MEM0",
                        "woredaEng": "Meyu Muluke",
                        "woredaAmh": "መዩ ሙሉቄ"
                    },
                    {
                        "woredaCode": "OREAH0MIT0",
                        "woredaEng": "Midega Tola",
                        "woredaAmh": "ሚደጋ ቶላ"
                    }
                ]
            },
            {
                "zoneCode": "OREAS00000",
                "zoneEng": "East Shawa",
                "zoneAmh": "ምስራቅ ሸዋ",
                "woredas": [
                    {
                        "woredaCode": "OREAS0ADM0",
                        "woredaEng": "Adama",
                        "woredaAmh": "አዳማ"
                    },
                    {
                        "woredaCode": "OREAS0ATJ0",
                        "woredaEng": "Adami Tulu Jido Kombolcha",
                        "woredaAmh": "አዳሚ ቱሉ ጅዶ ኮምቦልቻ"
                    },
                    {
                        "woredaCode": "OREAS0ADA0",
                        "woredaEng": "Ade'a",
                        "woredaAmh": "አደኣ"
                    },
                    {
                        "woredaCode": "OREAS0AKK0",
                        "woredaEng": "Akaki",
                        "woredaAmh": "አቃቂ"
                    },
                    {
                        "woredaCode": "OREAS0BOR0",
                        "woredaEng": "Bora",
                        "woredaAmh": "ቦራ"
                    },
                    {
                        "woredaCode": "OREAS0BST0",
                        "woredaEng": "Boset",
                        "woredaAmh": "ቦሰት"
                    },
                    {
                        "woredaCode": "OREAS0DGD0",
                        "woredaEng": "Dugda",
                        "woredaAmh": "ዱግዳ"
                    },
                    {
                        "woredaCode": "OREAS0FNT0",
                        "woredaEng": "Fentale",
                        "woredaAmh": "ፋንታሌ"
                    },
                    {
                        "woredaCode": "OREAS0GMB0",
                        "woredaEng": "Gimbichu",
                        "woredaAmh": "ጊምቢቹ"
                    },
                    {
                        "woredaCode": "OREAS0LIC0",
                        "woredaEng": "Liben Chuqala",
                        "woredaAmh": "ሊበን ጩቃላ"
                    },
                    {
                        "woredaCode": "OREAS0LUM0",
                        "woredaEng": "Lume",
                        "woredaAmh": "ሉሜ"
                    },
                    {
                        "woredaCode": "OREAS0MEK2",
                        "woredaEng": "Meki Town",
                        "woredaAmh": "መቂ ከተማ"
                    },
                    {
                        "woredaCode": "OREAS0MTH2",
                        "woredaEng": "Metehara Town",
                        "woredaAmh": "መተሃራ ከተማ"
                    }
                ]
            },
            {
                "zoneCode": "OREAW00000",
                "zoneEng": "East Wellega",
                "zoneAmh": "ምስራቅ ወለጋ",
                "woredas": [
                    {
                        "woredaCode": "OREAW0ANG2",
                        "woredaEng": "Angar Guutee Town",
                        "woredaAmh": "አንገር ጉቴ ከተማ"
                    },
                    {
                        "woredaCode": "OREAW0BOB0",
                        "woredaEng": "Boneya Boshe",
                        "woredaAmh": "ቦነያ ቦሼ"
                    },
                    {
                        "woredaCode": "OREAW0DIG0",
                        "woredaEng": "Diga",
                        "woredaAmh": "ዲጋ"
                    },
                    {
                        "woredaCode": "OREAW0EBN0",
                        "woredaEng": "Ebantu",
                        "woredaAmh": "ኢባንቱ"
                    },
                    {
                        "woredaCode": "OREAW0GIA0",
                        "woredaEng": "Gida Ayana",
                        "woredaAmh": "ጊዳ አያና"
                    },
                    {
                        "woredaCode": "OREAW0GOS0",
                        "woredaEng": "Gobu Seyo",
                        "woredaAmh": "ጎቡ ሰዮ"
                    },
                    {
                        "woredaCode": "OREAW0GUB0",
                        "woredaEng": "Gudeya Bila",
                        "woredaAmh": "ጉደያ ቢላ"
                    },
                    {
                        "woredaCode": "OREAW0GUG0",
                        "woredaEng": "Guto Gida",
                        "woredaAmh": "ጉቶ ጊዳ"
                    },
                    {
                        "woredaCode": "OREAW0HAL0",
                        "woredaEng": "Haro Limu",
                        "woredaAmh": "ሃሮ ሊሙ"
                    },
                    {
                        "woredaCode": "OREAW0JIA0",
                        "woredaEng": "Jimma Arjo",
                        "woredaAmh": "ጂማ አርጆ"
                    },
                    {
                        "woredaCode": "OREAW0KRM0",
                        "woredaEng": "Kiremu",
                        "woredaAmh": "ኪረሙ"
                    },
                    {
                        "woredaCode": "OREAW0LED0",
                        "woredaEng": "Leka Dulecha",
                        "woredaAmh": "ሌቃ ዱለቻ"
                    },
                    {
                        "woredaCode": "OREAW0LIM0",
                        "woredaEng": "Limu",
                        "woredaAmh": "ሊሙ"
                    },
                    {
                        "woredaCode": "OREAW0NUK0",
                        "woredaEng": "Nunu Kumba",
                        "woredaAmh": "ኑኖ ቁምባ"
                    },
                    {
                        "woredaCode": "OREAW0SSG0",
                        "woredaEng": "Sasiga",
                        "woredaAmh": "ሳሲጋ"
                    },
                    {
                        "woredaCode": "OREAW0SIS0",
                        "woredaEng": "Sibu Sire",
                        "woredaAmh": "ሲቡ ሲሬ"
                    },
                    {
                        "woredaCode": "OREAW0WAH0",
                        "woredaEng": "Wama Hagelo",
                        "woredaAmh": "ዋማ ሃጋሎ"
                    },
                    {
                        "woredaCode": "OREAW0WAT0",
                        "woredaEng": "Wayu Tuka",
                        "woredaAmh": "ዋዩ ቱቃ"
                    }
                ]
            },
            {
                "zoneCode": "ORGUJ00000",
                "zoneEng": "Guji",
                "zoneAmh": "ጉጂ",
                "woredas": [
                    {
                        "woredaCode": "ORGUJ0ADR0",
                        "woredaEng": "Adola Rede",
                        "woredaAmh": "አዶላ ሬዴ"
                    },
                    {
                        "woredaCode": "ORGUJ0ADW2",
                        "woredaEng": "Adola Wayu Town",
                        "woredaAmh": "አዶላ ወዩ ከተማ"
                    },
                    {
                        "woredaCode": "ORGUJ0AGW0",
                        "woredaEng": "Aga Wayu",
                        "woredaAmh": "ዓጋ ዋዩ"
                    },
                    {
                        "woredaCode": "ORGUJ0ANS0",
                        "woredaEng": "Anna Sora",
                        "woredaAmh": "አና ሶራ"
                    },
                    {
                        "woredaCode": "ORGUJ0AJM0",
                        "woredaEng": "Arada Jila Mi'e Boko",
                        "woredaAmh": "አርዳ ጂላ ሚኤ ቦኩ"
                    },
                    {
                        "woredaCode": "ORGUJ0BOR0",
                        "woredaEng": "Bore",
                        "woredaAmh": "ቦሬ"
                    },
                    {
                        "woredaCode": "ORGUJ0DAM0",
                        "woredaEng": "Dama",
                        "woredaAmh": "ዳማ"
                    },
                    {
                        "woredaCode": "ORGUJ0GRJ0",
                        "woredaEng": "Girja",
                        "woredaAmh": "ግርጃ"
                    },
                    {
                        "woredaCode": "ORGUJ0HAW0",
                        "woredaEng": "Haro Welabu",
                        "woredaAmh": "ሀሮ ወላቡ"
                    },
                    {
                        "woredaCode": "ORGUJ0ODS0",
                        "woredaEng": "Odo Shakiso",
                        "woredaAmh": "ኦዶ ሻኪሶ"
                    },
                    {
                        "woredaCode": "ORGUJ0SEB0",
                        "woredaEng": "Seba Boru",
                        "woredaAmh": "ሰባ ቦሩ"
                    },
                    {
                        "woredaCode": "ORGUJ0URG0",
                        "woredaEng": "Uraga",
                        "woredaAmh": "ኡራጋ"
                    },
                    {
                        "woredaCode": "ORGUJ0WDR0",
                        "woredaEng": "Wadera",
                        "woredaAmh": "ዋደራ"
                    }
                ]
            },
            {
                "zoneCode": "ORHLT10000",
                "zoneEng": "Holata City Administration",
                "zoneAmh": "ሆለታ ከተማ አስተዳደር",
                "woredas": [
                    {
                        "woredaCode": "ORHLT1BSK7",
                        "woredaEng": "Birbirsa Siba Kebele",
                        "woredaAmh": "ቢሪቢረሳ ሲባ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORHLT1BHK7",
                        "woredaEng": "Burka Harbu Kebele",
                        "woredaAmh": "ቡርቃ ሀርቡ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORHLT1BWK7",
                        "woredaEng": "Burka Welmera Kebele",
                        "woredaAmh": "ቡሪካ ዌልሜራ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORHLT1GKK7",
                        "woredaEng": "Gegel Kuyu Kebele",
                        "woredaAmh": "ጌጊል ኩዩ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORHLT1GKB7",
                        "woredaEng": "Goro Keransa Kebele",
                        "woredaAmh": "ጎሮ ኬርንሳ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORHLT1MGK7",
                        "woredaEng": "Meda Gudina Kebele",
                        "woredaAmh": "ሜዴ ጉዲና ቀበሌ"
                    },
                    {
                        "woredaCode": "ORHLT1SAK7",
                        "woredaEng": "Sademo Kebele",
                        "woredaAmh": "ሳዴሞ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORHLT1THK7",
                        "woredaEng": "Tulu Harbu Kebele",
                        "woredaAmh": "ቱሉ ሀሪቡ ቀበሌ"
                    }
                ]
            },
            {
                "zoneCode": "ORHGW00000",
                "zoneEng": "Horo Guduru Wellega",
                "zoneAmh": "ሆሮ ጉዱሩ ወለጋ",
                "woredas": [
                    {
                        "woredaCode": "ORHGW0ABC0",
                        "woredaEng": "Abay Chomen",
                        "woredaAmh": "አባይ ጮመን"
                    },
                    {
                        "woredaCode": "ORHGW0ABD0",
                        "woredaEng": "Abe Dengoro",
                        "woredaAmh": "አቤ ዶንጎሮ"
                    },
                    {
                        "woredaCode": "ORHGW0AMR0",
                        "woredaEng": "Amuru",
                        "woredaAmh": "ኡሙሩ"
                    },
                    {
                        "woredaCode": "ORHGW0CHG0",
                        "woredaEng": "Chomen Guduru",
                        "woredaAmh": "ጮመን ጉዱሩ"
                    },
                    {
                        "woredaCode": "ORHGW0GDR0",
                        "woredaEng": "Guduru",
                        "woredaAmh": "ጉዱሩ"
                    },
                    {
                        "woredaCode": "ORHGW0HAG0",
                        "woredaEng": "Hababo Guduru",
                        "woredaAmh": "ሀባቦ ጉድሩ"
                    },
                    {
                        "woredaCode": "ORHGW0HOR0",
                        "woredaEng": "Horo",
                        "woredaAmh": "ሆሮ"
                    },
                    {
                        "woredaCode": "ORHGW0HOB0",
                        "woredaEng": "Horo Buluk",
                        "woredaAmh": "ሆሮ ቡሉቅ"
                    },
                    {
                        "woredaCode": "ORHGW0JAJ0",
                        "woredaEng": "Jardega Jarte",
                        "woredaAmh": "ጃርደጋ ጃርቴ"
                    },
                    {
                        "woredaCode": "ORHGW0JIG0",
                        "woredaEng": "Jimma Geneti",
                        "woredaAmh": "ጅማ ገነቲ"
                    },
                    {
                        "woredaCode": "ORHGW0JIR0",
                        "woredaEng": "Jimma Rare",
                        "woredaAmh": "ጅማ ራሬ"
                    },
                    {
                        "woredaCode": "ORHGW0SHM2",
                        "woredaEng": "Shambu Town",
                        "woredaAmh": "ሻምቡ ከተማ"
                    },
                    {
                        "woredaCode": "ORHGW0SUF0",
                        "woredaEng": "Sulula Finca",
                        "woredaAmh": "ሱሉላ ፊንጫአ"
                    }
                ]
            },
            {
                "zoneCode": "ORIAB00000",
                "zoneEng": "Ilu Aba Bor",
                "zoneAmh": "ኢሉ አባ ቦር",
                "woredas": [
                    {
                        "woredaCode": "ORIAB0ALE0",
                        "woredaEng": "Ale",
                        "woredaAmh": "አሌ"
                    },
                    {
                        "woredaCode": "ORIAB0ALS0",
                        "woredaEng": "Alge Sachi",
                        "woredaAmh": "አልጌ ሳቺ"
                    },
                    {
                        "woredaCode": "ORIAB0BCH0",
                        "woredaEng": "Becho",
                        "woredaAmh": "በቾ"
                    },
                    {
                        "woredaCode": "ORIAB0BIN0",
                        "woredaEng": "Bilo Nopa",
                        "woredaAmh": "ቢሎ ኖጳ"
                    },
                    {
                        "woredaCode": "ORIAB0BUR0",
                        "woredaEng": "Bure",
                        "woredaAmh": "ቡሬ"
                    },
                    {
                        "woredaCode": "ORIAB0DRM0",
                        "woredaEng": "Darimu",
                        "woredaAmh": "ዳሪሙ"
                    },
                    {
                        "woredaCode": "ORIAB0DID0",
                        "woredaEng": "Didu",
                        "woredaAmh": "ዲዱ"
                    },
                    {
                        "woredaCode": "ORIAB0DRN0",
                        "woredaEng": "Doreni",
                        "woredaAmh": "ዶረኒ"
                    },
                    {
                        "woredaCode": "ORIAB0HAL0",
                        "woredaEng": "Halu",
                        "woredaAmh": "ሀሉ"
                    },
                    {
                        "woredaCode": "ORIAB0HRM0",
                        "woredaEng": "Hurumu",
                        "woredaAmh": "ሁሩሙ"
                    },
                    {
                        "woredaCode": "ORIAB0MET0",
                        "woredaEng": "Metu",
                        "woredaAmh": "መቱ"
                    },
                    {
                        "woredaCode": "ORIAB0NEN0",
                        "woredaEng": "Nedi Nono",
                        "woredaAmh": "ነዲ ኖኖ"
                    },
                    {
                        "woredaCode": "ORIAB0YAY0",
                        "woredaEng": "Yayo",
                        "woredaAmh": "ያዮ"
                    }
                ]
            },
            {
                "zoneCode": "ORJMM00000",
                "zoneEng": "Jimma",
                "zoneAmh": "ጅማ",
                "woredas": [
                    {
                        "woredaCode": "ORJMM0BOT0",
                        "woredaEng": "Boter Tolay",
                        "woredaAmh": "ቦቶር ጦላይ"
                    },
                    {
                        "woredaCode": "ORJMM0CHB0",
                        "woredaEng": "Chora Botor",
                        "woredaAmh": "ጮራ ቦቶር"
                    },
                    {
                        "woredaCode": "ORJMM0DED0",
                        "woredaEng": "Dedo",
                        "woredaAmh": "ዴዶ"
                    },
                    {
                        "woredaCode": "ORJMM0GER0",
                        "woredaEng": "Gera",
                        "woredaAmh": "ጌራ"
                    },
                    {
                        "woredaCode": "ORJMM0GMM0",
                        "woredaEng": "Gomma",
                        "woredaAmh": "ጎማ"
                    },
                    {
                        "woredaCode": "ORJMM0GMY0",
                        "woredaEng": "Gumay",
                        "woredaAmh": "ጉማይ"
                    },
                    {
                        "woredaCode": "ORJMM0KRS0",
                        "woredaEng": "Kersa",
                        "woredaAmh": "ቀርሳ"
                    },
                    {
                        "woredaCode": "ORJMM0LIG2",
                        "woredaEng": "Limu Genet Town",
                        "woredaAmh": "ሊሙ ገነት ከተማ"
                    },
                    {
                        "woredaCode": "ORJMM0LIK0",
                        "woredaEng": "Limu Kosa",
                        "woredaAmh": "ሊሙ ኮሳ"
                    },
                    {
                        "woredaCode": "ORJMM0LIS0",
                        "woredaEng": "Limu Seka",
                        "woredaAmh": "ሊሙ ሰቃ"
                    },
                    {
                        "woredaCode": "ORJMM0MNC0",
                        "woredaEng": "Mancho",
                        "woredaAmh": "መንቾ"
                    },
                    {
                        "woredaCode": "ORJMM0MNN0",
                        "woredaEng": "Manna",
                        "woredaAmh": "ማና"
                    },
                    {
                        "woredaCode": "ORJMM0NEG0",
                        "woredaEng": "Nedi Gibe",
                        "woredaAmh": "ነዲ ጊቤ"
                    },
                    {
                        "woredaCode": "ORJMM0NOB0",
                        "woredaEng": "Nono Benja",
                        "woredaAmh": "ኖኖ ቤንጃ"
                    },
                    {
                        "woredaCode": "ORJMM0OMB0",
                        "woredaEng": "Omo Beyam",
                        "woredaAmh": "ኦሞ ቤያም"
                    },
                    {
                        "woredaCode": "ORJMM0OMN0",
                        "woredaEng": "Omo Nada",
                        "woredaAmh": "ኦሞ ናዳ"
                    },
                    {
                        "woredaCode": "ORJMM0SEC0",
                        "woredaEng": "Seka Chekorsa",
                        "woredaAmh": "ሰቃ ጨቆርሳ"
                    },
                    {
                        "woredaCode": "ORJMM0STM0",
                        "woredaEng": "Setema",
                        "woredaAmh": "ሰጠማ"
                    },
                    {
                        "woredaCode": "ORJMM0SHS0",
                        "woredaEng": "Shebe Sembo",
                        "woredaAmh": "ሸቤ ሶምቦ"
                    },
                    {
                        "woredaCode": "ORJMM0SGM0",
                        "woredaEng": "Sigmo",
                        "woredaAmh": "ሲግሞ"
                    },
                    {
                        "woredaCode": "ORJMM0SKR0",
                        "woredaEng": "Sokoru",
                        "woredaAmh": "ሶኮሩ"
                    }
                ]
            },
            {
                "zoneCode": "ORJMM10000",
                "zoneEng": "Jimma City Administration",
                "zoneAmh": "ጅማ ከተማ አስተዳደር",
                "woredas": [
                    {
                        "woredaCode": "ORJMM1AMK7",
                        "woredaEng": "Awetu Mandara Kebele",
                        "woredaAmh": "አዌቱ መንደራ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORJMM1BBK7",
                        "woredaEng": "Bacho Bore Kebele",
                        "woredaAmh": "በቾ ቦሬ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORJMM1BAK7",
                        "woredaEng": "Bosa Addis Kebele",
                        "woredaAmh": "ቦሳ አዲስ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORJMM1BKK7",
                        "woredaEng": "Bosa Kito Kebele",
                        "woredaAmh": "ቦሳ ኪቶ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORJMM1GGK7",
                        "woredaEng": "Ginjo Guduru Kebele",
                        "woredaAmh": "ጊንጆ ጉድሩ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORJMM1GIK7",
                        "woredaEng": "Ginjo Kebele",
                        "woredaAmh": "ጊንጆ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORJMM1HEK7",
                        "woredaEng": "Hermata Kebele",
                        "woredaAmh": "ሔርማታ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORJMM1HMK7",
                        "woredaEng": "Hermata Mantina Kebele",
                        "woredaAmh": "ሄርማታ መንቲና ቀበሌ"
                    },
                    {
                        "woredaCode": "ORJMM1HMB7",
                        "woredaEng": "Hermata Markato Kebele",
                        "woredaAmh": "ሄርማታ መርካቶ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORJMM1JIK7",
                        "woredaEng": "Jiren Kebele",
                        "woredaAmh": "ጅሬን ቀበሌ"
                    },
                    {
                        "woredaCode": "ORJMM1MKK7",
                        "woredaEng": "Mandara Kochi Kebele",
                        "woredaAmh": "መንደራ ቆጪ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORJMM1MAK7",
                        "woredaEng": "Mantina Kebele",
                        "woredaAmh": "መንቲና ቀበሌ"
                    },
                    {
                        "woredaCode": "ORJMM1SSK7",
                        "woredaEng": "Sato Samaro Kebele",
                        "woredaAmh": "ሰጦ ሰመሮ ቀበሌ"
                    }
                ]
            },
            {
                "zoneCode": "ORKEW00000",
                "zoneEng": "Kelem Wellega",
                "zoneAmh": "ቄለም ወለጋ",
                "woredas": [
                    {
                        "woredaCode": "ORKEW0ANF0",
                        "woredaEng": "Anfilo",
                        "woredaAmh": "አንፍሎ"
                    },
                    {
                        "woredaCode": "ORKEW0DAS0",
                        "woredaEng": "Dale Sedi",
                        "woredaAmh": "ዳሌ ሰዲ"
                    },
                    {
                        "woredaCode": "ORKEW0DAW0",
                        "woredaEng": "Dale Wabera",
                        "woredaAmh": "ዳሌ ዋበራ"
                    },
                    {
                        "woredaCode": "ORKEW0DED2",
                        "woredaEng": "Dembi Dolo Town",
                        "woredaAmh": "ደምቢ ዶሎ ከተማ"
                    },
                    {
                        "woredaCode": "ORKEW0GAK0",
                        "woredaEng": "Gawo Kebe",
                        "woredaAmh": "ጋዎ ቄቤ"
                    },
                    {
                        "woredaCode": "ORKEW0GDM0",
                        "woredaEng": "Gidami",
                        "woredaAmh": "ጊዳሚ"
                    },
                    {
                        "woredaCode": "ORKEW0HAG0",
                        "woredaEng": "Hawa Gelan",
                        "woredaAmh": "ሐዋ ገላን"
                    },
                    {
                        "woredaCode": "ORKEW0JIH0",
                        "woredaEng": "Jimma Horo",
                        "woredaAmh": "ጅማ ሆሮ"
                    },
                    {
                        "woredaCode": "ORKEW0LAK0",
                        "woredaEng": "Lalo Kile",
                        "woredaAmh": "ላሎ ቂሌ"
                    },
                    {
                        "woredaCode": "ORKEW0SEC0",
                        "woredaEng": "Sedi Chenka",
                        "woredaAmh": "ሰዲ ጫንቃ"
                    },
                    {
                        "woredaCode": "ORKEW0SEY0",
                        "woredaEng": "Seyo",
                        "woredaAmh": "ሰዮ"
                    },
                    {
                        "woredaCode": "ORKEW0YEW0",
                        "woredaEng": "Yemalogi Welel",
                        "woredaAmh": "የማሎጊ ወለል"
                    }
                ]
            },
            {
                "zoneCode": "ORMAT10000",
                "zoneEng": "Matu City Administration",
                "zoneAmh": "መቱ ከተማ አስተዳደር",
                "woredas": [
                    {
                        "woredaCode": "ORMAT1AMK7",
                        "woredaEng": "Aba Mole Kebele",
                        "woredaAmh": "አባ ሞሌ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORMAT1ASK7",
                        "woredaEng": "Aba Saya Kebele",
                        "woredaAmh": "አባ ሳያ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORMAT1GOK7",
                        "woredaEng": "Gadisa Oda Kebele",
                        "woredaAmh": "ጋዲሳ ኦዳ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORMAT1KKK7",
                        "woredaEng": "Kolo Korma Kebele",
                        "woredaAmh": "ቆሎ ኮርማ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORMAT1SOK7",
                        "woredaEng": "Sor Kebele",
                        "woredaAmh": "ሶር ቀበሌ"
                    },
                    {
                        "woredaCode": "ORMAT1TAK7",
                        "woredaEng": "Tabo Kebele",
                        "woredaAmh": "ታቦ ቀበሌ"
                    }
                ]
            },
            {
                "zoneCode": "ORMAA10000",
                "zoneEng": "Maya City Administration - Adelle",
                "zoneAmh": "ማያ ከተማ አስተዳደር - አዳሌ",
                "woredas": [
                    {
                        "woredaCode": "ORMAA1ADK7",
                        "woredaEng": "Adele Kebele",
                        "woredaAmh": "አዴሌ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORMAA1BGK7",
                        "woredaEng": "Biftu Gada Kebele",
                        "woredaAmh": "ቢፊቱ ገዳ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORMAA1DAK7",
                        "woredaEng": "Dangago Kebele",
                        "woredaAmh": "ደንገጎ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORMAA1KUK7",
                        "woredaEng": "Kuro Kebele",
                        "woredaAmh": "ኩሮ ቀበሌ"
                    }
                ]
            },
            {
                "zoneCode": "ORMAW10000",
                "zoneEng": "Maya City Administration - Awaday",
                "zoneAmh": "ማያ ከተማ አስተዳደር - አወዳይ",
                "woredas": [
                    {
                        "woredaCode": "ORMAW1AWK7",
                        "woredaEng": "Awaday Kebele",
                        "woredaAmh": "አወዳይ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORMAW1BOK7",
                        "woredaEng": "Boji Kebele",
                        "woredaAmh": "ቦጂ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORMAW1FAK7",
                        "woredaEng": "Fandisha Kebele",
                        "woredaAmh": "ፈንዲሻ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORMAW1NAK7",
                        "woredaEng": "Nagaya Kebele",
                        "woredaAmh": "ነጋያ ቀበሌ"
                    }
                ]
            },
            {
                "zoneCode": "ORMAH10000",
                "zoneEng": "Maya City Administration - Haramaya",
                "zoneAmh": "ማያ ከተማ አስተዳደር - ሐረማያ",
                "woredas": [
                    {
                        "woredaCode": "ORMAH1BAK7",
                        "woredaEng": "Bate Kebele",
                        "woredaAmh": "ባቴ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORMAH1MGK7",
                        "woredaEng": "Maya Gudo Kebele",
                        "woredaAmh": "ማያ ጉዶ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORMAH1MKK7",
                        "woredaEng": "Maya Kalo Kebele",
                        "woredaAmh": "ማያ ቃሎ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORMAH1MLK7",
                        "woredaEng": "Maya Lamen Kebele",
                        "woredaAmh": "ማያ ለሜን ቀበሌ"
                    }
                ]
            },
            {
                "zoneCode": "ORMOJ10000",
                "zoneEng": "Mojo City Administration",
                "zoneAmh": "ሞጆ ከተማ አስተዳደር",
                "woredas": [
                    {
                        "woredaCode": "ORMOJ1KAK7",
                        "woredaEng": "Karsa Kebele",
                        "woredaAmh": "ቀርሳ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORMOJ1MLK7",
                        "woredaEng": "Malka Lami Kebele",
                        "woredaAmh": "መልካ ለሚ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORMOJ1OBK7",
                        "woredaEng": "Obo Kebele",
                        "woredaAmh": "ኦቦ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORMOJ1SAK7",
                        "woredaEng": "Sayo Kebele",
                        "woredaAmh": "ሰዮ ቀበሌ"
                    }
                ]
            },
            {
                "zoneCode": "ORMYL10000",
                "zoneEng": "Moyale City Administration",
                "zoneAmh": "ሞያሌ ከተማ አስተዳደር",
                "woredas": [
                    {
                        "woredaCode": "ORMYL1ARK7",
                        "woredaEng": "Arbale Kebele",
                        "woredaAmh": "አርበሌ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORMYL1CHK7",
                        "woredaEng": "Chamuq Kebele",
                        "woredaAmh": "ጫሙቅ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORMYL1GBK7",
                        "woredaEng": "Goro Bute Kebele",
                        "woredaAmh": "ጎሮ ቡቴ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORMYL1KAK7",
                        "woredaEng": "Kabana'a Kebele",
                        "woredaAmh": "ቀበናኦ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORMYL1MMK7",
                        "woredaEng": "Mado Migo Kebele",
                        "woredaAmh": "ማዶ ሚጎ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORMYL1MAK7",
                        "woredaEng": "Malabi Kebele",
                        "woredaAmh": "ማላቢ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORMYL1M0K7",
                        "woredaEng": "Moyale 01 Kebele",
                        "woredaAmh": "ሞያሌ 01 ቀበሌ"
                    },
                    {
                        "woredaCode": "ORMYL1M0B7",
                        "woredaEng": "Moyale 02 Kebele",
                        "woredaAmh": "ሞያሌ 02 ቀበሌ"
                    },
                    {
                        "woredaCode": "ORMYL1SBK7",
                        "woredaEng": "Shawa Bare Kebele",
                        "woredaAmh": "ሸዋ በሬ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORMYL1TMK7",
                        "woredaEng": "Tile Medo Kebele",
                        "woredaAmh": "ጥሌ መዶ ቀበሌ"
                    }
                ]
            },
            {
                "zoneCode": "ORNEJ10000",
                "zoneEng": "Nejo City Administration",
                "zoneAmh": "ነጆ ከተማ አስተዳደር",
                "woredas": [
                    {
                        "woredaCode": "ORNEJ1DBK7",
                        "woredaEng": "Deka Badeso Kebele",
                        "woredaAmh": "ደካ ባዴሶ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORNEJ1KNK7",
                        "woredaEng": "Kota Najo Kebele",
                        "woredaAmh": "ቆታ ናጆ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORNEJ1LCA7",
                        "woredaEng": "L/C/Abdisa Aga Kebele",
                        "woredaAmh": "ሌ/ኮ/አብድሳ አጋ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORNEJ1YBK7",
                        "woredaEng": "Yako Badeso Kebele",
                        "woredaAmh": "ያኮ ባዴሶ ቀበሌ"
                    }
                ]
            },
            {
                "zoneCode": "ORNKM10000",
                "zoneEng": "Nekemte City Administration",
                "zoneAmh": "ነቀምቴ ከተማ አስተዳደር",
                "woredas": [
                    {
                        "woredaCode": "ORNKM1BKK7",
                        "woredaEng": "Bakanisa Kase Kebele",
                        "woredaAmh": "በካኒስ ቀሴ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORNKM1BJK7",
                        "woredaEng": "Bake Jama Kebele",
                        "woredaAmh": "በኬ ጀማ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORNKM1BJB7",
                        "woredaEng": "Burka Jato Kebele",
                        "woredaAmh": "ቡርቃ ጃቶ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORNKM1CHK7",
                        "woredaEng": "Cheleleki Kebele",
                        "woredaAmh": "ጨለለቂ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORNKM1DAK7",
                        "woredaEng": "Darge Kebele",
                        "woredaAmh": "ደርጌ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORNKM1KEK7",
                        "woredaEng": "Keso Kebele",
                        "woredaAmh": "ቀሶ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORNKM1SOK7",
                        "woredaEng": "Sorga Kebele",
                        "woredaAmh": "ሶርጋ ቀበሌ"
                    }
                ]
            },
            {
                "zoneCode": "ORNOS00000",
                "zoneEng": "North Shawa",
                "zoneAmh": "ሰሜን ሸዋ",
                "woredas": [
                    {
                        "woredaCode": "ORNOS0AGA0",
                        "woredaEng": "Abichu Gne'a",
                        "woredaAmh": "አቢቹ ኛኣ"
                    },
                    {
                        "woredaCode": "ORNOS0ALL0",
                        "woredaEng": "Aleltu",
                        "woredaAmh": "አለልቱ"
                    },
                    {
                        "woredaCode": "ORNOS0BRK0",
                        "woredaEng": "Berek",
                        "woredaAmh": "በረክ"
                    },
                    {
                        "woredaCode": "ORNOS0CHN2",
                        "woredaEng": "Chancho Town",
                        "woredaAmh": "ጫንጮ ከተማ"
                    },
                    {
                        "woredaCode": "ORNOS0DEL0",
                        "woredaEng": "Debre Libanos",
                        "woredaAmh": "ደብረ ሊባኖስ"
                    },
                    {
                        "woredaCode": "ORNOS0DGM0",
                        "woredaEng": "Degem",
                        "woredaAmh": "ደገም"
                    },
                    {
                        "woredaCode": "ORNOS0DER0",
                        "woredaEng": "Dera",
                        "woredaAmh": "ደራ"
                    },
                    {
                        "woredaCode": "ORNOS0FCH2",
                        "woredaEng": "Fiche Town",
                        "woredaAmh": "ፍቼ ከተማ"
                    },
                    {
                        "woredaCode": "ORNOS0GEG2",
                        "woredaEng": "Gerbe Guracha Town",
                        "woredaAmh": "ገርባ ጉራቻ ከተማ"
                    },
                    {
                        "woredaCode": "ORNOS0GIJ0",
                        "woredaEng": "Girar Jarso",
                        "woredaAmh": "ግራር ጃርሶ"
                    },
                    {
                        "woredaCode": "ORNOS0HIA0",
                        "woredaEng": "Hidabu Abote",
                        "woredaAmh": "ሂደቡ አቦቴ"
                    },
                    {
                        "woredaCode": "ORNOS0JID0",
                        "woredaEng": "Jida",
                        "woredaAmh": "ጂዳ"
                    },
                    {
                        "woredaCode": "ORNOS0KMB0",
                        "woredaEng": "Kimbibit",
                        "woredaAmh": "ቅምብቢት"
                    },
                    {
                        "woredaCode": "ORNOS0KUY0",
                        "woredaEng": "Kuyu",
                        "woredaAmh": "ኩዩ"
                    },
                    {
                        "woredaCode": "ORNOS0MUL0",
                        "woredaEng": "Mulo",
                        "woredaAmh": "ሙሎ"
                    },
                    {
                        "woredaCode": "ORNOS0SLL0",
                        "woredaEng": "Sululta",
                        "woredaAmh": "ሱሉልታ"
                    },
                    {
                        "woredaCode": "ORNOS0WEJ0",
                        "woredaEng": "Wera Jarso",
                        "woredaAmh": "ወራ ጃርሶ"
                    },
                    {
                        "woredaCode": "ORNOS0WCH0",
                        "woredaEng": "Wuchale",
                        "woredaAmh": "ዉጫሌ"
                    },
                    {
                        "woredaCode": "ORNOS0YAG0",
                        "woredaEng": "Yaya Gulele",
                        "woredaAmh": "ያያ ጉለሌ"
                    }
                ]
            },
            {
                "zoneCode": "ORROA10000",
                "zoneEng": "Robe City Administration - Adoshe Walashe",
                "zoneAmh": "ሮቤ ከተማ አስተዳደር - አዶሼ ዋላሼ",
                "woredas": [
                    {
                        "woredaCode": "ORROA1BBK7",
                        "woredaEng": "Baha Biftu Kebele",
                        "woredaAmh": "በሃ ቢፍቱ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORROA1CDK7",
                        "woredaEng": "Chafe Donsa Kebele",
                        "woredaAmh": "ጨፌ ዶንሳ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORROA1HRK7",
                        "woredaEng": "Handura Robe Kebele",
                        "woredaAmh": "ሀንዱራ ሮቤ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORROA1WCK7",
                        "woredaEng": "Waltahi Chafe Kebele",
                        "woredaAmh": "ወልታኢ ጨፌ ቀበሌ"
                    }
                ]
            },
            {
                "zoneCode": "ORROG10000",
                "zoneEng": "Robe City Administration - Goba",
                "zoneAmh": "ሮቤ ከተማ አስተዳደር - ጎባ",
                "woredas": [
                    {
                        "woredaCode": "ORROG1AMK7",
                        "woredaEng": "Arada Micha Kebele",
                        "woredaAmh": "አረዳ ሚጫ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORROG1CHK7",
                        "woredaEng": "Chafe Hora Kebele",
                        "woredaAmh": "ጨፌ ሆራ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORROG1FBK7",
                        "woredaEng": "Fincha Bamo Kebele",
                        "woredaAmh": "ፊንጫአ ባሞ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORROG1OBK7",
                        "woredaEng": "Oda Baha Kebele",
                        "woredaAmh": "ኦዳ ባሃ ቀበሌ"
                    }
                ]
            },
            {
                "zoneCode": "ORROZ10000",
                "zoneEng": "Robe City Administration - Zaybala Walashe",
                "zoneAmh": "ሮቤ ከተማ አስተዳደር - ዘይበላ ዋላሼ",
                "woredas": [
                    {
                        "woredaCode": "ORROZ1BTK7",
                        "woredaEng": "Bole Tokuma Kebele",
                        "woredaAmh": "ቦሌ ቶኩማ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORROZ1HBK7",
                        "woredaEng": "Hora Boka Kebele",
                        "woredaAmh": "ሆራ ቦቃ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORROZ1KIK7",
                        "woredaEng": "Kibtate Kebele",
                        "woredaAmh": "ኪብጠቴ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORROZ1ORK7",
                        "woredaEng": "Oda Robe Kebele",
                        "woredaAmh": "ኦዳ ሮቤ ቀበሌ"
                    }
                ]
            },
            {
                "zoneCode": "ORSAB10000",
                "zoneEng": "Sandafa Bake City Administration",
                "zoneAmh": "ሳንዳፋ ባኬ ከተማ አስተዳደር",
                "woredas": [
                    {
                        "woredaCode": "ORSAB1BTK7",
                        "woredaEng": "Bake Tabo Kebele",
                        "woredaAmh": "በኬ ጣቦ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORSAB1DGK7",
                        "woredaEng": "Dale Godo Kebele",
                        "woredaAmh": "ዳሌ ጎዶ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORSAB1GBK7",
                        "woredaEng": "Girar Berak Kebele",
                        "woredaAmh": "ግራር በራክ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORSAB1LJK7",
                        "woredaEng": "Laga Jila Kebele",
                        "woredaAmh": "ለጋ ጂላ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORSAB1SDK7",
                        "woredaEng": "Sandafa Dabe Kebele",
                        "woredaAmh": "ሰንዳፋ ዳቤ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORSAB1TOK7",
                        "woredaEng": "Tokiye Kebele",
                        "woredaAmh": "ቶክዬ ቀበሌ"
                    }
                ]
            },
            {
                "zoneCode": "ORSHF30000",
                "zoneEng": "Shager City Administration - Furi Sub City",
                "zoneAmh": "ሸገር ከተማ አስተዳደር - ፉሪ ክፍለ ከተማ",
                "woredas": [
                    {
                        "woredaCode": "ORSHF3CHK0",
                        "woredaEng": "Chafe Karabu",
                        "woredaAmh": "ጨፌ ከራቡ"
                    },
                    {
                        "woredaCode": "ORSHF3GEF0",
                        "woredaEng": "Geda Faji",
                        "woredaAmh": "ገዳ ፋጂ"
                    },
                    {
                        "woredaCode": "ORSHF3MUF0",
                        "woredaEng": "Muda Furi",
                        "woredaAmh": "ሙዳ ፉሪ"
                    }
                ]
            },
            {
                "zoneCode": "ORSHA30000",
                "zoneEng": "Shager City Administration - Galan Guda Sub City",
                "zoneAmh": "ሸገር ከተማ አስተዳደር - ገላን ጉዳ ክፍለ ከተማ",
                "woredas": [
                    {
                        "woredaCode": "ORSHA3DLT0",
                        "woredaEng": "Dalati",
                        "woredaAmh": "ዳለቲ"
                    },
                    {
                        "woredaCode": "ORSHA3GEG0",
                        "woredaEng": "Gelan Gudda",
                        "woredaAmh": "ገላን ጉዳ"
                    },
                    {
                        "woredaCode": "ORSHA3LAG0",
                        "woredaEng": "Lakule Gajja",
                        "woredaAmh": "ለኩሌ ገጃ"
                    }
                ]
            },
            {
                "zoneCode": "ORSHG30000",
                "zoneEng": "Shager City Administration - Galan Sub City",
                "zoneAmh": "ሸገር ከተማ አስተዳደር - ገላን ክፍለ ከተማ",
                "woredas": [
                    {
                        "woredaCode": "ORSHG3AND0",
                        "woredaEng": "Andode",
                        "woredaAmh": "አንዶዴ"
                    },
                    {
                        "woredaCode": "ORSHG3GLN0",
                        "woredaEng": "Galan",
                        "woredaAmh": "ገላን"
                    },
                    {
                        "woredaCode": "ORSHG3SIA0",
                        "woredaEng": "Sida Awash",
                        "woredaAmh": "ሲዳ አዋሽ"
                    }
                ]
            },
            {
                "zoneCode": "ORSHE30000",
                "zoneEng": "Shager City Administration - Gefersa Guje Sub City",
                "zoneAmh": "ሸገር ከተማ አስተዳደር- ገፈርሳ ጉጄ ክፍለ ከተማ",
                "woredas": [
                    {
                        "woredaCode": "ORSHE3EGE0",
                        "woredaEng": "Egdu Elala",
                        "woredaAmh": "ኤግዱ ኢላላ"
                    },
                    {
                        "woredaCode": "ORSHE3GUD0",
                        "woredaEng": "Gudu",
                        "woredaAmh": "ጉዱ"
                    },
                    {
                        "woredaCode": "ORSHE3GUJ0",
                        "woredaEng": "Guje",
                        "woredaAmh": "ጉጄ"
                    },
                    {
                        "woredaCode": "ORSHE3KLB0",
                        "woredaEng": "Kolobo",
                        "woredaAmh": "ኮሎቦ"
                    }
                ]
            },
            {
                "zoneCode": "ORSHK30000",
                "zoneEng": "Shager City Administration - Koye Feche Sub City",
                "zoneAmh": "ሸገር ከተማ አስተዳደር - ኮዬ ፈጬ ክፍለ ከተማ",
                "woredas": [
                    {
                        "woredaCode": "ORSHK3GEA0",
                        "woredaEng": "Gelan Arabsa",
                        "woredaAmh": "ገላን አራብሳ"
                    },
                    {
                        "woredaCode": "ORSHK3TUD0",
                        "woredaEng": "Tullu Dimtu",
                        "woredaAmh": "ቱሉ ዲሚቱ"
                    },
                    {
                        "woredaCode": "ORSHK3WDD0",
                        "woredaEng": "Waddesa",
                        "woredaAmh": "ወዴሳ"
                    }
                ]
            },
            {
                "zoneCode": "ORSHL30000",
                "zoneEng": "Shager City Administration - Lege Dadi Lege Tafo Sub City",
                "zoneAmh": "ሸገር ከተማ አስተዳደር - ለገ ዳዲ ለገ ጣፎ ክፍለ ከተማ",
                "woredas": [
                    {
                        "woredaCode": "ORSHL3DET0",
                        "woredaEng": "Denbel Tafo",
                        "woredaAmh": "ደንባል ጣፎ"
                    },
                    {
                        "woredaCode": "ORSHL3EKT0",
                        "woredaEng": "Eka Tafo",
                        "woredaAmh": "ኤካ ጣፎ"
                    },
                    {
                        "woredaCode": "ORSHL3LDD0",
                        "woredaEng": "Lege Dadi Dalle",
                        "woredaAmh": "ለጋ ዳዲ ዳሌ"
                    }
                ]
            },
            {
                "zoneCode": "ORSHN30000",
                "zoneEng": "Shager City Administration - Mana Abichu Sub City",
                "zoneAmh": "ሸገር ከተማ አስተዳደር - መነ አቢቹ ክፍለ ከተማ",
                "woredas": [
                    {
                        "woredaCode": "ORSHN3AMA0",
                        "woredaEng": "Akako Mana Abichu",
                        "woredaAmh": "አካኮ መነ አብቹ"
                    },
                    {
                        "woredaCode": "ORSHN3TUM0",
                        "woredaEng": "Tufa Muna",
                        "woredaAmh": "ቱፋ ሙና"
                    }
                ]
            },
            {
                "zoneCode": "ORSHM30000",
                "zoneEng": "Shager City Administration - Melka Nonno Sub City",
                "zoneAmh": "ሸገር ከተማ አስተዳደር - መልካ ኖኖ ክፍለ ከተማ",
                "woredas": [
                    {
                        "woredaCode": "ORSHM3BER0",
                        "woredaEng": "Bero",
                        "woredaAmh": "ቤሮ"
                    },
                    {
                        "woredaCode": "ORSHM3MEG0",
                        "woredaEng": "Melka Gefersa",
                        "woredaAmh": "መልካ ገፈርሣ"
                    },
                    {
                        "woredaCode": "ORSHM3NNN0",
                        "woredaEng": "Nonno",
                        "woredaAmh": "ኖኖ"
                    }
                ]
            },
            {
                "zoneCode": "ORSHS30000",
                "zoneEng": "Shager City Administration - Sebeta Sub City",
                "zoneAmh": "ሸገር ከተማ አስተዳደር - ሰበታ ክፍለ ከተማ",
                "woredas": [
                    {
                        "woredaCode": "ORSHS3CHF0",
                        "woredaEng": "Chafe",
                        "woredaAmh": "ጨፌ"
                    },
                    {
                        "woredaCode": "ORSHS3MET0",
                        "woredaEng": "Meta",
                        "woredaAmh": "ሜታ"
                    },
                    {
                        "woredaCode": "ORSHS3MGL0",
                        "woredaEng": "Mogle",
                        "woredaAmh": "ሞግሌ"
                    }
                ]
            },
            {
                "zoneCode": "ORSHU30000",
                "zoneEng": "Shager City Administration - Sululta Sub City",
                "zoneAmh": "ሸገር ከተማ አስተዳደር - ሱሉልታ ክፍለ ከተማ",
                "woredas": [
                    {
                        "woredaCode": "ORSHU3ABG0",
                        "woredaEng": "Aba Geda",
                        "woredaAmh": "አባ ገዳ"
                    },
                    {
                        "woredaCode": "ORSHU3WSR0",
                        "woredaEng": "Wasarbi",
                        "woredaAmh": "ወሰርቢ"
                    }
                ]
            },
            {
                "zoneCode": "ORSHB30000",
                "zoneEng": "Shager City Administration- Burayu Sub City",
                "zoneAmh": "ሸገር ከተማ አስተዳደር - ቡራዩ ክፍለ ከተማ",
                "woredas": [
                    {
                        "woredaCode": "ORSHB3AND0",
                        "woredaEng": "Ane Dima",
                        "woredaAmh": "አኔ ዲማ"
                    },
                    {
                        "woredaCode": "ORSHB3EJG0",
                        "woredaEng": "Ejersa Goro",
                        "woredaAmh": "አጀርሰ ጎሮ"
                    },
                    {
                        "woredaCode": "ORSHB3GEB0",
                        "woredaEng": "Gefersa Burayu",
                        "woredaAmh": "ገፈርሣ ቡራዩ"
                    },
                    {
                        "woredaCode": "ORSHB3KET0",
                        "woredaEng": "Keta",
                        "woredaAmh": "ከታ"
                    }
                ]
            },
            {
                "zoneCode": "ORSHJ30000",
                "zoneEng": "Shager City Administration- Kura Jida Sub City",
                "zoneAmh": "ሸገር ከተማ አስተዳደር - ኩራ ጅዳ ክፍለ ከተማ",
                "woredas": [
                    {
                        "woredaCode": "ORSHJ3DIS0",
                        "woredaEng": "Dire Sokoru",
                        "woredaAmh": "ድሬ ሶኮሩ"
                    },
                    {
                        "woredaCode": "ORSHJ3KUJ0",
                        "woredaEng": "Kura Jida",
                        "woredaAmh": "ኩራ ጂዳ"
                    },
                    {
                        "woredaCode": "ORSHJ3WLB0",
                        "woredaEng": "Walgawo Laga Bari",
                        "woredaAmh": "ወልጋዎ ለጋ ባሪ"
                    }
                ]
            },
            {
                "zoneCode": "ORSHK10000",
                "zoneEng": "Shakiso City Administration",
                "zoneAmh": "ሻኪሶ ከተማ አስተዳደር",
                "woredas": [
                    {
                        "woredaCode": "ORSHK1BAK7",
                        "woredaEng": "Banti Arba Kebele",
                        "woredaAmh": "በንቲ አርባ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORSHK1BFK7",
                        "woredaEng": "Bika Fora Kebele",
                        "woredaAmh": "ቢቃ ፎራ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORSHK1DAK7",
                        "woredaEng": "Dugo Awata Kebele",
                        "woredaAmh": "ዱጎ አዋጣ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORSHK1UDK7",
                        "woredaEng": "Udeyi Kebele",
                        "woredaAmh": "ኡዴይ ቀበሌ"
                    }
                ]
            },
            {
                "zoneCode": "ORSHA10000",
                "zoneEng": "Shashamane City Administration - Alache",
                "zoneAmh": "ሻሸመኔ ከተማ አስተዳደር - አላቼ",
                "woredas": [
                    {
                        "woredaCode": "ORSHA1AWS0",
                        "woredaEng": "Awasho",
                        "woredaAmh": "አዋሾ"
                    },
                    {
                        "woredaCode": "ORSHA1DIB0",
                        "woredaEng": "Dida Boke",
                        "woredaAmh": "ዲዳ ቦቄ"
                    },
                    {
                        "woredaCode": "ORSHA1MAB0",
                        "woredaEng": "Malka Badesa",
                        "woredaAmh": "መልካ በዴሳ"
                    }
                ]
            },
            {
                "zoneCode": "ORSHB10000",
                "zoneEng": "Shashamane City Administration - Bishan Guracha",
                "zoneAmh": "ሻሸመኔ ከተማ አስተዳደር - ቢሻን ጉራቻ",
                "woredas": [
                    {
                        "woredaCode": "ORSHB1ALR0",
                        "woredaEng": "Algi Rima",
                        "woredaAmh": "አልጊ ሪማ"
                    },
                    {
                        "woredaCode": "ORSHB1HBS0",
                        "woredaEng": "Habas",
                        "woredaAmh": "ሀባስ"
                    },
                    {
                        "woredaCode": "ORSHB1TOG0",
                        "woredaEng": "Toga",
                        "woredaAmh": "ቶጋ"
                    }
                ]
            },
            {
                "zoneCode": "ORSHH10000",
                "zoneEng": "Shashamane City Administration - Harufa",
                "zoneAmh": "ሻሸመኔ ከተማ አስተዳደር - ሀሩፋ",
                "woredas": [
                    {
                        "woredaCode": "ORSHH1ALL0",
                        "woredaEng": "Alelu",
                        "woredaAmh": "አሌሉ"
                    },
                    {
                        "woredaCode": "ORSHH1BLC0",
                        "woredaEng": "Bulchana",
                        "woredaAmh": "ቡልቻና"
                    },
                    {
                        "woredaCode": "ORSHH1MAD0",
                        "woredaEng": "Maja Dama",
                        "woredaAmh": "መጃ ደማ"
                    }
                ]
            },
            {
                "zoneCode": "ORSHM10000",
                "zoneEng": "Shashamane City Administration - Malka Sirba",
                "zoneAmh": "ሻሸመኔ ከተማ አስተዳደር - መልካ ሲርባ",
                "woredas": [
                    {
                        "woredaCode": "ORSHM1BUF0",
                        "woredaEng": "Bute Filcha",
                        "woredaAmh": "ቡቴ ፍልቻ"
                    },
                    {
                        "woredaCode": "ORSHM1EDL0",
                        "woredaEng": "Edo Lencha",
                        "woredaAmh": "ኤዶ ሌንጫ"
                    },
                    {
                        "woredaCode": "ORSHM1KAF0",
                        "woredaEng": "Karara Filcha",
                        "woredaAmh": "ካራራ ፌሊቻ"
                    }
                ]
            },
            {
                "zoneCode": "ORSHN10000",
                "zoneEng": "Sheno City Administration",
                "zoneAmh": "ሸኖ ከተማ አስተዳደር",
                "woredas": [
                    {
                        "woredaCode": "ORSHN1ADK7",
                        "woredaEng": "Adadimato Kebele",
                        "woredaAmh": "አዳዲማቶ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORSHN1BEK7",
                        "woredaEng": "Burka Ejersa Kebele",
                        "woredaAmh": "ቡርቃ ኤጀርሳ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORSHN1KGK7",
                        "woredaEng": "Kombolcha Goro Kebele",
                        "woredaAmh": "ኮምቦልቻ ጎሮ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORSHN1MGK7",
                        "woredaEng": "Mogerona Gardaga Kebele",
                        "woredaAmh": "ሞገሮና ጋራዳጋ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORSHN1OKK7",
                        "woredaEng": "Oda Kuni Kebele",
                        "woredaAmh": "ኦዳ ኩኒ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORSHN1TKS7",
                        "woredaEng": "Tulu Kurfo Sinke Kebele",
                        "woredaAmh": "ቱሉ ኩርፎ ሲንቄ ቀበሌ"
                    }
                ]
            },
            {
                "zoneCode": "ORSWS00000",
                "zoneEng": "South West Shawa",
                "zoneAmh": "ደቡብ ምዕራብ ሸዋ",
                "woredas": [
                    {
                        "woredaCode": "ORSWS0AMY0",
                        "woredaEng": "Ameya",
                        "woredaAmh": "አመያ"
                    },
                    {
                        "woredaCode": "ORSWS0BCH0",
                        "woredaEng": "Becho",
                        "woredaAmh": "በቾ"
                    },
                    {
                        "woredaCode": "ORSWS0DAW0",
                        "woredaEng": "Dawo",
                        "woredaAmh": "ዳዎ"
                    },
                    {
                        "woredaCode": "ORSWS0GOR0",
                        "woredaEng": "Goro",
                        "woredaAmh": "ጎሮ"
                    },
                    {
                        "woredaCode": "ORSWS0ILU0",
                        "woredaEng": "Ilu",
                        "woredaAmh": "ኢሉ"
                    },
                    {
                        "woredaCode": "ORSWS0KEM0",
                        "woredaEng": "Kersa Malima",
                        "woredaAmh": "ቀርሳ ማሊማ"
                    },
                    {
                        "woredaCode": "ORSWS0SAH0",
                        "woredaEng": "Sabata Hawas",
                        "woredaAmh": "ሰበታ ሀዋስ"
                    },
                    {
                        "woredaCode": "ORSWS0SES0",
                        "woredaEng": "Seden Sodo",
                        "woredaAmh": "ሰደን ሶዶ"
                    },
                    {
                        "woredaCode": "ORSWS0SOD0",
                        "woredaEng": "Sodo Dachi",
                        "woredaAmh": "ሶዶ ዳጪ"
                    },
                    {
                        "woredaCode": "ORSWS0TOL0",
                        "woredaEng": "Tole",
                        "woredaAmh": "ቶሌ"
                    },
                    {
                        "woredaCode": "ORSWS0WLS0",
                        "woredaEng": "Weliso",
                        "woredaAmh": "ወሊሶ"
                    },
                    {
                        "woredaCode": "ORSWS0WNC0",
                        "woredaEng": "Wenchi",
                        "woredaAmh": "ወንጪ"
                    }
                ]
            },
            {
                "zoneCode": "ORWLS10000",
                "zoneEng": "Waliso City Administration",
                "zoneAmh": "ወሊሶ ከተማ አስተዳደር",
                "woredas": [
                    {
                        "woredaCode": "ORWLS1AYK7",
                        "woredaEng": "Ayetu Kebele",
                        "woredaAmh": "አዬቱ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORWLS1BGK7",
                        "woredaEng": "Burka Gudina Kebele",
                        "woredaAmh": "ቡርቃ ጉዲና ቀበሌ"
                    },
                    {
                        "woredaCode": "ORWLS1EJK7",
                        "woredaEng": "Ejersa Kebele",
                        "woredaAmh": "ኤጀርሳ ቀበሌ"
                    },
                    {
                        "woredaCode": "ORWLS1HOK7",
                        "woredaEng": "Hora Kebele",
                        "woredaAmh": "ሆራ ቀበሌ"
                    }
                ]
            },
            {
                "zoneCode": "ORWEA00000",
                "zoneEng": "West Arsi",
                "zoneAmh": "ምዕራብ አርሲ",
                "woredas": [
                    {
                        "woredaCode": "ORWEA0ADB0",
                        "woredaEng": "Adaba",
                        "woredaAmh": "አዳባ"
                    },
                    {
                        "woredaCode": "ORWEA0ARN0",
                        "woredaEng": "Arsi Negele",
                        "woredaAmh": "አርሲ ነጌሌ"
                    },
                    {
                        "woredaCode": "ORWEA0ARN2",
                        "woredaEng": "Arsi Negele Town",
                        "woredaAmh": "አርሲ ነጌሌ ከተማ"
                    },
                    {
                        "woredaCode": "ORWEA0DDL0",
                        "woredaEng": "Dodola",
                        "woredaAmh": "ዶዶላ"
                    },
                    {
                        "woredaCode": "ORWEA0GEA0",
                        "woredaEng": "Gedeb Aasasa",
                        "woredaAmh": "ገደብ ሀሳሳ"
                    },
                    {
                        "woredaCode": "ORWEA0HEA0",
                        "woredaEng": "Heban Arsi",
                        "woredaAmh": "ሄበን አርሲ"
                    },
                    {
                        "woredaCode": "ORWEA0KFL0",
                        "woredaEng": "Kofele",
                        "woredaAmh": "ኮፈሌ"
                    },
                    {
                        "woredaCode": "ORWEA0KFL2",
                        "woredaEng": "Kofele Town",
                        "woredaAmh": "ኮፈሌ ከተማ"
                    },
                    {
                        "woredaCode": "ORWEA0KKS0",
                        "woredaEng": "Kokosa",
                        "woredaAmh": "ኮኮሳ"
                    },
                    {
                        "woredaCode": "ORWEA0KOR0",
                        "woredaEng": "Kore",
                        "woredaAmh": "ቆሬ"
                    },
                    {
                        "woredaCode": "ORWEA0NNS0",
                        "woredaEng": "Nensebo",
                        "woredaAmh": "ነንሰቦ"
                    },
                    {
                        "woredaCode": "ORWEA0SHL0",
                        "woredaEng": "Shala",
                        "woredaAmh": "ሻላ"
                    },
                    {
                        "woredaCode": "ORWEA0SHS0",
                        "woredaEng": "Shashemene",
                        "woredaAmh": "ሻሸመኔ"
                    },
                    {
                        "woredaCode": "ORWEA0SRR0",
                        "woredaEng": "Siraro",
                        "woredaAmh": "ሲራሮ"
                    },
                    {
                        "woredaCode": "ORWEA0WND0",
                        "woredaEng": "Wendo",
                        "woredaAmh": "ወንዶ"
                    }
                ]
            },
            {
                "zoneCode": "ORWEG00000",
                "zoneEng": "West Guji",
                "zoneAmh": "ምዕራብ ጉጂ",
                "woredas": [
                    {
                        "woredaCode": "ORWEG0ABY0",
                        "woredaEng": "Abaya",
                        "woredaAmh": "አባያ"
                    },
                    {
                        "woredaCode": "ORWEG0BIK0",
                        "woredaEng": "Birbirsa Kojowa",
                        "woredaAmh": "ቢርቢርሳ ኮጆዋ"
                    },
                    {
                        "woredaCode": "ORWEG0BUH0",
                        "woredaEng": "Bule Hora",
                        "woredaAmh": "ቡሌ ሆራ"
                    },
                    {
                        "woredaCode": "ORWEG0DUD0",
                        "woredaEng": "Dugda Dewa",
                        "woredaAmh": "ዱግደ ዳዋ"
                    },
                    {
                        "woredaCode": "ORWEG0GLN0",
                        "woredaEng": "Gelana",
                        "woredaAmh": "ገላና"
                    },
                    {
                        "woredaCode": "ORWEG0HAW0",
                        "woredaEng": "Hanbela Wamena",
                        "woredaAmh": "ሀንበላ ዋመና"
                    },
                    {
                        "woredaCode": "ORWEG0KRC0",
                        "woredaEng": "Kercha",
                        "woredaAmh": "ቀርጫ"
                    },
                    {
                        "woredaCode": "ORWEG0KRC2",
                        "woredaEng": "Kercha Town",
                        "woredaAmh": "ቀርጫ ከተማ"
                    },
                    {
                        "woredaCode": "ORWEG0MES0",
                        "woredaEng": "Melka Soda",
                        "woredaAmh": "መልካ ሶዳ"
                    },
                    {
                        "woredaCode": "ORWEG0SUB0",
                        "woredaEng": "Suro Berguda",
                        "woredaAmh": "ሱሮ በርጉዳ"
                    }
                ]
            },
            {
                "zoneCode": "ORWEH00000",
                "zoneEng": "West Harerge",
                "zoneAmh": "ምዕራብ ሐረርጌ",
                "woredas": [
                    {
                        "woredaCode": "ORWEH0ANC0",
                        "woredaEng": "Anchar",
                        "woredaAmh": "አንጫር"
                    },
                    {
                        "woredaCode": "ORWEH0BDS2",
                        "woredaEng": "Bedesa Town",
                        "woredaAmh": "ባዴሳ ከተማ"
                    },
                    {
                        "woredaCode": "ORWEH0BOK0",
                        "woredaEng": "Boke",
                        "woredaAmh": "ቦኬ"
                    },
                    {
                        "woredaCode": "ORWEH0BUD0",
                        "woredaEng": "Burka Dhintu",
                        "woredaAmh": "ቡርቃ ዲንቱ"
                    },
                    {
                        "woredaCode": "ORWEH0CHR0",
                        "woredaEng": "Chiro",
                        "woredaAmh": "ጭሮ"
                    },
                    {
                        "woredaCode": "ORWEH0CHR2",
                        "woredaEng": "Chiro Town",
                        "woredaAmh": "ጭሮ ከተማ"
                    },
                    {
                        "woredaCode": "ORWEH0DAL0",
                        "woredaEng": "Daro Lebu",
                        "woredaAmh": "ዳሮ ለቡ"
                    },
                    {
                        "woredaCode": "ORWEH0DOB0",
                        "woredaEng": "Doba",
                        "woredaAmh": "ዶባ"
                    },
                    {
                        "woredaCode": "ORWEH0GLM2",
                        "woredaEng": "Galamso Town",
                        "woredaAmh": "ገለምሶ ከተማ"
                    },
                    {
                        "woredaCode": "ORWEH0GMC0",
                        "woredaEng": "Gemechis",
                        "woredaAmh": "ገመቺስ"
                    },
                    {
                        "woredaCode": "ORWEH0GUK0",
                        "woredaEng": "Guba Koricha",
                        "woredaAmh": "ጉባ ቆሪቻ"
                    },
                    {
                        "woredaCode": "ORWEH0GUB0",
                        "woredaEng": "Gumbi Bordode",
                        "woredaAmh": "ጉምቢ ቦርዶዴ"
                    },
                    {
                        "woredaCode": "ORWEH0HBR0",
                        "woredaEng": "Habro",
                        "woredaAmh": "ሀብሮ"
                    },
                    {
                        "woredaCode": "ORWEH0HAG0",
                        "woredaEng": "Hawi Gudina",
                        "woredaAmh": "ሐዊ ጉዲና"
                    },
                    {
                        "woredaCode": "ORWEH0HRN2",
                        "woredaEng": "Hirna Town",
                        "woredaAmh": "ሂርና ከተማ"
                    },
                    {
                        "woredaCode": "ORWEH0MEM2",
                        "woredaEng": "Mechara Micheta Town",
                        "woredaAmh": "መቻራ ሚጫታ ከተማ"
                    },
                    {
                        "woredaCode": "ORWEH0MEI0",
                        "woredaEng": "Meiso",
                        "woredaAmh": "ሚኤሶ"
                    },
                    {
                        "woredaCode": "ORWEH0ODB0",
                        "woredaEng": "Oda Bultum",
                        "woredaAmh": "ኦዳ ቡልቱም"
                    },
                    {
                        "woredaCode": "ORWEH0SHD0",
                        "woredaEng": "Shanan Dugo",
                        "woredaAmh": "ሸነን ዱጎ"
                    },
                    {
                        "woredaCode": "ORWEH0TUL0",
                        "woredaEng": "Tulo",
                        "woredaAmh": "ጡሎ"
                    }
                ]
            },
            {
                "zoneCode": "ORWES00000",
                "zoneEng": "West Shawa",
                "zoneAmh": "ምዕራብ ሸዋ",
                "woredas": [
                    {
                        "woredaCode": "ORWES0ABG0",
                        "woredaEng": "Abuna Gindeberet",
                        "woredaAmh": "አቡና ግንደበረት"
                    },
                    {
                        "woredaCode": "ORWES0AAB0",
                        "woredaEng": "Ade'a Berga",
                        "woredaAmh": "አደአ በርጋ"
                    },
                    {
                        "woredaCode": "ORWES0AMB0",
                        "woredaEng": "Ambo",
                        "woredaAmh": "አምቦ"
                    },
                    {
                        "woredaCode": "ORWES0BAT0",
                        "woredaEng": "Bako Tibe",
                        "woredaAmh": "ባኮ ቲቤ"
                    },
                    {
                        "woredaCode": "ORWES0CHL0",
                        "woredaEng": "Cheliya",
                        "woredaAmh": "ጨሊያ"
                    },
                    {
                        "woredaCode": "ORWES0COB0",
                        "woredaEng": "Cobi",
                        "woredaAmh": "ጮቢ"
                    },
                    {
                        "woredaCode": "ORWES0DND0",
                        "woredaEng": "Dendi",
                        "woredaAmh": "ደንዲ"
                    },
                    {
                        "woredaCode": "ORWES0DEN0",
                        "woredaEng": "Deno",
                        "woredaAmh": "ዳኖ"
                    },
                    {
                        "woredaCode": "ORWES0DII0",
                        "woredaEng": "Dire Inchini",
                        "woredaAmh": "ድሬ እንጭኒ"
                    },
                    {
                        "woredaCode": "ORWES0EJR0",
                        "woredaEng": "Ejere",
                        "woredaAmh": "ኤጄሬ"
                    },
                    {
                        "woredaCode": "ORWES0EJL0",
                        "woredaEng": "Ejersa Lafo",
                        "woredaAmh": "ኤጄሪሳ ለፎ"
                    },
                    {
                        "woredaCode": "ORWES0GND0",
                        "woredaEng": "Gindeberet",
                        "woredaAmh": "ግንደበረት"
                    },
                    {
                        "woredaCode": "ORWES0ILF0",
                        "woredaEng": "Ilfeta",
                        "woredaAmh": "ኢልፈታ"
                    },
                    {
                        "woredaCode": "ORWES0ILG0",
                        "woredaEng": "Ilu Gelan",
                        "woredaAmh": "ኢሉ ገላን"
                    },
                    {
                        "woredaCode": "ORWES0JLD0",
                        "woredaEng": "Jeldu",
                        "woredaAmh": "ጀልዱ"
                    },
                    {
                        "woredaCode": "ORWES0JBT0",
                        "woredaEng": "Jibat",
                        "woredaAmh": "ጅባት"
                    },
                    {
                        "woredaCode": "ORWES0LIJ0",
                        "woredaEng": "Liban Jewi",
                        "woredaAmh": "ሊበን ጃዊ"
                    },
                    {
                        "woredaCode": "ORWES0MER0",
                        "woredaEng": "Meta Robi",
                        "woredaAmh": "ሜታ ሮቢ"
                    },
                    {
                        "woredaCode": "ORWES0MEW0",
                        "woredaEng": "Meta Welkite",
                        "woredaAmh": "ሜታ ወልቂጤ"
                    },
                    {
                        "woredaCode": "ORWES0MDK0",
                        "woredaEng": "Midakegni",
                        "woredaAmh": "ሚዳቀኝ"
                    },
                    {
                        "woredaCode": "ORWES0NON0",
                        "woredaEng": "Nono",
                        "woredaAmh": "ኖኖ"
                    },
                    {
                        "woredaCode": "ORWES0TOK0",
                        "woredaEng": "Toke Kutaye",
                        "woredaAmh": "ቶኬ ኩታዬ"
                    },
                    {
                        "woredaCode": "ORWES0WLM0",
                        "woredaEng": "Walmara",
                        "woredaAmh": "ወልመራ"
                    }
                ]
            },
            {
                "zoneCode": "ORWEW00000",
                "zoneEng": "West Wellega",
                "zoneAmh": "ምዕራብ ወለጋ",
                "woredas": [
                    {
                        "woredaCode": "ORWEW0AYR0",
                        "woredaEng": "Ayira",
                        "woredaAmh": "አይራ"
                    },
                    {
                        "woredaCode": "ORWEW0BAG0",
                        "woredaEng": "Babo Gembel",
                        "woredaAmh": "ባቦ ጋምቤል"
                    },
                    {
                        "woredaCode": "ORWEW0BEG0",
                        "woredaEng": "Begi",
                        "woredaAmh": "ቤጊ"
                    },
                    {
                        "woredaCode": "ORWEW0BOC0",
                        "woredaEng": "Boji Chekorsa",
                        "woredaAmh": "ቦጅ ጮቆርሳ"
                    },
                    {
                        "woredaCode": "ORWEW0BOD0",
                        "woredaEng": "Boji Dirmeji",
                        "woredaAmh": "ቦጂ ድርመጂ"
                    },
                    {
                        "woredaCode": "ORWEW0GNJ0",
                        "woredaEng": "Genji",
                        "woredaAmh": "ገንጂ"
                    },
                    {
                        "woredaCode": "ORWEW0GMB0",
                        "woredaEng": "Gimbi",
                        "woredaAmh": "ጊምቢ"
                    },
                    {
                        "woredaCode": "ORWEW0GMB2",
                        "woredaEng": "Gimbi Town",
                        "woredaAmh": "ጊምቢ ከተማ"
                    },
                    {
                        "woredaCode": "ORWEW0GLS0",
                        "woredaEng": "Guliso",
                        "woredaAmh": "ጉሊሶ"
                    },
                    {
                        "woredaCode": "ORWEW0HAR0",
                        "woredaEng": "Haru",
                        "woredaAmh": "ሃሩ"
                    },
                    {
                        "woredaCode": "ORWEW0HOM0",
                        "woredaEng": "Homa",
                        "woredaAmh": "ሆማ"
                    },
                    {
                        "woredaCode": "ORWEW0JRS0",
                        "woredaEng": "Jarso",
                        "woredaAmh": "ጃርሶ"
                    },
                    {
                        "woredaCode": "ORWEW0KIK0",
                        "woredaEng": "Kiltu Kara",
                        "woredaAmh": "ቂልጡ ካራ"
                    },
                    {
                        "woredaCode": "ORWEW0KND0",
                        "woredaEng": "Kondala",
                        "woredaAmh": "ቆንዳላ"
                    },
                    {
                        "woredaCode": "ORWEW0LAA0",
                        "woredaEng": "Lalo Asabi",
                        "woredaAmh": "ላሎ አሳቢ"
                    },
                    {
                        "woredaCode": "ORWEW0LES0",
                        "woredaEng": "Leta Sibu",
                        "woredaAmh": "ለታ ስቡ"
                    },
                    {
                        "woredaCode": "ORWEW0MND2",
                        "woredaEng": "Mendi Town",
                        "woredaAmh": "መንዲ ከተማ"
                    },
                    {
                        "woredaCode": "ORWEW0MES0",
                        "woredaEng": "Mene Sibu",
                        "woredaAmh": "መነ ሲቡ"
                    },
                    {
                        "woredaCode": "ORWEW0NEJ0",
                        "woredaEng": "Nejo",
                        "woredaAmh": "ነጆ"
                    },
                    {
                        "woredaCode": "ORWEW0NOK0",
                        "woredaEng": "Nole Kaba",
                        "woredaAmh": "ኖሌ ካባ"
                    },
                    {
                        "woredaCode": "ORWEW0SEN0",
                        "woredaEng": "Seyo Nole",
                        "woredaAmh": "ሰዮ ኖሌ"
                    },
                    {
                        "woredaCode": "ORWEW0YBD0",
                        "woredaEng": "Yubdo",
                        "woredaAmh": "ዩብዶ"
                    }
                ]
            }
        ]
    },
    {
        "regionCode": "SD00000000",
        "regionEng": "Sidama",
        "regionAmh": "ሲዳማ",
        "zones": [
            {
                "zoneCode": "SDCES00000",
                "zoneEng": "Central Sidama",
                "zoneAmh": "ማዕከላዊ ሲዳማ",
                "woredas": [
                    {
                        "woredaCode": "SDCES0ARB0",
                        "woredaEng": "Arbegona",
                        "woredaAmh": "አርቤጎና"
                    },
                    {
                        "woredaCode": "SDCES0DAL0",
                        "woredaEng": "Dale",
                        "woredaAmh": "ዳሌ"
                    },
                    {
                        "woredaCode": "SDCES0DRR0",
                        "woredaEng": "Darara",
                        "woredaAmh": "ዳራራ"
                    },
                    {
                        "woredaCode": "SDCES0LOA0",
                        "woredaEng": "Loka Abaya",
                        "woredaAmh": "ሎካ አባያ"
                    },
                    {
                        "woredaCode": "SDCES0SHF0",
                        "woredaEng": "Shafamo",
                        "woredaAmh": "ሻፋሞ"
                    },
                    {
                        "woredaCode": "SDCES0WNS0",
                        "woredaEng": "Wonsho",
                        "woredaAmh": "ወንሾ"
                    },
                    {
                        "woredaCode": "SDCES0YRG1",
                        "woredaEng": "Yirgalem City Administration",
                        "woredaAmh": "ይርጋለም ከተማ አስተዳደር"
                    }
                ]
            },
            {
                "zoneCode": "SDEAS00000",
                "zoneEng": "Eastern Sidama",
                "zoneAmh": "ምስራቃዊ ሲዳማ",
                "woredas": [
                    {
                        "woredaCode": "SDEAS0ARR0",
                        "woredaEng": "Aroresa",
                        "woredaAmh": "አሮሬሳ"
                    },
                    {
                        "woredaCode": "SDEAS0BNS0",
                        "woredaEng": "Bensa",
                        "woredaAmh": "በንሳ"
                    },
                    {
                        "woredaCode": "SDEAS0BOZ0",
                        "woredaEng": "Bona Zuria",
                        "woredaAmh": "ቦና ዙሪያ"
                    },
                    {
                        "woredaCode": "SDEAS0BUR0",
                        "woredaEng": "Bura",
                        "woredaAmh": "ቡራ"
                    },
                    {
                        "woredaCode": "SDEAS0CHG0",
                        "woredaEng": "Chebe Gambeltu",
                        "woredaAmh": "ጫቤ ጋምቤልቱ"
                    },
                    {
                        "woredaCode": "SDEAS0CHR0",
                        "woredaEng": "Chire Woreda",
                        "woredaAmh": "ጭሬ ወረዳ"
                    },
                    {
                        "woredaCode": "SDEAS0DAE0",
                        "woredaEng": "Daela",
                        "woredaAmh": "ዳኤላ"
                    },
                    {
                        "woredaCode": "SDEAS0DAY1",
                        "woredaEng": "Daye City Administration",
                        "woredaAmh": "ዳዬ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "SDEAS0HOK0",
                        "woredaEng": "Hoko",
                        "woredaAmh": "ሆኮ"
                    }
                ]
            },
            {
                "zoneCode": "SDHWS10000",
                "zoneEng": "Hawassa City Administration",
                "zoneAmh": "ሀዋሳ ከተማ አስተዳደር",
                "woredas": [
                    {
                        "woredaCode": "SDHWS1ADK0",
                        "woredaEng": "Addis ketema",
                        "woredaAmh": "አዲስ ከተማ"
                    },
                    {
                        "woredaCode": "SDHWS1BAA0",
                        "woredaEng": "Bahel Adarash",
                        "woredaAmh": "ባህል አዳራሽ"
                    },
                    {
                        "woredaCode": "SDHWS1HAD0",
                        "woredaEng": "Haik Dar",
                        "woredaAmh": "ሀይቅ ዳር"
                    },
                    {
                        "woredaCode": "SDHWS1MHL0",
                        "woredaEng": "Mehal",
                        "woredaAmh": "መሀል"
                    },
                    {
                        "woredaCode": "SDHWS1MNH0",
                        "woredaEng": "Meneharya",
                        "woredaAmh": "መናሃሪያ"
                    },
                    {
                        "woredaCode": "SDHWS1MSR0",
                        "woredaEng": "Misrak",
                        "woredaAmh": "ምስራቅ"
                    },
                    {
                        "woredaCode": "SDHWS1TBR0",
                        "woredaEng": "Tabor",
                        "woredaAmh": "ታቦር"
                    },
                    {
                        "woredaCode": "SDHWS1TUL0",
                        "woredaEng": "Tula",
                        "woredaAmh": "ቱላ"
                    }
                ]
            },
            {
                "zoneCode": "SDNOS00000",
                "zoneEng": "Northern Sidama",
                "zoneAmh": "ሰሜናዊ ሲዳማ",
                "woredas": [
                    {
                        "woredaCode": "SDNOS0BIZ0",
                        "woredaEng": "Bilate Zuriya",
                        "woredaAmh": "ቢላቴ ዙሪያ"
                    },
                    {
                        "woredaCode": "SDNOS0BRC0",
                        "woredaEng": "Boricha",
                        "woredaAmh": "ቦርቻ"
                    },
                    {
                        "woredaCode": "SDNOS0GRC0",
                        "woredaEng": "Gorche",
                        "woredaAmh": "ጎርቼ"
                    },
                    {
                        "woredaCode": "SDNOS0HAZ0",
                        "woredaEng": "Hawassa Zuriya",
                        "woredaAmh": "ሀዋሳ ዙሪያ"
                    },
                    {
                        "woredaCode": "SDNOS0HAL0",
                        "woredaEng": "Hawela Lida",
                        "woredaAmh": "ሀዌላ ሊዳ"
                    },
                    {
                        "woredaCode": "SDNOS0LEK1",
                        "woredaEng": "Leku City Administration",
                        "woredaAmh": "ለኩ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "SDNOS0MLG0",
                        "woredaEng": "Malga",
                        "woredaAmh": "ማልጋ"
                    },
                    {
                        "woredaCode": "SDNOS0SHB0",
                        "woredaEng": "Shebedino",
                        "woredaAmh": "ሸበዲኖ"
                    },
                    {
                        "woredaCode": "SDNOS0WEG0",
                        "woredaEng": "Wendo Genet",
                        "woredaAmh": "ወንዶ ገነት"
                    },
                    {
                        "woredaCode": "SDNOS0WEG1",
                        "woredaEng": "Wendo Genet City administration",
                        "woredaAmh": "ወንዶ ገነት ከተማ አስተዳደር"
                    }
                ]
            },
            {
                "zoneCode": "SDSOS00000",
                "zoneEng": "Southern Sidama",
                "zoneAmh": "ደቡባዊ ሲዳማ",
                "woredas": [
                    {
                        "woredaCode": "SDSOS0ALC0",
                        "woredaEng": "Aleta Chuko",
                        "woredaAmh": "አለታ ጩኮ"
                    },
                    {
                        "woredaCode": "SDSOS0ALC1",
                        "woredaEng": "Aleta Chuko City Administration",
                        "woredaAmh": "አለታ ጩኮ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "SDSOS0ALW0",
                        "woredaEng": "Aleta Wendo",
                        "woredaAmh": "አለታ ወንዶ"
                    },
                    {
                        "woredaCode": "SDSOS0ALW1",
                        "woredaEng": "Aleta Wendo City Administration",
                        "woredaAmh": "አለታ ወንዶ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "SDSOS0BRS0",
                        "woredaEng": "Bursa",
                        "woredaAmh": "ቡርሳ"
                    },
                    {
                        "woredaCode": "SDSOS0CHR0",
                        "woredaEng": "Chirone",
                        "woredaAmh": "ጭሮኔ"
                    },
                    {
                        "woredaCode": "SDSOS0DAK0",
                        "woredaEng": "Dara Kawado",
                        "woredaAmh": "ዳራ ቃዋዶ"
                    },
                    {
                        "woredaCode": "SDSOS0DAO0",
                        "woredaEng": "Dara Otilcho",
                        "woredaAmh": "ዳራ ኦቲልቾ"
                    },
                    {
                        "woredaCode": "SDSOS0HUL0",
                        "woredaEng": "Hula",
                        "woredaAmh": "ሁላ"
                    },
                    {
                        "woredaCode": "SDSOS0TTC0",
                        "woredaEng": "Teticha",
                        "woredaAmh": "ጤጥቻ"
                    }
                ]
            }
        ]
    },
    {
        "regionCode": "SM00000000",
        "regionEng": "Somali",
        "regionAmh": "ሶማሌ",
        "zones": [
            {
                "zoneCode": "SMAFD00000",
                "zoneEng": "Afder",
                "zoneAmh": "አፍዴር",
                "woredas": [
                    {
                        "woredaCode": "SMAFD0BRY0",
                        "woredaEng": "Barey",
                        "woredaAmh": "ባሬይ"
                    },
                    {
                        "woredaCode": "SMAFD0CHR0",
                        "woredaEng": "Chereti",
                        "woredaAmh": "ጨረቲ"
                    },
                    {
                        "woredaCode": "SMAFD0DLB0",
                        "woredaEng": "Dolobay",
                        "woredaAmh": "ዶሎባይ"
                    },
                    {
                        "woredaCode": "SMAFD0ELK0",
                        "woredaEng": "Elkere",
                        "woredaAmh": "ኤልከሬ"
                    },
                    {
                        "woredaCode": "SMAFD0GOG0",
                        "woredaEng": "God-God",
                        "woredaAmh": "ጎድ-ጎድ"
                    },
                    {
                        "woredaCode": "SMAFD0HRG0",
                        "woredaEng": "Hergele",
                        "woredaAmh": "ሀርጌሌ"
                    },
                    {
                        "woredaCode": "SMAFD0KHL0",
                        "woredaEng": "Kohle",
                        "woredaAmh": "ቆሀሌ"
                    },
                    {
                        "woredaCode": "SMAFD0MII0",
                        "woredaEng": "Mierab Imey",
                        "woredaAmh": "ምዕራብ ኢሜይ"
                    },
                    {
                        "woredaCode": "SMAFD0RAS0",
                        "woredaEng": "Raso",
                        "woredaAmh": "ራሶ"
                    }
                ]
            },
            {
                "zoneCode": "SMDAW00000",
                "zoneEng": "Dawa",
                "zoneAmh": "ዳዋ",
                "woredas": [
                    {
                        "woredaCode": "SMDAW0KDD0",
                        "woredaEng": "Kedaduma",
                        "woredaAmh": "ቃዳዱማ"
                    },
                    {
                        "woredaCode": "SMDAW0MYL0",
                        "woredaEng": "Moyale",
                        "woredaAmh": "ሞያሌ"
                    },
                    {
                        "woredaCode": "SMDAW0MBR0",
                        "woredaEng": "Mubarek",
                        "woredaAmh": "ሙባረክ"
                    },
                    {
                        "woredaCode": "SMDAW0UDT0",
                        "woredaEng": "Udet",
                        "woredaAmh": "ኡደት"
                    }
                ]
            },
            {
                "zoneCode": "SMDGH10000",
                "zoneEng": "Degahbur City Administration",
                "zoneAmh": "ደጋህቡር ከተማ አስተዳደር",
                "woredas": [
                    {
                        "woredaCode": "SMDGH1DGH1",
                        "woredaEng": "Degahbur City Administration",
                        "woredaAmh": "ደጋህቡር ከተማ አስተዳደር"
                    }
                ]
            },
            {
                "zoneCode": "SMDLL00000",
                "zoneEng": "Dollo",
                "zoneAmh": "ዶሎ",
                "woredas": [
                    {
                        "woredaCode": "SMDLL0BKH0",
                        "woredaEng": "Bokh",
                        "woredaAmh": "ቦክ"
                    },
                    {
                        "woredaCode": "SMDLL0DND0",
                        "woredaEng": "Danod",
                        "woredaAmh": "ዳኖድ"
                    },
                    {
                        "woredaCode": "SMDLL0DRT0",
                        "woredaEng": "Deratole",
                        "woredaAmh": "ደራቶሌ"
                    },
                    {
                        "woredaCode": "SMDLL0GLD0",
                        "woredaEng": "Geladi",
                        "woredaAmh": "ገላዲ"
                    },
                    {
                        "woredaCode": "SMDLL0GLH0",
                        "woredaEng": "Gelhamer",
                        "woredaAmh": "ገልሀመር"
                    },
                    {
                        "woredaCode": "SMDLL0LEY0",
                        "woredaEng": "Lehelow-Yub",
                        "woredaAmh": "ላሄሎው-ዩኡብ"
                    },
                    {
                        "woredaCode": "SMDLL0WRD0",
                        "woredaEng": "Warder",
                        "woredaAmh": "ዋርዴር"
                    }
                ]
            },
            {
                "zoneCode": "SMERR00000",
                "zoneEng": "Erer",
                "zoneAmh": "ኤረር",
                "woredas": [
                    {
                        "woredaCode": "SMERR0FIQ0",
                        "woredaEng": "Fiq",
                        "woredaAmh": "ፊቅ"
                    },
                    {
                        "woredaCode": "SMERR0HMR0",
                        "woredaEng": "Hamero",
                        "woredaAmh": "ሀመሮ"
                    },
                    {
                        "woredaCode": "SMERR0LGH0",
                        "woredaEng": "Legehida",
                        "woredaAmh": "ለገሂዳ"
                    },
                    {
                        "woredaCode": "SMERR0MEM0",
                        "woredaEng": "Meyu-Muluko",
                        "woredaAmh": "መዩ-ሙሉቆ"
                    },
                    {
                        "woredaCode": "SMERR0QUB0",
                        "woredaEng": "Qubi",
                        "woredaAmh": "ቁቢ"
                    },
                    {
                        "woredaCode": "SMERR0SLH0",
                        "woredaEng": "Selehad",
                        "woredaAmh": "ሰለሃድ"
                    },
                    {
                        "woredaCode": "SMERR0WNG0",
                        "woredaEng": "Wangay",
                        "woredaAmh": "ዋንጋይ"
                    },
                    {
                        "woredaCode": "SMERR0YHB0",
                        "woredaEng": "Yahob",
                        "woredaAmh": "ያሆብ"
                    }
                ]
            },
            {
                "zoneCode": "SMFFN00000",
                "zoneEng": "Fafan",
                "zoneAmh": "ፋፈን",
                "woredas": [
                    {
                        "woredaCode": "SMFFN0AWB0",
                        "woredaEng": "Awbere",
                        "woredaAmh": "አውበሬ"
                    },
                    {
                        "woredaCode": "SMFFN0BBL0",
                        "woredaEng": "Babille",
                        "woredaAmh": "ባቢሌ"
                    },
                    {
                        "woredaCode": "SMFFN0GLJ0",
                        "woredaEng": "Goljano",
                        "woredaAmh": "ጎልጃኖ"
                    },
                    {
                        "woredaCode": "SMFFN0GRS0",
                        "woredaEng": "Gursum",
                        "woredaAmh": "ጉርሱም"
                    },
                    {
                        "woredaCode": "SMFFN0HRW0",
                        "woredaEng": "Harawo",
                        "woredaAmh": "ሃራዎ"
                    },
                    {
                        "woredaCode": "SMFFN0HRS0",
                        "woredaEng": "Hershin",
                        "woredaAmh": "ሐርሽን"
                    },
                    {
                        "woredaCode": "SMFFN0KRN0",
                        "woredaEng": "Koran",
                        "woredaAmh": "ቆራን"
                    },
                    {
                        "woredaCode": "SMFFN0NJH0",
                        "woredaEng": "North Jigjiga (Harores)",
                        "woredaAmh": "ሰሜን ጅግጅጋ (ሀሮሬስ)"
                    },
                    {
                        "woredaCode": "SMFFN0SJS0",
                        "woredaEng": "South Jigjiga (Shebeley)",
                        "woredaAmh": "ደቡብ ጅግጅጋ (ሸቤሌይ)"
                    },
                    {
                        "woredaCode": "SMFFN0TUG0",
                        "woredaEng": "Tuli-guled",
                        "woredaAmh": "ቱሊ-ጉሌድ"
                    }
                ]
            },
            {
                "zoneCode": "SMGOD10000",
                "zoneEng": "Gode City Administration",
                "zoneAmh": "ጎዴ ከተማ አስተዳደር",
                "woredas": [
                    {
                        "woredaCode": "SMGOD1GOD1",
                        "woredaEng": "Gode City Administration",
                        "woredaAmh": "ጎዴ ከተማ አስተዳደር"
                    }
                ]
            },
            {
                "zoneCode": "SMJRR00000",
                "zoneEng": "Jarar",
                "zoneAmh": "ጀረር",
                "woredas": [
                    {
                        "woredaCode": "SMJRR0ARR0",
                        "woredaEng": "Ararso",
                        "woredaAmh": "አራርሶ"
                    },
                    {
                        "woredaCode": "SMJRR0AWR0",
                        "woredaEng": "Aware",
                        "woredaAmh": "አዋሬ"
                    },
                    {
                        "woredaCode": "SMJRR0BIB0",
                        "woredaEng": "Bilil Bur",
                        "woredaAmh": "ቢልኢል ቡር"
                    },
                    {
                        "woredaCode": "SMJRR0BRK0",
                        "woredaEng": "Birkod",
                        "woredaAmh": "ብርቆድ"
                    },
                    {
                        "woredaCode": "SMJRR0DRR0",
                        "woredaEng": "Daror",
                        "woredaAmh": "ዳሮር"
                    },
                    {
                        "woredaCode": "SMJRR0DGB0",
                        "woredaEng": "Degahbur",
                        "woredaAmh": "ደጋህቡር"
                    },
                    {
                        "woredaCode": "SMJRR0DGH0",
                        "woredaEng": "Degahmedow",
                        "woredaAmh": "ደጋህመዶው"
                    },
                    {
                        "woredaCode": "SMJRR0DIG0",
                        "woredaEng": "Dig",
                        "woredaAmh": "ዲግ"
                    },
                    {
                        "woredaCode": "SMJRR0GSH0",
                        "woredaEng": "Gashamo",
                        "woredaAmh": "ጋሻሞ"
                    },
                    {
                        "woredaCode": "SMJRR0GNG0",
                        "woredaEng": "Gunagado",
                        "woredaAmh": "ጉናጋዶ"
                    },
                    {
                        "woredaCode": "SMJRR0YOA0",
                        "woredaEng": "Yoale",
                        "woredaAmh": "ዮኣሌ"
                    }
                ]
            },
            {
                "zoneCode": "SMJGJ10000",
                "zoneEng": "Jigijga City Administration",
                "zoneAmh": "ጅግጅጋ ከተማ አስተዳደር",
                "woredas": [
                    {
                        "woredaCode": "SMJGJ1JGJ1",
                        "woredaEng": "Jigijga City Administration",
                        "woredaAmh": "ጅግጅጋ ከተማ አስተዳደር"
                    }
                ]
            },
            {
                "zoneCode": "SMKEB10000",
                "zoneEng": "Kebri Beyah City Administration",
                "zoneAmh": "ቀብሪ በያህ ከተማ አስተዳደር",
                "woredas": [
                    {
                        "woredaCode": "SMKEB1KEB1",
                        "woredaEng": "Kebri Beyah City Administration",
                        "woredaAmh": "ቀብሪ በያህ ከተማ አስተዳደር"
                    }
                ]
            },
            {
                "zoneCode": "SMKRH00000",
                "zoneEng": "Korahey",
                "zoneAmh": "ቆራህይ",
                "woredas": [
                    {
                        "woredaCode": "SMKRH0BDL0",
                        "woredaEng": "Bodaley",
                        "woredaAmh": "ቦዳሌይ"
                    },
                    {
                        "woredaCode": "SMKRH0DOW0",
                        "woredaEng": "Dobo-Weyn",
                        "woredaAmh": "ዶቦ-ዌይን"
                    },
                    {
                        "woredaCode": "SMKRH0ELO0",
                        "woredaEng": "El Ogaden",
                        "woredaAmh": "ኤል ኦጋዴን"
                    },
                    {
                        "woredaCode": "SMKRH0GOK0",
                        "woredaEng": "Gogilo-Kudunbur",
                        "woredaAmh": "ጎግሎ-ኩዱንቡር"
                    },
                    {
                        "woredaCode": "SMKRH0HGL0",
                        "woredaEng": "Higloley",
                        "woredaAmh": "ሂግሎሌይ"
                    },
                    {
                        "woredaCode": "SMKRH0LSD0",
                        "woredaEng": "Lasdankeyre",
                        "woredaAmh": "ላስዳንከይሬ"
                    },
                    {
                        "woredaCode": "SMKRH0MRS0",
                        "woredaEng": "Marsin",
                        "woredaAmh": "ማርሲን"
                    },
                    {
                        "woredaCode": "SMKRH0QBR0",
                        "woredaEng": "Qebridehar",
                        "woredaAmh": "ቀብሪደሃር"
                    },
                    {
                        "woredaCode": "SMKRH0SHY0",
                        "woredaEng": "Sheykosh",
                        "woredaAmh": "ሸይኮሽ"
                    },
                    {
                        "woredaCode": "SMKRH0SHL0",
                        "woredaEng": "Shilabo",
                        "woredaAmh": "ሺላቦ"
                    }
                ]
            },
            {
                "zoneCode": "SMLBN00000",
                "zoneEng": "Liben",
                "zoneAmh": "ሊበን",
                "woredas": [
                    {
                        "woredaCode": "SMLBN0BKL0",
                        "woredaEng": "Bokolmayo",
                        "woredaAmh": "ቦቆልማዮ"
                    },
                    {
                        "woredaCode": "SMLBN0DES0",
                        "woredaEng": "Deka Suftu",
                        "woredaAmh": "ዴካ ሱፍቱ"
                    },
                    {
                        "woredaCode": "SMLBN0DOA0",
                        "woredaEng": "Dollo-Ado",
                        "woredaAmh": "ዶሎ-አዶ"
                    },
                    {
                        "woredaCode": "SMLBN0FLT0",
                        "woredaEng": "Filtu",
                        "woredaAmh": "ፊልቱ"
                    },
                    {
                        "woredaCode": "SMLBN0GOB0",
                        "woredaEng": "Goro Bekeksa",
                        "woredaAmh": "ጎሮ በቀቅሳ"
                    },
                    {
                        "woredaCode": "SMLBN0GUD0",
                        "woredaEng": "Gura-Damole",
                        "woredaAmh": "ጉራ-ዳሞሌ"
                    },
                    {
                        "woredaCode": "SMLBN0QAD0",
                        "woredaEng": "Qarsa Dula",
                        "woredaAmh": "ቀርሳ ዱላ"
                    }
                ]
            },
            {
                "zoneCode": "SMNGB00000",
                "zoneEng": "Nogob",
                "zoneAmh": "ኖጎብ",
                "woredas": [
                    {
                        "woredaCode": "SMNGB0AYN0",
                        "woredaEng": "Ayun",
                        "woredaAmh": "አዩን"
                    },
                    {
                        "woredaCode": "SMNGB0DHN0",
                        "woredaEng": "Duhun",
                        "woredaAmh": "ዱሁን"
                    },
                    {
                        "woredaCode": "SMNGB0ELW0",
                        "woredaEng": "Elweyne",
                        "woredaAmh": "ኤልዌይን"
                    },
                    {
                        "woredaCode": "SMNGB0GRB0",
                        "woredaEng": "Gerbo",
                        "woredaAmh": "ገርቦ"
                    },
                    {
                        "woredaCode": "SMNGB0HRR0",
                        "woredaEng": "Hararey",
                        "woredaAmh": "ሃራሬይ"
                    },
                    {
                        "woredaCode": "SMNGB0ILH0",
                        "woredaEng": "Ila-Horoshagah",
                        "woredaAmh": "ኢላ-ሆሮሻጋህ"
                    },
                    {
                        "woredaCode": "SMNGB0SGG0",
                        "woredaEng": "Segeg",
                        "woredaAmh": "ሰገግ"
                    }
                ]
            },
            {
                "zoneCode": "SMQBR10000",
                "zoneEng": "Qebridehar City Administration",
                "zoneAmh": "ቀብሪደሃር ከተማ አስተዳደር",
                "woredas": [
                    {
                        "woredaCode": "SMQBR1QBR1",
                        "woredaEng": "Qebridehar City Administration",
                        "woredaAmh": "ቀብሪደሃር ከተማ አስተዳደር"
                    }
                ]
            },
            {
                "zoneCode": "SMSHB00000",
                "zoneEng": "Shebele",
                "zoneAmh": "ሸበሌ",
                "woredas": [
                    {
                        "woredaCode": "SMSHB0ABQ0",
                        "woredaEng": "Abaqorow",
                        "woredaAmh": "አባቆሮው"
                    },
                    {
                        "woredaCode": "SMSHB0ADD0",
                        "woredaEng": "Adadley",
                        "woredaAmh": "አዳድለይ"
                    },
                    {
                        "woredaCode": "SMSHB0BRN0",
                        "woredaEng": "Berano",
                        "woredaAmh": "ቤርአኖ"
                    },
                    {
                        "woredaCode": "SMSHB0DNN0",
                        "woredaEng": "Denan",
                        "woredaAmh": "ደናን"
                    },
                    {
                        "woredaCode": "SMSHB0ELL0",
                        "woredaEng": "Elalle",
                        "woredaAmh": "ኤላሌ"
                    },
                    {
                        "woredaCode": "SMSHB0FEF0",
                        "woredaEng": "Fer-Fer",
                        "woredaAmh": "ፌር-ፌር"
                    },
                    {
                        "woredaCode": "SMSHB0GOD0",
                        "woredaEng": "Gode",
                        "woredaAmh": "ጎዴ"
                    },
                    {
                        "woredaCode": "SMSHB0KLF0",
                        "woredaEng": "Kelafo",
                        "woredaAmh": "ቀላፎ"
                    },
                    {
                        "woredaCode": "SMSHB0MII0",
                        "woredaEng": "Misraq Imey",
                        "woredaAmh": "ምስራቅ ኢሜይ"
                    },
                    {
                        "woredaCode": "SMSHB0MST0",
                        "woredaEng": "Mustahil",
                        "woredaAmh": "ሙስታሂል"
                    }
                ]
            },
            {
                "zoneCode": "SMSTT00000",
                "zoneEng": "Sitti",
                "zoneAmh": "ሲቲ",
                "woredas": [
                    {
                        "woredaCode": "SMSTT0AFD0",
                        "woredaEng": "Afdem",
                        "woredaAmh": "አፍደም"
                    },
                    {
                        "woredaCode": "SMSTT0AYS0",
                        "woredaEng": "Aysha",
                        "woredaAmh": "አይሻ"
                    },
                    {
                        "woredaCode": "SMSTT0DMB0",
                        "woredaEng": "Dambel",
                        "woredaAmh": "ደምበል"
                    },
                    {
                        "woredaCode": "SMSTT0DYM0",
                        "woredaEng": "Deymed",
                        "woredaAmh": "ዴይሜድ"
                    },
                    {
                        "woredaCode": "SMSTT0DNY0",
                        "woredaEng": "Dunyer",
                        "woredaAmh": "ዱንያር"
                    },
                    {
                        "woredaCode": "SMSTT0ERR0",
                        "woredaEng": "Erer",
                        "woredaAmh": "ኤረር"
                    },
                    {
                        "woredaCode": "SMSTT0GBL0",
                        "woredaEng": "Gablalu",
                        "woredaAmh": "ጋብላሉ"
                    },
                    {
                        "woredaCode": "SMSTT0GTB0",
                        "woredaEng": "Gotabik",
                        "woredaAmh": "ጎታቢክ"
                    },
                    {
                        "woredaCode": "SMSTT0HDG0",
                        "woredaEng": "Hadagala",
                        "woredaAmh": "ሃዳጋላ"
                    },
                    {
                        "woredaCode": "SMSTT0MEA0",
                        "woredaEng": "Me'aso",
                        "woredaAmh": "ሜኢሶ"
                    },
                    {
                        "woredaCode": "SMSTT0SHN0",
                        "woredaEng": "Shinile",
                        "woredaAmh": "ሺኒሌ"
                    }
                ]
            },
            {
                "zoneCode": "SMTOW10000",
                "zoneEng": "Tog-Wichale City Administration",
                "zoneAmh": "ቶግ-ዉጫሌ ከተማ አስተዳደር",
                "woredas": [
                    {
                        "woredaCode": "SMTOW1TOW1",
                        "woredaEng": "Tog-Wichale City Administration",
                        "woredaAmh": "ቶግ-ዉጫሌ ከተማ አስተዳደር"
                    }
                ]
            }
        ]
    },
    {
        "regionCode": "SE00000000",
        "regionEng": "South Ethiopia",
        "regionAmh": "ደቡብ ኢትዮጵያ",
        "zones": [
            {
                "zoneCode": "SEALL00000",
                "zoneEng": "Alle",
                "zoneAmh": "አሌ",
                "woredas": [
                    {
                        "woredaCode": "SEALL0KLN2",
                        "woredaEng": "Kolango Town Administration",
                        "woredaAmh": "ኮላንጎ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "SEALL0KOZ0",
                        "woredaEng": "Kolango Zuria Woreda",
                        "woredaAmh": "ኮላንጎ ዙሪያ ወረዳ"
                    }
                ]
            },
            {
                "zoneCode": "SEARB20000",
                "zoneEng": "Arbaminch Town Administration",
                "zoneAmh": "አርባምንጭ ከተማ አስተዳደር",
                "woredas": [
                    {
                        "woredaCode": "SEARB2ABY3",
                        "woredaEng": "Abaya Sub City",
                        "woredaAmh": "አባያ ክፍለ ከተማ"
                    },
                    {
                        "woredaCode": "SEARB2SHC3",
                        "woredaEng": "Shecha Sub City",
                        "woredaAmh": "ሼቻ ክፍለ ከተማ"
                    },
                    {
                        "woredaCode": "SEARB2SKL3",
                        "woredaEng": "Sikela Sub City",
                        "woredaAmh": "ሲቀላ ክፍለ ከተማ"
                    }
                ]
            },
            {
                "zoneCode": "SEARI00000",
                "zoneEng": "Ari",
                "zoneAmh": "አሪ",
                "woredas": [
                    {
                        "woredaCode": "SEARI0BAA0",
                        "woredaEng": "Bakodawula Ari",
                        "woredaAmh": "ባኮዳውላ አሪ"
                    },
                    {
                        "woredaCode": "SEARI0DEA0",
                        "woredaEng": "Debub Ari",
                        "woredaAmh": "ደቡብ አሪ"
                    },
                    {
                        "woredaCode": "SEARI0GZR2",
                        "woredaEng": "Gazer Town Administration",
                        "woredaAmh": "ጋዘር ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "SEARI0GLL2",
                        "woredaEng": "Gelila Town Administration",
                        "woredaAmh": "ገሊላ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "SEARI0JNK2",
                        "woredaEng": "Jinka Town Administration",
                        "woredaAmh": "ጂንካ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "SEARI0SEA0",
                        "woredaEng": "Semen Ari",
                        "woredaAmh": "ሰሜን አሪ"
                    },
                    {
                        "woredaCode": "SEARI0WOA0",
                        "woredaEng": "Woba Ari",
                        "woredaAmh": "ዎባ አሪ"
                    }
                ]
            },
            {
                "zoneCode": "SEBSK00000",
                "zoneEng": "Basketo",
                "zoneAmh": "ባስኬቶ ልዩ",
                "woredas": [
                    {
                        "woredaCode": "SEBSK0LSK2",
                        "woredaEng": "Laska Town Administration",
                        "woredaAmh": "ላስካ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "SEBSK0LAZ0",
                        "woredaEng": "Laska Zuria Woreda",
                        "woredaAmh": "ላስካ ዙሪያ ወረዳ"
                    }
                ]
            },
            {
                "zoneCode": "SEBRJ00000",
                "zoneEng": "Burji",
                "zoneAmh": "ቡርጂ",
                "woredas": [
                    {
                        "woredaCode": "SEBRJ0SYM2",
                        "woredaEng": "Soyama Town Administration",
                        "woredaAmh": "ሶያማ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "SEBRJ0SOZ0",
                        "woredaEng": "Soyama Zuriya Woreda",
                        "woredaAmh": "ሶያማ ዙሪያ ወረዳ"
                    }
                ]
            },
            {
                "zoneCode": "SEDEO00000",
                "zoneEng": "Debube Omo",
                "zoneAmh": "ደቡብ ኦሞ",
                "woredas": [
                    {
                        "woredaCode": "SEDEO0BET0",
                        "woredaEng": "Bena Tsemay",
                        "woredaAmh": "በና ፀማይ"
                    },
                    {
                        "woredaCode": "SEDEO0DSS0",
                        "woredaEng": "Dassenech",
                        "woredaAmh": "ዳሰነች"
                    },
                    {
                        "woredaCode": "SEDEO0DMK2",
                        "woredaEng": "Dimeka Town Administration",
                        "woredaAmh": "ዲመካ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "SEDEO0HMR0",
                        "woredaEng": "Hamer",
                        "woredaAmh": "ሐመር"
                    },
                    {
                        "woredaCode": "SEDEO0MAL0",
                        "woredaEng": "Malie",
                        "woredaAmh": "ማሌ"
                    },
                    {
                        "woredaCode": "SEDEO0NYN0",
                        "woredaEng": "Nyngatom",
                        "woredaAmh": "ኛንጋቶም"
                    },
                    {
                        "woredaCode": "SEDEO0SLM0",
                        "woredaEng": "Salamago",
                        "woredaAmh": "ሣላማጎ"
                    },
                    {
                        "woredaCode": "SEDEO0TRM2",
                        "woredaEng": "Turmi Town Administration",
                        "woredaAmh": "ቱርሚ ከተማ አስተዳደር"
                    }
                ]
            },
            {
                "zoneCode": "SEDLL20000",
                "zoneEng": "Dilla Town Administration",
                "zoneAmh": "ዲላ ከተማ አስተዳደር",
                "woredas": [
                    {
                        "woredaCode": "SEDLL2MCH3",
                        "woredaEng": "Michle Sub City",
                        "woredaAmh": "ሚችሌ ክፍለ ከተማ"
                    },
                    {
                        "woredaCode": "SEDLL2SES3",
                        "woredaEng": "Sesa Sub City",
                        "woredaAmh": "ሴሳ ክፍለ ከተማ"
                    }
                ]
            },
            {
                "zoneCode": "SEGAM00000",
                "zoneEng": "Gamo",
                "zoneAmh": "ጋሞ",
                "woredas": [
                    {
                        "woredaCode": "SEGAM0ARZ0",
                        "woredaEng": "Arbaminch Zuria Woreda",
                        "woredaAmh": "አርባምንጭ ዙሪያ ወረዳ"
                    },
                    {
                        "woredaCode": "SEGAM0BRB2",
                        "woredaEng": "Birbir Town Administration",
                        "woredaAmh": "ብርብር ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "SEGAM0BNK0",
                        "woredaEng": "Bonke",
                        "woredaAmh": "ቦንኬ"
                    },
                    {
                        "woredaCode": "SEGAM0BRD0",
                        "woredaEng": "Boreda",
                        "woredaAmh": "ቦረዳ"
                    },
                    {
                        "woredaCode": "SEGAM0CHN2",
                        "woredaEng": "Chencha Town Administration",
                        "woredaAmh": "ጬንቻ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "SEGAM0CHZ0",
                        "woredaEng": "Chencha Zuriya Woreda",
                        "woredaAmh": "ጬንቻ ዙሪያ ወረዳ"
                    },
                    {
                        "woredaCode": "SEGAM0DRM0",
                        "woredaEng": "Daramalo",
                        "woredaAmh": "ዳራማሎ"
                    },
                    {
                        "woredaCode": "SEGAM0DIT0",
                        "woredaEng": "Dita",
                        "woredaAmh": "ዲታ"
                    },
                    {
                        "woredaCode": "SEGAM0GAB0",
                        "woredaEng": "Gacho Baba",
                        "woredaAmh": "ጋጮ ባባ"
                    },
                    {
                        "woredaCode": "SEGAM0GAM0",
                        "woredaEng": "Garda Marta",
                        "woredaAmh": "ጋርዳ ማርታ"
                    },
                    {
                        "woredaCode": "SEGAM0GRS2",
                        "woredaEng": "Gerese Town Administration",
                        "woredaAmh": "ገረሴ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "SEGAM0GEZ0",
                        "woredaEng": "Gerese Zuriya Woreda",
                        "woredaAmh": "ገረሴ ዙሪያ ወረዳ"
                    },
                    {
                        "woredaCode": "SEGAM0KMB2",
                        "woredaEng": "Kemba Town Administration",
                        "woredaAmh": "ከምባ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "SEGAM0KEZ0",
                        "woredaEng": "Kemba Zuriya Woreda",
                        "woredaAmh": "ከምባ ዙሪያ ወረዳ"
                    },
                    {
                        "woredaCode": "SEGAM0KCH0",
                        "woredaEng": "Kucha",
                        "woredaAmh": "ቁጫ"
                    },
                    {
                        "woredaCode": "SEGAM0KUA0",
                        "woredaEng": "Kucha Alpha",
                        "woredaAmh": "ቁጫ አልፋ"
                    },
                    {
                        "woredaCode": "SEGAM0MIA0",
                        "woredaEng": "Mierab Abaya",
                        "woredaAmh": "ምዕራብ አባያ"
                    },
                    {
                        "woredaCode": "SEGAM0QGT0",
                        "woredaEng": "Qogota",
                        "woredaAmh": "ቆጎታ"
                    },
                    {
                        "woredaCode": "SEGAM0SLM2",
                        "woredaEng": "Selamber Town Administration",
                        "woredaAmh": "ሰላምበር ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "SEGAM0WCH2",
                        "woredaEng": "Wacha Town Administration",
                        "woredaAmh": "ዋጫ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "SEGAM0ZFN2",
                        "woredaEng": "Zefine Town Administration",
                        "woredaAmh": "ዘፊኔ ከተማ አስተዳደር"
                    }
                ]
            },
            {
                "zoneCode": "SEGRD00000",
                "zoneEng": "Gardula",
                "zoneAmh": "ጋርዱላ",
                "woredas": [
                    {
                        "woredaCode": "SEGRD0DRS0",
                        "woredaEng": "Derashe",
                        "woredaAmh": "ደራሼ"
                    },
                    {
                        "woredaCode": "SEGRD0GDL2",
                        "woredaEng": "Gidole Town Administration",
                        "woredaAmh": "ጊዶሌ ከተማ አስተዳደር"
                    }
                ]
            },
            {
                "zoneCode": "SEGED00000",
                "zoneEng": "Gedio",
                "zoneAmh": "ጌዴኦ",
                "woredas": [
                    {
                        "woredaCode": "SEGED0BUL0",
                        "woredaEng": "Bule",
                        "woredaAmh": "ቡሌ"
                    },
                    {
                        "woredaCode": "SEGED0BUL2",
                        "woredaEng": "Bule Town Administration",
                        "woredaAmh": "ቡሌ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "SEGED0CHL2",
                        "woredaEng": "Chelelektu Town Administration",
                        "woredaAmh": "ጨለለቅቱ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "SEGED0CHR0",
                        "woredaEng": "Chorso",
                        "woredaAmh": "ጮርሶ"
                    },
                    {
                        "woredaCode": "SEGED0DIZ0",
                        "woredaEng": "Dilla Zuria Woreda",
                        "woredaAmh": "ዲላ ዙሪያ ወረዳ"
                    },
                    {
                        "woredaCode": "SEGED0GDB0",
                        "woredaEng": "Gedeb",
                        "woredaAmh": "ገደብ"
                    },
                    {
                        "woredaCode": "SEGED0GDB2",
                        "woredaEng": "Gedeb Town Administration",
                        "woredaAmh": "ገደብ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "SEGED0KCH0",
                        "woredaEng": "Kochere",
                        "woredaAmh": "ኮቸሬ"
                    },
                    {
                        "woredaCode": "SEGED0RPH0",
                        "woredaEng": "Rephe",
                        "woredaAmh": "ረጴ"
                    },
                    {
                        "woredaCode": "SEGED0WNG0",
                        "woredaEng": "Wenago",
                        "woredaAmh": "ወናጎ"
                    },
                    {
                        "woredaCode": "SEGED0WNG2",
                        "woredaEng": "Wenago Town Administration",
                        "woredaAmh": "ወናጎ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "SEGED0YRG0",
                        "woredaEng": "Yergachefe",
                        "woredaAmh": "ይርጋጨፌ"
                    },
                    {
                        "woredaCode": "SEGED0YRG2",
                        "woredaEng": "Yergachefe Town Administration",
                        "woredaAmh": "ይርጋጨፌ ከተማ አስተዳደር"
                    }
                ]
            },
            {
                "zoneCode": "SEGOF00000",
                "zoneEng": "Gofa",
                "zoneAmh": "ጎፋ",
                "woredas": [
                    {
                        "woredaCode": "SEGOF0BET2",
                        "woredaEng": "Beto Town Administration",
                        "woredaAmh": "በቶ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "SEGOF0BLK2",
                        "woredaEng": "Bulki Town Administration",
                        "woredaAmh": "ቡልቂ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "SEGOF0DEG0",
                        "woredaEng": "Demba Gofa",
                        "woredaAmh": "ደምባ ጎፋ"
                    },
                    {
                        "woredaCode": "SEGOF0GLM2",
                        "woredaEng": "Galma Town Administration",
                        "woredaAmh": "ጋልማ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "SEGOF0GEG0",
                        "woredaEng": "Gezei Gofa",
                        "woredaAmh": "ገዜ ጎፋ"
                    },
                    {
                        "woredaCode": "SEGOF0LAH2",
                        "woredaEng": "Laha Town Administration",
                        "woredaAmh": "ላሃ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "SEGOF0MEG0",
                        "woredaEng": "Melo Gada",
                        "woredaAmh": "መሎ ጋዳ"
                    },
                    {
                        "woredaCode": "SEGOF0MEK0",
                        "woredaEng": "Melo Koza",
                        "woredaAmh": "መሎ ኮዛ"
                    },
                    {
                        "woredaCode": "SEGOF0OYI0",
                        "woredaEng": "O'yida",
                        "woredaAmh": "ኦይዳ"
                    },
                    {
                        "woredaCode": "SEGOF0SWL2",
                        "woredaEng": "Sawla Town Administration",
                        "woredaAmh": "ሣውላ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "SEGOF0UDT0",
                        "woredaEng": "Uba Debre Tsehay",
                        "woredaAmh": "ኡባ ደብረ ፀሃይ"
                    },
                    {
                        "woredaCode": "SEGOF0ZAL0",
                        "woredaEng": "Zala",
                        "woredaAmh": "ዛላ"
                    }
                ]
            },
            {
                "zoneCode": "SEKNS00000",
                "zoneEng": "Konso",
                "zoneAmh": "ኮንሶ",
                "woredas": [
                    {
                        "woredaCode": "SEKNS0KAZ0",
                        "woredaEng": "Karat Zuriya Woreda",
                        "woredaAmh": "ካራት ዙሪያ ወረዳ"
                    },
                    {
                        "woredaCode": "SEKNS0KRT2",
                        "woredaEng": "Karate Town Administration",
                        "woredaAmh": "ካራት ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "SEKNS0KEN0",
                        "woredaEng": "Kena",
                        "woredaAmh": "ኬና"
                    },
                    {
                        "woredaCode": "SEKNS0KLM0",
                        "woredaEng": "Kolme",
                        "woredaAmh": "ኮልሜ"
                    },
                    {
                        "woredaCode": "SEKNS0SEZ0",
                        "woredaEng": "Segen Zuriya Woreda",
                        "woredaAmh": "ሰገን ዙሪያ ወረዳ"
                    }
                ]
            },
            {
                "zoneCode": "SEKOR00000",
                "zoneEng": "Kore",
                "zoneAmh": "ኮሬ",
                "woredas": [
                    {
                        "woredaCode": "SEKOR0GRK0",
                        "woredaEng": "Gorka",
                        "woredaAmh": "ጎርካ"
                    },
                    {
                        "woredaCode": "SEKOR0KEL2",
                        "woredaEng": "Kele Town Administration",
                        "woredaAmh": "ኬሌ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "SEKOR0SRM0",
                        "woredaEng": "Sarmale",
                        "woredaAmh": "ሳርማሌ"
                    }
                ]
            },
            {
                "zoneCode": "SEWLY00000",
                "zoneEng": "Wolayita",
                "zoneAmh": "ወላይታ",
                "woredas": [
                    {
                        "woredaCode": "SEWLY0ABA0",
                        "woredaEng": "Abela Abaya",
                        "woredaAmh": "አበላ አባያ"
                    },
                    {
                        "woredaCode": "SEWLY0ARK2",
                        "woredaEng": "Areka Town Administration",
                        "woredaAmh": "አረካ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "SEWLY0BAK0",
                        "woredaEng": "Bayra koysha",
                        "woredaAmh": "ባይራ ኮይሻ"
                    },
                    {
                        "woredaCode": "SEWLY0BDS2",
                        "woredaEng": "Bedesa Town Administration",
                        "woredaAmh": "በዴሳ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "SEWLY0BEA2",
                        "woredaEng": "Bele Awasa Town Administration",
                        "woredaAmh": "በሌ አዋሳ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "SEWLY0BDT2",
                        "woredaEng": "Bodity Town Administration",
                        "woredaAmh": "ቦዲቲ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "SEWLY0BOB0",
                        "woredaEng": "Boloso Bombe",
                        "woredaAmh": "ቦሎሶ ቦምቤ"
                    },
                    {
                        "woredaCode": "SEWLY0BOS0",
                        "woredaEng": "Boloso Sore",
                        "woredaAmh": "ቦሎሶ ሶሬ"
                    },
                    {
                        "woredaCode": "SEWLY0BMB2",
                        "woredaEng": "Bombe Town Administration",
                        "woredaAmh": "ቦምቤ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "SEWLY0DAG0",
                        "woredaEng": "Damot Gale",
                        "woredaAmh": "ዳሞት ጋሌ"
                    },
                    {
                        "woredaCode": "SEWLY0DAP0",
                        "woredaEng": "Damot Pullasa",
                        "woredaAmh": "ዳሞት ፑላሳ"
                    },
                    {
                        "woredaCode": "SEWLY0DAS0",
                        "woredaEng": "Damot Sore",
                        "woredaAmh": "ዳሞት ሶሬ"
                    },
                    {
                        "woredaCode": "SEWLY0DAW0",
                        "woredaEng": "Damot Woide",
                        "woredaAmh": "ዳሞት ወይዴ"
                    },
                    {
                        "woredaCode": "SEWLY0DMT2",
                        "woredaEng": "Dimtu Town Administration",
                        "woredaAmh": "ዲምቱ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "SEWLY0DUF0",
                        "woredaEng": "Duguna Fango",
                        "woredaAmh": "ዱጉና ፋንጎ"
                    },
                    {
                        "woredaCode": "SEWLY0GSB2",
                        "woredaEng": "Gesuba Town Administration",
                        "woredaAmh": "ገሱባ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "SEWLY0GUH2",
                        "woredaEng": "Gununo hamus Town Administration",
                        "woredaAmh": "ጉኑኖ ሃሙስ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "SEWLY0HBC0",
                        "woredaEng": "Hobicha",
                        "woredaAmh": "ሆቢቻ"
                    },
                    {
                        "woredaCode": "SEWLY0HMB0",
                        "woredaEng": "Humbo",
                        "woredaAmh": "ሁምቦ"
                    },
                    {
                        "woredaCode": "SEWLY0KAK0",
                        "woredaEng": "Kawo Koysha",
                        "woredaAmh": "ካዎ ኮይሻ"
                    },
                    {
                        "woredaCode": "SEWLY0KID0",
                        "woredaEng": "Kindo Diddaye",
                        "woredaAmh": "ኪንዶ ዲዳዬ"
                    },
                    {
                        "woredaCode": "SEWLY0KIK0",
                        "woredaEng": "Kindo Koisha",
                        "woredaAmh": "ኪንዶ ኮይሻ"
                    },
                    {
                        "woredaCode": "SEWLY0OFF0",
                        "woredaEng": "Offa",
                        "woredaAmh": "ኦፋ"
                    },
                    {
                        "woredaCode": "SEWLY0SHN2",
                        "woredaEng": "Shanto Town Administration",
                        "woredaAmh": "ሻንቶ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "SEWLY0SOZ0",
                        "woredaEng": "Sodo Zuria Woreda",
                        "woredaAmh": "ሶዶ ዙሪያ ወረዳ"
                    },
                    {
                        "woredaCode": "SEWLY0TBL2",
                        "woredaEng": "Tebela Town Administration",
                        "woredaAmh": "ጠበላ ከተማ አስተዳደር"
                    }
                ]
            },
            {
                "zoneCode": "SEWOS20000",
                "zoneEng": "Wolayita Sodo Town Administration",
                "zoneAmh": "ወላይታ ሶዶ ከተማ አስተዳደር",
                "woredas": [
                    {
                        "woredaCode": "SEWOS2ARD3",
                        "woredaEng": "Arada Sub City",
                        "woredaAmh": "አራዳ ክፍለ ከተማ"
                    },
                    {
                        "woredaCode": "SEWOS2MHL3",
                        "woredaEng": "Mehal Sub City",
                        "woredaAmh": "መሐል ክፍለ ከተማ"
                    },
                    {
                        "woredaCode": "SEWOS2MRK3",
                        "woredaEng": "Merkato Sub City",
                        "woredaAmh": "መርካቶ ክፍለ ከተማ"
                    }
                ]
            }
        ]
    },
    {
        "regionCode": "SW00000000",
        "regionEng": "South West Ethiopia",
        "regionAmh": "ደቡብ ምዕራብ ኢትዮጵያ",
        "zones": [
            {
                "zoneCode": "SWBES00000",
                "zoneEng": "Bench Sheko",
                "zoneAmh": "ቤንች ሸኮ",
                "woredas": [
                    {
                        "woredaCode": "SWBES0GIB0",
                        "woredaEng": "Gidi bench",
                        "woredaAmh": "ጊዲ ቤንች"
                    },
                    {
                        "woredaCode": "SWBES0GRF0",
                        "woredaEng": "Gurafereda",
                        "woredaAmh": "ጉራፈርዳ"
                    },
                    {
                        "woredaCode": "SWBES0MIA1",
                        "woredaEng": "Mizan-Aman City Administration",
                        "woredaAmh": "ሚዛን-አማን ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "SWBES0NOB0",
                        "woredaEng": "North bench",
                        "woredaAmh": "ሰሜን ቤንች"
                    },
                    {
                        "woredaCode": "SWBES0SHK0",
                        "woredaEng": "Sheko",
                        "woredaAmh": "ሸኮ"
                    },
                    {
                        "woredaCode": "SWBES0SHK1",
                        "woredaEng": "Sheko City Administration",
                        "woredaAmh": "ሸኮ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "SWBES0SHB0",
                        "woredaEng": "Shey bench",
                        "woredaAmh": "ሼይ ቤንች"
                    },
                    {
                        "woredaCode": "SWBES0SIZ1",
                        "woredaEng": "Siz City Administration",
                        "woredaAmh": "ሲዝ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "SWBES0SOB0",
                        "woredaEng": "South Bench",
                        "woredaAmh": "ደቡብ ቤንች"
                    }
                ]
            },
            {
                "zoneCode": "SWDWR00000",
                "zoneEng": "Dawuro",
                "zoneAmh": "ዳውሮ",
                "woredas": [
                    {
                        "woredaCode": "SWDWR0DIS0",
                        "woredaEng": "Disa",
                        "woredaAmh": "ዲሳ"
                    },
                    {
                        "woredaCode": "SWDWR0ESR0",
                        "woredaEng": "Esera",
                        "woredaAmh": "ኢሠራ"
                    },
                    {
                        "woredaCode": "SWDWR0ESB1",
                        "woredaEng": "Esera Bale City Administration",
                        "woredaAmh": "ኢሠራ ባሌ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "SWDWR0GEN0",
                        "woredaEng": "Gena",
                        "woredaAmh": "ገና"
                    },
                    {
                        "woredaCode": "SWDWR0GEC1",
                        "woredaEng": "Gesa Chare City Administration",
                        "woredaAmh": "ገሳ ጫሬ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "SWDWR0KCH0",
                        "woredaEng": "Kechi",
                        "woredaAmh": "ከጪ"
                    },
                    {
                        "woredaCode": "SWDWR0LOB0",
                        "woredaEng": "Loma Bosa",
                        "woredaAmh": "ሎማ ቦሳ"
                    },
                    {
                        "woredaCode": "SWDWR0MRK0",
                        "woredaEng": "Mareka",
                        "woredaAmh": "ማረቃ"
                    },
                    {
                        "woredaCode": "SWDWR0MAM0",
                        "woredaEng": "Mari-Mansa",
                        "woredaAmh": "ማሪ-ማንሳ"
                    },
                    {
                        "woredaCode": "SWDWR0TRC1",
                        "woredaEng": "Tarecha City Administration",
                        "woredaAmh": "ታርጫ ከተማ አሰተዳደር"
                    },
                    {
                        "woredaCode": "SWDWR0TAZ0",
                        "woredaEng": "Tarecha Zuriya",
                        "woredaAmh": "ታርጫ ዙሪያ"
                    },
                    {
                        "woredaCode": "SWDWR0TCH0",
                        "woredaEng": "Tocha",
                        "woredaAmh": "ቶጫ"
                    },
                    {
                        "woredaCode": "SWDWR0WAK1",
                        "woredaEng": "Waka City Administration",
                        "woredaAmh": "ዋካ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "SWDWR0ZAG0",
                        "woredaEng": "Zaba Gazo",
                        "woredaAmh": "ዛባ ጋዞ"
                    }
                ]
            },
            {
                "zoneCode": "SWKAF00000",
                "zoneEng": "Kafa",
                "zoneAmh": "ካፋ",
                "woredas": [
                    {
                        "woredaCode": "SWKAF0ADY0",
                        "woredaEng": "Adiyo",
                        "woredaAmh": "አዲዮ"
                    },
                    {
                        "woredaCode": "SWKAF0AWR1",
                        "woredaEng": "Awerada City Administration",
                        "woredaAmh": "አዉራዳ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "SWKAF0BIT0",
                        "woredaEng": "Bita",
                        "woredaAmh": "ቢጣ"
                    },
                    {
                        "woredaCode": "SWKAF0BNG1",
                        "woredaEng": "Bonga City Administration",
                        "woredaAmh": "ቦንጋ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "SWKAF0CHN0",
                        "woredaEng": "Chena",
                        "woredaAmh": "ጨና"
                    },
                    {
                        "woredaCode": "SWKAF0CHT0",
                        "woredaEng": "Cheta",
                        "woredaAmh": "ጨታ"
                    },
                    {
                        "woredaCode": "SWKAF0DCH0",
                        "woredaEng": "Decha",
                        "woredaAmh": "ዴቻ"
                    },
                    {
                        "woredaCode": "SWKAF0DEK1",
                        "woredaEng": "Deka City Administration",
                        "woredaAmh": "ደካ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "SWKAF0GSH0",
                        "woredaEng": "Gesha",
                        "woredaAmh": "ጌሻ"
                    },
                    {
                        "woredaCode": "SWKAF0GWT0",
                        "woredaEng": "Gewata",
                        "woredaAmh": "ገዋታ"
                    },
                    {
                        "woredaCode": "SWKAF0GMB0",
                        "woredaEng": "Gimbo",
                        "woredaAmh": "ጊምቦ"
                    },
                    {
                        "woredaCode": "SWKAF0GOB0",
                        "woredaEng": "Goba",
                        "woredaAmh": "ጎባ"
                    },
                    {
                        "woredaCode": "SWKAF0SYL0",
                        "woredaEng": "Saylem",
                        "woredaAmh": "ሳይለም"
                    },
                    {
                        "woredaCode": "SWKAF0SHE0",
                        "woredaEng": "Shesho Ende",
                        "woredaAmh": "ሺሾ እንዴ"
                    },
                    {
                        "woredaCode": "SWKAF0SHS1",
                        "woredaEng": "Shishenda City Administration",
                        "woredaAmh": "ሺሽንዳ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "SWKAF0TEL0",
                        "woredaEng": "Telo",
                        "woredaAmh": "ጠሎ"
                    },
                    {
                        "woredaCode": "SWKAF0WCH1",
                        "woredaEng": "Wacha City Administration",
                        "woredaAmh": "ዋቻ ከተማ አስተዳደር"
                    }
                ]
            },
            {
                "zoneCode": "SWKNT00000",
                "zoneEng": "Konta",
                "zoneAmh": "ኮንታ",
                "woredas": [
                    {
                        "woredaCode": "SWKNT0AMY1",
                        "woredaEng": "Ameya City Administration",
                        "woredaAmh": "አመያ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "SWKNT0AMZ0",
                        "woredaEng": "Ameya Zuriya",
                        "woredaAmh": "አመያ ዙሪያ"
                    },
                    {
                        "woredaCode": "SWKNT0CHD1",
                        "woredaEng": "Cheda City Administration",
                        "woredaAmh": "ጭዳ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "SWKNT0ELA0",
                        "woredaEng": "Ela-Anchano",
                        "woredaAmh": "ኤላ-አንቻኖ"
                    },
                    {
                        "woredaCode": "SWKNT0KOK0",
                        "woredaEng": "Konta Koysha",
                        "woredaAmh": "ኮንታ ኮይሻ"
                    }
                ]
            },
            {
                "zoneCode": "SWSHK00000",
                "zoneEng": "Sheka",
                "zoneAmh": "ሸካ",
                "woredas": [
                    {
                        "woredaCode": "SWSHK0AND0",
                        "woredaEng": "Anderacha",
                        "woredaAmh": "አንድራቻ"
                    },
                    {
                        "woredaCode": "SWSHK0MSH0",
                        "woredaEng": "Masha",
                        "woredaAmh": "ማሻ"
                    },
                    {
                        "woredaCode": "SWSHK0MSH1",
                        "woredaEng": "Masha City Administration",
                        "woredaAmh": "ማሻ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "SWSHK0TEP1",
                        "woredaEng": "Tepi City Administration",
                        "woredaAmh": "ቴፒ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "SWSHK0YEK0",
                        "woredaEng": "Yeki",
                        "woredaAmh": "የኪ"
                    }
                ]
            },
            {
                "zoneCode": "SWWEO00000",
                "zoneEng": "West Omo",
                "zoneAmh": "ምዕራብ ኦሞ",
                "woredas": [
                    {
                        "woredaCode": "SWWEO0BCH1",
                        "woredaEng": "Bachuma City Administration",
                        "woredaAmh": "ባቹማ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "SWWEO0BER0",
                        "woredaEng": "Bero",
                        "woredaAmh": "ቤሮ"
                    },
                    {
                        "woredaCode": "SWWEO0GCH0",
                        "woredaEng": "Gachit",
                        "woredaAmh": "ጋችት"
                    },
                    {
                        "woredaCode": "SWWEO0GRG0",
                        "woredaEng": "Gorigesha",
                        "woredaAmh": "ጎሪጌሻ"
                    },
                    {
                        "woredaCode": "SWWEO0JEM1",
                        "woredaEng": "Jemu City Administration",
                        "woredaAmh": "ጀሙ ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "SWWEO0MAJ0",
                        "woredaEng": "Maji",
                        "woredaAmh": "ማጂ"
                    },
                    {
                        "woredaCode": "SWWEO0MAT1",
                        "woredaEng": "Maji-Tum City Administration",
                        "woredaAmh": "ማጂ-ቱም ከተማ አስተዳደር"
                    },
                    {
                        "woredaCode": "SWWEO0MEG0",
                        "woredaEng": "Me'enit Goldiya",
                        "woredaAmh": "መኤኒት ጎልድያ"
                    },
                    {
                        "woredaCode": "SWWEO0MES0",
                        "woredaEng": "Me'enit Shasha",
                        "woredaAmh": "መኤኒት ሻሻ"
                    },
                    {
                        "woredaCode": "SWWEO0SUR0",
                        "woredaEng": "Suri",
                        "woredaAmh": "ሱሪ"
                    }
                ]
            }
        ]
    },
    {
        "regionCode": "TG00000000",
        "regionEng": "Tigray",
        "regionAmh": "ትግራይ",
        "zones": [
            {
                "zoneCode": "TGCNT00000",
                "zoneEng": "Central",
                "zoneAmh": "ማዕከላዊ",
                "woredas": [
                    {
                        "woredaCode": "TGCNT0ABR0",
                        "woredaEng": "Abergele",
                        "woredaAmh": "ኣበርገለ"
                    },
                    {
                        "woredaCode": "TGCNT0ABA2",
                        "woredaEng": "Abyi Adi Town",
                        "woredaAmh": "ዓብዪ ዓዲ ከተማ"
                    },
                    {
                        "woredaCode": "TGCNT0ADT0",
                        "woredaEng": "Adet",
                        "woredaAmh": "ዓዴት"
                    },
                    {
                        "woredaCode": "TGCNT0ADW0",
                        "woredaEng": "Adwa",
                        "woredaAmh": "ዓድዋ"
                    },
                    {
                        "woredaCode": "TGCNT0ADW2",
                        "woredaEng": "Adwa Town",
                        "woredaAmh": "ዓድዋ ከተማ"
                    },
                    {
                        "woredaCode": "TGCNT0AHF0",
                        "woredaEng": "Ahferom",
                        "woredaAmh": "ኣሕፈሮም"
                    },
                    {
                        "woredaCode": "TGCNT0AHS0",
                        "woredaEng": "Ahsea",
                        "woredaAmh": "ኣሕሰኣ"
                    },
                    {
                        "woredaCode": "TGCNT0AXM2",
                        "woredaEng": "Axum Town",
                        "woredaAmh": "ኣክሱም ከተማ"
                    },
                    {
                        "woredaCode": "TGCNT0CHL0",
                        "woredaEng": "Chila",
                        "woredaAmh": "ጭላ"
                    },
                    {
                        "woredaCode": "TGCNT0EGL0",
                        "woredaEng": "Egela",
                        "woredaAmh": "እገላ"
                    },
                    {
                        "woredaCode": "TGCNT0EMB0",
                        "woredaEng": "Embaseneyti",
                        "woredaAmh": "እምባሰነይቲ"
                    },
                    {
                        "woredaCode": "TGCNT0ETE2",
                        "woredaEng": "Endaba Tsahima Edaga Arbi Town",
                        "woredaAmh": "እንዳባ ፃሕማ ዕዳጋ ዓርቢ ከተማ"
                    },
                    {
                        "woredaCode": "TGCNT0ENT2",
                        "woredaEng": "Enticho Town",
                        "woredaAmh": "እንትጮ ከተማ"
                    },
                    {
                        "woredaCode": "TGCNT0HHY0",
                        "woredaEng": "Hahayle",
                        "woredaAmh": "ሓሓይለ"
                    },
                    {
                        "woredaCode": "TGCNT0KET0",
                        "woredaEng": "Keyhi tekli",
                        "woredaAmh": "ቀይሕ ተኽሊ"
                    },
                    {
                        "woredaCode": "TGCNT0KOT0",
                        "woredaEng": "Kola Temben",
                        "woredaAmh": "ቆላ ተምቤን"
                    },
                    {
                        "woredaCode": "TGCNT0LAM0",
                        "woredaEng": "Laelay Maychew",
                        "woredaAmh": "ላዕላይ ማይጨው"
                    },
                    {
                        "woredaCode": "TGCNT0MAK0",
                        "woredaEng": "May kinetal",
                        "woredaAmh": "ማይ ቅነጣል"
                    },
                    {
                        "woredaCode": "TGCNT0NDR0",
                        "woredaEng": "Naeder",
                        "woredaAmh": "ናዕዴር"
                    },
                    {
                        "woredaCode": "TGCNT0RAA2",
                        "woredaEng": "Rama Adi Arbaete Town",
                        "woredaAmh": "ራማ ዓዲ ኣርባዕተ ከተማ"
                    },
                    {
                        "woredaCode": "TGCNT0TAM0",
                        "woredaEng": "Tahitay Maychew",
                        "woredaAmh": "ታሕታይ ማይጨዉ"
                    },
                    {
                        "woredaCode": "TGCNT0TAB0",
                        "woredaEng": "Tanqua Milash",
                        "woredaAmh": "ጣንቋ ምላሽ"
                    }
                ]
            },
            {
                "zoneCode": "TGEST00000",
                "zoneEng": "East",
                "zoneAmh": "ምስራቅ",
                "woredas": [
                    {
                        "woredaCode": "TGEST0ADG2",
                        "woredaEng": "Adigrat Town",
                        "woredaAmh": "ዓዲግራት ከተማ"
                    },
                    {
                        "woredaCode": "TGEST0ATS0",
                        "woredaEng": "Atsbi",
                        "woredaAmh": "ኣፅቢ"
                    },
                    {
                        "woredaCode": "TGEST0ATE2",
                        "woredaEng": "Atsbi Endasilassie Town",
                        "woredaAmh": "ኣፅቢ እንዳስላሴ ከተማ"
                    },
                    {
                        "woredaCode": "TGEST0BZT0",
                        "woredaEng": "Bizet",
                        "woredaAmh": "ብዘት"
                    },
                    {
                        "woredaCode": "TGEST0EDH2",
                        "woredaEng": "Edaga Hamus Town",
                        "woredaAmh": "ዕዳጋ ሓሙስ ከተማ"
                    },
                    {
                        "woredaCode": "TGEST0ERB0",
                        "woredaEng": "Erob",
                        "woredaAmh": "ኢሮብ"
                    },
                    {
                        "woredaCode": "TGEST0FRW2",
                        "woredaEng": "Fireweyni Town",
                        "woredaAmh": "ፍረወይኒ ከተማ"
                    },
                    {
                        "woredaCode": "TGEST0GAA0",
                        "woredaEng": "Ganta Afeshum",
                        "woredaAmh": "ጋንታ ኣፈሹም"
                    },
                    {
                        "woredaCode": "TGEST0GRL0",
                        "woredaEng": "Gerealta",
                        "woredaAmh": "ገረዓልታ"
                    },
                    {
                        "woredaCode": "TGEST0GUM0",
                        "woredaEng": "Gule Mekeda",
                        "woredaAmh": "ጉለ መኸዳ"
                    },
                    {
                        "woredaCode": "TGEST0HWZ0",
                        "woredaEng": "Hawzen",
                        "woredaAmh": "ሓውዜን"
                    },
                    {
                        "woredaCode": "TGEST0HWZ2",
                        "woredaEng": "Hawzen Town",
                        "woredaAmh": "ሓውዜን ከተማ"
                    },
                    {
                        "woredaCode": "TGEST0KIA0",
                        "woredaEng": "Kilite Awlaelo",
                        "woredaAmh": "ኸልተ ኣውላዕሎ"
                    },
                    {
                        "woredaCode": "TGEST0SES0",
                        "woredaEng": "Sewha Saesie",
                        "woredaAmh": "ሰቡሓ ሳዕሰዕ"
                    },
                    {
                        "woredaCode": "TGEST0TSE0",
                        "woredaEng": "Tsaeda Emba",
                        "woredaAmh": "ፃዕዳ እምባ"
                    },
                    {
                        "woredaCode": "TGEST0TSW0",
                        "woredaEng": "Tsirae Wemberta",
                        "woredaAmh": "ፅራእ ወምበርታ"
                    },
                    {
                        "woredaCode": "TGEST0WKR2",
                        "woredaEng": "Wukro Town",
                        "woredaAmh": "ዉቅሮ ከተማ"
                    },
                    {
                        "woredaCode": "TGEST0ZLN2",
                        "woredaEng": "Zalanbesa Town",
                        "woredaAmh": "ዛላንበሳ ከተማ"
                    }
                ]
            },
            {
                "zoneCode": "TGMKL00000",
                "zoneEng": "Mekelle",
                "zoneAmh": "መቐለ",
                "woredas": [
                    {
                        "woredaCode": "TGMKL0ADH3",
                        "woredaEng": "Adi Haki Sub city",
                        "woredaAmh": "ዓዲ ሓቂ ክፍለ ከተማ"
                    },
                    {
                        "woredaCode": "TGMKL0AYD3",
                        "woredaEng": "Ayder Sub city",
                        "woredaAmh": "ዓይደር ክፍለ ከተማ"
                    },
                    {
                        "woredaCode": "TGMKL0HDN3",
                        "woredaEng": "Hadnet Sub city",
                        "woredaAmh": "ሓድነት ክፍለ ከተማ"
                    },
                    {
                        "woredaCode": "TGMKL0HWL3",
                        "woredaEng": "Hawelti Sub city",
                        "woredaAmh": "ሓወልቲ ክፍለ ከተማ"
                    },
                    {
                        "woredaCode": "TGMKL0KEW3",
                        "woredaEng": "Kedamay Weyane Sub city",
                        "woredaAmh": "ቀዳማይ ወያነ ክፍለ ከተማ"
                    },
                    {
                        "woredaCode": "TGMKL0KUI3",
                        "woredaEng": "Kuiha Sub city",
                        "woredaAmh": "ኲሓ ክፍለ ከተማ"
                    },
                    {
                        "woredaCode": "TGMKL0SMN3",
                        "woredaEng": "Semen Sub city",
                        "woredaAmh": "ሰሜን ክፍለ ከተማ"
                    }
                ]
            },
            {
                "zoneCode": "TGNOW00000",
                "zoneEng": "North West",
                "zoneAmh": "ሰሜን ምዕራብ",
                "woredas": [
                    {
                        "woredaCode": "TGNOW0ADD2",
                        "woredaEng": "Adi Daero Town",
                        "woredaAmh": "ዓዲ ዳዕሮ ከተማ"
                    },
                    {
                        "woredaCode": "TGNOW0ASG0",
                        "woredaEng": "Asgede",
                        "woredaAmh": "ኣስገደ"
                    },
                    {
                        "woredaCode": "TGNOW0END2",
                        "woredaEng": "Endabaguna Town",
                        "woredaAmh": "እንዳባጉና ከተማ"
                    },
                    {
                        "woredaCode": "TGNOW0LAK0",
                        "woredaEng": "Laelay Koraro",
                        "woredaAmh": "ላዕላይ ቆራሮ"
                    },
                    {
                        "woredaCode": "TGNOW0LAT0",
                        "woredaEng": "Laelay Tselemti",
                        "woredaAmh": "ላዕላይ ፀለምቲ"
                    },
                    {
                        "woredaCode": "TGNOW0MAA0",
                        "woredaEng": "Maekel Adiyabo",
                        "woredaAmh": "ማእኸል ኣድያቦ"
                    },
                    {
                        "woredaCode": "TGNOW0SEA0",
                        "woredaEng": "Seyemti Adyabo",
                        "woredaAmh": "ሰየምቲ ኣድያቦ"
                    },
                    {
                        "woredaCode": "TGNOW0SHR2",
                        "woredaEng": "Sheraro Town",
                        "woredaAmh": "ሸራሮ ከተማ"
                    },
                    {
                        "woredaCode": "TGNOW0SHE2",
                        "woredaEng": "Shire Endaslassie Town",
                        "woredaAmh": "ሽረ እንዳስላሴ ከተማ"
                    },
                    {
                        "woredaCode": "TGNOW0TAA0",
                        "woredaEng": "Tahtay Adiyabo",
                        "woredaAmh": "ታሕታይ ኣድያቦ"
                    },
                    {
                        "woredaCode": "TGNOW0TAK0",
                        "woredaEng": "Tahtay Koraro",
                        "woredaAmh": "ታሕታይ ቆራሮ"
                    },
                    {
                        "woredaCode": "TGNOW0TSL0",
                        "woredaEng": "Tselemti",
                        "woredaAmh": "ፀለምቲ"
                    },
                    {
                        "woredaCode": "TGNOW0TSM0",
                        "woredaEng": "Tsimbila",
                        "woredaAmh": "ፅምብላ"
                    },
                    {
                        "woredaCode": "TGNOW0ZAN0",
                        "woredaEng": "Zana",
                        "woredaAmh": "ዛና"
                    }
                ]
            },
            {
                "zoneCode": "TGSTH00000",
                "zoneEng": "South",
                "zoneAmh": "ደቡብ",
                "woredas": [
                    {
                        "woredaCode": "TGSTH0BOR0",
                        "woredaEng": "Bora",
                        "woredaAmh": "ቦራ"
                    },
                    {
                        "woredaCode": "TGSTH0EMA0",
                        "woredaEng": "Emba Alaje",
                        "woredaAmh": "እምባ አላጀ"
                    },
                    {
                        "woredaCode": "TGSTH0ENM0",
                        "woredaEng": "Enda mekoni",
                        "woredaAmh": "እንዳ መኾኒ"
                    },
                    {
                        "woredaCode": "TGSTH0MYC2",
                        "woredaEng": "Maychew Town",
                        "woredaAmh": "ማይጨዉ ከተማ"
                    },
                    {
                        "woredaCode": "TGSTH0MKN2",
                        "woredaEng": "Mekoni Town",
                        "woredaAmh": "መኾኒ ከተማ"
                    },
                    {
                        "woredaCode": "TGSTH0NQS0",
                        "woredaEng": "Neqsege",
                        "woredaAmh": "ነቅሰገ"
                    },
                    {
                        "woredaCode": "TGSTH0RAA0",
                        "woredaEng": "Raya Azebo",
                        "woredaAmh": "ራያ ዓዘቦ"
                    },
                    {
                        "woredaCode": "TGSTH0RAC0",
                        "woredaEng": "Raya Chercher",
                        "woredaAmh": "ራያ ጨርጨር"
                    },
                    {
                        "woredaCode": "TGSTH0SLW0",
                        "woredaEng": "Silawa",
                        "woredaAmh": "ስላዋ"
                    }
                ]
            },
            {
                "zoneCode": "TGSOE00000",
                "zoneEng": "South East",
                "zoneAmh": "ደቡብ ምስራቅ",
                "woredas": [
                    {
                        "woredaCode": "TGSOE0ADG2",
                        "woredaEng": "Adigudom Town",
                        "woredaAmh": "ዓዲጉዶም ከተማ"
                    },
                    {
                        "woredaCode": "TGSOE0DET0",
                        "woredaEng": "Degua Temben",
                        "woredaAmh": "ደጉዓ ተምቤን"
                    },
                    {
                        "woredaCode": "TGSOE0END0",
                        "woredaEng": "Enderta",
                        "woredaAmh": "እንደርታ"
                    },
                    {
                        "woredaCode": "TGSOE0HAS2",
                        "woredaEng": "Hagere Selam Town",
                        "woredaAmh": "ሃገረ ሰላም ከተማ"
                    },
                    {
                        "woredaCode": "TGSOE0HNT0",
                        "woredaEng": "Hintalo",
                        "woredaAmh": "ሕንጣሎ"
                    },
                    {
                        "woredaCode": "TGSOE0SHR0",
                        "woredaEng": "Saharti",
                        "woredaAmh": "ሳሓርቲ"
                    },
                    {
                        "woredaCode": "TGSOE0SMR0",
                        "woredaEng": "Samre",
                        "woredaAmh": "ሳምረ"
                    },
                    {
                        "woredaCode": "TGSOE0WJR0",
                        "woredaEng": "Wojerat",
                        "woredaAmh": "ወጀራት"
                    }
                ]
            }
        ]
    }
]
export const region_data = [
    {
        "id": 1,
        "name": "Addis Ababa",
        "nameamh": "አዲስ አበባ"
    },
    {
        "id": 2,
        "name": "Afar",
        "nameamh": "አፋር"
    },
    {
        "id": 3,
        "name": "Amhara",
        "nameamh": "አማራ"
    },
    {
        "id": 4,
        "name": "Benishangul-Gumuz",
        "nameamh": "ቤኒሻንጉል-ጉሙዝ"
    },
    {
        "id": 5,
        "name": "Central Ethiopia Region",
        "nameamh": "ማዕከላዊ ኢትዮጵያ ክልል"
    },
    {
        "id": 6,
        "name": "Dire Dawa",
        "nameamh": "ድሬዳዋ"
    },
    {
        "id": 7,
        "name": "Gambela",
        "nameamh": "ጋምቤላ"
    },
    {
        "id": 8,
        "name": "Harari",
        "nameamh": "ሀረሪ"
    },
    {
        "id": 9,
        "name": "Oromia",
        "nameamh": "ኦሮሚያ"
    },
    {
        "id": 10,
        "name": "Sidama",
        "nameamh": "ሲዳማ"
    },
    {
        "id": 11,
        "name": "South Ethiopia Region",
        "nameamh": "ደቡብ ክልል"
    },
    {
        "id": 12,
        "name": "Somali",
        "nameamh": "ሶማሌ"
    },
    {
        "id": 13,
        "name": "South West",
        "nameamh": "ደቡብ ምዕራብ"
    },
    {
        "id": 14,
        "name": "Tigray",
        "nameamh": "ትግራይ"
    }
]
export const zone_data = {
    "1": [
        {
            "id": 1,
            "name": "Addis Ketema",
            "nameamh": "አዲስ ከተማ"
        },
        {
            "id": 2,
            "name": "Akaki Kality",
            "nameamh": "አቃቂ ቃሊቲ"
        },
        {
            "id": 3,
            "name": "Arada",
            "nameamh": "አራዳ"
        },
        {
            "id": 4,
            "name": "Bole",
            "nameamh": "ቦሌ"
        },
        {
            "id": 5,
            "name": "Gullele",
            "nameamh": "ጉለሌ"
        },
        {
            "id": 6,
            "name": "Kolfe Keranio",
            "nameamh": "ኮልፌ ቀራንዮ"
        },
        {
            "id": 7,
            "name": "Kirkos",
            "nameamh": "ቂርቆስ"
        },
        {
            "id": 8,
            "name": "Lideta",
            "nameamh": "ልደታ"
        },
        {
            "id": 9,
            "name": "Lemi Kura",
            "nameamh": "ለሚ ኩራ"
        },
        {
            "id": 10,
            "name": "Nifas Silk-Lafto",
            "nameamh": "ንፋስ ስልክ ላፍቶ"
        },
        {
            "id": 11,
            "name": "Yeka",
            "nameamh": "የካ"
        }
    ],
    "2": [
        {
            "id": 12,
            "name": "Awsi Rasu",
            "nameamh": "አውሲ ራሱ"
        },
        {
            "id": 13,
            "name": "Semera",
            "nameamh": "ሰመራ ሎጊያ"
        },
        {
            "id": 14,
            "name": "Fantena Rasu",
            "nameamh": "ፋንታና ራሱ"
        },
        {
            "id": 15,
            "name": "Gabi Rasu",
            "nameamh": "ጋቢ ራሱ"
        },
        {
            "id": 16,
            "name": "Hari Rasu",
            "nameamh": "ሀሪ ራሱ"
        },
        {
            "id": 17,
            "name": "Kilbet Rasu",
            "nameamh": "ኪልቤት ራሱ"
        }
    ],
    "3": [
        {
            "id": 18,
            "name": "Awi Zone",
            "nameamh": "አዊ ዞን"
        },
        {
            "id": 19,
            "name": "Argoba Special Zone",
            "nameamh": "አርጎባ ልዩ ዞን"
        },
        {
            "id": 20,
            "name": "Bahir Dar Special Zone",
            "nameamh": "ባህር ዳር ልዩ ዞን"
        },
        {
            "id": 21,
            "name": "Central Gonder",
            "nameamh": "ማዕከላዊ ጎንደር"
        },
        {
            "id": 22,
            "name": "Dessie Town Administration",
            "nameamh": "ደሴ ከተማ አስተዳደር"
        },
        {
            "id": 23,
            "name": "East Gojjam Zone",
            "nameamh": "ምስራቅ ጎጃም ዞን"
        },
        {
            "id": 24,
            "name": "Gondar Town Special Zone",
            "nameamh": "ጎንደር ከተማ ልዩ ዞን"
        },
        {
            "id": 25,
            "name": "North Gondar Zone",
            "nameamh": "ሰሜን ጎንደር ዞን"
        },
        {
            "id": 26,
            "name": "North Shewa Zone",
            "nameamh": "ሰሜን ሸዋ ዞን"
        },
        {
            "id": 27,
            "name": "North Wollo Zone",
            "nameamh": "ሰሜን ወሎ ዞን"
        },
        {
            "id": 28,
            "name": "Oromiya-Special Zone",
            "nameamh": "የኦሮሚያ-ልዩ ዞን"
        },
        {
            "id": 29,
            "name": "South Gondar Zone",
            "nameamh": "ደቡብ ጎንደር ዞን"
        },
        {
            "id": 30,
            "name": "South Wollo Zone",
            "nameamh": "ደቡብ ወሎ ዞን"
        },
        {
            "id": 31,
            "name": "West Gonder",
            "nameamh": "ምዕራብ ጎንደር"
        },
        {
            "id": 32,
            "name": "West Gojjam Zone",
            "nameamh": "ምዕራብ ጎጃም ዞን"
        },
        {
            "id": 33,
            "name": "Waghimra Zone",
            "nameamh": "የዋግ ኽምራ ዞን"
        }
    ],
    "4": [
        {
            "id": 34,
            "name": "Assosa Zone",
            "nameamh": "አሶሳ ዞን"
        },
        {
            "id": 35,
            "name": "Mao Ena Komo",
            "nameamh": "ማኦ እና ኮሜ"
        },
        {
            "id": 36,
            "name": "Kamashi Zone",
            "nameamh": "ካማሺ ዞን"
        },
        {
            "id": 37,
            "name": "Metekel Zone",
            "nameamh": "መተከል ዞን"
        }
    ],
    "5": [
        {
            "id": 38,
            "name": "Gurage Zone",
            "nameamh": "ጉራጌ ዞን"
        },
        {
            "id": 39,
            "name": "Hadiya Zone",
            "nameamh": "ሀዲያ ዞን"
        },
        {
            "id": 40,
            "name": "Halaba",
            "nameamh": "ሀላባ"
        },
        {
            "id": 41,
            "name": "Kembata Zone",
            "nameamh": "ከምባታ ዞን"
        },
        {
            "id": 42,
            "name": "Mareqo Special Wereda",
            "nameamh": "ማረቆ ልዩ ወረዳ"
        },
        {
            "id": 43,
            "name": "East Gurage",
            "nameamh": "ምስራቅ ጉራጌ"
        },
        {
            "id": 44,
            "name": "Qebena Special Wereda",
            "nameamh": "ቀበና ልዩ ወረዳ"
        },
        {
            "id": 45,
            "name": "Silti Zone",
            "nameamh": "ስልጢ ዞን"
        },
        {
            "id": 46,
            "name": "Tembaro Special Wereda",
            "nameamh": "ተምባሮ ልዩ ወረዳ"
        },
        {
            "id": 47,
            "name": "Yem",
            "nameamh": "የም"
        }
    ],
    "6": [
        {
            "id": 48,
            "name": "Dire Dawa",
            "nameamh": "ድሬዳዋ"
        }
    ],
    "7": [
        {
            "id": 49,
            "name": "AGNUA",
            "nameamh": "አኟ"
        },
        {
            "id": 50,
            "name": "ETANG Special Woreda",
            "nameamh": "ኢታንግ ልዩ ወረዳ"
        },
        {
            "id": 51,
            "name": "GAMBELLA TOWN ADMIN",
            "nameamh": "ጋምቤላ ከተማ አስተዳደር"
        },
        {
            "id": 52,
            "name": "MEJANG",
            "nameamh": "ማጃንግ"
        },
        {
            "id": 53,
            "name": "NUER",
            "nameamh": "ኑዌር"
        }
    ],
    "8": [
        {
            "id": 54,
            "name": "Harari",
            "nameamh": "ሀሪሪ"
        }
    ],
    "9": [
        {
            "id": 55,
            "name": "Ambo City Administration",
            "nameamh": "አምቦ ከተማ አስተዳደር"
        },
        {
            "id": 56,
            "name": "Asella City Administration",
            "nameamh": "አሰላ ከተማ አስተዳደር"
        },
        {
            "id": 57,
            "name": "Adama City Administration - Aba Gada Subcity",
            "nameamh": "አዳማ ከተማ አስተዳደር - አባ ገዳ ክፍለ ከተማ"
        },
        {
            "id": 58,
            "name": "Adama City Administration - Bole",
            "nameamh": "አዳማ ከተማ አስተዳደር - ቦሌ"
        },
        {
            "id": 59,
            "name": "Adama City Administration - Boku Shanan",
            "nameamh": "አዳማ ከተማ አስተዳደር - ቦኩ ሻናን"
        },
        {
            "id": 60,
            "name": "Adama City Administration - Dabe",
            "nameamh": "አዳማ ከተማ አስተዳደር - ዳቤ"
        },
        {
            "id": 61,
            "name": "Adama City Administration - Danbala",
            "nameamh": "አዳማ ከተማ አስተዳደር - ደንበላ"
        },
        {
            "id": 62,
            "name": "Adama City Administration - Lugo",
            "nameamh": "አዳማ ከተማ አስተዳደር - ሎጎ"
        },
        {
            "id": 63,
            "name": "Agaro City Administration",
            "nameamh": "አጋሮ ከተማ አስተዳደር"
        },
        {
            "id": 64,
            "name": "Arsi",
            "nameamh": "አርሲ"
        },
        {
            "id": 65,
            "name": "Batu City Administration",
            "nameamh": "ባቱ ከተማ አስተዳደር"
        },
        {
            "id": 66,
            "name": "Bishoftu City Administration - Chalalaka",
            "nameamh": "ቢሾፍቱ ከተማ አስተዳደር - ጨለለቃ"
        },
        {
            "id": 67,
            "name": "Bishoftu City Administration - Dukam",
            "nameamh": "ቢሾፍቱ ከተማ አስተዳደር - ዱካም"
        },
        {
            "id": 68,
            "name": "Bishoftu City Administration - Dibayu",
            "nameamh": "ቢሾፍቱ ከተማ አስተዳደር - ዲባዩ"
        },
        {
            "id": 69,
            "name": "Bule Hora City Administration",
            "nameamh": "ቡሌ ሆራ ከተማ አስተዳደር"
        },
        {
            "id": 70,
            "name": "Bale",
            "nameamh": "ባሌ"
        },
        {
            "id": 71,
            "name": "Buno Bedele",
            "nameamh": "ቡኖ በደሌ"
        },
        {
            "id": 72,
            "name": "Borena",
            "nameamh": "ቦረና"
        },
        {
            "id": 73,
            "name": "Shager City Administration- Burayu Sub-city",
            "nameamh": "ሸገር ከተማ አስተዳደር - ቡራዩ ክፍለ ከተማ"
        },
        {
            "id": 74,
            "name": "Dodola City Administration",
            "nameamh": "ዶዶላ ከተማ አስተዳደር"
        },
        {
            "id": 75,
            "name": "East Bale",
            "nameamh": "ምስራቅ ባሌ"
        },
        {
            "id": 76,
            "name": "East Borena",
            "nameamh": "ምስራቅ ቦረና"
        },
        {
            "id": 77,
            "name": "East Harerge",
            "nameamh": "ምስራቅ ሀረርጌ"
        },
        {
            "id": 78,
            "name": "East Shawa",
            "nameamh": "ምስራቅ ሸዋ"
        },
        {
            "id": 79,
            "name": "East Wollega",
            "nameamh": "ምስራቅ ወለጋ"
        },
        {
            "id": 80,
            "name": "Shager City Administration - Furi Sub-city",
            "nameamh": "ሸገር ከተማ አስተዳደር - ፉሪ ክፍለ ከተማ"
        },
        {
            "id": 81,
            "name": "Shager City Administration - Gefersa Guje Sub-city",
            "nameamh": "ሸገር ከተማ አስተዳደር- ገፈርሳ ጉጄ ክፍለ ከተማ"
        },
        {
            "id": 82,
            "name": "Shager City Administration - Galan Guda Sub-city",
            "nameamh": "ሸገር ከተማ አስተዳደር - ገላን ጉዳ ክፍለ ከተማ"
        },
        {
            "id": 83,
            "name": "Guji",
            "nameamh": "ጉጂ"
        },
        {
            "id": 84,
            "name": "Shager City Administration - Galan Sub-city",
            "nameamh": "ሸገር ከተማ -  ገላን ክፍለ ከተማ"
        },
        {
            "id": 85,
            "name": "Holata City Administration",
            "nameamh": "ሆለታ ከተማ አስተዳደር"
        },
        {
            "id": 86,
            "name": "Horo Guduru Wellega",
            "nameamh": "ሆሮ ጉዱሩ ወለጋ"
        },
        {
            "id": 87,
            "name": "Ilu Aba Bora",
            "nameamh": "ኢሉ አባ ቦራ"
        },
        {
            "id": 88,
            "name": "Jimma City Administration",
            "nameamh": "ጅማ ከተማ አስተዳደር"
        },
        {
            "id": 89,
            "name": "Jimma",
            "nameamh": "ጅማ"
        },
        {
            "id": 90,
            "name": "Shager City Administration - Koye Feche Sub-city",
            "nameamh": "ሸገር ከተማ አስተዳደር -  ኮዬ ፈጬ ክፍለ ከተማ"
        },
        {
            "id": 91,
            "name": "Shager City Administration- Kura Jida Sub-city",
            "nameamh": "ሸገር ከተማ አስተዳደር - ኩራ ጅዳ ክፍለ ከተማ"
        },
        {
            "id": 92,
            "name": "Kelem Wellega",
            "nameamh": "ቄለም ወለጋ"
        },
        {
            "id": 93,
            "name": "Shager City Administration - Lege Dadi Lege Tafo Sub-city",
            "nameamh": "ሸገር ከተማ - ለገ ዳዲ ለገ ጣፎ ክፍለ ከተማ"
        },
        {
            "id": 94,
            "name": "Shager City Administration - Mana Abichu Sub-city",
            "nameamh": "ሸገር ከተማ አስተዳደር -  መነ አቢቹ ክፍለ ከተማ"
        },
        {
            "id": 95,
            "name": "Maya City Administration - Haramaya",
            "nameamh": "ማያ ከተማ አስተዳደር - ሐረማያ"
        },
        {
            "id": 96,
            "name": "Maya City Administration - Awaday",
            "nameamh": "ማያ ከተማ አስተዳደር - አወዳይ"
        },
        {
            "id": 97,
            "name": "Maya City Administration - Adelle",
            "nameamh": "ማያ ከተማ አስተዳደር - አዳሌ"
        },
        {
            "id": 98,
            "name": "Mojo City Administration",
            "nameamh": "ሞጆ ከተማ አስተዳደር"
        },
        {
            "id": 99,
            "name": "Shager City Administration - Melka Nonno Sub-city",
            "nameamh": "ሸገር ከተማ አስተዳደር - መልካ ኖኖ ክፍለ ከተማ"
        },
        {
            "id": 100,
            "name": "Matu City Administration",
            "nameamh": "መቱ ከተማ አስተዳደር"
        },
        {
            "id": 101,
            "name": "Moyale City Administration",
            "nameamh": "ሞያሌ ከተማ አስተዳደር"
        },
        {
            "id": 102,
            "name": "Nejo City Administration",
            "nameamh": "ነጆ ከተማ አስተዳደር"
        },
        {
            "id": 103,
            "name": "Nekemte City Administration",
            "nameamh": "ነቀምቴ ከተማ አስተዳደር"
        },
        {
            "id": 104,
            "name": "North Shawa",
            "nameamh": "ሰሜን ሸዋ"
        },
        {
            "id": 105,
            "name": "Robe City Administration - Adoshe Walashe",
            "nameamh": "ሮቤ ከተማ አስተዳደር - አዶሼ ዋላሼ"
        },
        {
            "id": 106,
            "name": "Robe City Administration - Goba",
            "nameamh": "ሮቤ ከተማ አስተዳደር - ጎባ"
        },
        {
            "id": 107,
            "name": "Robe City Administration - Zaybala Walashe",
            "nameamh": "ሮቤ ከተማ አስተዳደር - ዘይበላ ዋላሼ"
        },
        {
            "id": 108,
            "name": "Sandafa Bake City Administration",
            "nameamh": "ሳንዳፋ ባኬ ከተማ አስተዳደር"
        },
        {
            "id": 109,
            "name": "Shager City Administration - Sebeta Sub-city",
            "nameamh": "ሸገር ከተማ አስተዳደር - ሰበታ ክፍለ ከተማ"
        },
        {
            "id": 110,
            "name": "Shashamane City Administration - Alache",
            "nameamh": "ሻሼመኔ ከተማ አስተዳደር - አላቼ"
        },
        {
            "id": 111,
            "name": "Shashamane Urban Administration - Bishan Guracha",
            "nameamh": "ሻሼመኔ ከተማ አስተዳደር - ቢሻን ጉራቻ"
        },
        {
            "id": 112,
            "name": "Shashamane City Administration - Harufa",
            "nameamh": "ሻሼመኔ ከተማ አስተዳደር - ሀሩፋ"
        },
        {
            "id": 113,
            "name": "Shashamane City Administration - Malka Sirba",
            "nameamh": "ሻሼመኔ ከተማ አስተዳደር - መልካ ሲርባ"
        },
        {
            "id": 114,
            "name": "Shakiso City Administration",
            "nameamh": "ሻኪሶ ከተማ አስተዳደር"
        },
        {
            "id": 115,
            "name": "Sheno City Administration",
            "nameamh": "ሻኖ ከተማ አስተዳደር"
        },
        {
            "id": 116,
            "name": "Shager City Administration - Sululta Sub-city",
            "nameamh": "ሸገር ከተማ አስተዳደር -  ሱሉልታ ክፍለ ከተማ"
        },
        {
            "id": 117,
            "name": "South West Shawa",
            "nameamh": "ደቡብ ምዕራብ ሸዋ"
        },
        {
            "id": 118,
            "name": "Waliso City Administration",
            "nameamh": "ወልሶ ከተማ አስተዳደር"
        },
        {
            "id": 119,
            "name": "West Guji",
            "nameamh": "ምዕራብ ጉጂ"
        },
        {
            "id": 120,
            "name": "West Arsi",
            "nameamh": "ምዕራብ አርሲ"
        },
        {
            "id": 121,
            "name": "West Harerge",
            "nameamh": "ምዕራብ ሀረርጌ"
        },
        {
            "id": 122,
            "name": "West Shawa",
            "nameamh": "ምዕራብ ሸዋ"
        },
        {
            "id": 123,
            "name": "West Wellega",
            "nameamh": "ምዕራብ ወለጋ"
        }
    ],
    "10": [
        {
            "id": 124,
            "name": "Debubawi Sidama Zone",
            "nameamh": "ደቡባዊ ሲዳማ ዞን"
        },
        {
            "id": 125,
            "name": "Hawassa City Admnistration",
            "nameamh": "ሀዋሳ ከተማ አስተዳደር"
        },
        {
            "id": 126,
            "name": "Misrak Sidama Zone",
            "nameamh": "ምስራቅ ሲዳማ ዞን"
        },
        {
            "id": 127,
            "name": "Mehal Sidama Zone",
            "nameamh": "መሃል ሲዳማ ዞን"
        },
        {
            "id": 128,
            "name": "Semen Sidama Zone",
            "nameamh": "ሰሜን ሲዳማ ዞን"
        }
    ],
    "11": [
        {
            "id": 129,
            "name": "Ari",
            "nameamh": "አሪ"
        },
        {
            "id": 130,
            "name": "Gamo Zone",
            "nameamh": "ጋሞ ዞን"
        },
        {
            "id": 131,
            "name": "Basketo",
            "nameamh": "ባስኬቶ"
        },
        {
            "id": 132,
            "name": "Konso",
            "nameamh": "ኮንሶ"
        },
        {
            "id": 133,
            "name": "Gofa",
            "nameamh": "ጎፋ"
        },
        {
            "id": 134,
            "name": "South Omo",
            "nameamh": "ደቡብ ኦሞ"
        },
        {
            "id": 135,
            "name": "Gardula",
            "nameamh": "ጋርዱላ"
        },
        {
            "id": 136,
            "name": "Wolayita",
            "nameamh": "ወላይታ"
        },
        {
            "id": 137,
            "name": "Gedeo",
            "nameamh": "ጌዴኦ"
        },
        {
            "id": 138,
            "name": "Koore",
            "nameamh": "ኮሬ"
        },
        {
            "id": 139,
            "name": "Burji",
            "nameamh": "ቡርጂ"
        },
        {
            "id": 140,
            "name": "Ale",
            "nameamh": "አሌ"
        }
    ],
    "12": [
        {
            "id": 141,
            "name": "Afder Zone",
            "nameamh": "አፍደር ዞን"
        },
        {
            "id": 142,
            "name": "Dawa Zone",
            "nameamh": "ዳዋ ዞን"
        },
        {
            "id": 143,
            "name": "Dollo Zone",
            "nameamh": "ዶሎ ዞን"
        },
        {
            "id": 144,
            "name": "Erer Zone",
            "nameamh": "ኤረር ዞን"
        },
        {
            "id": 145,
            "name": "Fafan Zone",
            "nameamh": "ፋፋን ዞን"
        },
        {
            "id": 146,
            "name": "Jarar Zone",
            "nameamh": "ጃረር ዞን"
        },
        {
            "id": 147,
            "name": "Korahe Zone",
            "nameamh": "ቆራሄ ዞን"
        },
        {
            "id": 148,
            "name": "Liben Zone",
            "nameamh": "ሊበን ዞን"
        },
        {
            "id": 149,
            "name": "Nogob Zone",
            "nameamh": "ኖጎብ ዞን"
        },
        {
            "id": 150,
            "name": "Shebele Zone",
            "nameamh": "ሸበሌ ዞን"
        },
        {
            "id": 151,
            "name": "Sitti Zone",
            "nameamh": "ሲቲ ዞን"
        }
    ],
    "13": [
        {
            "id": 152,
            "name": "Bench Sheko",
            "nameamh": "ቤንች ሸኮ"
        },
        {
            "id": 153,
            "name": "Dawuro",
            "nameamh": "ዳዉሮ"
        },
        {
            "id": 154,
            "name": "Kafa",
            "nameamh": "ካፋ"
        },
        {
            "id": 155,
            "name": "Konta",
            "nameamh": "ኮንታ"
        },
        {
            "id": 156,
            "name": "Sheka",
            "nameamh": "ሸካ"
        },
        {
            "id": 157,
            "name": "West Omo",
            "nameamh": "ምዕራብ ኦሞ"
        }
    ],
    "14": [
        {
            "id": 158,
            "name": "Mekelle",
            "nameamh": "መቐለ"
        },
        {
            "id": 159,
            "name": "North West",
            "nameamh": "ሰሜን ምዕራብ"
        },
        {
            "id": 160,
            "name": "Central Zone",
            "nameamh": "ማዕከላዊ ዞን"
        },
        {
            "id": 161,
            "name": "East Zone",
            "nameamh": "ምስራቅ ዞን"
        },
        {
            "id": 162,
            "name": "Mekele Special Zone",
            "nameamh": "መቀሌ ልዩ ዞን"
        },
        {
            "id": 163,
            "name": "South East Zone",
            "nameamh": "ደቡብ ምስራቅ ዞን"
        },
        {
            "id": 164,
            "name": "South Zone",
            "nameamh": "ደቡብ ዞን"
        },
        {
            "id": 165,
            "name": "West Zone",
            "nameamh": "ምዕራብ ዞን"
        }
    ]
}
export const woreda_data = {
    "1": [
        {
            "id": 1,
            "name": "Woreda 01",
            "nameamh": "ወረዳ 01"
        },
        {
            "id": 2,
            "name": "Woreda 02",
            "nameamh": "ወረዳ 02"
        },
        {
            "id": 3,
            "name": "Woreda 03",
            "nameamh": "ወረዳ 03"
        },
        {
            "id": 4,
            "name": "Woreda 04",
            "nameamh": "ወረዳ 04"
        },
        {
            "id": 5,
            "name": "Woreda 05",
            "nameamh": "ወረዳ 05"
        },
        {
            "id": 6,
            "name": "Woreda 06",
            "nameamh": "ወረዳ 06"
        },
        {
            "id": 7,
            "name": "Woreda 07",
            "nameamh": "ወረዳ 07"
        },
        {
            "id": 8,
            "name": "Woreda 08",
            "nameamh": "ወረዳ 08"
        },
        {
            "id": 9,
            "name": "Woreda 09",
            "nameamh": "ወረዳ 09"
        },
        {
            "id": 10,
            "name": "Woreda 10",
            "nameamh": "ወረዳ 10"
        },
        {
            "id": 11,
            "name": "Woreda 11",
            "nameamh": "ወረዳ 11"
        },
        {
            "id": 12,
            "name": "Woreda 12",
            "nameamh": "ወረዳ 12"
        },
        {
            "id": 13,
            "name": "Woreda 13",
            "nameamh": "ወረዳ 13"
        },
        {
            "id": 14,
            "name": "Woreda 14",
            "nameamh": "ወረዳ 14"
        }
    ],
    "2": [
        {
            "id": 1,
            "name": "Woreda 01",
            "nameamh": "ወረዳ 01"
        },
        {
            "id": 2,
            "name": "Woreda 02",
            "nameamh": "ወረዳ 02"
        },
        {
            "id": 3,
            "name": "Woreda 03",
            "nameamh": "ወረዳ 03"
        },
        {
            "id": 4,
            "name": "Woreda 04",
            "nameamh": "ወረዳ 04"
        },
        {
            "id": 5,
            "name": "Woreda 05",
            "nameamh": "ወረዳ 05"
        },
        {
            "id": 6,
            "name": "Woreda 06",
            "nameamh": "ወረዳ 06"
        },
        {
            "id": 7,
            "name": "Woreda 07",
            "nameamh": "ወረዳ 07"
        },
        {
            "id": 8,
            "name": "Woreda 08",
            "nameamh": "ወረዳ 08"
        },
        {
            "id": 9,
            "name": "Woreda 09",
            "nameamh": "ወረዳ 09"
        },
        {
            "id": 10,
            "name": "Woreda 10",
            "nameamh": "ወረዳ 10"
        },
        {
            "id": 11,
            "name": "Woreda 11",
            "nameamh": "ወረዳ 11"
        },
        {
            "id": 12,
            "name": "Woreda 12",
            "nameamh": "ወረዳ 12"
        },
        {
            "id": 13,
            "name": "Woreda 13",
            "nameamh": "ወረዳ 13"
        }
    ],
    "3": [
        {
            "id": 1,
            "name": "Woreda 01",
            "nameamh": "ወረዳ 01"
        },
        {
            "id": 2,
            "name": "Woreda 02",
            "nameamh": "ወረዳ 02"
        },
        {
            "id": 3,
            "name": "Woreda 03",
            "nameamh": "ወረዳ 03"
        },
        {
            "id": 4,
            "name": "Woreda 04",
            "nameamh": "ወረዳ 04"
        },
        {
            "id": 5,
            "name": "Woreda 05",
            "nameamh": "ወረዳ 05"
        },
        {
            "id": 6,
            "name": "Woreda 06",
            "nameamh": "ወረዳ 06"
        },
        {
            "id": 7,
            "name": "Woreda 07",
            "nameamh": "ወረዳ 07"
        },
        {
            "id": 8,
            "name": "Woreda 08",
            "nameamh": "ወረዳ 08"
        },
        {
            "id": 9,
            "name": "Woreda 09",
            "nameamh": "ወረዳ 09"
        },
        {
            "id": 10,
            "name": "Woreda 10",
            "nameamh": "ወረዳ 10"
        }
    ],
    "4": [
        {
            "id": 1,
            "name": "Woreda 10",
            "nameamh": "ወረዳ 10"
        },
        {
            "id": 2,
            "name": "Woreda 11",
            "nameamh": "ወረዳ 11"
        },
        {
            "id": 3,
            "name": "Woreda 12",
            "nameamh": "ወረዳ 12"
        },
        {
            "id": 4,
            "name": "Woreda 13",
            "nameamh": "ወረዳ 13"
        },
        {
            "id": 5,
            "name": "Woreda 14",
            "nameamh": "ወረዳ 14"
        },
        {
            "id": 6,
            "name": "Woreda 15",
            "nameamh": "ወረዳ 15"
        },
        {
            "id": 7,
            "name": "Woreda 01",
            "nameamh": "ወረዳ 01"
        },
        {
            "id": 8,
            "name": "Woreda 02",
            "nameamh": "ወረዳ 02"
        },
        {
            "id": 9,
            "name": "Woreda 03",
            "nameamh": "ወረዳ 03"
        },
        {
            "id": 10,
            "name": "Woreda 04",
            "nameamh": "ወረዳ 04"
        },
        {
            "id": 11,
            "name": "Woreda 05",
            "nameamh": "ወረዳ 05"
        },
        {
            "id": 12,
            "name": "Woreda 06",
            "nameamh": "ወረዳ 06"
        },
        {
            "id": 13,
            "name": "Woreda 07",
            "nameamh": "ወረዳ 07"
        },
        {
            "id": 14,
            "name": "Woreda 08",
            "nameamh": "ወረዳ 08"
        },
        {
            "id": 15,
            "name": "Woreda 09",
            "nameamh": "ወረዳ 09"
        }
    ],
    "5": [
        {
            "id": 1,
            "name": "Woreda 01",
            "nameamh": "ወረዳ 01"
        },
        {
            "id": 2,
            "name": "Woreda 02",
            "nameamh": "ወረዳ 02"
        },
        {
            "id": 3,
            "name": "Woreda 03",
            "nameamh": "ወረዳ 03"
        },
        {
            "id": 4,
            "name": "Woreda 04",
            "nameamh": "ወረዳ 04"
        },
        {
            "id": 5,
            "name": "Woreda 05",
            "nameamh": "ወረዳ 05"
        },
        {
            "id": 6,
            "name": "Woreda 06",
            "nameamh": "ወረዳ 06"
        },
        {
            "id": 7,
            "name": "Woreda 07",
            "nameamh": "ወረዳ 07"
        },
        {
            "id": 8,
            "name": "Woreda 08",
            "nameamh": "ወረዳ 08"
        },
        {
            "id": 9,
            "name": "Woreda 09",
            "nameamh": "ወረዳ 09"
        },
        {
            "id": 10,
            "name": "Woreda 10",
            "nameamh": "ወረዳ 10"
        }
    ],
    "6": [
        {
            "id": 1,
            "name": "Woreda 01",
            "nameamh": "ወረዳ 01"
        },
        {
            "id": 2,
            "name": "Woreda 02",
            "nameamh": "ወረዳ 02"
        },
        {
            "id": 3,
            "name": "Woreda 03",
            "nameamh": "ወረዳ 03"
        },
        {
            "id": 4,
            "name": "Woreda 04",
            "nameamh": "ወረዳ 04"
        },
        {
            "id": 5,
            "name": "Woreda 05",
            "nameamh": "ወረዳ 05"
        },
        {
            "id": 6,
            "name": "Woreda 06",
            "nameamh": "ወረዳ 06"
        },
        {
            "id": 7,
            "name": "Woreda 07",
            "nameamh": "ወረዳ 07"
        },
        {
            "id": 8,
            "name": "Woreda 08",
            "nameamh": "ወረዳ 08"
        },
        {
            "id": 9,
            "name": "Woreda 09",
            "nameamh": "ወረዳ 09"
        },
        {
            "id": 10,
            "name": "Woreda 10",
            "nameamh": "ወረዳ 10"
        },
        {
            "id": 11,
            "name": "Woreda 11",
            "nameamh": "ወረዳ 11"
        },
        {
            "id": 12,
            "name": "Woreda 12",
            "nameamh": "ወረዳ 12"
        },
        {
            "id": 13,
            "name": "Woreda 13",
            "nameamh": "ወረዳ 13"
        },
        {
            "id": 14,
            "name": "Woreda 14",
            "nameamh": "ወረዳ 14"
        }
    ],
    "7": [
        {
            "id": 1,
            "name": "Woreda 01",
            "nameamh": "ወረዳ 01"
        },
        {
            "id": 2,
            "name": "Woreda 02",
            "nameamh": "ወረዳ 02"
        },
        {
            "id": 3,
            "name": "Woreda 03",
            "nameamh": "ወረዳ 03"
        },
        {
            "id": 4,
            "name": "Woreda 04",
            "nameamh": "ወረዳ 04"
        },
        {
            "id": 5,
            "name": "Woreda 05",
            "nameamh": "ወረዳ 05"
        },
        {
            "id": 6,
            "name": "Woreda 06",
            "nameamh": "ወረዳ 06"
        },
        {
            "id": 7,
            "name": "Woreda 07",
            "nameamh": "ወረዳ 07"
        },
        {
            "id": 8,
            "name": "Woreda 08",
            "nameamh": "ወረዳ 08"
        },
        {
            "id": 9,
            "name": "Woreda 09",
            "nameamh": "ወረዳ 09"
        },
        {
            "id": 10,
            "name": "Woreda 10",
            "nameamh": "ወረዳ 10"
        },
        {
            "id": 11,
            "name": "Woreda 11",
            "nameamh": "ወረዳ 11"
        }
    ],
    "8": [
        {
            "id": 1,
            "name": "Woreda 01",
            "nameamh": "ወረዳ 01"
        },
        {
            "id": 2,
            "name": "Woreda 02",
            "nameamh": "ወረዳ 02"
        },
        {
            "id": 3,
            "name": "Woreda 03",
            "nameamh": "ወረዳ 03"
        },
        {
            "id": 4,
            "name": "Woreda 04",
            "nameamh": "ወረዳ 04"
        },
        {
            "id": 5,
            "name": "Woreda 05",
            "nameamh": "ወረዳ 05"
        },
        {
            "id": 6,
            "name": "Woreda 06",
            "nameamh": "ወረዳ 06"
        },
        {
            "id": 7,
            "name": "Woreda 07",
            "nameamh": "ወረዳ 07"
        },
        {
            "id": 8,
            "name": "Woreda 08",
            "nameamh": "ወረዳ 08"
        },
        {
            "id": 9,
            "name": "Woreda 09",
            "nameamh": "ወረዳ 09"
        },
        {
            "id": 10,
            "name": "Woreda 10",
            "nameamh": "ወረዳ 10"
        }
    ],
    "9": [
        {
            "id": 1,
            "name": "Woreda 01",
            "nameamh": "ወረዳ 01"
        },
        {
            "id": 2,
            "name": "Woreda 10",
            "nameamh": "ወረዳ 10"
        },
        {
            "id": 3,
            "name": "Woreda 11",
            "nameamh": "ወረዳ 11"
        },
        {
            "id": 4,
            "name": "Woreda 12",
            "nameamh": "ወረዳ 12"
        },
        {
            "id": 5,
            "name": "Woreda 13",
            "nameamh": "ወረዳ 13"
        },
        {
            "id": 6,
            "name": "Woreda 14",
            "nameamh": "ወረዳ 14"
        },
        {
            "id": 7,
            "name": "Woreda 02",
            "nameamh": "ወረዳ 02"
        },
        {
            "id": 8,
            "name": "Woreda 03",
            "nameamh": "ወረዳ 03"
        },
        {
            "id": 9,
            "name": "Woreda 04",
            "nameamh": "ወረዳ 04"
        },
        {
            "id": 10,
            "name": "Woreda 05",
            "nameamh": "ወረዳ 05"
        },
        {
            "id": 11,
            "name": "Woreda 06",
            "nameamh": "ወረዳ 06"
        },
        {
            "id": 12,
            "name": "Woreda 07",
            "nameamh": "ወረዳ 07"
        },
        {
            "id": 13,
            "name": "Woreda 08",
            "nameamh": "ወረዳ 08"
        },
        {
            "id": 14,
            "name": "Woreda 09",
            "nameamh": "ወረዳ 09"
        }
    ],
    "10": [
        {
            "id": 1,
            "name": "Woreda 01",
            "nameamh": "ወረዳ 01"
        },
        {
            "id": 2,
            "name": "Woreda 02",
            "nameamh": "ወረዳ 02"
        },
        {
            "id": 3,
            "name": "Woreda 03",
            "nameamh": "ወረዳ 03"
        },
        {
            "id": 4,
            "name": "Woreda 04",
            "nameamh": "ወረዳ 04"
        },
        {
            "id": 5,
            "name": "Woreda 05",
            "nameamh": "ወረዳ 05"
        },
        {
            "id": 6,
            "name": "Woreda 06",
            "nameamh": "ወረዳ 06"
        },
        {
            "id": 7,
            "name": "Woreda 07",
            "nameamh": "ወረዳ 07"
        },
        {
            "id": 8,
            "name": "Woreda 08",
            "nameamh": "ወረዳ 08"
        },
        {
            "id": 9,
            "name": "Woreda 09",
            "nameamh": "ወረዳ 09"
        },
        {
            "id": 10,
            "name": "Woreda 10",
            "nameamh": "ወረዳ 10"
        },
        {
            "id": 11,
            "name": "Woreda 11",
            "nameamh": "ወረዳ 11"
        },
        {
            "id": 12,
            "name": "Woreda 12",
            "nameamh": "ወረዳ 12"
        },
        {
            "id": 13,
            "name": "Woreda 13",
            "nameamh": "ወረዳ 13"
        },
        {
            "id": 14,
            "name": "Woreda 14",
            "nameamh": "ወረዳ 14"
        },
        {
            "id": 15,
            "name": "Woreda 15",
            "nameamh": "ወረዳ 15"
        }
    ],
    "11": [
        {
            "id": 1,
            "name": "Woreda 01",
            "nameamh": "ወረዳ 01"
        },
        {
            "id": 2,
            "name": "Woreda 02",
            "nameamh": "ወረዳ 02"
        },
        {
            "id": 3,
            "name": "Woreda 03",
            "nameamh": "ወረዳ 03"
        },
        {
            "id": 4,
            "name": "Woreda 04",
            "nameamh": "ወረዳ 04"
        },
        {
            "id": 5,
            "name": "Woreda 05",
            "nameamh": "ወረዳ 05"
        },
        {
            "id": 6,
            "name": "Woreda 06",
            "nameamh": "ወረዳ 06"
        },
        {
            "id": 7,
            "name": "Woreda 07",
            "nameamh": "ወረዳ 07"
        },
        {
            "id": 8,
            "name": "Woreda 08",
            "nameamh": "ወረዳ 08"
        },
        {
            "id": 9,
            "name": "Woreda 09",
            "nameamh": "ወረዳ 09"
        },
        {
            "id": 10,
            "name": "Woreda 10",
            "nameamh": "ወረዳ 10"
        },
        {
            "id": 11,
            "name": "Woreda 11",
            "nameamh": "ወረዳ 11"
        },
        {
            "id": 12,
            "name": "Woreda 12",
            "nameamh": "ወረዳ 12"
        },
        {
            "id": 13,
            "name": "Woreda 13",
            "nameamh": "ወረዳ 13"
        },
        {
            "id": 14,
            "name": "Woreda 14",
            "nameamh": "ወረዳ 14"
        }
    ],
    "12": [
        {
            "id": 1,
            "name": "Afambo",
            "nameamh": "አፋምቦ"
        },
        {
            "id": 2,
            "name": "Dubti",
            "nameamh": "ዱብቲ"
        },
        {
            "id": 3,
            "name": "Ada'Ar",
            "nameamh": "አዳአር"
        },
        {
            "id": 4,
            "name": "Chifra",
            "nameamh": "ጭፍራ"
        },
        {
            "id": 5,
            "name": "Mille",
            "nameamh": "ሚሌ"
        },
        {
            "id": 6,
            "name": "Asayita",
            "nameamh": "ኣሳይታ"
        },
        {
            "id": 7,
            "name": "Elidar",
            "nameamh": "ኤሊዳር"
        },
        {
            "id": 8,
            "name": "Geyreni",
            "nameamh": "ገይረኒ"
        },
        {
            "id": 9,
            "name": "Kori",
            "nameamh": "ኮሪ"
        }
    ],
    "13": [],
    "14": [
        {
            "id": 1,
            "name": "Aura",
            "nameamh": "ኦራ"
        },
        {
            "id": 2,
            "name": "Ewa",
            "nameamh": "ኢዋ"
        },
        {
            "id": 3,
            "name": "Golina",
            "nameamh": "ጎሊና"
        },
        {
            "id": 4,
            "name": "Teru",
            "nameamh": "ቴሩ"
        },
        {
            "id": 5,
            "name": "Yalo",
            "nameamh": "ያሎ"
        }
    ],
    "15": [
        {
            "id": 1,
            "name": "Canruka",
            "nameamh": "ካንሩካ"
        },
        {
            "id": 2,
            "name": "Awash Fentale",
            "nameamh": "አዋሽ ፈንታሌ"
        },
        {
            "id": 3,
            "name": "Gewane",
            "nameamh": "ገዋኔ"
        },
        {
            "id": 4,
            "name": "Amibara",
            "nameamh": "አሚባራ"
        },
        {
            "id": 5,
            "name": "Dulesa",
            "nameamh": "ዱሌሳ"
        },
        {
            "id": 6,
            "name": "Awash Ketema Astedader",
            "nameamh": "አዋሽ ከተማ አስተዳደር"
        },
        {
            "id": 7,
            "name": "Gelalo",
            "nameamh": "ገላሎ"
        },
        {
            "id": 8,
            "name": "Argoba Liyu",
            "nameamh": "አርጎባ ልዩ"
        }
    ],
    "16": [
        {
            "id": 1,
            "name": "Dalifage",
            "nameamh": "ዳሊፋጅ"
        },
        {
            "id": 2,
            "name": "Hadele Ele",
            "nameamh": "ሀደለ እሌ"
        },
        {
            "id": 3,
            "name": "Telalak",
            "nameamh": "ተላላክ"
        },
        {
            "id": 4,
            "name": "Dewe",
            "nameamh": "ድዌ"
        },
        {
            "id": 5,
            "name": "Simurobi Gele'Alo",
            "nameamh": "ሲሙሮቢ ገለአሎ"
        },
        {
            "id": 6,
            "name": "Yangudi",
            "nameamh": "ያንጉዲ"
        }
    ],
    "17": [
        {
            "id": 1,
            "name": "Abala",
            "nameamh": "አባላ"
        },
        {
            "id": 2,
            "name": "Afdera",
            "nameamh": "አፍዴራ"
        },
        {
            "id": 3,
            "name": "Berhale",
            "nameamh": "በርሀሌ"
        },
        {
            "id": 4,
            "name": "Dallol",
            "nameamh": "ዳሎል"
        },
        {
            "id": 5,
            "name": "Megale",
            "nameamh": "ሜጋሌ"
        },
        {
            "id": 6,
            "name": "Bidu",
            "nameamh": "ቢዱ"
        },
        {
            "id": 7,
            "name": "Erebti",
            "nameamh": "ኤረብቲ"
        },
        {
            "id": 8,
            "name": "Kuneba",
            "nameamh": "ኩነባ"
        }
    ],
    "18": [
        {
            "id": 1,
            "name": "Dangila",
            "nameamh": "ዳንጊላ"
        },
        {
            "id": 2,
            "name": "Ankesha Guagusa",
            "nameamh": "አንክሻ ጓጉሳ"
        },
        {
            "id": 3,
            "name": "Jawi",
            "nameamh": "ጃዊ"
        },
        {
            "id": 4,
            "name": "Banja Shekudad",
            "nameamh": "ባንጃ ሽኩዳድ"
        },
        {
            "id": 5,
            "name": "Guangua",
            "nameamh": "ጓንጓ"
        },
        {
            "id": 6,
            "name": "Fagita Lekoma",
            "nameamh": "ፋግታ ለኮማ"
        },
        {
            "id": 7,
            "name": "Guagusa Shekudad",
            "nameamh": "ጓጉሳ ሽኩዳድ"
        },
        {
            "id": 8,
            "name": "Zigem",
            "nameamh": "ዝገም"
        },
        {
            "id": 9,
            "name": "Ayehu Guagusa",
            "nameamh": "አየሁ ጓጉሳ"
        },
        {
            "id": 10,
            "name": "Chagini",
            "nameamh": "ቻግኒ"
        },
        {
            "id": 11,
            "name": "Enjibara City Administration",
            "nameamh": "እንጅባራ ከተማ አስተዳደር"
        },
        {
            "id": 12,
            "name": "Dangla City Administration",
            "nameamh": "ዳንግላ ከተማ አስተዳደር"
        }
    ],
    "19": [
        {
            "id": 1,
            "name": "Argobba Special",
            "nameamh": "አርጎባ ልዩ"
        }
    ],
    "20": [
        {
            "id": 1,
            "name": "Bahir Dar City Tana Subcity",
            "nameamh": "ባህር ዳር ከተማ ጣና ክፍለ ከተማ"
        },
        {
            "id": 2,
            "name": "Fasilo",
            "nameamh": "ፋሲሎ"
        },
        {
            "id": 3,
            "name": "Gishe Abay",
            "nameamh": "ግሽ አባይ"
        },
        {
            "id": 4,
            "name": "Atse Tewedros",
            "nameamh": "አፄ ቴዎድሮስ"
        },
        {
            "id": 5,
            "name": "Belay Zeleke",
            "nameamh": "በላይ ዘለቀ"
        },
        {
            "id": 6,
            "name": "Dagmawi Minilik",
            "nameamh": "ዳግማዊ ሚኒሊክ"
        },
        {
            "id": 7,
            "name": "Around Bahir Dar City",
            "nameamh": "ባህር ዳር ከተማ ዙሪያ"
        }
    ],
    "21": [
        {
            "id": 1,
            "name": "Kinfaz Begela",
            "nameamh": "ኪንፋዝ በገላ"
        },
        {
            "id": 2,
            "name": "Mirabdembiya",
            "nameamh": "ምዕራብ ደምቢያ"
        },
        {
            "id": 3,
            "name": "Misrak Dembiya",
            "nameamh": "ምስራቅ ደምቢያ"
        },
        {
            "id": 4,
            "name": "Chilga",
            "nameamh": "ጭልጋ"
        },
        {
            "id": 5,
            "name": "Aykel City Administration",
            "nameamh": "አይከል ከተማ አስተዳደር"
        },
        {
            "id": 6,
            "name": "Tegedie",
            "nameamh": "ጠገዴ"
        },
        {
            "id": 7,
            "name": "Lay Armachiho",
            "nameamh": "ላይ አርማጨሆ"
        },
        {
            "id": 8,
            "name": "Wogera",
            "nameamh": "ወገራ"
        },
        {
            "id": 9,
            "name": "Gonder Zuriya",
            "nameamh": "ጎንደር ዙሪያ"
        },
        {
            "id": 10,
            "name": "Alefa",
            "nameamh": "አለፋ"
        },
        {
            "id": 11,
            "name": "Mirabbelesa",
            "nameamh": "ምዕራብ በለሳ"
        },
        {
            "id": 12,
            "name": "Misrakbelesa",
            "nameamh": "ምስራቅ በለሳ"
        },
        {
            "id": 13,
            "name": "Tachi Armachiho",
            "nameamh": "ታች አርማጨሆ"
        },
        {
            "id": 14,
            "name": "Takusa",
            "nameamh": "ታኩሳ"
        }
    ],
    "22": [
        {
            "id": 1,
            "name": "Dessie City Menafesha Subcity",
            "nameamh": "ደሴ ከተማ መናፈሻ ክፍለ ከተማ"
        },
        {
            "id": 2,
            "name": "Banbawuha",
            "nameamh": "ባንባውሃ"
        },
        {
            "id": 3,
            "name": "Hote",
            "nameamh": "ሆቴ"
        },
        {
            "id": 4,
            "name": "Arada",
            "nameamh": "አራዳ"
        },
        {
            "id": 5,
            "name": "Segnogebeya",
            "nameamh": "ሰኞ ገበያ"
        }
    ],
    "23": [
        {
            "id": 1,
            "name": "Gozamin",
            "nameamh": "ጎዛምን"
        },
        {
            "id": 2,
            "name": "Hulet Ej Enese",
            "nameamh": "ሁለት እጅ እንስ"
        },
        {
            "id": 3,
            "name": "Debre Elias",
            "nameamh": "ደብረ ኤልያስ"
        },
        {
            "id": 4,
            "name": "Enbise Sar Midir",
            "nameamh": "እነብሴ ሳር ምድር"
        },
        {
            "id": 5,
            "name": "Enarj Enawga",
            "nameamh": "እናርጅ እናውጋ"
        },
        {
            "id": 6,
            "name": "Enemay",
            "nameamh": "እንማይ"
        },
        {
            "id": 7,
            "name": "Debay Telatgen",
            "nameamh": "ደባይ ጠላትገን"
        },
        {
            "id": 8,
            "name": "Machakel",
            "nameamh": "ማቻከል"
        },
        {
            "id": 9,
            "name": "Baso Liben",
            "nameamh": "ባሶ ሊበን"
        },
        {
            "id": 10,
            "name": "Awabel",
            "nameamh": "አዋበል"
        },
        {
            "id": 11,
            "name": "Dejen",
            "nameamh": "ደጀን"
        },
        {
            "id": 12,
            "name": "Debre Markos",
            "nameamh": "ደብረ ማርቆስ"
        },
        {
            "id": 13,
            "name": "Shebel Berenta",
            "nameamh": "ሸበል በረንታ"
        },
        {
            "id": 14,
            "name": "Sinan",
            "nameamh": "ሲናን"
        },
        {
            "id": 15,
            "name": "Aneded",
            "nameamh": "አንደድ"
        },
        {
            "id": 16,
            "name": "Bibugn",
            "nameamh": "ቢቡኝ"
        },
        {
            "id": 17,
            "name": "Goncha Siso Enese",
            "nameamh": "ጎንቻ ሲሶ እነሴ"
        },
        {
            "id": 18,
            "name": "Mota City Administration",
            "nameamh": "ሞጣ ከተማ አስተዳደር"
        },
        {
            "id": 19,
            "name": "Sede",
            "nameamh": "ሰዴ"
        },
        {
            "id": 20,
            "name": "Dejen City Administration",
            "nameamh": "ደጀን ከተማ አስተዳደር"
        },
        {
            "id": 21,
            "name": "Bichena City Administration",
            "nameamh": "ቢቸና ከተማ አስተዳደር"
        }
    ],
    "24": [
        {
            "id": 1,
            "name": "Gondar City Zobel Subcity",
            "nameamh": "ጎንደር ከተማ ዞበል ክፍለ ከተማ"
        },
        {
            "id": 2,
            "name": "Fasil",
            "nameamh": "ፋሲል"
        },
        {
            "id": 3,
            "name": "Jantekel",
            "nameamh": "ጃን ተከል"
        },
        {
            "id": 4,
            "name": "Arada",
            "nameamh": "አራዳ"
        },
        {
            "id": 5,
            "name": "Maraki",
            "nameamh": "ማራኪ"
        },
        {
            "id": 6,
            "name": "Azezo Tseda",
            "nameamh": "አዘዞ ፀዳ"
        }
    ],
    "25": [
        {
            "id": 1,
            "name": "Adi Arkay",
            "nameamh": "ዓዲ አርካይ"
        },
        {
            "id": 2,
            "name": "Beyeda",
            "nameamh": "ቤየዳ"
        },
        {
            "id": 3,
            "name": "Debark",
            "nameamh": "ደባርቅ"
        },
        {
            "id": 4,
            "name": "Dabat",
            "nameamh": "ዳባት"
        },
        {
            "id": 5,
            "name": "Jan Amora",
            "nameamh": "ጃን አሞራ"
        },
        {
            "id": 6,
            "name": "Telemit",
            "nameamh": "ጠለምት"
        },
        {
            "id": 7,
            "name": "Debark City Administration",
            "nameamh": "ደባርቅ ከተማ አስተዳደር"
        },
        {
            "id": 8,
            "name": "Dabat City Administration",
            "nameamh": "ዳባት ከተማ አስተዳደር"
        }
    ],
    "26": [
        {
            "id": 1,
            "name": "Menz Gera Midere",
            "nameamh": "መንዝ ጌራ ምድር"
        },
        {
            "id": 2,
            "name": "Mida Woremo",
            "nameamh": "ሚዳ ወረሞ"
        },
        {
            "id": 3,
            "name": "Antsokiyana Gemza",
            "nameamh": "አንጾኪያና ገምዛ"
        },
        {
            "id": 4,
            "name": "Mojana Wadera",
            "nameamh": "ሞጃና ዋደራ"
        },
        {
            "id": 5,
            "name": "Hagere Mariamna Kesem",
            "nameamh": "ሀገረ ማርያምናከሰም"
        },
        {
            "id": 6,
            "name": "Debre Birhan",
            "nameamh": "ደብረ ብርሃን"
        },
        {
            "id": 7,
            "name": "Merhabetie",
            "nameamh": "መርሐቤቴ"
        },
        {
            "id": 8,
            "name": "Geshe",
            "nameamh": "ጌሸ"
        },
        {
            "id": 9,
            "name": "Efratana Gidim",
            "nameamh": "ኤፍራታና ግድም"
        },
        {
            "id": 10,
            "name": "Menz Mama Midir",
            "nameamh": "መንዝ ማማ ምድር"
        },
        {
            "id": 11,
            "name": "Termaber",
            "nameamh": "ጣርማበር"
        },
        {
            "id": 12,
            "name": "Kewet",
            "nameamh": "ቀወት"
        },
        {
            "id": 13,
            "name": "Angolallana Tera",
            "nameamh": "አንጎለላና ጠራ"
        },
        {
            "id": 14,
            "name": "Asagirt",
            "nameamh": "አሳግርት"
        },
        {
            "id": 15,
            "name": "Berehet",
            "nameamh": "በረኸት"
        },
        {
            "id": 16,
            "name": "Ankober",
            "nameamh": "አንኮበር"
        },
        {
            "id": 17,
            "name": "Menjarna Shenkora",
            "nameamh": "ምንጃርና ሸንኮራ"
        },
        {
            "id": 18,
            "name": "Basona Werana",
            "nameamh": "ባሶና ወራና"
        },
        {
            "id": 19,
            "name": "Menz Keya Gebreal",
            "nameamh": "መንዝ ቀዬ ገብርኤል"
        },
        {
            "id": 20,
            "name": "Menz Lalo Midir",
            "nameamh": "መንዝ ላሎ ምድር"
        },
        {
            "id": 21,
            "name": "Siya Debrina Wayu",
            "nameamh": "ሲያ ደብርና ዋዩ"
        },
        {
            "id": 22,
            "name": "Moretna Jiru",
            "nameamh": "ሞረትና ጅሩ"
        },
        {
            "id": 23,
            "name": "Ensaro",
            "nameamh": "እንሳሮ"
        },
        {
            "id": 24,
            "name": "Shewarobit",
            "nameamh": "ሸዋ ሮቢት"
        },
        {
            "id": 25,
            "name": "Ataye Town Administration",
            "nameamh": "አጣዬ ከተማ አስተዳደር"
        },
        {
            "id": 26,
            "name": "Mehalmeda",
            "nameamh": "መሃል ሜዳ"
        },
        {
            "id": 27,
            "name": "Alemketema Town Adminstration",
            "nameamh": "አለምከተማ ከተማ አስተዳደር"
        }
    ],
    "27": [
        {
            "id": 1,
            "name": "Bugna",
            "nameamh": "ቡኛ"
        },
        {
            "id": 2,
            "name": "Woldiya City Administration",
            "nameamh": "ወልድያ ከተማ አስተዳደር"
        },
        {
            "id": 3,
            "name": "Kobo City",
            "nameamh": "ቆቦ ከተማ"
        },
        {
            "id": 4,
            "name": "Gidan",
            "nameamh": "ግዳን"
        },
        {
            "id": 5,
            "name": "Meqet",
            "nameamh": "መቄት"
        },
        {
            "id": 6,
            "name": "Wadila",
            "nameamh": "ዋድላ"
        },
        {
            "id": 7,
            "name": "Lasta",
            "nameamh": "ላስታ"
        },
        {
            "id": 8,
            "name": "Dawunt",
            "nameamh": "ዳውንት"
        },
        {
            "id": 9,
            "name": "Raya Kobo",
            "nameamh": "ራያ ቆቦ"
        },
        {
            "id": 10,
            "name": "Raya-Bala",
            "nameamh": "ራያ ባላ"
        },
        {
            "id": 11,
            "name": "Raya-Alamata",
            "nameamh": "ራያ አላማጣ"
        },
        {
            "id": 12,
            "name": "Mersa City Administration",
            "nameamh": "መርሳ ከተማ አስተዳደር"
        },
        {
            "id": 13,
            "name": "Gubalafto",
            "nameamh": "ጉባ ላፍቶ"
        },
        {
            "id": 14,
            "name": "Habiru",
            "nameamh": "ሃቢሩ"
        },
        {
            "id": 15,
            "name": "Gazo",
            "nameamh": "ጋዞ"
        },
        {
            "id": 16,
            "name": "Angot",
            "nameamh": "አንጎት"
        },
        {
            "id": 17,
            "name": "Lalibela City Administration",
            "nameamh": "ላሊበላ ከተማ አስተዳደር"
        }
    ],
    "28": [
        {
            "id": 1,
            "name": "Dawa Chefe",
            "nameamh": "ዳዋ ጨፌ"
        },
        {
            "id": 2,
            "name": "Dawa Harewa",
            "nameamh": "ዳዋ ሀረዋ"
        },
        {
            "id": 3,
            "name": "Jile Timuga",
            "nameamh": "ጂሌ ጥሙጋ"
        },
        {
            "id": 4,
            "name": "Kemisse",
            "nameamh": "ከሚሴ"
        },
        {
            "id": 5,
            "name": "Artuma Fursi",
            "nameamh": "አርቱማ ፉርሲ"
        },
        {
            "id": 6,
            "name": "Bati",
            "nameamh": "ባቲ"
        },
        {
            "id": 7,
            "name": "Bati City Administration",
            "nameamh": "ባቲ ከተማ አስተዳደር"
        }
    ],
    "29": [
        {
            "id": 1,
            "name": "Libokemekem",
            "nameamh": "ሊቦከመከም"
        },
        {
            "id": 2,
            "name": "Ebinat",
            "nameamh": "እብነት"
        },
        {
            "id": 3,
            "name": "Fogera",
            "nameamh": "ፎገራ"
        },
        {
            "id": 4,
            "name": "Simada",
            "nameamh": "ስማዳ"
        },
        {
            "id": 5,
            "name": "Lay Gayint",
            "nameamh": "ላይ ጋይንት"
        },
        {
            "id": 6,
            "name": "Farta",
            "nameamh": "ፋርታ"
        },
        {
            "id": 7,
            "name": "Tach Gayint",
            "nameamh": "ታች ጋይንት"
        },
        {
            "id": 8,
            "name": "Dera",
            "nameamh": "ደራ"
        },
        {
            "id": 9,
            "name": "Estie",
            "nameamh": "እስቴ"
        },
        {
            "id": 10,
            "name": "Debre Tabor",
            "nameamh": "ደብረታቦር"
        },
        {
            "id": 11,
            "name": "Guna Begie Midir",
            "nameamh": "ጉና በጌ ምድር"
        },
        {
            "id": 12,
            "name": "Addis Zemen",
            "nameamh": "አዲስ ዘመን"
        },
        {
            "id": 13,
            "name": "Wereta",
            "nameamh": "ወረታ"
        },
        {
            "id": 14,
            "name": "Andabet",
            "nameamh": "አንዳቤት"
        },
        {
            "id": 15,
            "name": "Meketewa",
            "nameamh": "መከታዋ"
        },
        {
            "id": 16,
            "name": "Nifas Mewcha",
            "nameamh": "ንፋስ መውጫ"
        },
        {
            "id": 17,
            "name": "Sedie Muja",
            "nameamh": "ሰዲ ሙጃ"
        },
        {
            "id": 18,
            "name": "Mekane Eyesus",
            "nameamh": "መካነ እየሱስ"
        }
    ],
    "30": [
        {
            "id": 1,
            "name": "Delanta",
            "nameamh": "ደላንታ"
        },
        {
            "id": 2,
            "name": "Around Dese",
            "nameamh": "ደሴ ዙርያ"
        },
        {
            "id": 3,
            "name": "Ambassel",
            "nameamh": "አምባሰል"
        },
        {
            "id": 4,
            "name": "Mekdela",
            "nameamh": "መቅደላ"
        },
        {
            "id": 5,
            "name": "Teneta",
            "nameamh": "ተንታ"
        },
        {
            "id": 6,
            "name": "Kutaber",
            "nameamh": "ኩታበር"
        },
        {
            "id": 7,
            "name": "Tehuledere",
            "nameamh": "ተሁለደሬ"
        },
        {
            "id": 8,
            "name": "Kalu",
            "nameamh": "ቃሉ"
        },
        {
            "id": 9,
            "name": "Albuko",
            "nameamh": "አልቡኮ"
        },
        {
            "id": 10,
            "name": "Legambo",
            "nameamh": "ለጋምቦ"
        },
        {
            "id": 11,
            "name": "Saynt Adjibar",
            "nameamh": "ሳይንት አጂባር"
        },
        {
            "id": 12,
            "name": "Kelala",
            "nameamh": "ኬላላ"
        },
        {
            "id": 13,
            "name": "Jama",
            "nameamh": "ጃማ"
        },
        {
            "id": 14,
            "name": "Wereilu",
            "nameamh": "ወረ ኢሉ"
        },
        {
            "id": 15,
            "name": "Wegde",
            "nameamh": "ወግዴ"
        },
        {
            "id": 16,
            "name": "Mehal Sayint",
            "nameamh": "መሐል ሳይንት"
        },
        {
            "id": 17,
            "name": "Legahida",
            "nameamh": "ለጋሂዳ"
        },
        {
            "id": 18,
            "name": "Werebabo",
            "nameamh": "ወረባቦ"
        },
        {
            "id": 19,
            "name": "Borena",
            "nameamh": "ቦረና"
        },
        {
            "id": 20,
            "name": "Kombolcha City Administration",
            "nameamh": "ኮምቦልቻ ከተማ አስተዳደር"
        },
        {
            "id": 21,
            "name": "Mekane Selam City Administration",
            "nameamh": "መካነ ሰላም ከተማ አስተዳደር"
        },
        {
            "id": 22,
            "name": "Haik",
            "nameamh": "ሃይቅ"
        },
        {
            "id": 23,
            "name": "Wereilu City Administration",
            "nameamh": "ወረኢሉ ከተማ አስተዳደር"
        }
    ],
    "31": [
        {
            "id": 1,
            "name": "Quara",
            "nameamh": "ቋራ"
        },
        {
            "id": 2,
            "name": "Gendewuha City",
            "nameamh": "ገንደውሃ ከተማ"
        },
        {
            "id": 3,
            "name": "Metema Yohannes City Administration",
            "nameamh": "መተማ ዮሐንስ ከተማ አስተዳደር"
        },
        {
            "id": 4,
            "name": "Merab Armachiho",
            "nameamh": "ምዕራብ አርማጨሆ"
        },
        {
            "id": 5,
            "name": "Metema",
            "nameamh": "መተማ"
        },
        {
            "id": 6,
            "name": "Midre Genet City Administration",
            "nameamh": "ምድረ ገነት ከተማ አስተዳደር"
        }
    ],
    "32": [
        {
            "id": 1,
            "name": "Semen Achefer",
            "nameamh": "ሰሜን አቸፈር"
        },
        {
            "id": 2,
            "name": "Dega Damot",
            "nameamh": "ደጋ ዳሞት"
        },
        {
            "id": 3,
            "name": "Debub Achefer",
            "nameamh": "ደቡብ አቸፈር"
        },
        {
            "id": 4,
            "name": "Wemberma",
            "nameamh": "ወምበርማ"
        },
        {
            "id": 5,
            "name": "Around Bahir Dar",
            "nameamh": "ባህርዳር ዙሪያ"
        },
        {
            "id": 6,
            "name": "Yilmana Densa",
            "nameamh": "ይልማና ደንሳ"
        },
        {
            "id": 7,
            "name": "Semen Mecha",
            "nameamh": "ሰሜን ሜቻ"
        },
        {
            "id": 8,
            "name": "Sekela",
            "nameamh": "ሰከላ"
        },
        {
            "id": 9,
            "name": "Kuarit",
            "nameamh": "ቋሪት"
        },
        {
            "id": 10,
            "name": "Dembecha",
            "nameamh": "ደምበጫ"
        },
        {
            "id": 11,
            "name": "Jabi Tehnan",
            "nameamh": "ጃቢ ተህናን"
        },
        {
            "id": 12,
            "name": "Around Burie",
            "nameamh": "ቡሬ ዙሪያ"
        },
        {
            "id": 13,
            "name": "Gonje Kolela",
            "nameamh": "ጎንጅ ቆለላ"
        },
        {
            "id": 14,
            "name": "Finote Selam City Administration",
            "nameamh": "ፍኖተ ሰላም ከተማ አስተዳደር"
        },
        {
            "id": 15,
            "name": "Debub Mecha",
            "nameamh": "ደቡብ ሜቻ"
        },
        {
            "id": 16,
            "name": "Adet Town Administration",
            "nameamh": "አዴት ከተማ አስተዳደር"
        },
        {
            "id": 17,
            "name": "Burie City Administration",
            "nameamh": "ቡሬ ከተማ አስተዳደር"
        },
        {
            "id": 18,
            "name": "Merawi City Administration",
            "nameamh": "መራዊ ከተማ አስተዳደር"
        },
        {
            "id": 19,
            "name": "Dembecha City Administration",
            "nameamh": "ደምበጫ ከተማ አስተዳደር"
        }
    ],
    "33": [
        {
            "id": 1,
            "name": "Zikuala",
            "nameamh": "ዝቋላ"
        },
        {
            "id": 2,
            "name": "Abergele",
            "nameamh": "አበርገሌ"
        },
        {
            "id": 3,
            "name": "Around Sokota",
            "nameamh": "ሰቆጣ ዙርያ"
        },
        {
            "id": 4,
            "name": "Dehana",
            "nameamh": "ደሃና"
        },
        {
            "id": 5,
            "name": "Gazgibla",
            "nameamh": "ጋዝጊብላ"
        },
        {
            "id": 6,
            "name": "Sehala Seyemt",
            "nameamh": "ስሃላ ሰየምት"
        },
        {
            "id": 7,
            "name": "Sekota City Administration",
            "nameamh": "ሰቆጣ ከተማ አስተዳደር"
        },
        {
            "id": 8,
            "name": "Tsagibji",
            "nameamh": "ፃግብጂ"
        }
    ],
    "34": [
        {
            "id": 1,
            "name": "Bambasi",
            "nameamh": "ባምባሲ"
        },
        {
            "id": 2,
            "name": "Assosa",
            "nameamh": "አሶሳ"
        },
        {
            "id": 3,
            "name": "Horazab",
            "nameamh": "ሆራዛብ"
        },
        {
            "id": 4,
            "name": "Menge",
            "nameamh": "መንጌ"
        },
        {
            "id": 5,
            "name": "Oda Bildigilu",
            "nameamh": "ኦዳ ቢልዲጊሉ"
        },
        {
            "id": 6,
            "name": "Sherkole",
            "nameamh": "ሸርኮል"
        },
        {
            "id": 7,
            "name": "Kurmuk",
            "nameamh": "ኩርሙክ"
        },
        {
            "id": 8,
            "name": "Homosha",
            "nameamh": "ሆሞሻ"
        },
        {
            "id": 9,
            "name": "Wereda And",
            "nameamh": "ወረዳ አንድ"
        },
        {
            "id": 10,
            "name": "Wereda Hulet",
            "nameamh": "ወረዳ ሁለት"
        }
    ],
    "35": [
        {
            "id": 1,
            "name": "Mao Ena Komo",
            "nameamh": "ማኦ እና ኮሞ"
        }
    ],
    "36": [
        {
            "id": 1,
            "name": "Agalo Mite",
            "nameamh": "አጋሎ ሚቴ"
        },
        {
            "id": 2,
            "name": "Kamashi",
            "nameamh": "ካማሺ"
        },
        {
            "id": 3,
            "name": "Belo Jegonfoy",
            "nameamh": "ቤሎ ጀጎንፎይ"
        },
        {
            "id": 4,
            "name": "Sadal",
            "nameamh": "ሳዳል"
        },
        {
            "id": 5,
            "name": "Yasso",
            "nameamh": "ያሶ"
        }
    ],
    "37": [
        {
            "id": 1,
            "name": "Mandura",
            "nameamh": "ማንዱራ"
        },
        {
            "id": 2,
            "name": "Guba",
            "nameamh": "ጉባ"
        },
        {
            "id": 3,
            "name": "Bulen",
            "nameamh": "ቡለን"
        },
        {
            "id": 4,
            "name": "Wenbera",
            "nameamh": "ወንበራ"
        },
        {
            "id": 5,
            "name": "Dibate",
            "nameamh": "ዲባቴ"
        },
        {
            "id": 6,
            "name": "Dangur",
            "nameamh": "ዳንጉር"
        },
        {
            "id": 7,
            "name": "Pawe",
            "nameamh": "ፓዌ"
        }
    ],
    "38": [
        {
            "id": 1,
            "name": "Welkite City Administration",
            "nameamh": "ወልቂጤ ከተማ አስተዳደ"
        },
        {
            "id": 2,
            "name": "Enor Ener Meger",
            "nameamh": "እኖር ኤነር መገር"
        },
        {
            "id": 3,
            "name": "Gumer",
            "nameamh": "ጉመር"
        },
        {
            "id": 4,
            "name": "Emdebir City Administration",
            "nameamh": "እምድብር ከተማ አስተዳደር"
        },
        {
            "id": 5,
            "name": "Endegagn",
            "nameamh": "እንደጋኝ"
        },
        {
            "id": 6,
            "name": "Cheha",
            "nameamh": "ቸሃ"
        },
        {
            "id": 7,
            "name": "Arekit City Administartion",
            "nameamh": "አረቅጥ ከተማ አስተዳደር"
        },
        {
            "id": 8,
            "name": "Enor",
            "nameamh": "እኖር"
        },
        {
            "id": 9,
            "name": "Muhurna Aklil",
            "nameamh": "ሙሁርና አክሊል"
        },
        {
            "id": 10,
            "name": "Abeshege",
            "nameamh": "አበሽጌ"
        },
        {
            "id": 11,
            "name": "Gedebano Gutazer Welene",
            "nameamh": "ገደባኖ ጉታዘር ወለኔ"
        },
        {
            "id": 12,
            "name": "Agena City Administration",
            "nameamh": "አገና ከተማ አስተዳደር"
        },
        {
            "id": 13,
            "name": "Geta",
            "nameamh": "ጌታ"
        },
        {
            "id": 14,
            "name": "Ezja",
            "nameamh": "እዣ"
        },
        {
            "id": 15,
            "name": "Gunchere City Administration",
            "nameamh": "ጉንችሬ ከተማ አስተዳደር"
        }
    ],
    "39": [
        {
            "id": 1,
            "name": "Misha",
            "nameamh": "ሚሻ"
        },
        {
            "id": 2,
            "name": "Mierab Soro",
            "nameamh": "ምዕራብ ሶሮ"
        },
        {
            "id": 3,
            "name": "Mierab Badawacho",
            "nameamh": "ምዕራብ ባዳዋቾ"
        },
        {
            "id": 4,
            "name": "Gimbichu Town Administration",
            "nameamh": "ጊምቢቹ ከተማ አስተዳደር"
        },
        {
            "id": 5,
            "name": "Soro",
            "nameamh": "ሶሮ"
        },
        {
            "id": 6,
            "name": "Misrak Badewacho",
            "nameamh": "ምስራቅ ባደዋቾ"
        },
        {
            "id": 7,
            "name": "Lemo",
            "nameamh": "ሌሞ"
        },
        {
            "id": 8,
            "name": "Shone  Town Administration",
            "nameamh": "ሾኔ ከተማ አስተዳደር"
        },
        {
            "id": 9,
            "name": "Anlemo",
            "nameamh": "አንሌሞ"
        },
        {
            "id": 10,
            "name": "Ameka",
            "nameamh": "አመካ"
        },
        {
            "id": 11,
            "name": "Jajura Town Administartion",
            "nameamh": "ጃጁራ ከተማ አስተዳደር"
        },
        {
            "id": 12,
            "name": "Mierab Soro Town Administration",
            "nameamh": "ምእራብ ሶሮ ከተማ አስተዳደር"
        },
        {
            "id": 13,
            "name": "Hossana Town Administration",
            "nameamh": "ሆሳዕና ከተማ አስተዳደር"
        },
        {
            "id": 14,
            "name": "Duna",
            "nameamh": "ዱና"
        },
        {
            "id": 15,
            "name": "Fonko Town Administration",
            "nameamh": "ፎንቆ ከተማ አስተዳደር"
        },
        {
            "id": 16,
            "name": "Homecho Town Administration",
            "nameamh": "ሆመቾ ከተማ አስተዳደር"
        },
        {
            "id": 17,
            "name": "Gibe",
            "nameamh": "ጊቤ"
        },
        {
            "id": 18,
            "name": "Shashogo",
            "nameamh": "ሻሾጎ"
        },
        {
            "id": 19,
            "name": "Gombora",
            "nameamh": "ጎምቦራ"
        },
        {
            "id": 20,
            "name": "Bonnosha Town Administration",
            "nameamh": "ቦኖሻ ከተማ አስተዳደር"
        }
    ],
    "40": [
        {
            "id": 1,
            "name": "Atoti Ulo",
            "nameamh": "አቶቲ ኡሎ"
        },
        {
            "id": 2,
            "name": "Qulito City Administration",
            "nameamh": "ቁሊቶ ከተማ አስተዳደር"
        },
        {
            "id": 3,
            "name": "Wera Zuriya",
            "nameamh": "ዌራ ዙሪያ"
        },
        {
            "id": 4,
            "name": "Wera Dijo",
            "nameamh": "ዌራ ዲጆ"
        }
    ],
    "41": [
        {
            "id": 1,
            "name": "Angacha",
            "nameamh": "አንጋቻ"
        },
        {
            "id": 2,
            "name": "Hadero Tunto",
            "nameamh": "ሓድሮ ቱንቶ"
        },
        {
            "id": 3,
            "name": "Adilo",
            "nameamh": "አዲሎ"
        },
        {
            "id": 4,
            "name": "Qedida Gamela",
            "nameamh": "ቀዲዳ ጋሜላ"
        },
        {
            "id": 5,
            "name": "Damboya",
            "nameamh": "ዳምቦያ"
        },
        {
            "id": 6,
            "name": "Shinshicho City Administartion",
            "nameamh": "ሺንሺቾ ከተማ አስተዳደር"
        },
        {
            "id": 7,
            "name": "Qacha Bira",
            "nameamh": "ቃጫ ቢራ"
        },
        {
            "id": 8,
            "name": "Angacha City Administration",
            "nameamh": "አንጋጫ ከተማ አስተዳደር"
        },
        {
            "id": 9,
            "name": "Hadero City Administration",
            "nameamh": "ሀደሮ ከተማ አስተዳደር"
        },
        {
            "id": 10,
            "name": "Denboya City Administration",
            "nameamh": "ደንቦያ ከተማ አስተዳደር"
        },
        {
            "id": 11,
            "name": "Doyogena",
            "nameamh": "ዶዮጌና"
        },
        {
            "id": 12,
            "name": "Durame City Adminstration",
            "nameamh": "ዱራሜ ከተማ አስተዳዳር"
        },
        {
            "id": 13,
            "name": "Mudula City Administration",
            "nameamh": "ሙዱላ ከተማ አስተዳደር"
        },
        {
            "id": 14,
            "name": "Doyogena City Administration",
            "nameamh": "ዶዮገና ከተማ አስተዳደር"
        }
    ],
    "42": [
        {
            "id": 1,
            "name": "Mareqo Special Wereda",
            "nameamh": "ማረቆ ልዩ ወረዳ"
        }
    ],
    "43": [
        {
            "id": 1,
            "name": "Buee Town Administration",
            "nameamh": "ቡኢ ከተማ አስተዳደር"
        },
        {
            "id": 2,
            "name": "Butajira Town Administration",
            "nameamh": "ቡታጅራ  ከተማ አስተዳደር"
        },
        {
            "id": 3,
            "name": "Meskane",
            "nameamh": "መስቃን"
        },
        {
            "id": 4,
            "name": "South Sodo",
            "nameamh": "ደቡብ ሶዶ"
        },
        {
            "id": 5,
            "name": "Enseno Town Administration",
            "nameamh": "ኢንሴኖ ከተማ አስተዳደር"
        },
        {
            "id": 6,
            "name": "Misrak Meskan",
            "nameamh": "ምስራቅ መስቃን"
        },
        {
            "id": 7,
            "name": "Sodo",
            "nameamh": "ሶዶ"
        }
    ],
    "44": [
        {
            "id": 1,
            "name": "Qebena Special Wereda",
            "nameamh": "ቀበና ልዩ ወረዳ"
        }
    ],
    "45": [
        {
            "id": 1,
            "name": "Tora City Administration",
            "nameamh": "ጦራ ከተማ አስተዳደር"
        },
        {
            "id": 2,
            "name": "Alicho weriro",
            "nameamh": "አሊቾ ወሪሮ"
        },
        {
            "id": 3,
            "name": "Sankura",
            "nameamh": "ሳንኩራ"
        },
        {
            "id": 4,
            "name": "Lanfro",
            "nameamh": "ላንፍሮ"
        },
        {
            "id": 5,
            "name": "Hulbereg",
            "nameamh": "ሁልባረግ"
        },
        {
            "id": 6,
            "name": "Mierab Azernet",
            "nameamh": "ምእራብ አዘርነት"
        },
        {
            "id": 7,
            "name": "Dalocha City Administration",
            "nameamh": "ዳሎቻ ከተማ አስተዳደር"
        },
        {
            "id": 8,
            "name": "Mito",
            "nameamh": "ሚቶ"
        },
        {
            "id": 9,
            "name": "Alem Gebeya City Administration",
            "nameamh": "አለም ገበያ ከተማ አስተዳደ"
        },
        {
            "id": 10,
            "name": "Misrak Azernet",
            "nameamh": "ምስራቅ አዘርነት"
        },
        {
            "id": 11,
            "name": "Werabe City Administration",
            "nameamh": "ወራቤ ከተማ አስተዳደር"
        },
        {
            "id": 12,
            "name": "Dalocha",
            "nameamh": "ዳሎቻ "
        },
        {
            "id": 13,
            "name": "Misrak Silti",
            "nameamh": "ምስራቅ ስልጢ"
        },
        {
            "id": 14,
            "name": "Kibet City Administration",
            "nameamh": "ቅበት ከተማ አስተዳደር"
        },
        {
            "id": 15,
            "name": "Silti",
            "nameamh": "ስልጢ "
        }
    ],
    "46": [
        {
            "id": 1,
            "name": "Mudula Town Administration",
            "nameamh": "ሙዱላ ከተማ አስተዳደር"
        }
    ],
    "47": [
        {
            "id": 1,
            "name": "Saja City Administration",
            "nameamh": "ሳጃ ከተማ አስተዳደር"
        },
        {
            "id": 2,
            "name": "Deri Saja",
            "nameamh": "ደሪ ሳጃ ዙሪያ"
        },
        {
            "id": 3,
            "name": "Fofa",
            "nameamh": "ፎፋ"
        },
        {
            "id": 4,
            "name": "Toba",
            "nameamh": "ቶባ"
        }
    ],
    "48": [
        {
            "id": 1,
            "name": "Dire Dawa Administration",
            "nameamh": "ድሬዳዋ አስተዳደር"
        }
    ],
    "49": [
        {
            "id": 1,
            "name": "ABOBO",
            "nameamh": "አቦቦ"
        },
        {
            "id": 2,
            "name": "GAMBELA",
            "nameamh": "ጋምቤላ"
        },
        {
            "id": 3,
            "name": "GOG",
            "nameamh": "ጎግ"
        },
        {
            "id": 4,
            "name": "Jor",
            "nameamh": "ጆር"
        },
        {
            "id": 5,
            "name": "DIMA",
            "nameamh": "ዲማ"
        }
    ],
    "50": [
        {
            "id": 1,
            "name": "ETANG Special Woreda",
            "nameamh": "ኢታንግ ልዩ ወረዳ"
        }
    ],
    "51": [
        {
            "id": 1,
            "name": "GAMBELLA TOWN ADMIN",
            "nameamh": "ጋምቤላ ከተማ አስተዳደር"
        }
    ],
    "52": [
        {
            "id": 1,
            "name": "GODERE",
            "nameamh": "ጎደሬ"
        },
        {
            "id": 2,
            "name": "MENGESH",
            "nameamh": "መንገሺ"
        }
    ],
    "53": [
        {
            "id": 1,
            "name": "JIKAWO",
            "nameamh": "ጂካዎ"
        },
        {
            "id": 2,
            "name": "LARE",
            "nameamh": "ላሬ"
        },
        {
            "id": 3,
            "name": "AKOBO",
            "nameamh": "አኮቦ"
        },
        {
            "id": 4,
            "name": "Wantuar",
            "nameamh": "ዋንቱዋረ"
        },
        {
            "id": 5,
            "name": "MAKUEY",
            "nameamh": "ማኳይ"
        }
    ],
    "54": [
        {
            "id": 1,
            "name": "Amir-Nur Woreda",
            "nameamh": "አሚር-ኑር ወረዳ"
        },
        {
            "id": 2,
            "name": "Abadir Woreda",
            "nameamh": "አባድር ወረዳ"
        },
        {
            "id": 3,
            "name": "Shenkor Woreda",
            "nameamh": "ሸንኮር ወረዳ"
        },
        {
            "id": 4,
            "name": "Jinela Woreda",
            "nameamh": "ጅኔላ ወረዳ"
        },
        {
            "id": 5,
            "name": "Aboker Woreda",
            "nameamh": "አቦከር ወረዳ"
        },
        {
            "id": 6,
            "name": "Hakim Woreda",
            "nameamh": "ሀኪም ወረዳ"
        },
        {
            "id": 7,
            "name": "Sofi Woreda",
            "nameamh": "ሶፊ ወረዳ"
        },
        {
            "id": 8,
            "name": "Errer Woreda",
            "nameamh": "ኤረር ወረዳ"
        },
        {
            "id": 9,
            "name": "Dire-Teyara Woreda",
            "nameamh": "ድሬ-ተያራ ወረዳ"
        }
    ],
    "55": [
        {
            "id": 1,
            "name": "Awaro Kora",
            "nameamh": "አዋሮ ቆራ"
        },
        {
            "id": 2,
            "name": "Hora Ayetu",
            "nameamh": "ሆራ አየቱ"
        },
        {
            "id": 3,
            "name": "Kisose Odo Liben",
            "nameamh": "ኪሶሴ ኦዶ ሊባን"
        },
        {
            "id": 4,
            "name": "Senkele Farisi",
            "nameamh": "ሰንቃሌ ፋርሲ"
        },
        {
            "id": 5,
            "name": "Torben Kutaye",
            "nameamh": "ቶርበን ኩታዬ"
        },
        {
            "id": 6,
            "name": "Yahi Geda",
            "nameamh": "ያኢ ገዳ"
        }
    ],
    "56": [
        {
            "id": 1,
            "name": "Burkitu",
            "nameamh": "ቡርቂቱ"
        },
        {
            "id": 2,
            "name": "Buseta",
            "nameamh": "ቡሰታ"
        },
        {
            "id": 3,
            "name": "Chilalo",
            "nameamh": "ጭላሎ"
        },
        {
            "id": 4,
            "name": "Hunde Gudina",
            "nameamh": "ሁንዴ ጉዲና"
        },
        {
            "id": 5,
            "name": "Helila",
            "nameamh": "ሀሊላ"
        },
        {
            "id": 6,
            "name": "Hanku",
            "nameamh": "ሃንቁ"
        },
        {
            "id": 7,
            "name": "Kombolcha ",
            "nameamh": "ኮምቦልቻ"
        },
        {
            "id": 8,
            "name": "Welkesa",
            "nameamh": "ወልኬሳ"
        }
    ],
    "57": [
        {
            "id": 1,
            "name": "Badatu",
            "nameamh": "ባዳቱ"
        },
        {
            "id": 2,
            "name": "Buta",
            "nameamh": "ቡታ"
        },
        {
            "id": 3,
            "name": "Degaga",
            "nameamh": "ደጋጋ"
        },
        {
            "id": 4,
            "name": "Oda",
            "nameamh": "ኦዳ"
        }
    ],
    "58": [
        {
            "id": 1,
            "name": "Dadacha Arara",
            "nameamh": "ዳዳቻ አራራ"
        },
        {
            "id": 2,
            "name": "Daka Adi",
            "nameamh": "ደካ አዲ"
        },
        {
            "id": 3,
            "name": "Goro",
            "nameamh": "ጎሮ"
        }
    ],
    "59": [
        {
            "id": 1,
            "name": "Awash Malka Saha",
            "nameamh": "አዋሽ መልካ ሰኣ"
        },
        {
            "id": 2,
            "name": "Aroreti",
            "nameamh": "አሮሬቲ"
        },
        {
            "id": 3,
            "name": "Torban Obo",
            "nameamh": "ቶርባን ኦቦ"
        }
    ],
    "60": [
        {
            "id": 1,
            "name": "Angatu",
            "nameamh": "አንጋቱ"
        },
        {
            "id": 2,
            "name": "Chafe",
            "nameamh": "ጨፌ"
        },
        {
            "id": 3,
            "name": "Soloke Dongore",
            "nameamh": "ሶሎቄ ዶንጎሬ"
        }
    ],
    "61": [
        {
            "id": 1,
            "name": "Erecha",
            "nameamh": "ኢሬቻ"
        },
        {
            "id": 2,
            "name": "Malka Adama",
            "nameamh": "መልካ አዳማ"
        },
        {
            "id": 3,
            "name": "Wanji",
            "nameamh": "ወንጂ"
        }
    ],
    "62": [
        {
            "id": 1,
            "name": "Barecha",
            "nameamh": "በሬቻ"
        },
        {
            "id": 2,
            "name": "Dire Naga",
            "nameamh": "ድሬ ነጋ"
        },
        {
            "id": 3,
            "name": "Migira",
            "nameamh": "ሚግራ"
        }
    ],
    "63": [
        {
            "id": 1,
            "name": "Biftu Balto",
            "nameamh": "ቢፍቱ ባለቶ"
        },
        {
            "id": 2,
            "name": "Beke Agelo",
            "nameamh": "በኬ አገሎ"
        },
        {
            "id": 3,
            "name": "Chelo Bulado",
            "nameamh": "Ûሎ ቡላዶ"
        },
        {
            "id": 4,
            "name": "Mesera Ababoka",
            "nameamh": "መሰራ አባቦቃ"
        },
        {
            "id": 5,
            "name": "Temsa Jida",
            "nameamh": "ተምሳ ጂዳ "
        }
    ],
    "64": [
        {
            "id": 1,
            "name": "Amigna",
            "nameamh": "አሚኛ"
        },
        {
            "id": 2,
            "name": "Aseko",
            "nameamh": "አሰኮ"
        },
        {
            "id": 3,
            "name": "Asela Town",
            "nameamh": "አሰላ ከተማ"
        },
        {
            "id": 4,
            "name": "Bokoji City Administration",
            "nameamh": "ቦቆጂ ከተማ አስተዳደር"
        },
        {
            "id": 5,
            "name": "Bele Gesgar",
            "nameamh": "በሌ ገሰጋር"
        },
        {
            "id": 6,
            "name": "Chole",
            "nameamh": "ጮሌ"
        },
        {
            "id": 7,
            "name": "Dodota",
            "nameamh": "ዶዶታ"
        },
        {
            "id": 8,
            "name": "Digeluna Tijo",
            "nameamh": "ዲገሉና ጢጆ"
        },
        {
            "id": 9,
            "name": "Dera City Administration",
            "nameamh": "ዴራ ከተማ አስተዳደር"
        },
        {
            "id": 10,
            "name": "Diksis",
            "nameamh": "ዲክሲስ"
        },
        {
            "id": 11,
            "name": "Gololcha",
            "nameamh": "ጎሎልቻ"
        },
        {
            "id": 12,
            "name": "Guna",
            "nameamh": "ጉና"
        },
        {
            "id": 13,
            "name": "Huruta City Administration",
            "nameamh": "ሁሩታ ከተማ አስተዳደር"
        },
        {
            "id": 14,
            "name": "Hetosa",
            "nameamh": "ሄጦሳ"
        },
        {
            "id": 15,
            "name": "Inkolo Wabe",
            "nameamh": "እንቆሎ ዋቤ"
        },
        {
            "id": 16,
            "name": "Jeju",
            "nameamh": "ጀጁ"
        },
        {
            "id": 17,
            "name": "Lode Hetosa",
            "nameamh": "ሎዴ ሄጦሳ"
        },
        {
            "id": 18,
            "name": "Lemuna Bilbilo",
            "nameamh": "ሌሙና ቢልቢሎ"
        },
        {
            "id": 19,
            "name": "Munesa",
            "nameamh": "ሙኔሳ"
        },
        {
            "id": 20,
            "name": "Merti",
            "nameamh": "መርቲ"
        },
        {
            "id": 21,
            "name": "Robe",
            "nameamh": "ሮቤ"
        },
        {
            "id": 22,
            "name": "Sude",
            "nameamh": "ሱዴ"
        },
        {
            "id": 23,
            "name": "Shirka",
            "nameamh": "ሽርካ"
        },
        {
            "id": 24,
            "name": "Shenen Kolu",
            "nameamh": "ሸነን ኮሉ"
        },
        {
            "id": 25,
            "name": "Sire",
            "nameamh": "ስሬ"
        },
        {
            "id": 26,
            "name": "Seru",
            "nameamh": "ሴሩ"
        },
        {
            "id": 27,
            "name": "Tena",
            "nameamh": "ጠና"
        },
        {
            "id": 28,
            "name": "Tiyo",
            "nameamh": "ጢዮ"
        },
        {
            "id": 29,
            "name": "Zeway Dugda",
            "nameamh": "ዙዋይ ዱግዳ"
        }
    ],
    "65": [
        {
            "id": 1,
            "name": "Abosa",
            "nameamh": "አቦሳ"
        },
        {
            "id": 2,
            "name": "Bochesa",
            "nameamh": "ቦጬሳ    "
        },
        {
            "id": 3,
            "name": "Batale",
            "nameamh": "በተሌ"
        },
        {
            "id": 4,
            "name": "Dambal",
            "nameamh": "ደምበል"
        },
        {
            "id": 5,
            "name": "Malka Shalo",
            "nameamh": "መልካ ሻሎ"
        },
        {
            "id": 6,
            "name": "Malka Wafiko",
            "nameamh": "መልካ ዋፊቆ"
        },
        {
            "id": 7,
            "name": "Warja",
            "nameamh": "ወርጃ "
        }
    ],
    "66": [
        {
            "id": 1,
            "name": "Arsade",
            "nameamh": "አርሰዴ"
        },
        {
            "id": 2,
            "name": "Erar",
            "nameamh": "ኤረር"
        },
        {
            "id": 3,
            "name": "Kilole",
            "nameamh": "ኪሎሌ"
        }
    ],
    "67": [
        {
            "id": 1,
            "name": "Abu Sera",
            "nameamh": "አቡ ሴራ"
        },
        {
            "id": 2,
            "name": "Melka",
            "nameamh": "መልካ"
        },
        {
            "id": 3,
            "name": "Oda Nabe",
            "nameamh": "ኦዳ ነቤ"
        },
        {
            "id": 4,
            "name": "Tedecha",
            "nameamh": "ጠደቻ"
        }
    ],
    "68": [
        {
            "id": 1,
            "name": "Biftu",
            "nameamh": "ቢፍቱ"
        },
        {
            "id": 2,
            "name": "Dire",
            "nameamh": "ድሬ"
        },
        {
            "id": 3,
            "name": "Daka Bora",
            "nameamh": "ደካ ቦራ"
        },
        {
            "id": 4,
            "name": "Hora",
            "nameamh": "ሆራ "
        }
    ],
    "69": [
        {
            "id": 1,
            "name": "Arda Biya",
            "nameamh": "አርዳ ቢያ"
        },
        {
            "id": 2,
            "name": "Bule Kagna",
            "nameamh": "ቡሌ ቃኛ"
        },
        {
            "id": 3,
            "name": "Bule Kilta",
            "nameamh": "ቡሌ ቂልጣ"
        },
        {
            "id": 4,
            "name": "Ejersa Fora",
            "nameamh": "ኤጄርሰ ፎራ"
        },
        {
            "id": 5,
            "name": "Goro Abayi",
            "nameamh": "ጎሮ አባይ"
        },
        {
            "id": 6,
            "name": "Goro Gudina",
            "nameamh": "ጎሮ ጉዲና"
        },
        {
            "id": 7,
            "name": "Kacha Ya'a",
            "nameamh": "ቃቻ ያኣ"
        }
    ],
    "70": [
        {
            "id": 1,
            "name": "Agarfa",
            "nameamh": "አጋርፋ"
        },
        {
            "id": 2,
            "name": "Berbere",
            "nameamh": "በርበሬ"
        },
        {
            "id": 3,
            "name": "Delo Mena",
            "nameamh": "ዶሎ ማና"
        },
        {
            "id": 4,
            "name": "Dinsho",
            "nameamh": "ዲንሾ"
        },
        {
            "id": 5,
            "name": "Goba",
            "nameamh": "ጎባ"
        },
        {
            "id": 6,
            "name": "Gura Damole",
            "nameamh": "ጉራዳሞሌ"
        },
        {
            "id": 7,
            "name": "Goro",
            "nameamh": "ጎሮ"
        },
        {
            "id": 8,
            "name": "Gasera",
            "nameamh": "ጋሳራ"
        },
        {
            "id": 9,
            "name": "Harena Buluk",
            "nameamh": "ሀረና ቡሉቅ"
        },
        {
            "id": 10,
            "name": "Robe-Goba Town",
            "nameamh": "ሮቤ-ጎባ ከተማ"
        },
        {
            "id": 11,
            "name": "Sinana",
            "nameamh": "ሲናና"
        }
    ],
    "71": [
        {
            "id": 1,
            "name": "Bedele City Administration",
            "nameamh": "በዴሌ ከተማ አስተዳደር"
        },
        {
            "id": 2,
            "name": "Bedele Rural",
            "nameamh": "በደሌ"
        },
        {
            "id": 3,
            "name": "Borecha",
            "nameamh": "ቦርቻ"
        },
        {
            "id": 4,
            "name": "Chora",
            "nameamh": "ጮራ"
        },
        {
            "id": 5,
            "name": "Chewaka",
            "nameamh": "ጨዋቃ"
        },
        {
            "id": 6,
            "name": "Dabo Hana",
            "nameamh": "ዳቦ ሃና"
        },
        {
            "id": 7,
            "name": "Dedessa",
            "nameamh": "ደዴሳ"
        },
        {
            "id": 8,
            "name": "Dega",
            "nameamh": "ዴጋ"
        },
        {
            "id": 9,
            "name": "Gechi",
            "nameamh": "ገቺ"
        },
        {
            "id": 10,
            "name": "Mako",
            "nameamh": "መኮ"
        }
    ],
    "72": [
        {
            "id": 1,
            "name": "Dubluq",
            "nameamh": "ዱቡሉቅ"
        },
        {
            "id": 2,
            "name": "Dilloo",
            "nameamh": "ዲሎ"
        },
        {
            "id": 3,
            "name": "Dire",
            "nameamh": "ዲሬ"
        },
        {
            "id": 4,
            "name": "Elawayyee",
            "nameamh": "ኤልወዬ"
        },
        {
            "id": 5,
            "name": "Guchi",
            "nameamh": "ጉቺ"
        },
        {
            "id": 6,
            "name": "Gomole",
            "nameamh": "ጎሞሌ"
        },
        {
            "id": 7,
            "name": "Moyale",
            "nameamh": "ሞያሌ"
        },
        {
            "id": 8,
            "name": "Miyoo",
            "nameamh": "ሚዮ"
        },
        {
            "id": 9,
            "name": "Taltale",
            "nameamh": "ታልታሌ"
        },
        {
            "id": 10,
            "name": "Yabelo City Administration",
            "nameamh": "ያቤሎ ከተማ አስተዳደር"
        },
        {
            "id": 11,
            "name": "Yabelo",
            "nameamh": "ያቤሎ"
        }
    ],
    "73": [
        {
            "id": 1,
            "name": "Ane Dima",
            "nameamh": "አኔ ዲማ"
        },
        {
            "id": 2,
            "name": "Ejersa Goro",
            "nameamh": "ኤጄርሰ ጎሮ"
        },
        {
            "id": 3,
            "name": "Gefersa Burayu",
            "nameamh": "ገፈርሳ ቡራዩ"
        },
        {
            "id": 4,
            "name": "Keta",
            "nameamh": "ከታ"
        }
    ],
    "74": [
        {
            "id": 1,
            "name": "Anole",
            "nameamh": "አኖሌ"
        },
        {
            "id": 2,
            "name": "Mada Wabe",
            "nameamh": "መደ ዋቤ"
        }
    ],
    "75": [
        {
            "id": 1,
            "name": "Dawe Kachen",
            "nameamh": "ዳዌ ቃጫን"
        },
        {
            "id": 2,
            "name": "Dawe Serer",
            "nameamh": "ዳዌ ሰረር"
        },
        {
            "id": 3,
            "name": "Gololcha",
            "nameamh": "ጎሎልቻ"
        },
        {
            "id": 4,
            "name": "Ginir City Administration",
            "nameamh": "ጊኒር ከተማ አስተዳደር"
        },
        {
            "id": 5,
            "name": "Ginir Rural",
            "nameamh": "ጊንር"
        },
        {
            "id": 6,
            "name": "Lege Hida",
            "nameamh": "ለገሂዳ"
        },
        {
            "id": 7,
            "name": "Rayitu",
            "nameamh": "ራይቱ"
        },
        {
            "id": 8,
            "name": "Seweyna",
            "nameamh": "ሰዌና"
        }
    ],
    "76": [
        {
            "id": 1,
            "name": "Arero",
            "nameamh": "አሬሮ"
        },
        {
            "id": 2,
            "name": "Dhas",
            "nameamh": "ደሀስ"
        },
        {
            "id": 3,
            "name": "Gumi Eldalo",
            "nameamh": "ጉሚ ኢልዳዶ"
        },
        {
            "id": 4,
            "name": "Goro Dola",
            "nameamh": "ጎሮ ዶላ"
        },
        {
            "id": 5,
            "name": "Liben",
            "nameamh": "ሊበን"
        },
        {
            "id": 6,
            "name": "Meda Welabu",
            "nameamh": "ማዳ ዋላቡ"
        },
        {
            "id": 7,
            "name": "Nagele Borana City Administration",
            "nameamh": "ነገሌ ቦረና ከተማ አስተዳደር"
        },
        {
            "id": 8,
            "name": "Walabu Lixaa",
            "nameamh": "ወላቡ ሊጣ"
        },
        {
            "id": 9,
            "name": "Wachile",
            "nameamh": "ዋጭሌ"
        }
    ],
    "77": [
        {
            "id": 1,
            "name": "Babile City Administration",
            "nameamh": "ባቢሌ ከተማ አስተዳደር"
        },
        {
            "id": 2,
            "name": "Babile",
            "nameamh": "ባቢሌ"
        },
        {
            "id": 3,
            "name": "Bedeno",
            "nameamh": "በደኖ"
        },
        {
            "id": 4,
            "name": "Chinaksen",
            "nameamh": "ጭናክሰን"
        },
        {
            "id": 5,
            "name": "Dadar City Administration",
            "nameamh": "ደዳር ከተማ አስተዳደር"
        },
        {
            "id": 6,
            "name": "Deder",
            "nameamh": "ደደር"
        },
        {
            "id": 7,
            "name": "Fedis",
            "nameamh": "ፈዲስ"
        },
        {
            "id": 8,
            "name": "Gola Oda",
            "nameamh": "ጎለ ኦዳ"
        },
        {
            "id": 9,
            "name": "Goro Gutu",
            "nameamh": "ጎሮ ጉቱ"
        },
        {
            "id": 10,
            "name": "Goro Muti",
            "nameamh": "ጎሮ ሙጢ"
        },
        {
            "id": 11,
            "name": "Gursum",
            "nameamh": "ጉርሱም"
        },
        {
            "id": 12,
            "name": "Gurawa",
            "nameamh": "ጉራዋ"
        },
        {
            "id": 13,
            "name": "Haramaya",
            "nameamh": "ሀሮማያ"
        },
        {
            "id": 14,
            "name": "Jarso",
            "nameamh": "ጃርሶ"
        },
        {
            "id": 15,
            "name": "Kombolcha",
            "nameamh": "ኮምቦልቻ"
        },
        {
            "id": 16,
            "name": "Kumbi",
            "nameamh": "ቁምቢ"
        },
        {
            "id": 17,
            "name": "Kurfa Chele",
            "nameamh": "ኩርፋ ጨሌ"
        },
        {
            "id": 18,
            "name": "Kersa",
            "nameamh": "ቀርሳ"
        },
        {
            "id": 19,
            "name": "Midega Tola",
            "nameamh": "ሚደጋ ቶላ"
        },
        {
            "id": 20,
            "name": "Melka Belo",
            "nameamh": "መልካ በልኦ"
        },
        {
            "id": 21,
            "name": "Mekanisa Oromo",
            "nameamh": "መከኒሰ ኦሮሞ"
        },
        {
            "id": 22,
            "name": "Meta",
            "nameamh": "ሜታ"
        },
        {
            "id": 23,
            "name": "Meyu Muluke",
            "nameamh": "መዩ ሙሉቄ"
        },
        {
            "id": 24,
            "name": "Maya Town",
            "nameamh": "ማያ ከተማ"
        }
    ],
    "78": [
        {
            "id": 1,
            "name": "Ade'a",
            "nameamh": "አደኣ"
        },
        {
            "id": 2,
            "name": "Adama Rural",
            "nameamh": "አዳማ"
        },
        {
            "id": 3,
            "name": "Adama Town",
            "nameamh": "አዳማ ከተማ"
        },
        {
            "id": 4,
            "name": "Akaki",
            "nameamh": "አቃቂ"
        },
        {
            "id": 5,
            "name": "Adami T. J. Kombolcha",
            "nameamh": "አዳሚ ቱሉ ጅዶ ኮምቦልቻ"
        },
        {
            "id": 6,
            "name": "Batu Town",
            "nameamh": "ባቱ ከተማ"
        },
        {
            "id": 7,
            "name": "Bora",
            "nameamh": "ቦራ"
        },
        {
            "id": 8,
            "name": "Boset",
            "nameamh": "ቦሰት"
        },
        {
            "id": 9,
            "name": "Bishoftu Town",
            "nameamh": "ቢሾፍቱ ከተማ"
        },
        {
            "id": 10,
            "name": "Dugda",
            "nameamh": "ዱግዳ"
        },
        {
            "id": 11,
            "name": "Fentale",
            "nameamh": "ፋንታሌ"
        },
        {
            "id": 12,
            "name": "Gimbichu",
            "nameamh": "ጊምቢቹ"
        },
        {
            "id": 13,
            "name": "Liben",
            "nameamh": "ሊበን ጩቃላ"
        },
        {
            "id": 14,
            "name": "Lume",
            "nameamh": "ሉሜ"
        },
        {
            "id": 15,
            "name": "Matahara City Administration",
            "nameamh": "መተሃራ ከተማ አስተዳደር"
        },
        {
            "id": 16,
            "name": "Mojo Town",
            "nameamh": "ሞጆ ከተማ"
        },
        {
            "id": 17,
            "name": "Meki City Administration",
            "nameamh": "መቂ ከተማ አስተዳደር"
        }
    ],
    "79": [
        {
            "id": 1,
            "name": "Angar Gute City Administration",
            "nameamh": "አንገር ጉቴ ከተማ አስተዳደር"
        },
        {
            "id": 2,
            "name": "Boneya Boshe",
            "nameamh": "ቦንያ ቦሼ"
        },
        {
            "id": 3,
            "name": "Diga",
            "nameamh": "ዲጋ"
        },
        {
            "id": 4,
            "name": "Ebantu",
            "nameamh": "ኢባንቱ "
        },
        {
            "id": 5,
            "name": "Gobu Seyo",
            "nameamh": "ጎቡ ሳዮ"
        },
        {
            "id": 6,
            "name": "Gida Ayana",
            "nameamh": "ጊዳ አያና"
        },
        {
            "id": 7,
            "name": "Guto Gida",
            "nameamh": "ጉቶ ጊዳ"
        },
        {
            "id": 8,
            "name": "Gudeya Bila",
            "nameamh": "ጉደያ ቢላ"
        },
        {
            "id": 9,
            "name": "Haro Limu",
            "nameamh": "ሃሮ ሊሙ"
        },
        {
            "id": 10,
            "name": "Jimma Arjo",
            "nameamh": "ጂማ አርጆ"
        },
        {
            "id": 11,
            "name": "Kiremu",
            "nameamh": "ኪረሙ"
        },
        {
            "id": 12,
            "name": "Leka Dulecha",
            "nameamh": "ለካ ዱለቻ"
        },
        {
            "id": 13,
            "name": "Limu",
            "nameamh": "ሊሙ"
        },
        {
            "id": 14,
            "name": "Nekemte Town",
            "nameamh": "ነቀምቴ ከተማ"
        },
        {
            "id": 15,
            "name": "Nunu Kumba",
            "nameamh": "ኑኑ ኩምባ"
        },
        {
            "id": 16,
            "name": "Sibu Sire",
            "nameamh": "ሲቡ ሲሬ"
        },
        {
            "id": 17,
            "name": "Sasiga",
            "nameamh": "ሳሲጋ"
        },
        {
            "id": 18,
            "name": "Wama Hagelo",
            "nameamh": "ዋማ ሃጋሎ"
        },
        {
            "id": 19,
            "name": "Wayu Tuka",
            "nameamh": "ዋዩ ቱቃ"
        }
    ],
    "80": [
        {
            "id": 1,
            "name": "Muda Furi",
            "nameamh": "ሙዳ ፉሪ"
        },
        {
            "id": 2,
            "name": "Geda Faji",
            "nameamh": "ገዳ ፋጂ"
        },
        {
            "id": 3,
            "name": "Chafe Karabu",
            "nameamh": "ጫፌ ካራቡ"
        }
    ],
    "81": [
        {
            "id": 1,
            "name": "Egdu Ilala",
            "nameamh": "ኤግዱ ኢላላ"
        },
        {
            "id": 2,
            "name": "Gudduu",
            "nameamh": "ጉዱ"
        },
        {
            "id": 3,
            "name": "Gefersa Guje",
            "nameamh": "ገፈርሳ ጉጄ"
        },
        {
            "id": 4,
            "name": "Kolobo",
            "nameamh": "ኮሎቦ"
        }
    ],
    "82": [
        {
            "id": 1,
            "name": "Dalati",
            "nameamh": "ዳለቲ"
        },
        {
            "id": 2,
            "name": "Gelan Gudda",
            "nameamh": "ገላን ጉዳ"
        },
        {
            "id": 3,
            "name": "Lakole Gajja",
            "nameamh": "ለኮሌ ጋጃ"
        }
    ],
    "83": [
        {
            "id": 1,
            "name": "Aga Wayu",
            "nameamh": "ዓጋ ዋዩ"
        },
        {
            "id": 2,
            "name": "Arada Jila Mi'e Boko",
            "nameamh": "አርዳ ጂላ ሚኤ ቦኩ"
        },
        {
            "id": 3,
            "name": "Adola Rede",
            "nameamh": "አዶላ ሬዴ"
        },
        {
            "id": 4,
            "name": "Anna Sora",
            "nameamh": "አና ሶራ"
        },
        {
            "id": 5,
            "name": "Adola Woyu City Administration",
            "nameamh": "አዶላ ወዩ ከተማ አስተዳደር"
        },
        {
            "id": 6,
            "name": "Bore",
            "nameamh": "ቦሬ"
        },
        {
            "id": 7,
            "name": "Dama",
            "nameamh": "ዳማ"
        },
        {
            "id": 8,
            "name": "Girja",
            "nameamh": "ግርጃ"
        },
        {
            "id": 9,
            "name": "Haro Welabu",
            "nameamh": "ሀሮ ወላቡ"
        },
        {
            "id": 10,
            "name": "Odo Shakiso",
            "nameamh": "ኦዶ ሻኪሶ"
        },
        {
            "id": 11,
            "name": "Seba Boru",
            "nameamh": "ሰባ ቦሩ"
        },
        {
            "id": 12,
            "name": "Shakiso Town",
            "nameamh": "ሻኪሶ ከተማ"
        },
        {
            "id": 13,
            "name": "Uraga",
            "nameamh": "ኡራጋ"
        },
        {
            "id": 14,
            "name": "Wadera",
            "nameamh": "ዋደራ"
        }
    ],
    "84": [
        {
            "id": 1,
            "name": "Andode",
            "nameamh": "አንዶዴ"
        },
        {
            "id": 2,
            "name": "Gelan",
            "nameamh": "ገላን"
        },
        {
            "id": 3,
            "name": "Sida Awash",
            "nameamh": "ሲዳ አዋሽ"
        }
    ],
    "85": [
        {
            "id": 1,
            "name": "Birbirsa Siba",
            "nameamh": "ብርብርሳ ሲባ"
        },
        {
            "id": 2,
            "name": "Burka Harbu",
            "nameamh": "ቡርቃ ሀርቡ"
        },
        {
            "id": 3,
            "name": "Burka Welmera",
            "nameamh": "ቡርቃ ወልመራ"
        },
        {
            "id": 4,
            "name": "Gelgel Kuyu",
            "nameamh": "ገልገል ኩዩ"
        },
        {
            "id": 5,
            "name": "Goro Keransa",
            "nameamh": "ጎሮ ቄረንሳ"
        },
        {
            "id": 6,
            "name": "Meda Gudina",
            "nameamh": "መደ ጉዲና"
        },
        {
            "id": 7,
            "name": "Sademo",
            "nameamh": "ሳደሞ"
        },
        {
            "id": 8,
            "name": "Tulu Harbu",
            "nameamh": "ቱሎ ሀርቡ"
        }
    ],
    "86": [
        {
            "id": 1,
            "name": "Abe Dengoro",
            "nameamh": "አቤ ደንጎሮ"
        },
        {
            "id": 2,
            "name": "Amuru",
            "nameamh": "አሙሩ"
        },
        {
            "id": 3,
            "name": "Abay Chomen",
            "nameamh": "አባይ ጮመን"
        },
        {
            "id": 4,
            "name": "Choman Guduru",
            "nameamh": "ጮመን ጉዱሩ"
        },
        {
            "id": 5,
            "name": "Guduru",
            "nameamh": "ጉዱሩ"
        },
        {
            "id": 6,
            "name": "Hababo Guduru",
            "nameamh": "ሀባቦ ጉድሩ"
        },
        {
            "id": 7,
            "name": "Horo Buluk",
            "nameamh": "ሆሮ ቡሉቅ"
        },
        {
            "id": 8,
            "name": "Horo",
            "nameamh": "ሆሮ"
        },
        {
            "id": 9,
            "name": "Jardega Jarte",
            "nameamh": "ጃርደጋ ጀርቴ"
        },
        {
            "id": 10,
            "name": "Jimma Geneti",
            "nameamh": "ጅማ ገነቲ"
        },
        {
            "id": 11,
            "name": "Jimma Rare",
            "nameamh": "ጅማ ራሬ"
        },
        {
            "id": 12,
            "name": "Shambu City Administration",
            "nameamh": "ሻምቡ ከተማ አስተዳደር"
        },
        {
            "id": 13,
            "name": "Sulula Finca'a",
            "nameamh": "ሱሉላ ፊንጫአ"
        }
    ],
    "87": [
        {
            "id": 1,
            "name": "Alge-Sachi",
            "nameamh": "አልጌ ሳቺ"
        },
        {
            "id": 2,
            "name": "Ale",
            "nameamh": "አሌ"
        },
        {
            "id": 3,
            "name": "Becho",
            "nameamh": "በቾ"
        },
        {
            "id": 4,
            "name": "Bilo-Nopa",
            "nameamh": "ቢሎ ኖጳ"
        },
        {
            "id": 5,
            "name": "Bure",
            "nameamh": "ቡሬ"
        },
        {
            "id": 6,
            "name": "Didu",
            "nameamh": "ዲዱ"
        },
        {
            "id": 7,
            "name": "Darimu",
            "nameamh": "ዳሪሙ"
        },
        {
            "id": 8,
            "name": "Doreni",
            "nameamh": "ዶረኒ"
        },
        {
            "id": 9,
            "name": "Halu",
            "nameamh": "ሀሉ"
        },
        {
            "id": 10,
            "name": "Hurumu",
            "nameamh": "ሁሩሙ"
        },
        {
            "id": 11,
            "name": "Metu Town",
            "nameamh": "መቱ ከተማ"
        },
        {
            "id": 12,
            "name": "Metu",
            "nameamh": "መቱ"
        },
        {
            "id": 13,
            "name": "Nono Sele",
            "nameamh": "ኖኖ ስሌ"
        },
        {
            "id": 14,
            "name": "Yayo",
            "nameamh": "ያዮ"
        }
    ],
    "88": [
        {
            "id": 1,
            "name": "Awetu Mandara",
            "nameamh": "አዌቱ መንደራ"
        },
        {
            "id": 2,
            "name": "Bacho Bore",
            "nameamh": "በቾ ቦሬ"
        },
        {
            "id": 3,
            "name": "Bosa Addis",
            "nameamh": "ቦሳ አዲስ"
        },
        {
            "id": 4,
            "name": "Bosa Kito",
            "nameamh": "ቦሳ ኪቶ"
        },
        {
            "id": 5,
            "name": "Ginjo Guduru",
            "nameamh": "ጊንጆ ጉዱሩ"
        },
        {
            "id": 6,
            "name": "Ginjo",
            "nameamh": "ጊንጆ"
        },
        {
            "id": 7,
            "name": "Hermata Markato",
            "nameamh": "ሔርማታ መርካቶ"
        },
        {
            "id": 8,
            "name": "Hermata Mantina",
            "nameamh": "ሔርማታ መንቲና"
        },
        {
            "id": 9,
            "name": "Hermata",
            "nameamh": "ሔርማታ"
        },
        {
            "id": 10,
            "name": "Jiren",
            "nameamh": "ጅሬን"
        },
        {
            "id": 11,
            "name": "Mandara Kochi",
            "nameamh": "መንዳራ ቆጪ"
        },
        {
            "id": 12,
            "name": "Mantina",
            "nameamh": "መንቲና"
        },
        {
            "id": 13,
            "name": "Sato Samaro",
            "nameamh": "ሰጦ ሰመሮ"
        }
    ],
    "89": [
        {
            "id": 1,
            "name": "Agaro Town",
            "nameamh": "አጋሮ ከተማ"
        },
        {
            "id": 2,
            "name": "Boter Tolay",
            "nameamh": "ቦቶር ጦላይ"
        },
        {
            "id": 3,
            "name": "Chora Botor",
            "nameamh": "ጮራ ቦቶር"
        },
        {
            "id": 4,
            "name": "Dedo",
            "nameamh": "ዴዶ"
        },
        {
            "id": 5,
            "name": "Gumay",
            "nameamh": "ጉማይ"
        },
        {
            "id": 6,
            "name": "Gomma",
            "nameamh": "ጎማ"
        },
        {
            "id": 7,
            "name": "Gera",
            "nameamh": "ጌራ"
        },
        {
            "id": 8,
            "name": "Jimma Town",
            "nameamh": "ጅማ ከተማ"
        },
        {
            "id": 9,
            "name": "Kersa",
            "nameamh": "ቀርሳ"
        },
        {
            "id": 10,
            "name": "Limu Genat City Administration",
            "nameamh": "ሊሙ ገነት ከተማ አስተዳደር"
        },
        {
            "id": 11,
            "name": "Limu Kosa",
            "nameamh": "ሊሙ ኮሳ"
        },
        {
            "id": 12,
            "name": "Limu Seka",
            "nameamh": "ሊሙ ሰቃ"
        },
        {
            "id": 13,
            "name": "Mancho",
            "nameamh": "መንቾ"
        },
        {
            "id": 14,
            "name": "Manna",
            "nameamh": "ማና"
        },
        {
            "id": 15,
            "name": "Nono Benja",
            "nameamh": "ኖኖ ቤንጃ"
        },
        {
            "id": 16,
            "name": "Omo Beyam",
            "nameamh": "ኦሞ ቤያም"
        },
        {
            "id": 17,
            "name": "Omo Nada",
            "nameamh": "ኦሞ ናዳ"
        },
        {
            "id": 18,
            "name": "Shebe Senbo",
            "nameamh": "ሻቤ ሶምቦ"
        },
        {
            "id": 19,
            "name": "Sigmo",
            "nameamh": "ሲግሞ"
        },
        {
            "id": 20,
            "name": "Seka Chekorsa",
            "nameamh": "ሰቃ ጨቆርሳ"
        },
        {
            "id": 21,
            "name": "Sokoru",
            "nameamh": "ሶኮሩ"
        },
        {
            "id": 22,
            "name": "Setema",
            "nameamh": "ሰጠማ"
        },
        {
            "id": 23,
            "name": "Tiro Afeta",
            "nameamh": "ቲሮ አፈታ"
        }
    ],
    "90": [
        {
            "id": 1,
            "name": "Gelan Arabsa",
            "nameamh": "ገላን አራብሳ"
        },
        {
            "id": 2,
            "name": "Tullu Dimtu",
            "nameamh": "ቱሉ ዲሚቱ"
        },
        {
            "id": 3,
            "name": "Waddesa",
            "nameamh": "ወዴሳ"
        }
    ],
    "91": [
        {
            "id": 1,
            "name": "Dire Sokoru",
            "nameamh": "ድሬ ሶኮሩ"
        },
        {
            "id": 2,
            "name": "Kura Jida",
            "nameamh": "ኩራ ጂዳ"
        },
        {
            "id": 3,
            "name": "Walgayo Laga Bari",
            "nameamh": "ወልገዮ ለገ በሪ"
        }
    ],
    "92": [
        {
            "id": 1,
            "name": "Anfilo",
            "nameamh": "አንፍሎ"
        },
        {
            "id": 2,
            "name": "Dambi Dollo City Administration",
            "nameamh": "ደምቢ ዶሎ ከተማ አስተዳደር"
        },
        {
            "id": 3,
            "name": "Dale Sedi",
            "nameamh": "ዳሌ ሰዲ"
        },
        {
            "id": 4,
            "name": "Dale Wabera",
            "nameamh": "ዳሌ ዋበራ"
        },
        {
            "id": 5,
            "name": "Gidami",
            "nameamh": "ጊዳሚ"
        },
        {
            "id": 6,
            "name": "Gawo Kebe",
            "nameamh": "ጋዎ ቄቤ"
        },
        {
            "id": 7,
            "name": "Hawa Gelan",
            "nameamh": "ሐዋ ገላን"
        },
        {
            "id": 8,
            "name": "Jimma Horo",
            "nameamh": "ጅማ ሆሮ"
        },
        {
            "id": 9,
            "name": "Lalo Kile",
            "nameamh": "ላሎ ኪሌ"
        },
        {
            "id": 10,
            "name": "Sedi Chenka",
            "nameamh": "ሳዲ ጫንቃ"
        },
        {
            "id": 11,
            "name": "Seyo",
            "nameamh": "ሳዮ"
        },
        {
            "id": 12,
            "name": "Yemalogi Welel",
            "nameamh": "የማሎጊ ወለል"
        }
    ],
    "93": [
        {
            "id": 1,
            "name": "Dembel Tafo",
            "nameamh": "ደምበል ጣፎ"
        },
        {
            "id": 2,
            "name": "Dalle Lege Dadi",
            "nameamh": "ዳሌ ለገ ዳዲ"
        },
        {
            "id": 3,
            "name": "Eka Tafo",
            "nameamh": "ኤካ ጣፎ"
        }
    ],
    "94": [
        {
            "id": 1,
            "name": "Akako Mana Abichu",
            "nameamh": "አካኮ መነ አቢቹ"
        },
        {
            "id": 2,
            "name": "Tufa Muna",
            "nameamh": "ቱፋ ሙና"
        }
    ],
    "95": [
        {
            "id": 1,
            "name": "Bate",
            "nameamh": "ባቴ"
        },
        {
            "id": 2,
            "name": "Maya Gudo",
            "nameamh": "ማያ ጉዶ"
        },
        {
            "id": 3,
            "name": "Maya Kalo",
            "nameamh": "ማያ ቀሎ"
        },
        {
            "id": 4,
            "name": "Maya Lamen",
            "nameamh": "ማያ ለሜን"
        }
    ],
    "96": [
        {
            "id": 1,
            "name": "Awaday",
            "nameamh": "አወዳይ"
        },
        {
            "id": 2,
            "name": "Boji",
            "nameamh": "ቦጂ"
        },
        {
            "id": 3,
            "name": "Fandisha",
            "nameamh": "ፋንድሻ"
        },
        {
            "id": 4,
            "name": "Nagaya",
            "nameamh": "ነገያ"
        }
    ],
    "97": [
        {
            "id": 1,
            "name": "Adele",
            "nameamh": "አዴሌ"
        },
        {
            "id": 2,
            "name": "Biftu Gada",
            "nameamh": "ቢፍቱ ገዳ"
        },
        {
            "id": 3,
            "name": "Dangago",
            "nameamh": "ደንገጎ"
        },
        {
            "id": 4,
            "name": "Kuro",
            "nameamh": "ኩሮ"
        }
    ],
    "98": [
        {
            "id": 1,
            "name": "Karsa",
            "nameamh": "ቀርሳ"
        },
        {
            "id": 2,
            "name": "Malka Lami",
            "nameamh": "መልካ ለሚ"
        },
        {
            "id": 3,
            "name": "Obo",
            "nameamh": "ኦቦ"
        },
        {
            "id": 4,
            "name": "Sayo",
            "nameamh": "ሰዮ"
        }
    ],
    "99": [
        {
            "id": 1,
            "name": "Bero",
            "nameamh": "ቤሮ"
        },
        {
            "id": 2,
            "name": "Melka Gefersa",
            "nameamh": "መልካ ገፈርሳ"
        },
        {
            "id": 3,
            "name": "Nonno",
            "nameamh": "ኖኖ"
        }
    ],
    "100": [
        {
            "id": 1,
            "name": "Aba Mole",
            "nameamh": "አባ ሞሌ"
        },
        {
            "id": 2,
            "name": "Aba Saya",
            "nameamh": "አባ ሳያ"
        },
        {
            "id": 3,
            "name": "Gadisa Oda",
            "nameamh": "ጋዲሳ ኦዳ"
        },
        {
            "id": 4,
            "name": "Kolo Kroma",
            "nameamh": "ቆሎ ኮርማ"
        },
        {
            "id": 5,
            "name": "Sor",
            "nameamh": "ሶር"
        },
        {
            "id": 6,
            "name": "Tabo",
            "nameamh": "ታቦ"
        }
    ],
    "101": [
        {
            "id": 1,
            "name": "Arbale",
            "nameamh": "አርባሌ"
        },
        {
            "id": 2,
            "name": "Kebele 1",
            "nameamh": "Kebele 1"
        },
        {
            "id": 3,
            "name": "Kebele 2",
            "nameamh": "Kebele 2"
        },
        {
            "id": 4,
            "name": "Kabana'a",
            "nameamh": "ቀበናኣ"
        },
        {
            "id": 5,
            "name": "Mado Migo",
            "nameamh": "መዶ ሚጎ"
        },
        {
            "id": 6,
            "name": "Shawa Bare",
            "nameamh": "ሸዋ ባሬ"
        }
    ],
    "102": [
        {
            "id": 1,
            "name": "Kebele 1",
            "nameamh": "Kebele 1"
        },
        {
            "id": 2,
            "name": "Kebele 2",
            "nameamh": "Kebele 2"
        },
        {
            "id": 3,
            "name": "Kebele 3",
            "nameamh": "Kebele 3"
        },
        {
            "id": 4,
            "name": "Kebele 4",
            "nameamh": "Kebele 4"
        }
    ],
    "103": [
        {
            "id": 1,
            "name": "Bake Jama",
            "nameamh": "በኬ ጀማ"
        },
        {
            "id": 2,
            "name": "Burka Jato",
            "nameamh": "ቡርቃ ጃቶ"
        },
        {
            "id": 3,
            "name": "Bakanisa Kase",
            "nameamh": "ባካኒሳ ቀሴ"
        },
        {
            "id": 4,
            "name": "Cheleleki",
            "nameamh": "ጨለለቂ"
        },
        {
            "id": 5,
            "name": "Darge",
            "nameamh": "ደርጌ"
        },
        {
            "id": 6,
            "name": "Keso",
            "nameamh": "ቀሶ"
        },
        {
            "id": 7,
            "name": "Sorga",
            "nameamh": "ሶርጋ"
        }
    ],
    "104": [
        {
            "id": 1,
            "name": "Abichu Gne'a",
            "nameamh": "አቢቹ ኛኣ"
        },
        {
            "id": 2,
            "name": "Aleltu",
            "nameamh": "አለልቱ"
        },
        {
            "id": 3,
            "name": "Berek",
            "nameamh": "በረክ"
        },
        {
            "id": 4,
            "name": "Chancho City Administration",
            "nameamh": "ጫንጮ ከተማ አስተዳደር"
        },
        {
            "id": 5,
            "name": "Debre Libanos",
            "nameamh": "ደብረሊባኖስ"
        },
        {
            "id": 6,
            "name": "Degem",
            "nameamh": "ዳጋም"
        },
        {
            "id": 7,
            "name": "Dera",
            "nameamh": "ደራ"
        },
        {
            "id": 8,
            "name": "Fiche City Administration",
            "nameamh": "ፍቼ ከተማ አስተዳደር"
        },
        {
            "id": 9,
            "name": "Garba Guracha City Administration",
            "nameamh": "ገርባ ጉራቻ ከተማ አስተዳደር"
        },
        {
            "id": 10,
            "name": "Girar Jarso",
            "nameamh": "ግራር ጃርሶ"
        },
        {
            "id": 11,
            "name": "Hidabu Abote",
            "nameamh": "ሂደቡ አቦቴ"
        },
        {
            "id": 12,
            "name": "Jida",
            "nameamh": "ጂዳ"
        },
        {
            "id": 13,
            "name": "Kimbibit",
            "nameamh": "ቅምብቢት"
        },
        {
            "id": 14,
            "name": "Kuyu",
            "nameamh": "ኩዩ"
        },
        {
            "id": 15,
            "name": "Mulo",
            "nameamh": "ሙሎ"
        },
        {
            "id": 16,
            "name": "Sandafa Bake Town",
            "nameamh": "ሰንዳፋ በኬ ከተማ"
        },
        {
            "id": 17,
            "name": "Sululta",
            "nameamh": "ሱሉልታ"
        },
        {
            "id": 18,
            "name": "Sheno town",
            "nameamh": "ሸኖ ከተማ"
        },
        {
            "id": 19,
            "name": "Wuchale",
            "nameamh": "ዉጫሌ"
        },
        {
            "id": 20,
            "name": "Were Jarso",
            "nameamh": "ወራ ጃርሶ"
        },
        {
            "id": 21,
            "name": "Yaya Gulele",
            "nameamh": "ያያ ጉለሌ"
        }
    ],
    "105": [
        {
            "id": 1,
            "name": "Baha Biftu",
            "nameamh": "በሃ ቢፍቱ"
        },
        {
            "id": 2,
            "name": "Chafe Donsa",
            "nameamh": "ጨፌ ዶንሳ"
        },
        {
            "id": 3,
            "name": "Handura Robe",
            "nameamh": "ሀንዱራ ሮቤ"
        },
        {
            "id": 4,
            "name": "Waltahi Chafe",
            "nameamh": "ወልታኢ ጨፌ"
        }
    ],
    "106": [
        {
            "id": 1,
            "name": "Arada Micha",
            "nameamh": "አረዳ ሚጫ"
        },
        {
            "id": 2,
            "name": "Chafe Hora",
            "nameamh": "ጨፌ ሆራ"
        },
        {
            "id": 3,
            "name": "Fincha Bamo",
            "nameamh": "ፊንጫአ ባሞ"
        },
        {
            "id": 4,
            "name": "Oda Baha",
            "nameamh": "ኦዳ በሃ"
        }
    ],
    "107": [
        {
            "id": 1,
            "name": "Bole Tokuma",
            "nameamh": "ቦሌ ቶኩማ"
        },
        {
            "id": 2,
            "name": "Hora Boka",
            "nameamh": "ሆራ ቦቃ"
        },
        {
            "id": 3,
            "name": "Kibtate",
            "nameamh": "ኪብጠቴ"
        },
        {
            "id": 4,
            "name": "Oda Robe",
            "nameamh": "ኦዳ ሮቤ"
        }
    ],
    "108": [
        {
            "id": 1,
            "name": "Bake",
            "nameamh": "በኬ"
        },
        {
            "id": 2,
            "name": "Dale",
            "nameamh": "ዳሌ"
        },
        {
            "id": 3,
            "name": "Laga Jila",
            "nameamh": "ለገ ጂላ"
        },
        {
            "id": 4,
            "name": "Sandafa",
            "nameamh": "ሰንዳፋ"
        }
    ],
    "109": [
        {
            "id": 1,
            "name": "Caffee",
            "nameamh": "ጨፌ"
        },
        {
            "id": 2,
            "name": "Mogole",
            "nameamh": "ሞጎሌ"
        },
        {
            "id": 3,
            "name": "Metta",
            "nameamh": "ሜታ"
        }
    ],
    "110": [
        {
            "id": 1,
            "name": "Awasho",
            "nameamh": "አዋሾ"
        },
        {
            "id": 2,
            "name": "Dida Boke",
            "nameamh": "ዲዳ ቦቄ"
        },
        {
            "id": 3,
            "name": "Malka Badesa",
            "nameamh": "መልካ በዴሳ"
        }
    ],
    "111": [
        {
            "id": 1,
            "name": "Alge Rima",
            "nameamh": "አልጌ ሪማ"
        },
        {
            "id": 2,
            "name": "Habas",
            "nameamh": "ሀባስ"
        },
        {
            "id": 3,
            "name": "Toga Waransa",
            "nameamh": "ቶጋ ወራንሳ"
        }
    ],
    "112": [
        {
            "id": 1,
            "name": "Alelu",
            "nameamh": "አሌሉ"
        },
        {
            "id": 2,
            "name": "Bulchana",
            "nameamh": "ቡልቻና"
        },
        {
            "id": 3,
            "name": "Maja Dama",
            "nameamh": "መጃ ዳማ"
        }
    ],
    "113": [
        {
            "id": 1,
            "name": "Bute Filcha",
            "nameamh": "ቡቴ ፊልቻ"
        },
        {
            "id": 2,
            "name": "Edo Lencha",
            "nameamh": "ኤዶ ሌንጫ"
        },
        {
            "id": 3,
            "name": "Karara Filcha",
            "nameamh": "ካራራ ፊልቻ"
        }
    ],
    "114": [
        {
            "id": 1,
            "name": "Bika Fora",
            "nameamh": "ቢቃ ፎራ"
        },
        {
            "id": 2,
            "name": "Banti Arba",
            "nameamh": "በንቲ አርባ"
        },
        {
            "id": 3,
            "name": "Dugo Awata ",
            "nameamh": "ዱጎ አዋጣ"
        },
        {
            "id": 4,
            "name": "Udeyi",
            "nameamh": "ኡዴይ"
        }
    ],
    "115": [
        {
            "id": 1,
            "name": "Burka Ejersa",
            "nameamh": "ቡርቃ ኤጄርሳ"
        },
        {
            "id": 2,
            "name": "Oda Kuni",
            "nameamh": "ኦዳ ኩኒ"
        },
        {
            "id": 3,
            "name": "Tulu Kurfo",
            "nameamh": "ቱሉ ኩርፎ"
        }
    ],
    "116": [
        {
            "id": 1,
            "name": "Aba Geda",
            "nameamh": "አባ ገዳ"
        },
        {
            "id": 2,
            "name": "Wasarbi",
            "nameamh": "ወሰርቢ"
        }
    ],
    "117": [
        {
            "id": 1,
            "name": "Ameya",
            "nameamh": "አመያ"
        },
        {
            "id": 2,
            "name": "Becho",
            "nameamh": "በቾ"
        },
        {
            "id": 3,
            "name": "Dawo",
            "nameamh": "ዳዎ"
        },
        {
            "id": 4,
            "name": "Goro",
            "nameamh": "ጎሮ"
        },
        {
            "id": 5,
            "name": "Ilu",
            "nameamh": "ኢሉ"
        },
        {
            "id": 6,
            "name": "Kersa Malima",
            "nameamh": "ቀርሳ ማሊማ"
        },
        {
            "id": 7,
            "name": "Sodo Dachi",
            "nameamh": "ሶዶ ዳጪ"
        },
        {
            "id": 8,
            "name": "Seden Sodo",
            "nameamh": "ሰደን ሶዶ"
        },
        {
            "id": 9,
            "name": "Sabata Hawas",
            "nameamh": "ሰበታ ሀዋስ"
        },
        {
            "id": 10,
            "name": "Tole",
            "nameamh": "ቶሌ"
        },
        {
            "id": 11,
            "name": "Weliso Rural",
            "nameamh": "ወሊሶ"
        },
        {
            "id": 12,
            "name": "Weliso Town",
            "nameamh": "ወሊሶ ከተማ"
        },
        {
            "id": 13,
            "name": "Wenchi",
            "nameamh": "ወንጪ"
        }
    ],
    "118": [
        {
            "id": 1,
            "name": "Ayetu",
            "nameamh": "አዬቱ"
        },
        {
            "id": 2,
            "name": "Burka Gudina",
            "nameamh": "ቡርቃ ጉዲና"
        },
        {
            "id": 3,
            "name": "Ejersa",
            "nameamh": "ኤጄርሳ"
        },
        {
            "id": 4,
            "name": "Hora",
            "nameamh": "ሆራ"
        }
    ],
    "119": [
        {
            "id": 1,
            "name": "Abaya",
            "nameamh": "አባያ"
        },
        {
            "id": 2,
            "name": "Birbirsa Kojowa",
            "nameamh": "ቢርቢርሳ ኮጆዋ"
        },
        {
            "id": 3,
            "name": "Bule Hora Town",
            "nameamh": "ቡሌ ሆራ ከተማ"
        },
        {
            "id": 4,
            "name": "Bule Hora",
            "nameamh": "ቡሌ ሆራ"
        },
        {
            "id": 5,
            "name": "Dugda Dewa",
            "nameamh": "ዱግደ ዳዋ"
        },
        {
            "id": 6,
            "name": "Gelana",
            "nameamh": "ገላና"
        },
        {
            "id": 7,
            "name": "Hambela Wamena",
            "nameamh": "ሀንበላ ዋመነ"
        },
        {
            "id": 8,
            "name": "Kercha City Administration",
            "nameamh": "ቃርጫ ከተማ አስተዳደር"
        },
        {
            "id": 9,
            "name": "Kercha",
            "nameamh": "ቀርጫ"
        },
        {
            "id": 10,
            "name": "Melka Soda",
            "nameamh": "መልካ ሶዳ"
        },
        {
            "id": 11,
            "name": "Suro Berguda",
            "nameamh": "ሱሮ በርጉዳ"
        }
    ],
    "120": [
        {
            "id": 1,
            "name": "Adaba",
            "nameamh": "አዳባ"
        },
        {
            "id": 2,
            "name": "Nagele Arsi City Administration",
            "nameamh": "ነገሌ አርሲ ከተማ አስተዳደር"
        },
        {
            "id": 3,
            "name": "Arsi Negele Rural",
            "nameamh": "አርሲ ነጌሌ"
        },
        {
            "id": 4,
            "name": "Dodola Rural",
            "nameamh": "ዶዶላ"
        },
        {
            "id": 5,
            "name": "Dodola Town",
            "nameamh": "ዶዶላ ከተማ"
        },
        {
            "id": 6,
            "name": "Gedeb Aasasa",
            "nameamh": "ገደብ ሀሳሳ"
        },
        {
            "id": 7,
            "name": "Heban Arsi",
            "nameamh": "ሄበን አርሲ"
        },
        {
            "id": 8,
            "name": "Kofele",
            "nameamh": "ኮፈሌ"
        },
        {
            "id": 9,
            "name": "Kokosa",
            "nameamh": "ኮኮሳ"
        },
        {
            "id": 10,
            "name": "Kofale City Administration",
            "nameamh": "ኮፋሌ ከተማ አስተዳደር"
        },
        {
            "id": 11,
            "name": "Kore",
            "nameamh": "ቆሬ"
        },
        {
            "id": 12,
            "name": "Nensebo",
            "nameamh": "ነንሰቦ"
        },
        {
            "id": 13,
            "name": "Shala",
            "nameamh": "ሻላ"
        },
        {
            "id": 14,
            "name": "Siraro",
            "nameamh": "ሲራሮ"
        },
        {
            "id": 15,
            "name": "Shashemene",
            "nameamh": "ሻሸመኔ"
        },
        {
            "id": 16,
            "name": "Shashemene Town",
            "nameamh": "ሻሸመኔ ከተማ"
        },
        {
            "id": 17,
            "name": "Wendo",
            "nameamh": "ወንዶ"
        }
    ],
    "121": [
        {
            "id": 1,
            "name": "Anchar",
            "nameamh": "አንጫር"
        },
        {
            "id": 2,
            "name": "Badesa City Administration",
            "nameamh": "ባዴሳ ከተማ አስተዳደር"
        },
        {
            "id": 3,
            "name": "Burka Dhintu",
            "nameamh": "ቡርቃ ዲንቱ"
        },
        {
            "id": 4,
            "name": "Boke",
            "nameamh": "ቦኬ"
        },
        {
            "id": 5,
            "name": "Chiro City Administration",
            "nameamh": "ጭሮ ከተማ አስተዳደር"
        },
        {
            "id": 6,
            "name": "Chiro Rural",
            "nameamh": "ጭሮ"
        },
        {
            "id": 7,
            "name": "Doba",
            "nameamh": "ዶባ"
        },
        {
            "id": 8,
            "name": "Daro Lebu",
            "nameamh": "ዳሮ ለቡ"
        },
        {
            "id": 9,
            "name": "Gumbi Bordede",
            "nameamh": "ጉምቢ ቦርዶዴ"
        },
        {
            "id": 10,
            "name": "Guba Koricha",
            "nameamh": "ጉባ ቆሪቻ"
        },
        {
            "id": 11,
            "name": "Galamso City Administration",
            "nameamh": "ገለምሶ ከተማ አስተዳደር"
        },
        {
            "id": 12,
            "name": "Gemechis",
            "nameamh": "ጋማቺስ"
        },
        {
            "id": 13,
            "name": "Habro",
            "nameamh": "ሀብሮ"
        },
        {
            "id": 14,
            "name": "Hirna City Administration",
            "nameamh": "ሂርና ከተማ አስተዳደር"
        },
        {
            "id": 15,
            "name": "Hawi Gudina",
            "nameamh": "ሐዊ ጉዲና"
        },
        {
            "id": 16,
            "name": "Machara Michata City Administration",
            "nameamh": "መቻራ ሚጫታ ከተማ አስተዳደር"
        },
        {
            "id": 17,
            "name": "Meiso",
            "nameamh": "ሚኤሶ"
        },
        {
            "id": 18,
            "name": "Oda Bultum",
            "nameamh": "ኦዳ ቡልቱም"
        },
        {
            "id": 19,
            "name": "Shanan Dungo",
            "nameamh": "ሸነን ዱንጎ"
        },
        {
            "id": 20,
            "name": "Tulo",
            "nameamh": "ጡሎ"
        }
    ],
    "122": [
        {
            "id": 1,
            "name": "Ambo",
            "nameamh": "አምቦ"
        },
        {
            "id": 2,
            "name": "Ade'a Berga",
            "nameamh": "አደአ በርጋ"
        },
        {
            "id": 3,
            "name": "Abuna Gindeberet",
            "nameamh": "አቡና ግንደበረት"
        },
        {
            "id": 4,
            "name": "Bako Tibe",
            "nameamh": "ባኮ ቲቤ"
        },
        {
            "id": 5,
            "name": "Cobi",
            "nameamh": "ጮቢ"
        },
        {
            "id": 6,
            "name": "Cheliya",
            "nameamh": "ጨሊያ"
        },
        {
            "id": 7,
            "name": "Dendi",
            "nameamh": "ደንዲ"
        },
        {
            "id": 8,
            "name": "Deno",
            "nameamh": "ዳኖ"
        },
        {
            "id": 9,
            "name": "Dire Inchini",
            "nameamh": "ድሬ እንጭኒ"
        },
        {
            "id": 10,
            "name": "Ejere",
            "nameamh": "ኤጄሬ"
        },
        {
            "id": 11,
            "name": "Ejersa Lafo",
            "nameamh": "ኤጄሪሳ ለፎ"
        },
        {
            "id": 12,
            "name": "Ginde Beret",
            "nameamh": "ግንዳበረት"
        },
        {
            "id": 13,
            "name": "Holata Town",
            "nameamh": "ሆላታ ከተማ"
        },
        {
            "id": 14,
            "name": "Ilfeta",
            "nameamh": "ኢልፈታ"
        },
        {
            "id": 15,
            "name": "Ilu Gelan",
            "nameamh": "ኢሉ ገላን"
        },
        {
            "id": 16,
            "name": "Jibat",
            "nameamh": "ጅባት"
        },
        {
            "id": 17,
            "name": "Jeldu",
            "nameamh": "ጃልዱ"
        },
        {
            "id": 18,
            "name": "Liban Jewi",
            "nameamh": "ሊባን ጀዊ"
        },
        {
            "id": 19,
            "name": "Mida Kegni",
            "nameamh": "ሚዳቀኝ"
        },
        {
            "id": 20,
            "name": "Meta Robi",
            "nameamh": "ሜታ ሮቢ"
        },
        {
            "id": 21,
            "name": "Meta Welkite",
            "nameamh": "ሜታ ወልቂጤ"
        },
        {
            "id": 22,
            "name": "Nono",
            "nameamh": "ኖኖ"
        },
        {
            "id": 23,
            "name": "Toke Kutaye",
            "nameamh": "ቶኬ ኩታዬ"
        },
        {
            "id": 24,
            "name": "Walmara",
            "nameamh": "ወልመራ"
        }
    ],
    "123": [
        {
            "id": 1,
            "name": "Ayira",
            "nameamh": "አይራ"
        },
        {
            "id": 2,
            "name": "Babo Gembel",
            "nameamh": "ባቦ ጋምቤል"
        },
        {
            "id": 3,
            "name": "Begi",
            "nameamh": "ቤጊ"
        },
        {
            "id": 4,
            "name": "Boji Chekorsa",
            "nameamh": "ቦጅ ጮቆርሳ"
        },
        {
            "id": 5,
            "name": "Boji Dirmeji",
            "nameamh": "ቦጅ ድርመጂ"
        },
        {
            "id": 6,
            "name": "Gimbi City Administration",
            "nameamh": "ጊምቢ ከተማ አስተዳደር"
        },
        {
            "id": 7,
            "name": "Gimbi Rural",
            "nameamh": "ጊምቢ"
        },
        {
            "id": 8,
            "name": "Guliso",
            "nameamh": "ጉሊሶ"
        },
        {
            "id": 9,
            "name": "Genji",
            "nameamh": "ጋንጂ"
        },
        {
            "id": 10,
            "name": "Haru",
            "nameamh": "ሃሩ"
        },
        {
            "id": 11,
            "name": "Homa",
            "nameamh": "ሆማ"
        },
        {
            "id": 12,
            "name": "Jarso",
            "nameamh": "ጃርሶ"
        },
        {
            "id": 13,
            "name": "Kondala",
            "nameamh": "ቆንዳላ"
        },
        {
            "id": 14,
            "name": "Kiltu Kara",
            "nameamh": "ቂልጡ ካራ"
        },
        {
            "id": 15,
            "name": "Lalo Asabi",
            "nameamh": "ላሎ አሳቢ"
        },
        {
            "id": 16,
            "name": "Leta Sibu",
            "nameamh": "ላታ ስቡ"
        },
        {
            "id": 17,
            "name": "Mandi City Administration",
            "nameamh": "መንዲ ከተማ አስተዳደር"
        },
        {
            "id": 18,
            "name": "Mene Sibu",
            "nameamh": "መነ ሲቡ"
        },
        {
            "id": 19,
            "name": "Nejo",
            "nameamh": "ነጆ"
        },
        {
            "id": 20,
            "name": "Nejo Town",
            "nameamh": "ነጆ ከተማ"
        },
        {
            "id": 21,
            "name": "Nole Kaba",
            "nameamh": "ኖሌ ካባ"
        },
        {
            "id": 22,
            "name": "Seyo Nole",
            "nameamh": "ሳዮ ኖሌ"
        },
        {
            "id": 23,
            "name": "Yubdo",
            "nameamh": "ዩብዶ"
        }
    ],
    "124": [
        {
            "id": 1,
            "name": "Aleta Chuko City Administration",
            "nameamh": "አለታ ጩኮ ከተማ አስተዳደር"
        },
        {
            "id": 2,
            "name": "Aleta Chuko",
            "nameamh": "አለታ ጩኮ"
        },
        {
            "id": 3,
            "name": "Aleta Wendo City Administration",
            "nameamh": "አለታ ወንዶ ከተማ አስተዳደር"
        },
        {
            "id": 4,
            "name": "Aleta Wendo",
            "nameamh": "አለታ ወንዶ"
        },
        {
            "id": 5,
            "name": "Bursa",
            "nameamh": "ቡርሳ"
        },
        {
            "id": 6,
            "name": "Chirone",
            "nameamh": "ጭሮኔ"
        },
        {
            "id": 7,
            "name": "Dara Kebado",
            "nameamh": "ዳራ ቀባዶ"
        },
        {
            "id": 8,
            "name": "Dara Otilcho",
            "nameamh": "ዳራ ኦቲልቾ"
        },
        {
            "id": 9,
            "name": "Hula",
            "nameamh": "ሁላ"
        },
        {
            "id": 10,
            "name": "Teticha",
            "nameamh": "ጤጥቻ"
        }
    ],
    "125": [
        {
            "id": 1,
            "name": "Adiss ketema",
            "nameamh": "አዲስ ከተማ"
        },
        {
            "id": 2,
            "name": "Bahel Adarash",
            "nameamh": "ባህል አዳራሽ"
        },
        {
            "id": 3,
            "name": "Haik Dar",
            "nameamh": "ሀይቅ ዳር"
        },
        {
            "id": 4,
            "name": "Mehal",
            "nameamh": "መሀል"
        },
        {
            "id": 5,
            "name": "Meneharya",
            "nameamh": "መናሃሪያ"
        },
        {
            "id": 6,
            "name": "Misrak",
            "nameamh": "ምስራቅ"
        },
        {
            "id": 7,
            "name": "Tabor",
            "nameamh": "ታቦር"
        },
        {
            "id": 8,
            "name": "Tula",
            "nameamh": "ቱላ"
        }
    ],
    "126": [
        {
            "id": 1,
            "name": "Aroresa",
            "nameamh": "አሮሬሳ"
        },
        {
            "id": 2,
            "name": "Bensa",
            "nameamh": "በንሳ"
        },
        {
            "id": 3,
            "name": "Bura",
            "nameamh": "ቡራ"
        },
        {
            "id": 4,
            "name": "Bona Zuria",
            "nameamh": "ቦና ዙሪያ"
        },
        {
            "id": 5,
            "name": "Chebe Gambeltu",
            "nameamh": "ጫቤ ጋምቤልቶ"
        },
        {
            "id": 6,
            "name": "Chire",
            "nameamh": "ጭሬ"
        },
        {
            "id": 7,
            "name": "Daye city administration",
            "nameamh": "ዳዬ ከተማ አስተዳደር"
        },
        {
            "id": 8,
            "name": "Daela",
            "nameamh": "ዳኤላ"
        },
        {
            "id": 9,
            "name": "Hoko",
            "nameamh": "ሆኮ"
        }
    ],
    "127": [
        {
            "id": 1,
            "name": "Arbegona",
            "nameamh": "አርቤጎና"
        },
        {
            "id": 2,
            "name": "Dale",
            "nameamh": "ዳሌ"
        },
        {
            "id": 3,
            "name": "Darara",
            "nameamh": "ዳራራ"
        },
        {
            "id": 4,
            "name": "Loka Abaya",
            "nameamh": "ሎካ አባያ"
        },
        {
            "id": 5,
            "name": "Shafamo",
            "nameamh": "ሻፋሞ"
        },
        {
            "id": 6,
            "name": "Wonsho",
            "nameamh": "ወንሾ"
        },
        {
            "id": 7,
            "name": "Yirgalem city administration",
            "nameamh": "ይርጋለም ከተማ አስተዳደር"
        }
    ],
    "128": [
        {
            "id": 1,
            "name": "Boricha",
            "nameamh": "ቦርቻ"
        },
        {
            "id": 2,
            "name": "Bilate Zuriya",
            "nameamh": "ብላቴ ዙሪያ"
        },
        {
            "id": 3,
            "name": "Gorche",
            "nameamh": "ጎርቼ"
        },
        {
            "id": 4,
            "name": "Hawela",
            "nameamh": "ሀዌላ"
        },
        {
            "id": 5,
            "name": "Hawassa Zuriya",
            "nameamh": "ሀዋሳ ዙሪያ"
        },
        {
            "id": 6,
            "name": "Leku city administration",
            "nameamh": "ለኩ ከተማ አስተዳደር"
        },
        {
            "id": 7,
            "name": "Malga",
            "nameamh": "ማልጋ"
        },
        {
            "id": 8,
            "name": "Shebedino",
            "nameamh": "ሸበዲኖ"
        },
        {
            "id": 9,
            "name": "Wendo Genet city administration",
            "nameamh": "ወንዶ ገነት ከተማ አስተዳደር"
        },
        {
            "id": 10,
            "name": "Wendo Genet",
            "nameamh": "ወንዶ ገነት"
        }
    ],
    "129": [
        {
            "id": 1,
            "name": "Bakadawla Ari Woreda",
            "nameamh": "ባካዳውላ አሪ ወረዳ"
        },
        {
            "id": 2,
            "name": "Woba Ari Woreda",
            "nameamh": "ወባ አሪ ወረዳ"
        },
        {
            "id": 3,
            "name": "Debub Ari Woreda",
            "nameamh": "ደቡብ አሪ ወረዳ"
        },
        {
            "id": 4,
            "name": "Gelila City Administration",
            "nameamh": "ገሊላ ከተማ አስተዳደር"
        },
        {
            "id": 5,
            "name": "Semen Ari Woreda",
            "nameamh": "ሰሜን አሪ ወረዳ"
        },
        {
            "id": 6,
            "name": "Jinka City Administration",
            "nameamh": "ጂንካ ከተማ አስተዳደር"
        }
    ],
    "130": [
        {
            "id": 1,
            "name": "Kogota Woreda",
            "nameamh": "ቆጎታ ወረዳ"
        },
        {
            "id": 2,
            "name": "Dita Woreda",
            "nameamh": "ዲታ ወረዳ"
        },
        {
            "id": 3,
            "name": "Kucha  Woreda",
            "nameamh": "ቁጫ ወረዳ"
        },
        {
            "id": 4,
            "name": "Gacho Baba Woreda",
            "nameamh": "ጋጮ ባባ ወረዳ"
        },
        {
            "id": 5,
            "name": "Deramalo Woreda",
            "nameamh": "ዳራማሎ ወረዳ"
        },
        {
            "id": 6,
            "name": "Arba Minch City Administration",
            "nameamh": "አርባ ምንጭ ከተማ አስተዳደር"
        },
        {
            "id": 7,
            "name": "Boreda Woreda",
            "nameamh": "ቦረዳ ወረዳ"
        },
        {
            "id": 8,
            "name": "Selamber City Administration",
            "nameamh": "ሰላምበር ከተማ አስተዳደር"
        },
        {
            "id": 9,
            "name": "Arba Minch Zuriya Woreda",
            "nameamh": "አርባ ምንጭ ዙሪያ ወረዳ"
        },
        {
            "id": 10,
            "name": "Garda Marta Woreda",
            "nameamh": "ጋርዳ ማርታ ወረዳ"
        },
        {
            "id": 11,
            "name": "Bonke Woreda",
            "nameamh": "ቦንኬ ወረዳ"
        },
        {
            "id": 12,
            "name": "Kemba City Administration",
            "nameamh": "ከምባ ከተማ አስተዳደር"
        },
        {
            "id": 13,
            "name": "Kemba Zuriya Woreda",
            "nameamh": "ከምባ ዙሪያ ወረዳ"
        },
        {
            "id": 14,
            "name": "Birbir City Administration",
            "nameamh": "ብርብር ከተማ አስተዳደር"
        },
        {
            "id": 15,
            "name": "Gerese Woreda",
            "nameamh": "ገረሴ ወረዳ"
        },
        {
            "id": 16,
            "name": "Mierab Abaya Woreda",
            "nameamh": "ምዕራብ አባያ ወረዳ"
        },
        {
            "id": 17,
            "name": "Chencha Zuriya Woreda",
            "nameamh": "ጬንቻ ዙሪያ ወረዳ"
        },
        {
            "id": 18,
            "name": "Chencha Zuriya Woreda",
            "nameamh": "ጬንቻ ዙሪያ ወረዳ"
        },
        {
            "id": 19,
            "name": "Alfa Kucha Woreda",
            "nameamh": "አልፋ ቁጫ ወረዳ"
        }
    ],
    "131": [
        {
            "id": 1,
            "name": "Laska Zuriya Woreda",
            "nameamh": "ላስካ ዙሪያ ወረዳ"
        },
        {
            "id": 2,
            "name": "Laska City Administration",
            "nameamh": "ላስካ ከተማ አስተዳደር"
        }
    ],
    "132": [
        {
            "id": 1,
            "name": "Kena Woreda",
            "nameamh": "ኬና ወረዳ"
        },
        {
            "id": 2,
            "name": "Segen Zuriya Woreda",
            "nameamh": "ሰገን ዙሪያ ወረዳ"
        },
        {
            "id": 3,
            "name": "Kolme Woreda",
            "nameamh": "ኮልሜ ወረዳ"
        },
        {
            "id": 4,
            "name": "Karat Zuriya Woreda",
            "nameamh": "ካራት ዙሪያ ወረዳ"
        },
        {
            "id": 5,
            "name": "Karat City Adminstration",
            "nameamh": "ካራት ከተማ አስተዳደር"
        }
    ],
    "133": [
        {
            "id": 1,
            "name": "Melo Koza Woreda",
            "nameamh": "መሎ ኮዛ ወረዳ"
        },
        {
            "id": 2,
            "name": "Oyda Woreda",
            "nameamh": "ኦይዳ ወረዳ"
        },
        {
            "id": 3,
            "name": "Laha City Adminstration",
            "nameamh": "ለሃ ከተማ አስተዳደር"
        },
        {
            "id": 4,
            "name": "Geze Gofa Woreda",
            "nameamh": "ገዜ ጎፋ ወረዳ"
        },
        {
            "id": 5,
            "name": "Uba Debre Tsehay Woreda",
            "nameamh": "ኡባ ደብረ ፀሃይ ወረዳ"
        },
        {
            "id": 6,
            "name": "Zala Woreda",
            "nameamh": "ዛላ ወረዳ"
        },
        {
            "id": 7,
            "name": "Beto City Adminstration",
            "nameamh": "በቶ ከተማ አስተዳደር"
        },
        {
            "id": 8,
            "name": "Bulqi City Adminstration",
            "nameamh": "ቡልቂ ከተማ አስተዳደር"
        },
        {
            "id": 9,
            "name": "Demba Gofa Woreda",
            "nameamh": "ደምባ ጎፋ ወረዳ"
        },
        {
            "id": 10,
            "name": "Melo Gada Woreda",
            "nameamh": "መሎ ጋዳ ወረዳ"
        },
        {
            "id": 11,
            "name": "Sawula City Adminstration",
            "nameamh": "ሣውላ ከተማ አስተዳደር"
        }
    ],
    "134": [
        {
            "id": 1,
            "name": "Gnangatom Woreda",
            "nameamh": "ኛንጋቶም ወረዳ"
        },
        {
            "id": 2,
            "name": "Turmi City Administration",
            "nameamh": "ቱርሚ ከተማ አስተዳደር"
        },
        {
            "id": 3,
            "name": "Hamer Woreda",
            "nameamh": "ሐመር ወረዳ"
        },
        {
            "id": 4,
            "name": "Salamago Woreda",
            "nameamh": "ሣላማጎ ወረዳ"
        },
        {
            "id": 5,
            "name": "Dasenech Woreda",
            "nameamh": "ዳሰነች ወረዳ"
        },
        {
            "id": 6,
            "name": "Bena Tsemay Woreda",
            "nameamh": "በና ፀማይ ወረዳ"
        },
        {
            "id": 7,
            "name": "Male Woreda",
            "nameamh": "ማሌ ወረዳ"
        }
    ],
    "135": [
        {
            "id": 1,
            "name": "Gidole City Administration",
            "nameamh": "ጊዶሌ ከተማ አስተዳደር"
        },
        {
            "id": 2,
            "name": "Derashe Woreda",
            "nameamh": "ደራሼ ወረዳ"
        }
    ],
    "136": [
        {
            "id": 1,
            "name": "Bayira Koysha Woreda",
            "nameamh": "ባይራ ኮይሻ ወረዳ"
        },
        {
            "id": 2,
            "name": "Boloso Bombe Woreda",
            "nameamh": "ቦሎሶ ቦምቤ ወረዳ"
        },
        {
            "id": 3,
            "name": "Damot Gale Woreda",
            "nameamh": "ዳሞት ጋሌ ወረዳ"
        },
        {
            "id": 4,
            "name": "Damot Fulasa Woreda",
            "nameamh": "ዳሞት ፉላሳ ወረዳ"
        },
        {
            "id": 5,
            "name": "Kindo Didaye Woreda",
            "nameamh": "ኪንዶ ዲዳዬ ወረዳ"
        },
        {
            "id": 6,
            "name": "Humbo Woreda",
            "nameamh": "ሁምቦ ወረዳ"
        },
        {
            "id": 7,
            "name": "Sodo Zuriya Woreda",
            "nameamh": "ሶዶ ዙሪያ ወረዳ"
        },
        {
            "id": 8,
            "name": "Kawo Koyisha Woreda",
            "nameamh": "ካዎ ኮይሻ ወረዳ"
        },
        {
            "id": 9,
            "name": "Abala Abaya",
            "nameamh": "አባላ አባያ"
        },
        {
            "id": 10,
            "name": "Areka City Administration",
            "nameamh": "አረካ ከተማ አስተዳደር"
        },
        {
            "id": 11,
            "name": "Boditi City Adminstration",
            "nameamh": "ቦዲቲ ከተማ አስተዳደር"
        },
        {
            "id": 12,
            "name": "Damot Sore Woreda",
            "nameamh": "ዳሞት ሶሬ ወረዳ"
        },
        {
            "id": 13,
            "name": "Boloso Sore Woreda",
            "nameamh": "ቦሎሶ ሶሬ ወረዳ"
        },
        {
            "id": 14,
            "name": "Hobicha Woreda",
            "nameamh": "ሆቢቻ ወረዳ"
        },
        {
            "id": 15,
            "name": "Duguna Fango Woreda",
            "nameamh": "ዱጉና ፋንጎ ወረዳ"
        },
        {
            "id": 16,
            "name": "Damot Woyde Woreda",
            "nameamh": "ዳሞት ወይዴ ወረዳ"
        },
        {
            "id": 17,
            "name": "Tebela City Administration",
            "nameamh": "ጠበላ ከተማ አስተዳደር"
        },
        {
            "id": 18,
            "name": "Offa Woreda",
            "nameamh": "ኦፋ ወረዳ"
        },
        {
            "id": 19,
            "name": "Gesuba City Administration",
            "nameamh": "ገሱባ ከተማ አስተዳደር"
        },
        {
            "id": 20,
            "name": "Sodo City Administration",
            "nameamh": "ሶዶ ከተማ አስተዳደር"
        }
    ],
    "137": [
        {
            "id": 1,
            "name": "Chelelektu City Administration",
            "nameamh": "ጨለለቅቱ ከተማ አስተዳደር"
        },
        {
            "id": 2,
            "name": "Repe Woreda",
            "nameamh": "ረጴ ወረዳ"
        },
        {
            "id": 3,
            "name": "Dilla Zuriya Woreda",
            "nameamh": "ዲላ ዙሪያ ወረዳ"
        },
        {
            "id": 4,
            "name": "Yirgachefe Woreda",
            "nameamh": "ይርጋ ጨፌ ወረዳ"
        },
        {
            "id": 5,
            "name": "Dilla City Administration",
            "nameamh": "ዲላ ከተማ አስተዳደር"
        },
        {
            "id": 6,
            "name": "Gedeb City Administration",
            "nameamh": "ገደብ ከተማ አስተዳደር"
        },
        {
            "id": 7,
            "name": "Yirgachefe City Administration",
            "nameamh": "ይርጋ ጨፌ ከተማ አስተዳደር"
        },
        {
            "id": 8,
            "name": "Chorso Woreda",
            "nameamh": "ጮርሶ ወረዳ"
        },
        {
            "id": 9,
            "name": "Wenago Woreda",
            "nameamh": "ወናጎ ወረዳ"
        },
        {
            "id": 10,
            "name": "Bule Woreda",
            "nameamh": "ቡሌ ወረዳ"
        },
        {
            "id": 11,
            "name": "Wenago Woreda",
            "nameamh": "ወናጎ ወረዳ"
        },
        {
            "id": 12,
            "name": "Gedeb Woreda",
            "nameamh": "ገደብ ወረዳ"
        },
        {
            "id": 13,
            "name": "Kochere Woreda",
            "nameamh": "ኮቸሬ ወረዳ"
        }
    ],
    "138": [
        {
            "id": 1,
            "name": "Sarmale Woreda",
            "nameamh": "ሳርማሌ ወረዳ"
        },
        {
            "id": 2,
            "name": "Gorka Woreda",
            "nameamh": "ጎርካ ወረዳ"
        },
        {
            "id": 3,
            "name": "Kele City Administration",
            "nameamh": "ኬሌ ከተማ አስተዳደር"
        }
    ],
    "139": [
        {
            "id": 1,
            "name": "Somaya City Administration",
            "nameamh": "ሶያማ ከተማ አስተዳደር"
        },
        {
            "id": 2,
            "name": "Somaya Zuriya Woreda",
            "nameamh": "ሶያማ ዙሪያ ወረዳ"
        }
    ],
    "140": [
        {
            "id": 1,
            "name": "Kolango Zuriya Woreda",
            "nameamh": "ኮላንጎ ዙሪያ ወረዳ"
        }
    ],
    "141": [
        {
            "id": 1,
            "name": "Hargelle",
            "nameamh": "ሃርጌል"
        },
        {
            "id": 2,
            "name": "Cherati",
            "nameamh": "ጨረቲ"
        },
        {
            "id": 3,
            "name": "Dolobay",
            "nameamh": "ዶሎባይ"
        },
        {
            "id": 4,
            "name": "Raaso",
            "nameamh": "ራሶ"
        },
        {
            "id": 5,
            "name": "Baarey",
            "nameamh": "ባአረይ"
        },
        {
            "id": 6,
            "name": "Ceelkarri",
            "nameamh": "ኤልከሪ"
        },
        {
            "id": 7,
            "name": "Iimey Galbeed",
            "nameamh": "ምዕራብ አይሜይ"
        },
        {
            "id": 8,
            "name": "Goro Bekeksa",
            "nameamh": "ጎሮ በከክሳ"
        },
        {
            "id": 9,
            "name": "Qooxle",
            "nameamh": "Qooxle"
        },
        {
            "id": 10,
            "name": "Godgod",
            "nameamh": "ጎድጎድ"
        }
    ],
    "142": [
        {
            "id": 1,
            "name": "Qadhaadhumo",
            "nameamh": "ቀዳሃድሁሞ"
        },
        {
            "id": 2,
            "name": "Hudet",
            "nameamh": "ሁደት"
        },
        {
            "id": 3,
            "name": "Moyale",
            "nameamh": "ሞያሌ"
        },
        {
            "id": 4,
            "name": "Mubarek",
            "nameamh": "ሙባረክ"
        }
    ],
    "143": [
        {
            "id": 1,
            "name": "Bokh",
            "nameamh": "ቦህ"
        },
        {
            "id": 2,
            "name": "Danot",
            "nameamh": "ዳኖት"
        },
        {
            "id": 3,
            "name": "Galladi",
            "nameamh": "ጋላዲ"
        },
        {
            "id": 4,
            "name": "Warder",
            "nameamh": "ዋርደር"
        },
        {
            "id": 5,
            "name": "Daratole",
            "nameamh": "ዳራቶሌ"
        },
        {
            "id": 6,
            "name": "Galxamur",
            "nameamh": "Galxamur"
        },
        {
            "id": 7,
            "name": "Lehel-Yucub",
            "nameamh": "Lehel-Yucub"
        },
        {
            "id": 8,
            "name": "Warder City Administration",
            "nameamh": "ዋርደር ከተማ አስተዳደር"
        }
    ],
    "144": [
        {
            "id": 1,
            "name": "Lagahida",
            "nameamh": "ላጋሂዳ"
        },
        {
            "id": 2,
            "name": "Qubi",
            "nameamh": "ቁቢ"
        },
        {
            "id": 3,
            "name": "Waangay",
            "nameamh": "ዋንጋይ"
        },
        {
            "id": 4,
            "name": "Fiqi",
            "nameamh": "ፍቅ"
        },
        {
            "id": 5,
            "name": "Salaxaad",
            "nameamh": "ሳላሃድ"
        },
        {
            "id": 6,
            "name": "Mayu-Muuqdheer",
            "nameamh": "መዩ-ሙቋደር"
        },
        {
            "id": 7,
            "name": "Yaxoob",
            "nameamh": "Yaxoob"
        },
        {
            "id": 8,
            "name": "Hamero",
            "nameamh": "ሃመሮ"
        }
    ],
    "145": [
        {
            "id": 1,
            "name": "Awbare",
            "nameamh": "አውባሬ"
        },
        {
            "id": 2,
            "name": "Jijiga",
            "nameamh": "ጅጅጋ"
        },
        {
            "id": 3,
            "name": "Babille",
            "nameamh": "ባቢሌ"
        },
        {
            "id": 4,
            "name": "Gursum",
            "nameamh": "ጉርሱም"
        },
        {
            "id": 5,
            "name": "Harshin",
            "nameamh": "ሀርሺን"
        },
        {
            "id": 6,
            "name": "Tuli Guled",
            "nameamh": "ቱሊ ጉሌድ"
        },
        {
            "id": 7,
            "name": "Kebri Beyah",
            "nameamh": "ቀብሪ በያህ"
        },
        {
            "id": 8,
            "name": "Togochale City Admenistration",
            "nameamh": "ቶጎጫሌ ከተማ አስተዳደር"
        },
        {
            "id": 9,
            "name": "Harawo",
            "nameamh": "ሀራዎ"
        },
        {
            "id": 10,
            "name": "Qooraan Mulla",
            "nameamh": "ቆራን ሙላ"
        },
        {
            "id": 11,
            "name": "Harores",
            "nameamh": "ሃሮሬስ"
        },
        {
            "id": 12,
            "name": "Goljano",
            "nameamh": "ጎልጃኖ"
        },
        {
            "id": 13,
            "name": "Debub Jigjiga",
            "nameamh": "ደቡብ ጅጅጋ"
        }
    ],
    "146": [
        {
            "id": 1,
            "name": "Daroor",
            "nameamh": "ዳሮር"
        },
        {
            "id": 2,
            "name": "Gunagado",
            "nameamh": "ጉናጋዶ"
        },
        {
            "id": 3,
            "name": "Bilcil Buur",
            "nameamh": "ቢልሲል ቡር"
        },
        {
            "id": 4,
            "name": "Gashamo",
            "nameamh": "ጋሻሞ"
        },
        {
            "id": 5,
            "name": "Aware",
            "nameamh": "አዋሬ"
        },
        {
            "id": 6,
            "name": "Dhagax-Buur",
            "nameamh": "Dhagax-Buur"
        },
        {
            "id": 7,
            "name": "Dhagax-Madow",
            "nameamh": "Dhagax-Madow"
        },
        {
            "id": 8,
            "name": "Birqod",
            "nameamh": "Birqod"
        },
        {
            "id": 9,
            "name": "Dig",
            "nameamh": "Dig"
        },
        {
            "id": 10,
            "name": "Yoocaale",
            "nameamh": "Yoocaale"
        },
        {
            "id": 11,
            "name": "Araarso",
            "nameamh": "አራርሶ"
        },
        {
            "id": 12,
            "name": "Degehabur City Admnistration",
            "nameamh": "ደገሃቡር ከተማ አስተዳደር"
        }
    ],
    "147": [
        {
            "id": 1,
            "name": "Kebri Dahar",
            "nameamh": "ቀብሪ ደሓር"
        },
        {
            "id": 2,
            "name": "Shekosh",
            "nameamh": "ሸይኮሽ"
        },
        {
            "id": 3,
            "name": "Laas-Dhankayre",
            "nameamh": "Laas-Dhankayre"
        },
        {
            "id": 4,
            "name": "Kudunbuur",
            "nameamh": "ኩዱንቡር"
        },
        {
            "id": 5,
            "name": "Dhooboweyn",
            "nameamh": "ዱህቦወይን"
        },
        {
            "id": 6,
            "name": "Shilaabo",
            "nameamh": "ሺላቦ"
        },
        {
            "id": 7,
            "name": "Marsin",
            "nameamh": "ማርሲን"
        },
        {
            "id": 8,
            "name": "Higloley",
            "nameamh": "ሂግሎሌይ"
        },
        {
            "id": 9,
            "name": "Boodaley",
            "nameamh": "ቦዳላይ"
        },
        {
            "id": 10,
            "name": "Ceel-Ogaden",
            "nameamh": "ኤል-ኦጋዴን"
        },
        {
            "id": 11,
            "name": "Gogilo",
            "nameamh": "ጎጊሎ"
        },
        {
            "id": 12,
            "name": "Qebridahar Citiy Administration",
            "nameamh": "ቀብሪ ደሃር ከተማ አስተዳደር"
        }
    ],
    "148": [
        {
            "id": 1,
            "name": "Filtu",
            "nameamh": "ፍልቱ"
        },
        {
            "id": 2,
            "name": "Dollo Addo",
            "nameamh": "ዶሎ አዶ"
        },
        {
            "id": 3,
            "name": "Qarsadula",
            "nameamh": "ቃርሳዱላ"
        },
        {
            "id": 4,
            "name": "Gura Damole",
            "nameamh": "ጉራ ዳሞሌ"
        },
        {
            "id": 5,
            "name": "Gura Baqasa",
            "nameamh": "ጉራ ባቃሳ"
        },
        {
            "id": 6,
            "name": "Bokolmayo",
            "nameamh": "ቦኮለማዮ"
        },
        {
            "id": 7,
            "name": "Deka Softu",
            "nameamh": "Deka Softu"
        }
    ],
    "149": [
        {
            "id": 1,
            "name": "Gerbo",
            "nameamh": "ገርቦ"
        },
        {
            "id": 2,
            "name": "Ayun",
            "nameamh": "አዩን"
        },
        {
            "id": 3,
            "name": "Hor-Shagah",
            "nameamh": "ሆር ሻጋህ"
        },
        {
            "id": 4,
            "name": "Elweyn Town",
            "nameamh": "ኤልዌይን ከተማ"
        },
        {
            "id": 5,
            "name": "Dhuxun",
            "nameamh": "ዱክሱን"
        },
        {
            "id": 6,
            "name": "Xaraarey",
            "nameamh": "Xaraarey"
        },
        {
            "id": 7,
            "name": "Segeg",
            "nameamh": "ሴጌግ"
        }
    ],
    "150": [
        {
            "id": 1,
            "name": "Danan",
            "nameamh": "ዳናን"
        },
        {
            "id": 2,
            "name": "Ferfer",
            "nameamh": "ፈርፈር"
        },
        {
            "id": 3,
            "name": "Gode",
            "nameamh": "ጎዴ"
        },
        {
            "id": 4,
            "name": "Kelafo",
            "nameamh": "ኬላፎ"
        },
        {
            "id": 5,
            "name": "Beercaano",
            "nameamh": "Beercaano"
        },
        {
            "id": 6,
            "name": "Gode Council",
            "nameamh": "ጎዴ ምክር ቤት"
        },
        {
            "id": 7,
            "name": "Elelle",
            "nameamh": "ኢሌሌ"
        },
        {
            "id": 8,
            "name": "Abaqorow",
            "nameamh": "አባቆሮው"
        },
        {
            "id": 9,
            "name": "East Eme",
            "nameamh": "ምስራቅ ኢሜ"
        },
        {
            "id": 10,
            "name": "Adadle",
            "nameamh": "አዳድሌ"
        },
        {
            "id": 11,
            "name": "Mustahil",
            "nameamh": "መስታህል"
        }
    ],
    "151": [
        {
            "id": 1,
            "name": "Afdem",
            "nameamh": "አፍዴም"
        },
        {
            "id": 2,
            "name": "Ayesha",
            "nameamh": "አይሻ"
        },
        {
            "id": 3,
            "name": "Shinile",
            "nameamh": "ሸእኔለ"
        },
        {
            "id": 4,
            "name": "Dambel",
            "nameamh": "ደምበል"
        },
        {
            "id": 5,
            "name": "Me' Aso",
            "nameamh": "መኢሶ"
        },
        {
            "id": 6,
            "name": "Erer",
            "nameamh": "ኤረር"
        },
        {
            "id": 7,
            "name": "Hadhagaale",
            "nameamh": "ሓዳጋለ"
        },
        {
            "id": 8,
            "name": "Geblalu",
            "nameamh": "ገብላሉ"
        },
        {
            "id": 9,
            "name": "Gotabike",
            "nameamh": "ጎታ ቢኪ"
        }
    ],
    "152": [
        {
            "id": 1,
            "name": "Gibe bench",
            "nameamh": "ጊዲ ቤንች"
        },
        {
            "id": 2,
            "name": "Gurafereda",
            "nameamh": "ጉራፈርዳ"
        },
        {
            "id": 3,
            "name": "Mizan-Aman City Adminstration",
            "nameamh": "ሚዛን-አማን ከተማ አስተዳደር"
        },
        {
            "id": 4,
            "name": "Nort bench",
            "nameamh": "ሰሜን ቤንች"
        },
        {
            "id": 5,
            "name": "shey bench",
            "nameamh": "ሼይ ቤንች"
        },
        {
            "id": 6,
            "name": "Siz City Adminstration",
            "nameamh": "ሲዝ ከተማ አስተዳደር"
        },
        {
            "id": 7,
            "name": "Sheko",
            "nameamh": "ሸኮ"
        },
        {
            "id": 8,
            "name": "South Bench",
            "nameamh": "ደቡብ ቤንች"
        }
    ],
    "153": [
        {
            "id": 1,
            "name": "Disa",
            "nameamh": "ዲሳ"
        },
        {
            "id": 2,
            "name": "Esera",
            "nameamh": "ኢሠራ"
        },
        {
            "id": 3,
            "name": "Gesa Chare Town Adminstration",
            "nameamh": "ገሳ ጫሬ ከተማ አስተዳደር"
        },
        {
            "id": 4,
            "name": "Gena",
            "nameamh": "ገና"
        },
        {
            "id": 5,
            "name": "Kechi",
            "nameamh": "ከጪ"
        },
        {
            "id": 6,
            "name": "Loma Bosa",
            "nameamh": "ሎማ ቦሳ"
        },
        {
            "id": 7,
            "name": "Mari-Mansa",
            "nameamh": "ማሪ-ማንሳ"
        },
        {
            "id": 8,
            "name": "Mareka",
            "nameamh": "ማረቃ"
        },
        {
            "id": 9,
            "name": "Tocha",
            "nameamh": "ቶጫ"
        },
        {
            "id": 10,
            "name": "Tarecha City Adminstration",
            "nameamh": "ታርጫ ከተማ አስተዳደር"
        },
        {
            "id": 11,
            "name": "Tarecha",
            "nameamh": "ታርጫ ዙሪያ"
        },
        {
            "id": 12,
            "name": "Zaba Gazo",
            "nameamh": "ዛባ ጋዞ"
        }
    ],
    "154": [
        {
            "id": 1,
            "name": "Awerada City Adminstration",
            "nameamh": "አዉራዳ ከተማ አስተዳደር"
        },
        {
            "id": 2,
            "name": "Adeyo",
            "nameamh": "አድዮ"
        },
        {
            "id": 3,
            "name": "Bonga City Adminstration",
            "nameamh": "ቦንጋ ከተማ አስተዳደር"
        },
        {
            "id": 4,
            "name": "Bita",
            "nameamh": "ቢጣ"
        },
        {
            "id": 5,
            "name": "Chena",
            "nameamh": "ጨና"
        },
        {
            "id": 6,
            "name": "Cheta",
            "nameamh": "ጨታ"
        },
        {
            "id": 7,
            "name": "Decha",
            "nameamh": "ዴቻ"
        },
        {
            "id": 8,
            "name": "Deka City Adminstration",
            "nameamh": "ደካ ከተማ አስተዳደር"
        },
        {
            "id": 9,
            "name": "Gibmo",
            "nameamh": "ጊምቦ"
        },
        {
            "id": 10,
            "name": "Goba",
            "nameamh": "ጎባ"
        },
        {
            "id": 11,
            "name": "Gesha",
            "nameamh": "ጌሻ"
        },
        {
            "id": 12,
            "name": "Gewata",
            "nameamh": "ገዋታ"
        },
        {
            "id": 13,
            "name": "Sheshenda City Adminstration",
            "nameamh": "ሺሽንዳ ከተማ አስተዳደር"
        },
        {
            "id": 14,
            "name": "Saylem",
            "nameamh": "ሳይለም"
        },
        {
            "id": 15,
            "name": "Shesho Ende",
            "nameamh": "ሺሾ እንዴ"
        },
        {
            "id": 16,
            "name": "Telo",
            "nameamh": "ጠሎ"
        },
        {
            "id": 17,
            "name": "Wacha City Adminstration",
            "nameamh": "ዋቻ ከተማ አስተዳደር"
        }
    ],
    "155": [
        {
            "id": 1,
            "name": "Ameya City Adminstration",
            "nameamh": "አመያ ከተማ አስተዳደር"
        },
        {
            "id": 2,
            "name": "Ameya Zuriya",
            "nameamh": "አመያ ዙሪያ"
        },
        {
            "id": 3,
            "name": "Cheda City Adminstration",
            "nameamh": "ጭዳ ከተማ አስተዳደር"
        },
        {
            "id": 4,
            "name": "Ela anchano",
            "nameamh": "ኤላ አንቻኖ"
        },
        {
            "id": 5,
            "name": "Konta Koysha",
            "nameamh": "ኮንታ ኮይሻ"
        }
    ],
    "156": [
        {
            "id": 1,
            "name": "Anderacha",
            "nameamh": "አንድራቻ"
        },
        {
            "id": 2,
            "name": "Masha",
            "nameamh": "ማሻ"
        },
        {
            "id": 3,
            "name": "Masha City Adminstration",
            "nameamh": "ማሻ ከተማ አስተዳደር"
        },
        {
            "id": 4,
            "name": "Tepi City Adminstration",
            "nameamh": "ቴፒ ከተማ አስተዳደር"
        },
        {
            "id": 5,
            "name": "Yeki",
            "nameamh": "የኪ"
        }
    ],
    "157": [
        {
            "id": 1,
            "name": "Bachuma City Adminstration",
            "nameamh": "ባቹማ ከተማ አስተዳደር"
        },
        {
            "id": 2,
            "name": "Bero",
            "nameamh": "ቤሮ"
        },
        {
            "id": 3,
            "name": "Gachet",
            "nameamh": "ጋችት"
        },
        {
            "id": 4,
            "name": "Gori Gesha",
            "nameamh": "ጎሪ ጌሻ"
        },
        {
            "id": 5,
            "name": "Jemu City Adminstration",
            "nameamh": "ጀሙ ከተማ አስተዳደር"
        },
        {
            "id": 6,
            "name": "Me'enit Goldiya",
            "nameamh": "መኤኒት ጎልዲያ"
        },
        {
            "id": 7,
            "name": "Maji",
            "nameamh": "ማጂ"
        },
        {
            "id": 8,
            "name": "Me'enit Shasha",
            "nameamh": "መኤኒት ሻሻ"
        },
        {
            "id": 9,
            "name": "Maji Tum City Adminstration",
            "nameamh": "ማጂ ቱም ከተማ አስተዳደር"
        },
        {
            "id": 10,
            "name": "Surma",
            "nameamh": "ሱርማ"
        }
    ],
    "158": [
        {
            "id": 1,
            "name": "Adi-Haki Sub City",
            "nameamh": "ዓዲ ሓቂ ክ/ከተማ"
        },
        {
            "id": 2,
            "name": "Ayder Sub City",
            "nameamh": "ዓይደር ክ/ከተማ "
        },
        {
            "id": 3,
            "name": "Hadnet Sub City",
            "nameamh": "ሓድነት ክ/ከተማ"
        },
        {
            "id": 4,
            "name": "Hawelti Sub City",
            "nameamh": "ሓዉልቲ ክ/ከተማ"
        },
        {
            "id": 5,
            "name": "Kedamay Weyane Sub City",
            "nameamh": "ቐ/ወያነ ክ/ከተማ"
        },
        {
            "id": 6,
            "name": "Mekelle City",
            "nameamh": "መቐለ ከተማ"
        },
        {
            "id": 7,
            "name": "Quiha Sub City",
            "nameamh": "ኲሓ ክ/ከተማ"
        },
        {
            "id": 8,
            "name": "Semien Sub City",
            "nameamh": "ሰሜን ክ/ከተማ"
        }
    ],
    "159": [
        {
            "id": 1,
            "name": "Adi_Daero Town",
            "nameamh": "ዓዲ ዳዕሮ ከተማ"
        },
        {
            "id": 2,
            "name": "Asgede",
            "nameamh": "አስገደ"
        },
        {
            "id": 3,
            "name": "Indabaguna Town",
            "nameamh": "እንዳባጉና ከተማ"
        },
        {
            "id": 4,
            "name": "La'ilay Koraro",
            "nameamh": "ላዕላይ ቆራሮ"
        },
        {
            "id": 5,
            "name": "La'ilay Tselemti",
            "nameamh": "ላዕላይ ፀለምቲ"
        },
        {
            "id": 6,
            "name": "Maekel Adiyabo",
            "nameamh": "ማእከል ኣድያቦ"
        },
        {
            "id": 7,
            "name": "Maytsebri Town",
            "nameamh": "ማይፀብሪ ከተማ"
        },
        {
            "id": 8,
            "name": "Medebay Zana Wereda",
            "nameamh": "መዳባይ ዛና ወረዳ"
        },
        {
            "id": 9,
            "name": "Shire Endaslassie Town",
            "nameamh": "ሸረ እንዳስላሰ ከተማ"
        },
        {
            "id": 10,
            "name": "Shiraro Town",
            "nameamh": "ሸራሮ ከተማ"
        },
        {
            "id": 11,
            "name": "Seyemti Adiyabo",
            "nameamh": "ሰየምቲ ኣድያቦ"
        },
        {
            "id": 12,
            "name": "Tahitay Koraro",
            "nameamh": "ታሕታይ ቆራሮ"
        },
        {
            "id": 13,
            "name": "Tsemebela",
            "nameamh": "ፅምብላ"
        },
        {
            "id": 14,
            "name": "Tselemti",
            "nameamh": "ፀለምቲ"
        },
        {
            "id": 15,
            "name": "Tahtay Adiyabo",
            "nameamh": "ታሕታይ ኣድያቦ"
        }
    ],
    "160": [
        {
            "id": 1,
            "name": "Abiy Adi Town",
            "nameamh": "ዓብይ ዓዲ ከተማ"
        },
        {
            "id": 2,
            "name": "Adet",
            "nameamh": "ዓዴት"
        },
        {
            "id": 3,
            "name": "Adewa Town",
            "nameamh": "ዓድዋ ከተማ"
        },
        {
            "id": 4,
            "name": "Adewa Wereda",
            "nameamh": "ወረዳ ዓድዋ"
        },
        {
            "id": 5,
            "name": "Ahferom",
            "nameamh": "ኣሕፈሮም"
        },
        {
            "id": 6,
            "name": "Abergele Yechila",
            "nameamh": "ኣበርገለ የጪላ"
        },
        {
            "id": 7,
            "name": "Ahsea",
            "nameamh": "ኣሕሰኣ"
        },
        {
            "id": 8,
            "name": "Aksum Town",
            "nameamh": "ኣክሱም ከተማ"
        },
        {
            "id": 9,
            "name": "Chela",
            "nameamh": "ጭላ"
        },
        {
            "id": 10,
            "name": "Embaseneyti",
            "nameamh": "እምባሰነይቲ"
        },
        {
            "id": 11,
            "name": "Egele",
            "nameamh": "እገለ"
        },
        {
            "id": 12,
            "name": "Enticho Town",
            "nameamh": "እንትጮ ከተማ"
        },
        {
            "id": 13,
            "name": "Endaba Tsahima Edaga Arbi Town",
            "nameamh": "ከተማ እንዳባ ፃሕማ ዕዳጋ ዓርቢ ከተማ"
        },
        {
            "id": 14,
            "name": "Hahayle",
            "nameamh": "ሓሓይለ"
        },
        {
            "id": 15,
            "name": "Kola Teimben",
            "nameamh": "ቆላ ተምቤን"
        },
        {
            "id": 16,
            "name": "La'ilay Maychew",
            "nameamh": "ላዕላይ ማይጨው"
        },
        {
            "id": 17,
            "name": "May_kinetal",
            "nameamh": "ማይ ቅነጣል"
        },
        {
            "id": 18,
            "name": "Na'eder",
            "nameamh": "ናዕዴር"
        },
        {
            "id": 19,
            "name": "Qeyh tekl'i",
            "nameamh": "ቀይሕ ተኽሊ"
        },
        {
            "id": 20,
            "name": "Rama Adi Arba'ate Town",
            "nameamh": "ራማ ዓዲ-ኣርባዕተ ከተማ"
        },
        {
            "id": 21,
            "name": "Tanqua Millash",
            "nameamh": "ጣንቋ ምላሽ"
        },
        {
            "id": 22,
            "name": "Tahitay Maychew",
            "nameamh": "ታሕታይ ማይጨዉ"
        }
    ],
    "161": [
        {
            "id": 1,
            "name": "Adigrat Town",
            "nameamh": "ዓዲግራት ከተማ"
        },
        {
            "id": 2,
            "name": "Atsbi Endasilassie Town",
            "nameamh": "አፅቢ እንዳስላሴ ከተማ"
        },
        {
            "id": 3,
            "name": "Atsebi Dera",
            "nameamh": "ኣፅቢ ደራ"
        },
        {
            "id": 4,
            "name": "Bizet",
            "nameamh": "ብዘት"
        },
        {
            "id": 5,
            "name": "Edaga Hamus Town",
            "nameamh": "ዕዳጋ ሓሙስ ከተማ"
        },
        {
            "id": 6,
            "name": "Fireweyni Town",
            "nameamh": "ፍረወይኒ ከተማ"
        },
        {
            "id": 7,
            "name": "Gulo Maheda",
            "nameamh": "ጎሎ መኸዳ"
        },
        {
            "id": 8,
            "name": "Gerealta Wereda",
            "nameamh": "ገረዓልታ ወረዳ"
        },
        {
            "id": 9,
            "name": "Ganta Afeshum",
            "nameamh": "ጋንታ ኣፈ-ሹም"
        },
        {
            "id": 10,
            "name": "Hawzen Town",
            "nameamh": "ሓዉዜን ከተማ"
        },
        {
            "id": 11,
            "name": "Hawzen Wereda",
            "nameamh": "ሓዉዜን ወረዳ"
        },
        {
            "id": 12,
            "name": "Irob",
            "nameamh": "ኢሮብ"
        },
        {
            "id": 13,
            "name": "Kilte Awelalo",
            "nameamh": "ክልተ ኣዉላዕሎ"
        },
        {
            "id": 14,
            "name": "Sewha_Saesae",
            "nameamh": "ሰዉሓ ሳዕሰዕ"
        },
        {
            "id": 15,
            "name": "Tsirae Wenberta",
            "nameamh": "ፅራእ ወንበርታ"
        },
        {
            "id": 16,
            "name": "Tsaeda Emba",
            "nameamh": "ፃዕዳ እምባ"
        },
        {
            "id": 17,
            "name": "Wukro Town",
            "nameamh": "ዉቕሮ ከተማ"
        },
        {
            "id": 18,
            "name": "Zalambesa Town",
            "nameamh": "ዛላምበሳ ከተማ"
        }
    ],
    "162": [
        {
            "id": 1,
            "name": "20 Adi Wejirat",
            "nameamh": "20 ዓዲ ወጅራት"
        },
        {
            "id": 2,
            "name": "Adi Gudom Town",
            "nameamh": "ዓዲ ጉዶም  ከተማ"
        },
        {
            "id": 3,
            "name": "Dogu'a Temben",
            "nameamh": "ደጉዓ ተምቤን"
        },
        {
            "id": 4,
            "name": "Enderta",
            "nameamh": "እንደርታ"
        },
        {
            "id": 5,
            "name": "Hagere Selam Town",
            "nameamh": "ሃገረ ሰላም ከተማ"
        },
        {
            "id": 6,
            "name": "Hintalo",
            "nameamh": "ሕንጣሎ"
        },
        {
            "id": 7,
            "name": "Seharti",
            "nameamh": "ሰሓርቲ"
        },
        {
            "id": 8,
            "name": "Samre",
            "nameamh": "ሳምረ"
        }
    ],
    "163": [
        {
            "id": 1,
            "name": "Alaje",
            "nameamh": "አላጀ"
        },
        {
            "id": 2,
            "name": "Alamata Town",
            "nameamh": "ኣላማጣ ከተማ"
        },
        {
            "id": 3,
            "name": "Bora Chelena",
            "nameamh": "ቦራ ቸለና"
        },
        {
            "id": 4,
            "name": "Endemehoni",
            "nameamh": "እንዳሞኸኒ"
        },
        {
            "id": 5,
            "name": "Korem Town",
            "nameamh": "ኮረም ከተማ"
        },
        {
            "id": 6,
            "name": "Moheni Town",
            "nameamh": "ሞኸኒ ከተማ"
        },
        {
            "id": 7,
            "name": "mayichew Town",
            "nameamh": "ማይጨዉ ከተማ"
        },
        {
            "id": 8,
            "name": "Nekesege",
            "nameamh": "ነቕሰገ"
        },
        {
            "id": 9,
            "name": "Ofla",
            "nameamh": "ኦፍላ"
        },
        {
            "id": 10,
            "name": "Raya Azebo",
            "nameamh": "ራያ ዓዘቦ"
        },
        {
            "id": 11,
            "name": "Raya Alamata",
            "nameamh": "ራያ ኣላማጣ"
        },
        {
            "id": 12,
            "name": "Raya Chercher",
            "nameamh": "ራያ ጨርጨር"
        },
        {
            "id": 13,
            "name": "Selewa",
            "nameamh": "ሰለዋ"
        },
        {
            "id": 14,
            "name": "Zata",
            "nameamh": "ዛታ"
        }
    ],
    "164": [
        {
            "id": 1,
            "name": "Awura",
            "nameamh": "ኣዉራ"
        },
        {
            "id": 2,
            "name": "Dansha Town",
            "nameamh": "ዳንሻ ከተማ"
        },
        {
            "id": 3,
            "name": "Kafta Humera",
            "nameamh": "ቃፍታ ሑመራ"
        },
        {
            "id": 4,
            "name": "Korarit Town",
            "nameamh": "ቆራሪት ከተማ"
        },
        {
            "id": 5,
            "name": "Maycadera Town",
            "nameamh": "ማይካድራ ከተማ"
        },
        {
            "id": 6,
            "name": "Maygaba Town",
            "nameamh": "ማይጋባ ከተማ"
        },
        {
            "id": 7,
            "name": "Setit Humera Town",
            "nameamh": "ሰቲት ሑመራ ከተማ"
        },
        {
            "id": 8,
            "name": "Tsegede",
            "nameamh": "ፀገዴ"
        },
        {
            "id": 9,
            "name": "Welkayit",
            "nameamh": "ወልቃይት"
        }
    ]
}
